
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8e65"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8e65"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kTZM9", function(module, exports) {
// Copyright (c) Microsoft, All rights reserved. See License.txt in the project root for license information.
(function(undefined) {
    var objectTypes = {
        'function': true,
        'object': true
    };
    function checkGlobal(value) {
        return value && value.Object === Object ? value : null;
    }
    var freeExports = objectTypes["object"] && exports && !exports.nodeType ? exports : null;
    var freeModule = objectTypes["object"] && module && !module.nodeType ? module : null;
    var freeGlobal = checkGlobal(freeExports && freeModule && typeof $parcel$global === 'object' && $parcel$global);
    var freeSelf = checkGlobal(objectTypes[typeof self] && self);
    var freeWindow = checkGlobal(objectTypes[typeof window] && window);
    var moduleExports = freeModule && freeModule.exports === freeExports ? freeExports : null;
    var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
    var root = freeGlobal || freeWindow !== (thisGlobal && thisGlobal.window) && freeWindow || freeSelf || thisGlobal || Function('return this')();
    var Rx = {
        internals: {},
        config: {
            Promise: root.Promise
        },
        helpers: {}
    };
    // Defaults
    var noop = Rx.helpers.noop = function() {}, identity = Rx.helpers.identity = function(x) {
        return x;
    }, defaultNow = Rx.helpers.defaultNow = Date.now, defaultComparer = Rx.helpers.defaultComparer = function(x, y) {
        return isEqual(x, y);
    }, defaultSubComparer = Rx.helpers.defaultSubComparer = function(x, y) {
        return x > y ? 1 : x < y ? -1 : 0;
    }, defaultKeySerializer = Rx.helpers.defaultKeySerializer = function(x) {
        return x.toString();
    }, defaultError = Rx.helpers.defaultError = function(err) {
        throw err;
    }, isPromise = Rx.helpers.isPromise = function(p) {
        return !!p && typeof p.subscribe !== 'function' && typeof p.then === 'function';
    }, isFunction = Rx.helpers.isFunction = function() {
        var isFn = function(value) {
            return typeof value == 'function' || false;
        };
        // fallback for older versions of Chrome and Safari
        if (isFn(/x/)) isFn = function(value) {
            return typeof value == 'function' && toString.call(value) == '[object Function]';
        };
        return isFn;
    }();
    function cloneArray(arr) {
        for(var a = [], i = 0, len = arr.length; i < len; i++)a.push(arr[i]);
        return a;
    }
    var errorObj = {
        e: {}
    };
    function tryCatcherGen(tryCatchTarget) {
        return function tryCatcher() {
            try {
                return tryCatchTarget.apply(this, arguments);
            } catch (e) {
                errorObj.e = e;
                return errorObj;
            }
        };
    }
    var tryCatch = Rx.internals.tryCatch = function tryCatch(fn) {
        if (!isFunction(fn)) throw new TypeError('fn must be a function');
        return tryCatcherGen(fn);
    };
    function thrower(e) {
        throw e;
    }
    Rx.config.longStackSupport = false;
    var hasStacks = false, stacks = tryCatch(function() {
        throw new Error();
    })();
    hasStacks = !!stacks.e && !!stacks.e.stack;
    // All code after this point will be filtered from stack traces reported by RxJS
    var rStartingLine = captureLine(), rFileName;
    var STACK_JUMP_SEPARATOR = 'From previous event:';
    function makeStackTraceLong(error, observable) {
        // If possible, transform the error stack trace by removing Node and RxJS
        // cruft, then concatenating with the stack trace of `observable`.
        if (hasStacks && observable.stack && typeof error === 'object' && error !== null && error.stack && error.stack.indexOf(STACK_JUMP_SEPARATOR) === -1) {
            var stacks = [];
            for(var o = observable; !!o; o = o.source)if (o.stack) stacks.unshift(o.stack);
            stacks.unshift(error.stack);
            var concatedStacks = stacks.join('\n' + STACK_JUMP_SEPARATOR + '\n');
            error.stack = filterStackString(concatedStacks);
        }
    }
    function filterStackString(stackString) {
        var lines = stackString.split('\n'), desiredLines = [];
        for(var i = 0, len = lines.length; i < len; i++){
            var line = lines[i];
            if (!isInternalFrame(line) && !isNodeFrame(line) && line) desiredLines.push(line);
        }
        return desiredLines.join('\n');
    }
    function isInternalFrame(stackLine) {
        var fileNameAndLineNumber = getFileNameAndLineNumber(stackLine);
        if (!fileNameAndLineNumber) return false;
        var fileName = fileNameAndLineNumber[0], lineNumber = fileNameAndLineNumber[1];
        return fileName === rFileName && lineNumber >= rStartingLine && lineNumber <= rEndingLine;
    }
    function isNodeFrame(stackLine) {
        return stackLine.indexOf('(module.js:') !== -1 || stackLine.indexOf('(node.js:') !== -1;
    }
    function captureLine() {
        if (!hasStacks) return;
        try {
            throw new Error();
        } catch (e) {
            var lines = e.stack.split('\n');
            var firstLine = lines[0].indexOf('@') > 0 ? lines[1] : lines[2];
            var fileNameAndLineNumber = getFileNameAndLineNumber(firstLine);
            if (!fileNameAndLineNumber) return;
            rFileName = fileNameAndLineNumber[0];
            return fileNameAndLineNumber[1];
        }
    }
    function getFileNameAndLineNumber(stackLine) {
        // Named functions: 'at functionName (filename:lineNumber:columnNumber)'
        var attempt1 = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(stackLine);
        if (attempt1) return [
            attempt1[1],
            Number(attempt1[2])
        ];
        // Anonymous functions: 'at filename:lineNumber:columnNumber'
        var attempt2 = /at ([^ ]+):(\d+):(?:\d+)$/.exec(stackLine);
        if (attempt2) return [
            attempt2[1],
            Number(attempt2[2])
        ];
        // Firefox style: 'function@filename:lineNumber or @filename:lineNumber'
        var attempt3 = /.*@(.+):(\d+)$/.exec(stackLine);
        if (attempt3) return [
            attempt3[1],
            Number(attempt3[2])
        ];
    }
    var EmptyError = Rx.EmptyError = function() {
        this.message = 'Sequence contains no elements.';
        Error.call(this);
    };
    EmptyError.prototype = Object.create(Error.prototype);
    EmptyError.prototype.name = 'EmptyError';
    var ObjectDisposedError = Rx.ObjectDisposedError = function() {
        this.message = 'Object has been disposed';
        Error.call(this);
    };
    ObjectDisposedError.prototype = Object.create(Error.prototype);
    ObjectDisposedError.prototype.name = 'ObjectDisposedError';
    var ArgumentOutOfRangeError = Rx.ArgumentOutOfRangeError = function() {
        this.message = 'Argument out of range';
        Error.call(this);
    };
    ArgumentOutOfRangeError.prototype = Object.create(Error.prototype);
    ArgumentOutOfRangeError.prototype.name = 'ArgumentOutOfRangeError';
    var NotSupportedError = Rx.NotSupportedError = function(message) {
        this.message = message || 'This operation is not supported';
        Error.call(this);
    };
    NotSupportedError.prototype = Object.create(Error.prototype);
    NotSupportedError.prototype.name = 'NotSupportedError';
    var NotImplementedError = Rx.NotImplementedError = function(message) {
        this.message = message || 'This operation is not implemented';
        Error.call(this);
    };
    NotImplementedError.prototype = Object.create(Error.prototype);
    NotImplementedError.prototype.name = 'NotImplementedError';
    var notImplemented = Rx.helpers.notImplemented = function() {
        throw new NotImplementedError();
    };
    var notSupported = Rx.helpers.notSupported = function() {
        throw new NotSupportedError();
    };
    // Shim in iterator support
    var $iterator$ = typeof Symbol === 'function' && Symbol.iterator || '_es6shim_iterator_';
    // Bug for mozilla version
    if (root.Set && typeof new root.Set()['@@iterator'] === 'function') $iterator$ = '@@iterator';
    var doneEnumerator = Rx.doneEnumerator = {
        done: true,
        value: undefined
    };
    var isIterable = Rx.helpers.isIterable = function(o) {
        return o && o[$iterator$] !== undefined;
    };
    var isArrayLike = Rx.helpers.isArrayLike = function(o) {
        return o && o.length !== undefined;
    };
    Rx.helpers.iterator = $iterator$;
    var bindCallback = Rx.internals.bindCallback = function(func, thisArg, argCount) {
        if (typeof thisArg === 'undefined') return func;
        switch(argCount){
            case 0:
                return function() {
                    return func.call(thisArg);
                };
            case 1:
                return function(arg) {
                    return func.call(thisArg, arg);
                };
            case 2:
                return function(value, index) {
                    return func.call(thisArg, value, index);
                };
            case 3:
                return function(value, index, collection) {
                    return func.call(thisArg, value, index, collection);
                };
        }
        return function() {
            return func.apply(thisArg, arguments);
        };
    };
    /** Used to determine if values are of the language type Object */ var dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ], dontEnumsLength = dontEnums.length;
    var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
    var arrayBufferTag = '[object ArrayBuffer]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var objectProto = Object.prototype, hasOwnProperty = objectProto.hasOwnProperty, objToString = objectProto.toString, MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;
    var keys = Object.keys || function() {
        var hasOwnProperty = Object.prototype.hasOwnProperty, hasDontEnumBug = !({
            toString: null
        }).propertyIsEnumerable('toString'), dontEnums = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor'
        ], dontEnumsLength = dontEnums.length;
        return function(obj) {
            if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) throw new TypeError('Object.keys called on non-object');
            var result = [], prop, i;
            for(prop in obj)if (hasOwnProperty.call(obj, prop)) result.push(prop);
            if (hasDontEnumBug) {
                for(i = 0; i < dontEnumsLength; i++)if (hasOwnProperty.call(obj, dontEnums[i])) result.push(dontEnums[i]);
            }
            return result;
        };
    }();
    function equalObjects(object, other, equalFunc, isLoose, stackA, stackB) {
        var objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
        if (objLength !== othLength && !isLoose) return false;
        var index = objLength, key;
        while(index--){
            key = objProps[index];
            if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) return false;
        }
        var skipCtor = isLoose;
        while(++index < objLength){
            key = objProps[index];
            var objValue = object[key], othValue = other[key], result;
            if (!(result === undefined ? equalFunc(objValue, othValue, isLoose, stackA, stackB) : result)) return false;
            skipCtor || (skipCtor = key === 'constructor');
        }
        if (!skipCtor) {
            var objCtor = object.constructor, othCtor = other.constructor;
            if (objCtor !== othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor === 'function' && objCtor instanceof objCtor && typeof othCtor === 'function' && othCtor instanceof othCtor)) return false;
        }
        return true;
    }
    function equalByTag(object, other, tag) {
        switch(tag){
            case boolTag:
            case dateTag:
                return +object === +other;
            case errorTag:
                return object.name === other.name && object.message === other.message;
            case numberTag:
                return object !== +object ? other !== +other : object === +other;
            case regexpTag:
            case stringTag:
                return object === other + '';
        }
        return false;
    }
    var isObject = Rx.internals.isObject = function(value) {
        var type = typeof value;
        return !!value && (type === 'object' || type === 'function');
    };
    function isObjectLike(value) {
        return !!value && typeof value === 'object';
    }
    function isLength(value) {
        return typeof value === 'number' && value > -1 && value % 1 === 0 && value <= MAX_SAFE_INTEGER;
    }
    var isHostObject = function() {
        try {
            Object({
                'toString': 0
            } + '');
        } catch (e) {
            return function() {
                return false;
            };
        }
        return function(value) {
            return typeof value.toString !== 'function' && typeof (value + '') === 'string';
        };
    }();
    function isTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
    }
    var isArray = Array.isArray || function(value) {
        return isObjectLike(value) && isLength(value.length) && objToString.call(value) === arrayTag;
    };
    function arraySome(array, predicate) {
        var index = -1, length = array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    function equalArrays(array, other, equalFunc, isLoose, stackA, stackB) {
        var index = -1, arrLength = array.length, othLength = other.length;
        if (arrLength !== othLength && !(isLoose && othLength > arrLength)) return false;
        // Ignore non-index properties.
        while(++index < arrLength){
            var arrValue = array[index], othValue = other[index], result;
            if (result !== undefined) {
                if (result) continue;
                return false;
            }
            // Recursively compare arrays (susceptible to call stack limits).
            if (isLoose) {
                if (!arraySome(other, function(othValue) {
                    return arrValue === othValue || equalFunc(arrValue, othValue, isLoose, stackA, stackB);
                })) return false;
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, isLoose, stackA, stackB))) return false;
        }
        return true;
    }
    function baseIsEqualDeep(object, other, equalFunc, isLoose, stackA, stackB) {
        var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
        if (!objIsArr) {
            objTag = objToString.call(object);
            if (objTag === argsTag) objTag = objectTag;
            else if (objTag !== objectTag) objIsArr = isTypedArray(object);
        }
        if (!othIsArr) {
            othTag = objToString.call(other);
            if (othTag === argsTag) othTag = objectTag;
        }
        var objIsObj = objTag === objectTag && !isHostObject(object), othIsObj = othTag === objectTag && !isHostObject(other), isSameTag = objTag === othTag;
        if (isSameTag && !(objIsArr || objIsObj)) return equalByTag(object, other, objTag);
        if (!isLoose) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
            if (objIsWrapped || othIsWrapped) return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, isLoose, stackA, stackB);
        }
        if (!isSameTag) return false;
        // Assume cyclic values are equal.
        // For more information on detecting circular references see https://es5.github.io/#JO.
        stackA || (stackA = []);
        stackB || (stackB = []);
        var length = stackA.length;
        while(length--){
            if (stackA[length] === object) return stackB[length] === other;
        }
        // Add `object` and `other` to the stack of traversed objects.
        stackA.push(object);
        stackB.push(other);
        var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, isLoose, stackA, stackB);
        stackA.pop();
        stackB.pop();
        return result;
    }
    function baseIsEqual(value, other, isLoose, stackA, stackB) {
        if (value === other) return true;
        if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
        return baseIsEqualDeep(value, other, baseIsEqual, isLoose, stackA, stackB);
    }
    var isEqual = Rx.internals.isEqual = function(value, other) {
        return baseIsEqual(value, other);
    };
    var hasProp = {}.hasOwnProperty, slice = Array.prototype.slice;
    var inherits = Rx.internals.inherits = function(child, parent) {
        function __() {
            this.constructor = child;
        }
        __.prototype = parent.prototype;
        child.prototype = new __();
    };
    var addProperties = Rx.internals.addProperties = function(obj) {
        for(var sources = [], i = 1, len = arguments.length; i < len; i++)sources.push(arguments[i]);
        for(var idx = 0, ln = sources.length; idx < ln; idx++){
            var source = sources[idx];
            for(var prop in source)obj[prop] = source[prop];
        }
    };
    // Rx Utils
    var addRef = Rx.internals.addRef = function(xs, r) {
        return new AnonymousObservable(function(observer) {
            return new BinaryDisposable(r.getDisposable(), xs.subscribe(observer));
        });
    };
    function arrayInitialize(count, factory) {
        var a = new Array(count);
        for(var i = 0; i < count; i++)a[i] = factory();
        return a;
    }
    /**
   * Represents a group of disposable resources that are disposed together.
   * @constructor
   */ var CompositeDisposable = Rx.CompositeDisposable = function() {
        var args = [], i, len;
        if (Array.isArray(arguments[0])) args = arguments[0];
        else {
            len = arguments.length;
            args = new Array(len);
            for(i = 0; i < len; i++)args[i] = arguments[i];
        }
        this.disposables = args;
        this.isDisposed = false;
        this.length = args.length;
    };
    var CompositeDisposablePrototype = CompositeDisposable.prototype;
    /**
   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
   * @param {Mixed} item Disposable to add.
   */ CompositeDisposablePrototype.add = function(item) {
        if (this.isDisposed) item.dispose();
        else {
            this.disposables.push(item);
            this.length++;
        }
    };
    /**
   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
   * @param {Mixed} item Disposable to remove.
   * @returns {Boolean} true if found; false otherwise.
   */ CompositeDisposablePrototype.remove = function(item) {
        var shouldDispose = false;
        if (!this.isDisposed) {
            var idx = this.disposables.indexOf(item);
            if (idx !== -1) {
                shouldDispose = true;
                this.disposables.splice(idx, 1);
                this.length--;
                item.dispose();
            }
        }
        return shouldDispose;
    };
    /**
   *  Disposes all disposables in the group and removes them from the group.
   */ CompositeDisposablePrototype.dispose = function() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            var len = this.disposables.length, currentDisposables = new Array(len);
            for(var i = 0; i < len; i++)currentDisposables[i] = this.disposables[i];
            this.disposables = [];
            this.length = 0;
            for(i = 0; i < len; i++)currentDisposables[i].dispose();
        }
    };
    /**
   * Provides a set of static methods for creating Disposables.
   * @param {Function} dispose Action to run during the first call to dispose. The action is guaranteed to be run at most once.
   */ var Disposable = Rx.Disposable = function(action) {
        this.isDisposed = false;
        this.action = action || noop;
    };
    /** Performs the task of cleaning up resources. */ Disposable.prototype.dispose = function() {
        if (!this.isDisposed) {
            this.action();
            this.isDisposed = true;
        }
    };
    /**
   * Creates a disposable object that invokes the specified action when disposed.
   * @param {Function} dispose Action to run during the first call to dispose. The action is guaranteed to be run at most once.
   * @return {Disposable} The disposable object that runs the given action upon disposal.
   */ var disposableCreate = Disposable.create = function(action) {
        return new Disposable(action);
    };
    /**
   * Gets the disposable that does nothing when disposed.
   */ var disposableEmpty = Disposable.empty = {
        dispose: noop
    };
    /**
   * Validates whether the given object is a disposable
   * @param {Object} Object to test whether it has a dispose method
   * @returns {Boolean} true if a disposable object, else false.
   */ var isDisposable = Disposable.isDisposable = function(d) {
        return d && isFunction(d.dispose);
    };
    var checkDisposed = Disposable.checkDisposed = function(disposable) {
        if (disposable.isDisposed) throw new ObjectDisposedError();
    };
    var disposableFixup = Disposable._fixup = function(result) {
        return isDisposable(result) ? result : disposableEmpty;
    };
    // Single assignment
    var SingleAssignmentDisposable = Rx.SingleAssignmentDisposable = function() {
        this.isDisposed = false;
        this.current = null;
    };
    SingleAssignmentDisposable.prototype.getDisposable = function() {
        return this.current;
    };
    SingleAssignmentDisposable.prototype.setDisposable = function(value) {
        if (this.current) throw new Error('Disposable has already been assigned');
        var shouldDispose = this.isDisposed;
        !shouldDispose && (this.current = value);
        shouldDispose && value && value.dispose();
    };
    SingleAssignmentDisposable.prototype.dispose = function() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            var old = this.current;
            this.current = null;
            old && old.dispose();
        }
    };
    // Multiple assignment disposable
    var SerialDisposable = Rx.SerialDisposable = function() {
        this.isDisposed = false;
        this.current = null;
    };
    SerialDisposable.prototype.getDisposable = function() {
        return this.current;
    };
    SerialDisposable.prototype.setDisposable = function(value) {
        var shouldDispose = this.isDisposed;
        if (!shouldDispose) {
            var old = this.current;
            this.current = value;
        }
        old && old.dispose();
        shouldDispose && value && value.dispose();
    };
    SerialDisposable.prototype.dispose = function() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            var old = this.current;
            this.current = null;
        }
        old && old.dispose();
    };
    var BinaryDisposable = Rx.BinaryDisposable = function(first, second) {
        this._first = first;
        this._second = second;
        this.isDisposed = false;
    };
    BinaryDisposable.prototype.dispose = function() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            var old1 = this._first;
            this._first = null;
            old1 && old1.dispose();
            var old2 = this._second;
            this._second = null;
            old2 && old2.dispose();
        }
    };
    var NAryDisposable = Rx.NAryDisposable = function(disposables) {
        this._disposables = disposables;
        this.isDisposed = false;
    };
    NAryDisposable.prototype.dispose = function() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            for(var i = 0, len = this._disposables.length; i < len; i++)this._disposables[i].dispose();
            this._disposables.length = 0;
        }
    };
    /**
   * Represents a disposable resource that only disposes its underlying disposable resource when all dependent disposable objects have been disposed.
   */ var RefCountDisposable = Rx.RefCountDisposable = function() {
        function InnerDisposable(disposable) {
            this.disposable = disposable;
            this.disposable.count++;
            this.isInnerDisposed = false;
        }
        InnerDisposable.prototype.dispose = function() {
            if (!this.disposable.isDisposed && !this.isInnerDisposed) {
                this.isInnerDisposed = true;
                this.disposable.count--;
                if (this.disposable.count === 0 && this.disposable.isPrimaryDisposed) {
                    this.disposable.isDisposed = true;
                    this.disposable.underlyingDisposable.dispose();
                }
            }
        };
        /**
     * Initializes a new instance of the RefCountDisposable with the specified disposable.
     * @constructor
     * @param {Disposable} disposable Underlying disposable.
      */ function RefCountDisposable(disposable) {
            this.underlyingDisposable = disposable;
            this.isDisposed = false;
            this.isPrimaryDisposed = false;
            this.count = 0;
        }
        /**
     * Disposes the underlying disposable only when all dependent disposables have been disposed
     */ RefCountDisposable.prototype.dispose = function() {
            if (!this.isDisposed && !this.isPrimaryDisposed) {
                this.isPrimaryDisposed = true;
                if (this.count === 0) {
                    this.isDisposed = true;
                    this.underlyingDisposable.dispose();
                }
            }
        };
        /**
     * Returns a dependent disposable that when disposed decreases the refcount on the underlying disposable.
     * @returns {Disposable} A dependent disposable contributing to the reference count that manages the underlying disposable's lifetime.
     */ RefCountDisposable.prototype.getDisposable = function() {
            return this.isDisposed ? disposableEmpty : new InnerDisposable(this);
        };
        return RefCountDisposable;
    }();
    function ScheduledDisposable(scheduler, disposable) {
        this.scheduler = scheduler;
        this.disposable = disposable;
        this.isDisposed = false;
    }
    function scheduleItem(s, self1) {
        if (!self1.isDisposed) {
            self1.isDisposed = true;
            self1.disposable.dispose();
        }
    }
    ScheduledDisposable.prototype.dispose = function() {
        this.scheduler.schedule(this, scheduleItem);
    };
    var ScheduledItem = Rx.internals.ScheduledItem = function(scheduler, state, action, dueTime, comparer) {
        this.scheduler = scheduler;
        this.state = state;
        this.action = action;
        this.dueTime = dueTime;
        this.comparer = comparer || defaultSubComparer;
        this.disposable = new SingleAssignmentDisposable();
    };
    ScheduledItem.prototype.invoke = function() {
        this.disposable.setDisposable(this.invokeCore());
    };
    ScheduledItem.prototype.compareTo = function(other) {
        return this.comparer(this.dueTime, other.dueTime);
    };
    ScheduledItem.prototype.isCancelled = function() {
        return this.disposable.isDisposed;
    };
    ScheduledItem.prototype.invokeCore = function() {
        return disposableFixup(this.action(this.scheduler, this.state));
    };
    /** Provides a set of static properties to access commonly used schedulers. */ var Scheduler = Rx.Scheduler = function() {
        function Scheduler() {}
        /** Determines whether the given object is a scheduler */ Scheduler.isScheduler = function(s) {
            return s instanceof Scheduler;
        };
        var schedulerProto = Scheduler.prototype;
        /**
   * Schedules an action to be executed.
   * @param state State passed to the action to be executed.
   * @param {Function} action Action to be executed.
   * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
   */ schedulerProto.schedule = function(state, action) {
            throw new NotImplementedError();
        };
        /**
   * Schedules an action to be executed after dueTime.
   * @param state State passed to the action to be executed.
   * @param {Function} action Action to be executed.
   * @param {Number} dueTime Relative time after which to execute the action.
   * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
   */ schedulerProto.scheduleFuture = function(state, dueTime, action) {
            var dt = dueTime;
            dt instanceof Date && (dt = dt - this.now());
            dt = Scheduler.normalize(dt);
            if (dt === 0) return this.schedule(state, action);
            return this._scheduleFuture(state, dt, action);
        };
        schedulerProto._scheduleFuture = function(state, dueTime, action) {
            throw new NotImplementedError();
        };
        /** Gets the current time according to the local machine's system clock. */ Scheduler.now = defaultNow;
        /** Gets the current time according to the local machine's system clock. */ Scheduler.prototype.now = defaultNow;
        /**
     * Normalizes the specified TimeSpan value to a positive value.
     * @param {Number} timeSpan The time span value to normalize.
     * @returns {Number} The specified TimeSpan value if it is zero or positive; otherwise, 0
     */ Scheduler.normalize = function(timeSpan) {
            timeSpan < 0 && (timeSpan = 0);
            return timeSpan;
        };
        return Scheduler;
    }();
    var normalizeTime = Scheduler.normalize, isScheduler = Scheduler.isScheduler;
    (function(schedulerProto) {
        function invokeRecImmediate(scheduler, pair) {
            var state = pair[0], action = pair[1], group = new CompositeDisposable();
            action(state, innerAction);
            return group;
            function innerAction(state2) {
                var isAdded = false, isDone = false;
                var d = scheduler.schedule(state2, scheduleWork);
                if (!isDone) {
                    group.add(d);
                    isAdded = true;
                }
                function scheduleWork(_, state3) {
                    if (isAdded) group.remove(d);
                    else isDone = true;
                    action(state3, innerAction);
                    return disposableEmpty;
                }
            }
        }
        function invokeRecDate(scheduler, pair) {
            var state = pair[0], action = pair[1], group = new CompositeDisposable();
            action(state, innerAction);
            return group;
            function innerAction(state2, dueTime1) {
                var isAdded = false, isDone = false;
                var d = scheduler.scheduleFuture(state2, dueTime1, scheduleWork);
                if (!isDone) {
                    group.add(d);
                    isAdded = true;
                }
                function scheduleWork(_, state3) {
                    if (isAdded) group.remove(d);
                    else isDone = true;
                    action(state3, innerAction);
                    return disposableEmpty;
                }
            }
        }
        /**
     * Schedules an action to be executed recursively.
     * @param {Mixed} state State passed to the action to be executed.
     * @param {Function} action Action to execute recursively. The last parameter passed to the action is used to trigger recursive scheduling of the action, passing in recursive invocation state.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
     */ schedulerProto.scheduleRecursive = function(state, action) {
            return this.schedule([
                state,
                action
            ], invokeRecImmediate);
        };
        /**
     * Schedules an action to be executed recursively after a specified relative or absolute due time.
     * @param {Mixed} state State passed to the action to be executed.
     * @param {Function} action Action to execute recursively. The last parameter passed to the action is used to trigger recursive scheduling of the action, passing in the recursive due time and invocation state.
     * @param {Number | Date} dueTime Relative or absolute time after which to execute the action for the first time.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
     */ schedulerProto.scheduleRecursiveFuture = function(state, dueTime, action) {
            return this.scheduleFuture([
                state,
                action
            ], dueTime, invokeRecDate);
        };
    })(Scheduler.prototype);
    (function(schedulerProto) {
        /**
     * Schedules a periodic piece of work by dynamically discovering the scheduler's capabilities. The periodic task will be scheduled using window.setInterval for the base implementation.
     * @param {Mixed} state Initial state passed to the action upon the first iteration.
     * @param {Number} period Period for running the work periodically.
     * @param {Function} action Action to be executed, potentially updating the state.
     * @returns {Disposable} The disposable object used to cancel the scheduled recurring action (best effort).
     */ schedulerProto.schedulePeriodic = function(state, period, action) {
            if (typeof root.setInterval === 'undefined') throw new NotSupportedError();
            period = normalizeTime(period);
            var s = state, id = root.setInterval(function() {
                s = action(s);
            }, period);
            return disposableCreate(function() {
                root.clearInterval(id);
            });
        };
    })(Scheduler.prototype);
    (function(schedulerProto) {
        /**
     * Returns a scheduler that wraps the original scheduler, adding exception handling for scheduled actions.
     * @param {Function} handler Handler that's run if an exception is caught. The exception will be rethrown if the handler returns false.
     * @returns {Scheduler} Wrapper around the original scheduler, enforcing exception handling.
     */ schedulerProto.catchError = schedulerProto['catch'] = function(handler) {
            return new CatchScheduler(this, handler);
        };
    })(Scheduler.prototype);
    var SchedulePeriodicRecursive = Rx.internals.SchedulePeriodicRecursive = function() {
        function createTick(self1) {
            return function tick(command, recurse) {
                recurse(0, self1._period);
                var state = tryCatch(self1._action)(self1._state);
                if (state === errorObj) {
                    self1._cancel.dispose();
                    thrower(state.e);
                }
                self1._state = state;
            };
        }
        function SchedulePeriodicRecursive(scheduler, state, period, action) {
            this._scheduler = scheduler;
            this._state = state;
            this._period = period;
            this._action = action;
        }
        SchedulePeriodicRecursive.prototype.start = function() {
            var d = new SingleAssignmentDisposable();
            this._cancel = d;
            d.setDisposable(this._scheduler.scheduleRecursiveFuture(0, this._period, createTick(this)));
            return d;
        };
        return SchedulePeriodicRecursive;
    }();
    /** Gets a scheduler that schedules work immediately on the current thread. */ var ImmediateScheduler = function(__super__) {
        inherits(ImmediateScheduler, __super__);
        function ImmediateScheduler() {
            __super__.call(this);
        }
        ImmediateScheduler.prototype.schedule = function(state, action) {
            return disposableFixup(action(this, state));
        };
        return ImmediateScheduler;
    }(Scheduler);
    var immediateScheduler = Scheduler.immediate = new ImmediateScheduler();
    /**
   * Gets a scheduler that schedules work as soon as possible on the current thread.
   */ var CurrentThreadScheduler = function(__super__) {
        var queue;
        function runTrampoline() {
            while(queue.length > 0){
                var item = queue.dequeue();
                !item.isCancelled() && item.invoke();
            }
        }
        inherits(CurrentThreadScheduler, __super__);
        function CurrentThreadScheduler() {
            __super__.call(this);
        }
        CurrentThreadScheduler.prototype.schedule = function(state, action) {
            var si = new ScheduledItem(this, state, action, this.now());
            if (!queue) {
                queue = new PriorityQueue(4);
                queue.enqueue(si);
                var result = tryCatch(runTrampoline)();
                queue = null;
                if (result === errorObj) thrower(result.e);
            } else queue.enqueue(si);
            return si.disposable;
        };
        CurrentThreadScheduler.prototype.scheduleRequired = function() {
            return !queue;
        };
        return CurrentThreadScheduler;
    }(Scheduler);
    var currentThreadScheduler = Scheduler.currentThread = new CurrentThreadScheduler();
    var scheduleMethod, clearMethod;
    var localTimer = function() {
        var localSetTimeout, localClearTimeout = noop;
        if (!!root.setTimeout) {
            localSetTimeout = root.setTimeout;
            localClearTimeout = root.clearTimeout;
        } else if (!!root.WScript) localSetTimeout = function(fn, time) {
            root.WScript.Sleep(time);
            fn();
        };
        else throw new NotSupportedError();
        return {
            setTimeout: localSetTimeout,
            clearTimeout: localClearTimeout
        };
    }();
    var localSetTimeout = localTimer.setTimeout, localClearTimeout = localTimer.clearTimeout;
    (function() {
        var nextHandle = 1, tasksByHandle = {}, currentlyRunning = false;
        clearMethod = function(handle) {
            delete tasksByHandle[handle];
        };
        function runTask(handle) {
            if (currentlyRunning) localSetTimeout(function() {
                runTask(handle);
            }, 0);
            else {
                var task = tasksByHandle[handle];
                if (task) {
                    currentlyRunning = true;
                    var result = tryCatch(task)();
                    clearMethod(handle);
                    currentlyRunning = false;
                    if (result === errorObj) thrower(result.e);
                }
            }
        }
        var reNative = new RegExp('^' + String(toString).replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/toString| for [^\]]+/g, '.*?') + '$');
        var setImmediate = typeof (setImmediate = freeGlobal && moduleExports && freeGlobal.setImmediate) == 'function' && !reNative.test(setImmediate) && setImmediate;
        function postMessageSupported() {
            // Ensure not in a worker
            if (!root.postMessage || root.importScripts) return false;
            var isAsync = false, oldHandler = root.onmessage;
            // Test for async
            root.onmessage = function() {
                isAsync = true;
            };
            root.postMessage('', '*');
            root.onmessage = oldHandler;
            return isAsync;
        }
        // Use in order, setImmediate, nextTick, postMessage, MessageChannel, script readystatechanged, setTimeout
        if (isFunction(setImmediate)) scheduleMethod = function(action) {
            var id = nextHandle++;
            tasksByHandle[id] = action;
            setImmediate(function() {
                runTask(id);
            });
            return id;
        };
        else {
            if (postMessageSupported()) {
                var MSG_PREFIX = 'ms.rx.schedule' + Math.random();
                var onGlobalPostMessage = function(event) {
                    // Only if we're a match to avoid any other global events
                    if (typeof event.data === 'string' && event.data.substring(0, MSG_PREFIX.length) === MSG_PREFIX) runTask(event.data.substring(MSG_PREFIX.length));
                };
                root.addEventListener('message', onGlobalPostMessage, false);
                scheduleMethod = function(action) {
                    var id = nextHandle++;
                    tasksByHandle[id] = action;
                    root.postMessage(MSG_PREFIX + id, '*');
                    return id;
                };
            } else if (!!root.MessageChannel) {
                var channel = new root.MessageChannel();
                channel.port1.onmessage = function(e) {
                    runTask(e.data);
                };
                scheduleMethod = function(action) {
                    var id = nextHandle++;
                    tasksByHandle[id] = action;
                    channel.port2.postMessage(id);
                    return id;
                };
            } else if ('document' in root && 'onreadystatechange' in root.document.createElement('script')) scheduleMethod = function(action) {
                var scriptElement = root.document.createElement('script');
                var id = nextHandle++;
                tasksByHandle[id] = action;
                scriptElement.onreadystatechange = function() {
                    runTask(id);
                    scriptElement.onreadystatechange = null;
                    scriptElement.parentNode.removeChild(scriptElement);
                    scriptElement = null;
                };
                root.document.documentElement.appendChild(scriptElement);
                return id;
            };
            else scheduleMethod = function(action) {
                var id = nextHandle++;
                tasksByHandle[id] = action;
                localSetTimeout(function() {
                    runTask(id);
                }, 0);
                return id;
            };
        }
    })();
    /**
   * Gets a scheduler that schedules work via a timed callback based upon platform.
   */ var DefaultScheduler = function(__super__) {
        inherits(DefaultScheduler, __super__);
        function DefaultScheduler() {
            __super__.call(this);
        }
        function scheduleAction(disposable, action, scheduler, state) {
            return function schedule() {
                disposable.setDisposable(Disposable._fixup(action(scheduler, state)));
            };
        }
        function ClearDisposable(id) {
            this._id = id;
            this.isDisposed = false;
        }
        ClearDisposable.prototype.dispose = function() {
            if (!this.isDisposed) {
                this.isDisposed = true;
                clearMethod(this._id);
            }
        };
        function LocalClearDisposable(id) {
            this._id = id;
            this.isDisposed = false;
        }
        LocalClearDisposable.prototype.dispose = function() {
            if (!this.isDisposed) {
                this.isDisposed = true;
                localClearTimeout(this._id);
            }
        };
        DefaultScheduler.prototype.schedule = function(state, action) {
            var disposable = new SingleAssignmentDisposable(), id = scheduleMethod(scheduleAction(disposable, action, this, state));
            return new BinaryDisposable(disposable, new ClearDisposable(id));
        };
        DefaultScheduler.prototype._scheduleFuture = function(state, dueTime, action) {
            if (dueTime === 0) return this.schedule(state, action);
            var disposable = new SingleAssignmentDisposable(), id = localSetTimeout(scheduleAction(disposable, action, this, state), dueTime);
            return new BinaryDisposable(disposable, new LocalClearDisposable(id));
        };
        function scheduleLongRunning(state, action, disposable) {
            return function() {
                action(state, disposable);
            };
        }
        DefaultScheduler.prototype.scheduleLongRunning = function(state, action) {
            var disposable = disposableCreate(noop);
            scheduleMethod(scheduleLongRunning(state, action, disposable));
            return disposable;
        };
        return DefaultScheduler;
    }(Scheduler);
    var defaultScheduler = Scheduler['default'] = Scheduler.async = new DefaultScheduler();
    var CatchScheduler = function(__super__) {
        inherits(CatchScheduler, __super__);
        function CatchScheduler(scheduler, handler) {
            this._scheduler = scheduler;
            this._handler = handler;
            this._recursiveOriginal = null;
            this._recursiveWrapper = null;
            __super__.call(this);
        }
        CatchScheduler.prototype.schedule = function(state, action) {
            return this._scheduler.schedule(state, this._wrap(action));
        };
        CatchScheduler.prototype._scheduleFuture = function(state, dueTime, action) {
            return this._scheduler.schedule(state, dueTime, this._wrap(action));
        };
        CatchScheduler.prototype.now = function() {
            return this._scheduler.now();
        };
        CatchScheduler.prototype._clone = function(scheduler) {
            return new CatchScheduler(scheduler, this._handler);
        };
        CatchScheduler.prototype._wrap = function(action) {
            var parent = this;
            return function(self1, state) {
                var res = tryCatch(action)(parent._getRecursiveWrapper(self1), state);
                if (res === errorObj) {
                    if (!parent._handler(res.e)) thrower(res.e);
                    return disposableEmpty;
                }
                return disposableFixup(res);
            };
        };
        CatchScheduler.prototype._getRecursiveWrapper = function(scheduler) {
            if (this._recursiveOriginal !== scheduler) {
                this._recursiveOriginal = scheduler;
                var wrapper = this._clone(scheduler);
                wrapper._recursiveOriginal = scheduler;
                wrapper._recursiveWrapper = wrapper;
                this._recursiveWrapper = wrapper;
            }
            return this._recursiveWrapper;
        };
        CatchScheduler.prototype.schedulePeriodic = function(state, period, action) {
            var self1 = this, failed = false, d = new SingleAssignmentDisposable();
            d.setDisposable(this._scheduler.schedulePeriodic(state, period, function(state1) {
                if (failed) return null;
                var res = tryCatch(action)(state1);
                if (res === errorObj) {
                    failed = true;
                    if (!self1._handler(res.e)) thrower(res.e);
                    d.dispose();
                    return null;
                }
                return res;
            }));
            return d;
        };
        return CatchScheduler;
    }(Scheduler);
    function IndexedItem(id, value) {
        this.id = id;
        this.value = value;
    }
    IndexedItem.prototype.compareTo = function(other) {
        var c = this.value.compareTo(other.value);
        c === 0 && (c = this.id - other.id);
        return c;
    };
    var PriorityQueue = Rx.internals.PriorityQueue = function(capacity) {
        this.items = new Array(capacity);
        this.length = 0;
    };
    var priorityProto = PriorityQueue.prototype;
    priorityProto.isHigherPriority = function(left, right) {
        return this.items[left].compareTo(this.items[right]) < 0;
    };
    priorityProto.percolate = function(index) {
        if (index >= this.length || index < 0) return;
        var parent = index - 1 >> 1;
        if (parent < 0 || parent === index) return;
        if (this.isHigherPriority(index, parent)) {
            var temp = this.items[index];
            this.items[index] = this.items[parent];
            this.items[parent] = temp;
            this.percolate(parent);
        }
    };
    priorityProto.heapify = function(index) {
        +index || (index = 0);
        if (index >= this.length || index < 0) return;
        var left = 2 * index + 1, right = 2 * index + 2, first = index;
        if (left < this.length && this.isHigherPriority(left, first)) first = left;
        if (right < this.length && this.isHigherPriority(right, first)) first = right;
        if (first !== index) {
            var temp = this.items[index];
            this.items[index] = this.items[first];
            this.items[first] = temp;
            this.heapify(first);
        }
    };
    priorityProto.peek = function() {
        return this.items[0].value;
    };
    priorityProto.removeAt = function(index) {
        this.items[index] = this.items[--this.length];
        this.items[this.length] = undefined;
        this.heapify();
    };
    priorityProto.dequeue = function() {
        var result = this.peek();
        this.removeAt(0);
        return result;
    };
    priorityProto.enqueue = function(item) {
        var index = this.length++;
        this.items[index] = new IndexedItem(PriorityQueue.count++, item);
        this.percolate(index);
    };
    priorityProto.remove = function(item) {
        for(var i = 0; i < this.length; i++)if (this.items[i].value === item) {
            this.removeAt(i);
            return true;
        }
        return false;
    };
    PriorityQueue.count = 0;
    /**
   *  Represents a notification to an observer.
   */ var Notification = Rx.Notification = function() {
        function Notification() {}
        Notification.prototype._accept = function(onNext, onError, onCompleted) {
            throw new NotImplementedError();
        };
        Notification.prototype._acceptObserver = function(onNext, onError, onCompleted) {
            throw new NotImplementedError();
        };
        /**
     * Invokes the delegate corresponding to the notification or the observer's method corresponding to the notification and returns the produced result.
     * @param {Function | Observer} observerOrOnNext Function to invoke for an OnNext notification or Observer to invoke the notification on..
     * @param {Function} onError Function to invoke for an OnError notification.
     * @param {Function} onCompleted Function to invoke for an OnCompleted notification.
     * @returns {Any} Result produced by the observation.
     */ Notification.prototype.accept = function(observerOrOnNext, onError, onCompleted) {
            return observerOrOnNext && typeof observerOrOnNext === 'object' ? this._acceptObserver(observerOrOnNext) : this._accept(observerOrOnNext, onError, onCompleted);
        };
        /**
     * Returns an observable sequence with a single notification.
     *
     * @memberOf Notifications
     * @param {Scheduler} [scheduler] Scheduler to send out the notification calls on.
     * @returns {Observable} The observable sequence that surfaces the behavior of the notification upon subscription.
     */ Notification.prototype.toObservable = function(scheduler) {
            var self1 = this;
            isScheduler(scheduler) || (scheduler = immediateScheduler);
            return new AnonymousObservable(function(o) {
                return scheduler.schedule(self1, function(_, notification) {
                    notification._acceptObserver(o);
                    notification.kind === 'N' && o.onCompleted();
                });
            });
        };
        return Notification;
    }();
    var OnNextNotification = function(__super__) {
        inherits(OnNextNotification, __super__);
        function OnNextNotification(value) {
            this.value = value;
            this.kind = 'N';
        }
        OnNextNotification.prototype._accept = function(onNext) {
            return onNext(this.value);
        };
        OnNextNotification.prototype._acceptObserver = function(o) {
            return o.onNext(this.value);
        };
        OnNextNotification.prototype.toString = function() {
            return 'OnNext(' + this.value + ')';
        };
        return OnNextNotification;
    }(Notification);
    var OnErrorNotification = function(__super__) {
        inherits(OnErrorNotification, __super__);
        function OnErrorNotification(error) {
            this.error = error;
            this.kind = 'E';
        }
        OnErrorNotification.prototype._accept = function(onNext, onError) {
            return onError(this.error);
        };
        OnErrorNotification.prototype._acceptObserver = function(o) {
            return o.onError(this.error);
        };
        OnErrorNotification.prototype.toString = function() {
            return 'OnError(' + this.error + ')';
        };
        return OnErrorNotification;
    }(Notification);
    var OnCompletedNotification = function(__super__) {
        inherits(OnCompletedNotification, __super__);
        function OnCompletedNotification() {
            this.kind = 'C';
        }
        OnCompletedNotification.prototype._accept = function(onNext, onError, onCompleted) {
            return onCompleted();
        };
        OnCompletedNotification.prototype._acceptObserver = function(o) {
            return o.onCompleted();
        };
        OnCompletedNotification.prototype.toString = function() {
            return 'OnCompleted()';
        };
        return OnCompletedNotification;
    }(Notification);
    /**
   * Creates an object that represents an OnNext notification to an observer.
   * @param {Any} value The value contained in the notification.
   * @returns {Notification} The OnNext notification containing the value.
   */ var notificationCreateOnNext = Notification.createOnNext = function(value) {
        return new OnNextNotification(value);
    };
    /**
   * Creates an object that represents an OnError notification to an observer.
   * @param {Any} error The exception contained in the notification.
   * @returns {Notification} The OnError notification containing the exception.
   */ var notificationCreateOnError = Notification.createOnError = function(error) {
        return new OnErrorNotification(error);
    };
    /**
   * Creates an object that represents an OnCompleted notification to an observer.
   * @returns {Notification} The OnCompleted notification.
   */ var notificationCreateOnCompleted = Notification.createOnCompleted = function() {
        return new OnCompletedNotification();
    };
    /**
   * Supports push-style iteration over an observable sequence.
   */ var Observer = Rx.Observer = function() {};
    /**
   *  Creates a notification callback from an observer.
   * @returns The action that forwards its input notification to the underlying observer.
   */ Observer.prototype.toNotifier = function() {
        var observer = this;
        return function(n) {
            return n.accept(observer);
        };
    };
    /**
   *  Hides the identity of an observer.
   * @returns An observer that hides the identity of the specified observer.
   */ Observer.prototype.asObserver = function() {
        var self1 = this;
        return new AnonymousObserver(function(x) {
            self1.onNext(x);
        }, function(err) {
            self1.onError(err);
        }, function() {
            self1.onCompleted();
        });
    };
    /**
   *  Checks access to the observer for grammar violations. This includes checking for multiple OnError or OnCompleted calls, as well as reentrancy in any of the observer methods.
   *  If a violation is detected, an Error is thrown from the offending observer method call.
   * @returns An observer that checks callbacks invocations against the observer grammar and, if the checks pass, forwards those to the specified observer.
   */ Observer.prototype.checked = function() {
        return new CheckedObserver(this);
    };
    /**
   *  Creates an observer from the specified OnNext, along with optional OnError, and OnCompleted actions.
   * @param {Function} [onNext] Observer's OnNext action implementation.
   * @param {Function} [onError] Observer's OnError action implementation.
   * @param {Function} [onCompleted] Observer's OnCompleted action implementation.
   * @returns {Observer} The observer object implemented using the given actions.
   */ var observerCreate = Observer.create = function(onNext, onError, onCompleted) {
        onNext || (onNext = noop);
        onError || (onError = defaultError);
        onCompleted || (onCompleted = noop);
        return new AnonymousObserver(onNext, onError, onCompleted);
    };
    /**
   *  Creates an observer from a notification callback.
   * @param {Function} handler Action that handles a notification.
   * @returns The observer object that invokes the specified handler using a notification corresponding to each message it receives.
   */ Observer.fromNotifier = function(handler, thisArg) {
        var cb = bindCallback(handler, thisArg, 1);
        return new AnonymousObserver(function(x) {
            return cb(notificationCreateOnNext(x));
        }, function(e) {
            return cb(notificationCreateOnError(e));
        }, function() {
            return cb(notificationCreateOnCompleted());
        });
    };
    /**
   * Schedules the invocation of observer methods on the given scheduler.
   * @param {Scheduler} scheduler Scheduler to schedule observer messages on.
   * @returns {Observer} Observer whose messages are scheduled on the given scheduler.
   */ Observer.prototype.notifyOn = function(scheduler) {
        return new ObserveOnObserver(scheduler, this);
    };
    Observer.prototype.makeSafe = function(disposable) {
        return new AnonymousSafeObserver(this._onNext, this._onError, this._onCompleted, disposable);
    };
    /**
   * Abstract base class for implementations of the Observer class.
   * This base class enforces the grammar of observers where OnError and OnCompleted are terminal messages.
   */ var AbstractObserver = Rx.internals.AbstractObserver = function(__super__) {
        inherits(AbstractObserver, __super__);
        /**
     * Creates a new observer in a non-stopped state.
     */ function AbstractObserver() {
            this.isStopped = false;
        }
        // Must be implemented by other observers
        AbstractObserver.prototype.next = notImplemented;
        AbstractObserver.prototype.error = notImplemented;
        AbstractObserver.prototype.completed = notImplemented;
        /**
     * Notifies the observer of a new element in the sequence.
     * @param {Any} value Next element in the sequence.
     */ AbstractObserver.prototype.onNext = function(value) {
            !this.isStopped && this.next(value);
        };
        /**
     * Notifies the observer that an exception has occurred.
     * @param {Any} error The error that has occurred.
     */ AbstractObserver.prototype.onError = function(error) {
            if (!this.isStopped) {
                this.isStopped = true;
                this.error(error);
            }
        };
        /**
     * Notifies the observer of the end of the sequence.
     */ AbstractObserver.prototype.onCompleted = function() {
            if (!this.isStopped) {
                this.isStopped = true;
                this.completed();
            }
        };
        /**
     * Disposes the observer, causing it to transition to the stopped state.
     */ AbstractObserver.prototype.dispose = function() {
            this.isStopped = true;
        };
        AbstractObserver.prototype.fail = function(e) {
            if (!this.isStopped) {
                this.isStopped = true;
                this.error(e);
                return true;
            }
            return false;
        };
        return AbstractObserver;
    }(Observer);
    /**
   * Class to create an Observer instance from delegate-based implementations of the on* methods.
   */ var AnonymousObserver = Rx.AnonymousObserver = function(__super__) {
        inherits(AnonymousObserver, __super__);
        /**
     * Creates an observer from the specified OnNext, OnError, and OnCompleted actions.
     * @param {Any} onNext Observer's OnNext action implementation.
     * @param {Any} onError Observer's OnError action implementation.
     * @param {Any} onCompleted Observer's OnCompleted action implementation.
     */ function AnonymousObserver(onNext, onError, onCompleted) {
            __super__.call(this);
            this._onNext = onNext;
            this._onError = onError;
            this._onCompleted = onCompleted;
        }
        /**
     * Calls the onNext action.
     * @param {Any} value Next element in the sequence.
     */ AnonymousObserver.prototype.next = function(value) {
            this._onNext(value);
        };
        /**
     * Calls the onError action.
     * @param {Any} error The error that has occurred.
     */ AnonymousObserver.prototype.error = function(error) {
            this._onError(error);
        };
        /**
     *  Calls the onCompleted action.
     */ AnonymousObserver.prototype.completed = function() {
            this._onCompleted();
        };
        return AnonymousObserver;
    }(AbstractObserver);
    var CheckedObserver = function(__super__) {
        inherits(CheckedObserver, __super__);
        function CheckedObserver(observer) {
            __super__.call(this);
            this._observer = observer;
            this._state = 0; // 0 - idle, 1 - busy, 2 - done
        }
        var CheckedObserverPrototype = CheckedObserver.prototype;
        CheckedObserverPrototype.onNext = function(value) {
            this.checkAccess();
            var res = tryCatch(this._observer.onNext).call(this._observer, value);
            this._state = 0;
            res === errorObj && thrower(res.e);
        };
        CheckedObserverPrototype.onError = function(err) {
            this.checkAccess();
            var res = tryCatch(this._observer.onError).call(this._observer, err);
            this._state = 2;
            res === errorObj && thrower(res.e);
        };
        CheckedObserverPrototype.onCompleted = function() {
            this.checkAccess();
            var res = tryCatch(this._observer.onCompleted).call(this._observer);
            this._state = 2;
            res === errorObj && thrower(res.e);
        };
        CheckedObserverPrototype.checkAccess = function() {
            if (this._state === 1) throw new Error('Re-entrancy detected');
            if (this._state === 2) throw new Error('Observer completed');
            if (this._state === 0) this._state = 1;
        };
        return CheckedObserver;
    }(Observer);
    var ScheduledObserver = Rx.internals.ScheduledObserver = function(__super__) {
        inherits(ScheduledObserver, __super__);
        function ScheduledObserver(scheduler, observer) {
            __super__.call(this);
            this.scheduler = scheduler;
            this.observer = observer;
            this.isAcquired = false;
            this.hasFaulted = false;
            this.queue = [];
            this.disposable = new SerialDisposable();
        }
        function enqueueNext(observer, x) {
            return function() {
                observer.onNext(x);
            };
        }
        function enqueueError(observer, e) {
            return function() {
                observer.onError(e);
            };
        }
        function enqueueCompleted(observer) {
            return function() {
                observer.onCompleted();
            };
        }
        ScheduledObserver.prototype.next = function(x) {
            this.queue.push(enqueueNext(this.observer, x));
        };
        ScheduledObserver.prototype.error = function(e) {
            this.queue.push(enqueueError(this.observer, e));
        };
        ScheduledObserver.prototype.completed = function() {
            this.queue.push(enqueueCompleted(this.observer));
        };
        function scheduleMethod(state, recurse) {
            var work;
            if (state.queue.length > 0) work = state.queue.shift();
            else {
                state.isAcquired = false;
                return;
            }
            var res = tryCatch(work)();
            if (res === errorObj) {
                state.queue = [];
                state.hasFaulted = true;
                return thrower(res.e);
            }
            recurse(state);
        }
        ScheduledObserver.prototype.ensureActive = function() {
            var isOwner = false;
            if (!this.hasFaulted && this.queue.length > 0) {
                isOwner = !this.isAcquired;
                this.isAcquired = true;
            }
            isOwner && this.disposable.setDisposable(this.scheduler.scheduleRecursive(this, scheduleMethod));
        };
        ScheduledObserver.prototype.dispose = function() {
            __super__.prototype.dispose.call(this);
            this.disposable.dispose();
        };
        return ScheduledObserver;
    }(AbstractObserver);
    var ObserveOnObserver = function(__super__) {
        inherits(ObserveOnObserver, __super__);
        function ObserveOnObserver(scheduler, observer, cancel) {
            __super__.call(this, scheduler, observer);
            this._cancel = cancel;
        }
        ObserveOnObserver.prototype.next = function(value) {
            __super__.prototype.next.call(this, value);
            this.ensureActive();
        };
        ObserveOnObserver.prototype.error = function(e) {
            __super__.prototype.error.call(this, e);
            this.ensureActive();
        };
        ObserveOnObserver.prototype.completed = function() {
            __super__.prototype.completed.call(this);
            this.ensureActive();
        };
        ObserveOnObserver.prototype.dispose = function() {
            __super__.prototype.dispose.call(this);
            this._cancel && this._cancel.dispose();
            this._cancel = null;
        };
        return ObserveOnObserver;
    }(ScheduledObserver);
    var observableProto;
    /**
   * Represents a push-style collection.
   */ var Observable = Rx.Observable = function() {
        function makeSubscribe(self1, subscribe) {
            return function(o) {
                var oldOnError = o.onError;
                o.onError = function(e) {
                    makeStackTraceLong(e, self1);
                    oldOnError.call(o, e);
                };
                return subscribe.call(self1, o);
            };
        }
        function Observable() {
            if (Rx.config.longStackSupport && hasStacks) {
                var oldSubscribe = this._subscribe;
                var e = tryCatch(thrower)(new Error()).e;
                this.stack = e.stack.substring(e.stack.indexOf('\n') + 1);
                this._subscribe = makeSubscribe(this, oldSubscribe);
            }
        }
        observableProto = Observable.prototype;
        /**
    * Determines whether the given object is an Observable
    * @param {Any} An object to determine whether it is an Observable
    * @returns {Boolean} true if an Observable, else false.
    */ Observable.isObservable = function(o) {
            return o && isFunction(o.subscribe);
        };
        /**
     *  Subscribes an o to the observable sequence.
     *  @param {Mixed} [oOrOnNext] The object that is to receive notifications or an action to invoke for each element in the observable sequence.
     *  @param {Function} [onError] Action to invoke upon exceptional termination of the observable sequence.
     *  @param {Function} [onCompleted] Action to invoke upon graceful termination of the observable sequence.
     *  @returns {Diposable} A disposable handling the subscriptions and unsubscriptions.
     */ observableProto.subscribe = observableProto.forEach = function(oOrOnNext, onError, onCompleted) {
            return this._subscribe(typeof oOrOnNext === 'object' ? oOrOnNext : observerCreate(oOrOnNext, onError, onCompleted));
        };
        /**
     * Subscribes to the next value in the sequence with an optional "this" argument.
     * @param {Function} onNext The function to invoke on each element in the observable sequence.
     * @param {Any} [thisArg] Object to use as this when executing callback.
     * @returns {Disposable} A disposable handling the subscriptions and unsubscriptions.
     */ observableProto.subscribeOnNext = function(onNext, thisArg) {
            return this._subscribe(observerCreate(typeof thisArg !== 'undefined' ? function(x) {
                onNext.call(thisArg, x);
            } : onNext));
        };
        /**
     * Subscribes to an exceptional condition in the sequence with an optional "this" argument.
     * @param {Function} onError The function to invoke upon exceptional termination of the observable sequence.
     * @param {Any} [thisArg] Object to use as this when executing callback.
     * @returns {Disposable} A disposable handling the subscriptions and unsubscriptions.
     */ observableProto.subscribeOnError = function(onError, thisArg) {
            return this._subscribe(observerCreate(null, typeof thisArg !== 'undefined' ? function(e) {
                onError.call(thisArg, e);
            } : onError));
        };
        /**
     * Subscribes to the next value in the sequence with an optional "this" argument.
     * @param {Function} onCompleted The function to invoke upon graceful termination of the observable sequence.
     * @param {Any} [thisArg] Object to use as this when executing callback.
     * @returns {Disposable} A disposable handling the subscriptions and unsubscriptions.
     */ observableProto.subscribeOnCompleted = function(onCompleted, thisArg) {
            return this._subscribe(observerCreate(null, null, typeof thisArg !== 'undefined' ? function() {
                onCompleted.call(thisArg);
            } : onCompleted));
        };
        return Observable;
    }();
    var ObservableBase = Rx.ObservableBase = function(__super__) {
        inherits(ObservableBase, __super__);
        function fixSubscriber(subscriber) {
            return subscriber && isFunction(subscriber.dispose) ? subscriber : isFunction(subscriber) ? disposableCreate(subscriber) : disposableEmpty;
        }
        function setDisposable(s, state) {
            var ado = state[0], self1 = state[1];
            var sub = tryCatch(self1.subscribeCore).call(self1, ado);
            if (sub === errorObj && !ado.fail(errorObj.e)) thrower(errorObj.e);
            ado.setDisposable(fixSubscriber(sub));
        }
        function ObservableBase() {
            __super__.call(this);
        }
        ObservableBase.prototype._subscribe = function(o) {
            var ado = new AutoDetachObserver(o), state = [
                ado,
                this
            ];
            if (currentThreadScheduler.scheduleRequired()) currentThreadScheduler.schedule(state, setDisposable);
            else setDisposable(null, state);
            return ado;
        };
        ObservableBase.prototype.subscribeCore = notImplemented;
        return ObservableBase;
    }(Observable);
    var FlatMapObservable = Rx.FlatMapObservable = function(__super__) {
        inherits(FlatMapObservable, __super__);
        function FlatMapObservable(source, selector, resultSelector, thisArg) {
            this.resultSelector = isFunction(resultSelector) ? resultSelector : null;
            this.selector = bindCallback(isFunction(selector) ? selector : function() {
                return selector;
            }, thisArg, 3);
            this.source = source;
            __super__.call(this);
        }
        FlatMapObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new InnerObserver(o, this.selector, this.resultSelector, this));
        };
        inherits(InnerObserver, AbstractObserver);
        function InnerObserver(observer, selector, resultSelector, source) {
            this.i = 0;
            this.selector = selector;
            this.resultSelector = resultSelector;
            this.source = source;
            this.o = observer;
            AbstractObserver.call(this);
        }
        InnerObserver.prototype._wrapResult = function(result, x, i) {
            return this.resultSelector ? result.map(function(y, i2) {
                return this.resultSelector(x, y, i, i2);
            }, this) : result;
        };
        InnerObserver.prototype.next = function(x) {
            var i = this.i++;
            var result = tryCatch(this.selector)(x, i, this.source);
            if (result === errorObj) return this.o.onError(result.e);
            isPromise(result) && (result = observableFromPromise(result));
            (isArrayLike(result) || isIterable(result)) && (result = Observable.from(result));
            this.o.onNext(this._wrapResult(result, x, i));
        };
        InnerObserver.prototype.error = function(e) {
            this.o.onError(e);
        };
        InnerObserver.prototype.completed = function() {
            this.o.onCompleted();
        };
        return FlatMapObservable;
    }(ObservableBase);
    var Enumerable = Rx.internals.Enumerable = function() {};
    function IsDisposedDisposable(state) {
        this._s = state;
        this.isDisposed = false;
    }
    IsDisposedDisposable.prototype.dispose = function() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            this._s.isDisposed = true;
        }
    };
    var ConcatEnumerableObservable = function(__super__) {
        inherits(ConcatEnumerableObservable, __super__);
        function ConcatEnumerableObservable(sources) {
            this.sources = sources;
            __super__.call(this);
        }
        function scheduleMethod(state, recurse) {
            if (state.isDisposed) return;
            var currentItem = tryCatch(state.e.next).call(state.e);
            if (currentItem === errorObj) return state.o.onError(currentItem.e);
            if (currentItem.done) return state.o.onCompleted();
            // Check if promise
            var currentValue = currentItem.value;
            isPromise(currentValue) && (currentValue = observableFromPromise(currentValue));
            var d = new SingleAssignmentDisposable();
            state.subscription.setDisposable(d);
            d.setDisposable(currentValue.subscribe(new InnerObserver(state, recurse)));
        }
        ConcatEnumerableObservable.prototype.subscribeCore = function(o) {
            var subscription = new SerialDisposable();
            var state = {
                isDisposed: false,
                o: o,
                subscription: subscription,
                e: this.sources[$iterator$]()
            };
            var cancelable = currentThreadScheduler.scheduleRecursive(state, scheduleMethod);
            return new NAryDisposable([
                subscription,
                cancelable,
                new IsDisposedDisposable(state)
            ]);
        };
        function InnerObserver(state, recurse) {
            this._state = state;
            this._recurse = recurse;
            AbstractObserver.call(this);
        }
        inherits(InnerObserver, AbstractObserver);
        InnerObserver.prototype.next = function(x) {
            this._state.o.onNext(x);
        };
        InnerObserver.prototype.error = function(e) {
            this._state.o.onError(e);
        };
        InnerObserver.prototype.completed = function() {
            this._recurse(this._state);
        };
        return ConcatEnumerableObservable;
    }(ObservableBase);
    Enumerable.prototype.concat = function() {
        return new ConcatEnumerableObservable(this);
    };
    var CatchErrorObservable = function(__super__) {
        function CatchErrorObservable(sources) {
            this.sources = sources;
            __super__.call(this);
        }
        inherits(CatchErrorObservable, __super__);
        function scheduleMethod(state, recurse) {
            if (state.isDisposed) return;
            var currentItem = tryCatch(state.e.next).call(state.e);
            if (currentItem === errorObj) return state.o.onError(currentItem.e);
            if (currentItem.done) return state.lastError !== null ? state.o.onError(state.lastError) : state.o.onCompleted();
            var currentValue = currentItem.value;
            isPromise(currentValue) && (currentValue = observableFromPromise(currentValue));
            var d = new SingleAssignmentDisposable();
            state.subscription.setDisposable(d);
            d.setDisposable(currentValue.subscribe(new InnerObserver(state, recurse)));
        }
        CatchErrorObservable.prototype.subscribeCore = function(o) {
            var subscription = new SerialDisposable();
            var state = {
                isDisposed: false,
                e: this.sources[$iterator$](),
                subscription: subscription,
                lastError: null,
                o: o
            };
            var cancelable = currentThreadScheduler.scheduleRecursive(state, scheduleMethod);
            return new NAryDisposable([
                subscription,
                cancelable,
                new IsDisposedDisposable(state)
            ]);
        };
        function InnerObserver(state, recurse) {
            this._state = state;
            this._recurse = recurse;
            AbstractObserver.call(this);
        }
        inherits(InnerObserver, AbstractObserver);
        InnerObserver.prototype.next = function(x) {
            this._state.o.onNext(x);
        };
        InnerObserver.prototype.error = function(e) {
            this._state.lastError = e;
            this._recurse(this._state);
        };
        InnerObserver.prototype.completed = function() {
            this._state.o.onCompleted();
        };
        return CatchErrorObservable;
    }(ObservableBase);
    Enumerable.prototype.catchError = function() {
        return new CatchErrorObservable(this);
    };
    var RepeatEnumerable = function(__super__) {
        inherits(RepeatEnumerable, __super__);
        function RepeatEnumerable(v, c) {
            this.v = v;
            this.c = c == null ? -1 : c;
        }
        RepeatEnumerable.prototype[$iterator$] = function() {
            return new RepeatEnumerator(this);
        };
        function RepeatEnumerator(p) {
            this.v = p.v;
            this.l = p.c;
        }
        RepeatEnumerator.prototype.next = function() {
            if (this.l === 0) return doneEnumerator;
            if (this.l > 0) this.l--;
            return {
                done: false,
                value: this.v
            };
        };
        return RepeatEnumerable;
    }(Enumerable);
    var enumerableRepeat = Enumerable.repeat = function(value, repeatCount) {
        return new RepeatEnumerable(value, repeatCount);
    };
    var OfEnumerable = function(__super__) {
        inherits(OfEnumerable, __super__);
        function OfEnumerable(s, fn, thisArg) {
            this.s = s;
            this.fn = fn ? bindCallback(fn, thisArg, 3) : null;
        }
        OfEnumerable.prototype[$iterator$] = function() {
            return new OfEnumerator(this);
        };
        function OfEnumerator(p) {
            this.i = -1;
            this.s = p.s;
            this.l = this.s.length;
            this.fn = p.fn;
        }
        OfEnumerator.prototype.next = function() {
            return ++this.i < this.l ? {
                done: false,
                value: !this.fn ? this.s[this.i] : this.fn(this.s[this.i], this.i, this.s)
            } : doneEnumerator;
        };
        return OfEnumerable;
    }(Enumerable);
    var enumerableOf = Enumerable.of = function(source, selector, thisArg) {
        return new OfEnumerable(source, selector, thisArg);
    };
    var ObserveOnObservable = function(__super__) {
        inherits(ObserveOnObservable, __super__);
        function ObserveOnObservable(source, s) {
            this.source = source;
            this._s = s;
            __super__.call(this);
        }
        ObserveOnObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new ObserveOnObserver(this._s, o));
        };
        return ObserveOnObservable;
    }(ObservableBase);
    /**
   *  Wraps the source sequence in order to run its observer callbacks on the specified scheduler.
   *
   *  This only invokes observer callbacks on a scheduler. In case the subscription and/or unsubscription actions have side-effects
   *  that require to be run on a scheduler, use subscribeOn.
   *
   *  @param {Scheduler} scheduler Scheduler to notify observers on.
   *  @returns {Observable} The source sequence whose observations happen on the specified scheduler.
   */ observableProto.observeOn = function(scheduler) {
        return new ObserveOnObservable(this, scheduler);
    };
    var SubscribeOnObservable = function(__super__) {
        inherits(SubscribeOnObservable, __super__);
        function SubscribeOnObservable(source, s) {
            this.source = source;
            this._s = s;
            __super__.call(this);
        }
        function scheduleMethod(scheduler, state) {
            var source = state[0], d = state[1], o = state[2];
            d.setDisposable(new ScheduledDisposable(scheduler, source.subscribe(o)));
        }
        SubscribeOnObservable.prototype.subscribeCore = function(o) {
            var m = new SingleAssignmentDisposable(), d = new SerialDisposable();
            d.setDisposable(m);
            m.setDisposable(this._s.schedule([
                this.source,
                d,
                o
            ], scheduleMethod));
            return d;
        };
        return SubscribeOnObservable;
    }(ObservableBase);
    /**
   *  Wraps the source sequence in order to run its subscription and unsubscription logic on the specified scheduler. This operation is not commonly used;
   *  see the remarks section for more information on the distinction between subscribeOn and observeOn.

   *  This only performs the side-effects of subscription and unsubscription on the specified scheduler. In order to invoke observer
   *  callbacks on a scheduler, use observeOn.

   *  @param {Scheduler} scheduler Scheduler to perform subscription and unsubscription actions on.
   *  @returns {Observable} The source sequence whose subscriptions and unsubscriptions happen on the specified scheduler.
   */ observableProto.subscribeOn = function(scheduler) {
        return new SubscribeOnObservable(this, scheduler);
    };
    var FromPromiseObservable = function(__super__) {
        inherits(FromPromiseObservable, __super__);
        function FromPromiseObservable(p, s) {
            this._p = p;
            this._s = s;
            __super__.call(this);
        }
        function scheduleNext(s, state) {
            var o = state[0], data = state[1];
            o.onNext(data);
            o.onCompleted();
        }
        function scheduleError(s, state) {
            var o = state[0], err = state[1];
            o.onError(err);
        }
        FromPromiseObservable.prototype.subscribeCore = function(o) {
            var sad = new SingleAssignmentDisposable(), self1 = this, p = this._p;
            if (isFunction(p)) {
                p = tryCatch(p)();
                if (p === errorObj) {
                    o.onError(p.e);
                    return sad;
                }
            }
            p.then(function(data) {
                sad.setDisposable(self1._s.schedule([
                    o,
                    data
                ], scheduleNext));
            }, function(err) {
                sad.setDisposable(self1._s.schedule([
                    o,
                    err
                ], scheduleError));
            });
            return sad;
        };
        return FromPromiseObservable;
    }(ObservableBase);
    /**
  * Converts a Promise to an Observable sequence
  * @param {Promise} An ES6 Compliant promise.
  * @returns {Observable} An Observable sequence which wraps the existing promise success and failure.
  */ var observableFromPromise = Observable.fromPromise = function(promise, scheduler) {
        scheduler || (scheduler = defaultScheduler);
        return new FromPromiseObservable(promise, scheduler);
    };
    /*
   * Converts an existing observable sequence to an ES6 Compatible Promise
   * @example
   * var promise = Rx.Observable.return(42).toPromise(RSVP.Promise);
   *
   * // With config
   * Rx.config.Promise = RSVP.Promise;
   * var promise = Rx.Observable.return(42).toPromise();
   * @param {Function} [promiseCtor] The constructor of the promise. If not provided, it looks for it in Rx.config.Promise.
   * @returns {Promise} An ES6 compatible promise with the last value from the observable sequence.
   */ observableProto.toPromise = function(promiseCtor) {
        promiseCtor || (promiseCtor = Rx.config.Promise);
        if (!promiseCtor) throw new NotSupportedError('Promise type not provided nor in Rx.config.Promise');
        var source = this;
        return new promiseCtor(function(resolve, reject) {
            // No cancellation can be done
            var value;
            source.subscribe(function(v) {
                value = v;
            }, reject, function() {
                resolve(value);
            });
        });
    };
    var ToArrayObservable = function(__super__) {
        inherits(ToArrayObservable, __super__);
        function ToArrayObservable(source) {
            this.source = source;
            __super__.call(this);
        }
        ToArrayObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new InnerObserver(o));
        };
        inherits(InnerObserver, AbstractObserver);
        function InnerObserver(o) {
            this.o = o;
            this.a = [];
            AbstractObserver.call(this);
        }
        InnerObserver.prototype.next = function(x) {
            this.a.push(x);
        };
        InnerObserver.prototype.error = function(e) {
            this.o.onError(e);
        };
        InnerObserver.prototype.completed = function() {
            this.o.onNext(this.a);
            this.o.onCompleted();
        };
        return ToArrayObservable;
    }(ObservableBase);
    /**
  * Creates an array from an observable sequence.
  * @returns {Observable} An observable sequence containing a single element with a list containing all the elements of the source sequence.
  */ observableProto.toArray = function() {
        return new ToArrayObservable(this);
    };
    /**
   *  Creates an observable sequence from a specified subscribe method implementation.
   * @example
   *  var res = Rx.Observable.create(function (observer) { return function () { } );
   *  var res = Rx.Observable.create(function (observer) { return Rx.Disposable.empty; } );
   *  var res = Rx.Observable.create(function (observer) { } );
   * @param {Function} subscribe Implementation of the resulting observable sequence's subscribe method, returning a function that will be wrapped in a Disposable.
   * @returns {Observable} The observable sequence with the specified implementation for the Subscribe method.
   */ Observable.create = function(subscribe, parent) {
        return new AnonymousObservable(subscribe, parent);
    };
    var Defer = function(__super__) {
        inherits(Defer, __super__);
        function Defer(factory) {
            this._f = factory;
            __super__.call(this);
        }
        Defer.prototype.subscribeCore = function(o) {
            var result = tryCatch(this._f)();
            if (result === errorObj) return observableThrow(result.e).subscribe(o);
            isPromise(result) && (result = observableFromPromise(result));
            return result.subscribe(o);
        };
        return Defer;
    }(ObservableBase);
    /**
   *  Returns an observable sequence that invokes the specified factory function whenever a new observer subscribes.
   *
   * @example
   *  var res = Rx.Observable.defer(function () { return Rx.Observable.fromArray([1,2,3]); });
   * @param {Function} observableFactory Observable factory function to invoke for each observer that subscribes to the resulting sequence or Promise.
   * @returns {Observable} An observable sequence whose observers trigger an invocation of the given observable factory function.
   */ var observableDefer = Observable.defer = function(observableFactory) {
        return new Defer(observableFactory);
    };
    var EmptyObservable = function(__super__) {
        inherits(EmptyObservable, __super__);
        function EmptyObservable(scheduler) {
            this.scheduler = scheduler;
            __super__.call(this);
        }
        EmptyObservable.prototype.subscribeCore = function(observer) {
            var sink = new EmptySink(observer, this.scheduler);
            return sink.run();
        };
        function EmptySink(observer, scheduler) {
            this.observer = observer;
            this.scheduler = scheduler;
        }
        function scheduleItem(s, state) {
            state.onCompleted();
            return disposableEmpty;
        }
        EmptySink.prototype.run = function() {
            var state = this.observer;
            return this.scheduler === immediateScheduler ? scheduleItem(null, state) : this.scheduler.schedule(state, scheduleItem);
        };
        return EmptyObservable;
    }(ObservableBase);
    var EMPTY_OBSERVABLE = new EmptyObservable(immediateScheduler);
    /**
   *  Returns an empty observable sequence, using the specified scheduler to send out the single OnCompleted message.
   *
   * @example
   *  var res = Rx.Observable.empty();
   *  var res = Rx.Observable.empty(Rx.Scheduler.timeout);
   * @param {Scheduler} [scheduler] Scheduler to send the termination call on.
   * @returns {Observable} An observable sequence with no elements.
   */ var observableEmpty = Observable.empty = function(scheduler) {
        isScheduler(scheduler) || (scheduler = immediateScheduler);
        return scheduler === immediateScheduler ? EMPTY_OBSERVABLE : new EmptyObservable(scheduler);
    };
    var FromObservable = function(__super__) {
        inherits(FromObservable, __super__);
        function FromObservable(iterable, fn, scheduler) {
            this._iterable = iterable;
            this._fn = fn;
            this._scheduler = scheduler;
            __super__.call(this);
        }
        function createScheduleMethod(o, it, fn) {
            return function loopRecursive(i, recurse) {
                var next = tryCatch(it.next).call(it);
                if (next === errorObj) return o.onError(next.e);
                if (next.done) return o.onCompleted();
                var result = next.value;
                if (isFunction(fn)) {
                    result = tryCatch(fn)(result, i);
                    if (result === errorObj) return o.onError(result.e);
                }
                o.onNext(result);
                recurse(i + 1);
            };
        }
        FromObservable.prototype.subscribeCore = function(o) {
            var list = Object(this._iterable), it = getIterable(list);
            return this._scheduler.scheduleRecursive(0, createScheduleMethod(o, it, this._fn));
        };
        return FromObservable;
    }(ObservableBase);
    var maxSafeInteger = Math.pow(2, 53) - 1;
    function StringIterable(s) {
        this._s = s;
    }
    StringIterable.prototype[$iterator$] = function() {
        return new StringIterator(this._s);
    };
    function StringIterator(s) {
        this._s = s;
        this._l = s.length;
        this._i = 0;
    }
    StringIterator.prototype[$iterator$] = function() {
        return this;
    };
    StringIterator.prototype.next = function() {
        return this._i < this._l ? {
            done: false,
            value: this._s.charAt(this._i++)
        } : doneEnumerator;
    };
    function ArrayIterable(a) {
        this._a = a;
    }
    ArrayIterable.prototype[$iterator$] = function() {
        return new ArrayIterator(this._a);
    };
    function ArrayIterator(a) {
        this._a = a;
        this._l = toLength(a);
        this._i = 0;
    }
    ArrayIterator.prototype[$iterator$] = function() {
        return this;
    };
    ArrayIterator.prototype.next = function() {
        return this._i < this._l ? {
            done: false,
            value: this._a[this._i++]
        } : doneEnumerator;
    };
    function numberIsFinite(value) {
        return typeof value === 'number' && root.isFinite(value);
    }
    function isNan(n) {
        return n !== n;
    }
    function getIterable(o) {
        var i = o[$iterator$], it;
        if (!i && typeof o === 'string') {
            it = new StringIterable(o);
            return it[$iterator$]();
        }
        if (!i && o.length !== undefined) {
            it = new ArrayIterable(o);
            return it[$iterator$]();
        }
        if (!i) throw new TypeError('Object is not iterable');
        return o[$iterator$]();
    }
    function sign(value) {
        var number = +value;
        if (number === 0) return number;
        if (isNaN(number)) return number;
        return number < 0 ? -1 : 1;
    }
    function toLength(o) {
        var len = +o.length;
        if (isNaN(len)) return 0;
        if (len === 0 || !numberIsFinite(len)) return len;
        len = sign(len) * Math.floor(Math.abs(len));
        if (len <= 0) return 0;
        if (len > maxSafeInteger) return maxSafeInteger;
        return len;
    }
    /**
  * This method creates a new Observable sequence from an array-like or iterable object.
  * @param {Any} arrayLike An array-like or iterable object to convert to an Observable sequence.
  * @param {Function} [mapFn] Map function to call on every element of the array.
  * @param {Any} [thisArg] The context to use calling the mapFn if provided.
  * @param {Scheduler} [scheduler] Optional scheduler to use for scheduling.  If not provided, defaults to Scheduler.currentThread.
  */ var observableFrom = Observable.from = function(iterable, mapFn, thisArg, scheduler) {
        if (iterable == null) throw new Error('iterable cannot be null.');
        if (mapFn && !isFunction(mapFn)) throw new Error('mapFn when provided must be a function');
        if (mapFn) var mapper = bindCallback(mapFn, thisArg, 2);
        isScheduler(scheduler) || (scheduler = currentThreadScheduler);
        return new FromObservable(iterable, mapper, scheduler);
    };
    var FromArrayObservable = function(__super__) {
        inherits(FromArrayObservable, __super__);
        function FromArrayObservable(args, scheduler) {
            this._args = args;
            this._scheduler = scheduler;
            __super__.call(this);
        }
        function scheduleMethod(o, args) {
            var len = args.length;
            return function loopRecursive(i, recurse) {
                if (i < len) {
                    o.onNext(args[i]);
                    recurse(i + 1);
                } else o.onCompleted();
            };
        }
        FromArrayObservable.prototype.subscribeCore = function(o) {
            return this._scheduler.scheduleRecursive(0, scheduleMethod(o, this._args));
        };
        return FromArrayObservable;
    }(ObservableBase);
    /**
  *  Converts an array to an observable sequence, using an optional scheduler to enumerate the array.
  * @deprecated use Observable.from or Observable.of
  * @param {Scheduler} [scheduler] Scheduler to run the enumeration of the input sequence on.
  * @returns {Observable} The observable sequence whose elements are pulled from the given enumerable sequence.
  */ var observableFromArray = Observable.fromArray = function(array, scheduler) {
        isScheduler(scheduler) || (scheduler = currentThreadScheduler);
        return new FromArrayObservable(array, scheduler);
    };
    var GenerateObservable = function(__super__) {
        inherits(GenerateObservable, __super__);
        function GenerateObservable(state, cndFn, itrFn, resFn, s) {
            this._initialState = state;
            this._cndFn = cndFn;
            this._itrFn = itrFn;
            this._resFn = resFn;
            this._s = s;
            __super__.call(this);
        }
        function scheduleRecursive(state, recurse) {
            if (state.first) state.first = false;
            else {
                state.newState = tryCatch(state.self._itrFn)(state.newState);
                if (state.newState === errorObj) return state.o.onError(state.newState.e);
            }
            var hasResult = tryCatch(state.self._cndFn)(state.newState);
            if (hasResult === errorObj) return state.o.onError(hasResult.e);
            if (hasResult) {
                var result = tryCatch(state.self._resFn)(state.newState);
                if (result === errorObj) return state.o.onError(result.e);
                state.o.onNext(result);
                recurse(state);
            } else state.o.onCompleted();
        }
        GenerateObservable.prototype.subscribeCore = function(o) {
            var state = {
                o: o,
                self: this,
                first: true,
                newState: this._initialState
            };
            return this._s.scheduleRecursive(state, scheduleRecursive);
        };
        return GenerateObservable;
    }(ObservableBase);
    /**
   *  Generates an observable sequence by running a state-driven loop producing the sequence's elements, using the specified scheduler to send out observer messages.
   *
   * @example
   *  var res = Rx.Observable.generate(0, function (x) { return x < 10; }, function (x) { return x + 1; }, function (x) { return x; });
   *  var res = Rx.Observable.generate(0, function (x) { return x < 10; }, function (x) { return x + 1; }, function (x) { return x; }, Rx.Scheduler.timeout);
   * @param {Mixed} initialState Initial state.
   * @param {Function} condition Condition to terminate generation (upon returning false).
   * @param {Function} iterate Iteration step function.
   * @param {Function} resultSelector Selector function for results produced in the sequence.
   * @param {Scheduler} [scheduler] Scheduler on which to run the generator loop. If not provided, defaults to Scheduler.currentThread.
   * @returns {Observable} The generated sequence.
   */ Observable.generate = function(initialState, condition, iterate, resultSelector, scheduler) {
        isScheduler(scheduler) || (scheduler = currentThreadScheduler);
        return new GenerateObservable(initialState, condition, iterate, resultSelector, scheduler);
    };
    var NeverObservable = function(__super__) {
        inherits(NeverObservable, __super__);
        function NeverObservable() {
            __super__.call(this);
        }
        NeverObservable.prototype.subscribeCore = function(observer) {
            return disposableEmpty;
        };
        return NeverObservable;
    }(ObservableBase);
    var NEVER_OBSERVABLE = new NeverObservable();
    /**
   * Returns a non-terminating observable sequence, which can be used to denote an infinite duration (e.g. when using reactive joins).
   * @returns {Observable} An observable sequence whose observers will never get called.
   */ var observableNever = Observable.never = function() {
        return NEVER_OBSERVABLE;
    };
    function observableOf(scheduler, array) {
        isScheduler(scheduler) || (scheduler = currentThreadScheduler);
        return new FromArrayObservable(array, scheduler);
    }
    /**
  *  This method creates a new Observable instance with a variable number of arguments, regardless of number or type of the arguments.
  * @returns {Observable} The observable sequence whose elements are pulled from the given arguments.
  */ Observable.of = function() {
        var len = arguments.length, args = new Array(len);
        for(var i = 0; i < len; i++)args[i] = arguments[i];
        return new FromArrayObservable(args, currentThreadScheduler);
    };
    /**
  *  This method creates a new Observable instance with a variable number of arguments, regardless of number or type of the arguments.
  * @param {Scheduler} scheduler A scheduler to use for scheduling the arguments.
  * @returns {Observable} The observable sequence whose elements are pulled from the given arguments.
  */ Observable.ofWithScheduler = function(scheduler) {
        var len = arguments.length, args = new Array(len - 1);
        for(var i = 1; i < len; i++)args[i - 1] = arguments[i];
        return new FromArrayObservable(args, scheduler);
    };
    var PairsObservable = function(__super__) {
        inherits(PairsObservable, __super__);
        function PairsObservable(o, scheduler) {
            this._o = o;
            this._keys = Object.keys(o);
            this._scheduler = scheduler;
            __super__.call(this);
        }
        function scheduleMethod(o, obj, keys) {
            return function loopRecursive(i, recurse) {
                if (i < keys.length) {
                    var key = keys[i];
                    o.onNext([
                        key,
                        obj[key]
                    ]);
                    recurse(i + 1);
                } else o.onCompleted();
            };
        }
        PairsObservable.prototype.subscribeCore = function(o) {
            return this._scheduler.scheduleRecursive(0, scheduleMethod(o, this._o, this._keys));
        };
        return PairsObservable;
    }(ObservableBase);
    /**
   * Convert an object into an observable sequence of [key, value] pairs.
   * @param {Object} obj The object to inspect.
   * @param {Scheduler} [scheduler] Scheduler to run the enumeration of the input sequence on.
   * @returns {Observable} An observable sequence of [key, value] pairs from the object.
   */ Observable.pairs = function(obj, scheduler) {
        scheduler || (scheduler = currentThreadScheduler);
        return new PairsObservable(obj, scheduler);
    };
    var RangeObservable = function(__super__) {
        inherits(RangeObservable, __super__);
        function RangeObservable(start, count, scheduler) {
            this.start = start;
            this.rangeCount = count;
            this.scheduler = scheduler;
            __super__.call(this);
        }
        function loopRecursive(start, count, o) {
            return function loop(i, recurse) {
                if (i < count) {
                    o.onNext(start + i);
                    recurse(i + 1);
                } else o.onCompleted();
            };
        }
        RangeObservable.prototype.subscribeCore = function(o) {
            return this.scheduler.scheduleRecursive(0, loopRecursive(this.start, this.rangeCount, o));
        };
        return RangeObservable;
    }(ObservableBase);
    /**
  *  Generates an observable sequence of integral numbers within a specified range, using the specified scheduler to send out observer messages.
  * @param {Number} start The value of the first integer in the sequence.
  * @param {Number} count The number of sequential integers to generate.
  * @param {Scheduler} [scheduler] Scheduler to run the generator loop on. If not specified, defaults to Scheduler.currentThread.
  * @returns {Observable} An observable sequence that contains a range of sequential integral numbers.
  */ Observable.range = function(start, count, scheduler) {
        isScheduler(scheduler) || (scheduler = currentThreadScheduler);
        return new RangeObservable(start, count, scheduler);
    };
    var RepeatObservable = function(__super__) {
        inherits(RepeatObservable, __super__);
        function RepeatObservable(value, repeatCount, scheduler) {
            this.value = value;
            this.repeatCount = repeatCount == null ? -1 : repeatCount;
            this.scheduler = scheduler;
            __super__.call(this);
        }
        RepeatObservable.prototype.subscribeCore = function(observer) {
            var sink = new RepeatSink(observer, this);
            return sink.run();
        };
        return RepeatObservable;
    }(ObservableBase);
    function RepeatSink(observer, parent) {
        this.observer = observer;
        this.parent = parent;
    }
    RepeatSink.prototype.run = function() {
        var observer = this.observer, value = this.parent.value;
        function loopRecursive(i, recurse) {
            if (i === -1 || i > 0) {
                observer.onNext(value);
                i > 0 && i--;
            }
            if (i === 0) return observer.onCompleted();
            recurse(i);
        }
        return this.parent.scheduler.scheduleRecursive(this.parent.repeatCount, loopRecursive);
    };
    /**
   *  Generates an observable sequence that repeats the given element the specified number of times, using the specified scheduler to send out observer messages.
   * @param {Mixed} value Element to repeat.
   * @param {Number} repeatCount [Optiona] Number of times to repeat the element. If not specified, repeats indefinitely.
   * @param {Scheduler} scheduler Scheduler to run the producer loop on. If not specified, defaults to Scheduler.immediate.
   * @returns {Observable} An observable sequence that repeats the given element the specified number of times.
   */ Observable.repeat = function(value, repeatCount, scheduler) {
        isScheduler(scheduler) || (scheduler = currentThreadScheduler);
        return new RepeatObservable(value, repeatCount, scheduler);
    };
    var JustObservable = function(__super__) {
        inherits(JustObservable, __super__);
        function JustObservable(value, scheduler) {
            this._value = value;
            this._scheduler = scheduler;
            __super__.call(this);
        }
        JustObservable.prototype.subscribeCore = function(o) {
            var state = [
                this._value,
                o
            ];
            return this._scheduler === immediateScheduler ? scheduleItem(null, state) : this._scheduler.schedule(state, scheduleItem);
        };
        function scheduleItem(s, state) {
            var value = state[0], observer = state[1];
            observer.onNext(value);
            observer.onCompleted();
            return disposableEmpty;
        }
        return JustObservable;
    }(ObservableBase);
    /**
   *  Returns an observable sequence that contains a single element, using the specified scheduler to send out observer messages.
   *  There is an alias called 'just' or browsers <IE9.
   * @param {Mixed} value Single element in the resulting observable sequence.
   * @param {Scheduler} scheduler Scheduler to send the single element on. If not specified, defaults to Scheduler.immediate.
   * @returns {Observable} An observable sequence containing the single specified element.
   */ var observableReturn = Observable['return'] = Observable.just = function(value, scheduler) {
        isScheduler(scheduler) || (scheduler = immediateScheduler);
        return new JustObservable(value, scheduler);
    };
    var ThrowObservable = function(__super__) {
        inherits(ThrowObservable, __super__);
        function ThrowObservable(error, scheduler) {
            this._error = error;
            this._scheduler = scheduler;
            __super__.call(this);
        }
        ThrowObservable.prototype.subscribeCore = function(o) {
            var state = [
                this._error,
                o
            ];
            return this._scheduler === immediateScheduler ? scheduleItem(null, state) : this._scheduler.schedule(state, scheduleItem);
        };
        function scheduleItem(s, state) {
            var e = state[0], o = state[1];
            o.onError(e);
            return disposableEmpty;
        }
        return ThrowObservable;
    }(ObservableBase);
    /**
   *  Returns an observable sequence that terminates with an exception, using the specified scheduler to send out the single onError message.
   *  There is an alias to this method called 'throwError' for browsers <IE9.
   * @param {Mixed} error An object used for the sequence's termination.
   * @param {Scheduler} scheduler Scheduler to send the exceptional termination call on. If not specified, defaults to Scheduler.immediate.
   * @returns {Observable} The observable sequence that terminates exceptionally with the specified exception object.
   */ var observableThrow = Observable['throw'] = function(error, scheduler) {
        isScheduler(scheduler) || (scheduler = immediateScheduler);
        return new ThrowObservable(error, scheduler);
    };
    var UsingObservable = function(__super__) {
        inherits(UsingObservable, __super__);
        function UsingObservable(resFn, obsFn) {
            this._resFn = resFn;
            this._obsFn = obsFn;
            __super__.call(this);
        }
        UsingObservable.prototype.subscribeCore = function(o) {
            var disposable = disposableEmpty;
            var resource = tryCatch(this._resFn)();
            if (resource === errorObj) return new BinaryDisposable(observableThrow(resource.e).subscribe(o), disposable);
            resource && (disposable = resource);
            var source = tryCatch(this._obsFn)(resource);
            if (source === errorObj) return new BinaryDisposable(observableThrow(source.e).subscribe(o), disposable);
            return new BinaryDisposable(source.subscribe(o), disposable);
        };
        return UsingObservable;
    }(ObservableBase);
    /**
   * Constructs an observable sequence that depends on a resource object, whose lifetime is tied to the resulting observable sequence's lifetime.
   * @param {Function} resourceFactory Factory function to obtain a resource object.
   * @param {Function} observableFactory Factory function to obtain an observable sequence that depends on the obtained resource.
   * @returns {Observable} An observable sequence whose lifetime controls the lifetime of the dependent resource object.
   */ Observable.using = function(resourceFactory, observableFactory) {
        return new UsingObservable(resourceFactory, observableFactory);
    };
    /**
   * Propagates the observable sequence or Promise that reacts first.
   * @param {Observable} rightSource Second observable sequence or Promise.
   * @returns {Observable} {Observable} An observable sequence that surfaces either of the given sequences, whichever reacted first.
   */ observableProto.amb = function(rightSource) {
        var leftSource = this;
        return new AnonymousObservable(function(observer) {
            var choice, leftChoice = 'L', rightChoice = 'R', leftSubscription = new SingleAssignmentDisposable(), rightSubscription = new SingleAssignmentDisposable();
            isPromise(rightSource) && (rightSource = observableFromPromise(rightSource));
            function choiceL() {
                if (!choice) {
                    choice = leftChoice;
                    rightSubscription.dispose();
                }
            }
            function choiceR() {
                if (!choice) {
                    choice = rightChoice;
                    leftSubscription.dispose();
                }
            }
            var leftSubscribe = observerCreate(function(left) {
                choiceL();
                choice === leftChoice && observer.onNext(left);
            }, function(e) {
                choiceL();
                choice === leftChoice && observer.onError(e);
            }, function() {
                choiceL();
                choice === leftChoice && observer.onCompleted();
            });
            var rightSubscribe = observerCreate(function(right) {
                choiceR();
                choice === rightChoice && observer.onNext(right);
            }, function(e) {
                choiceR();
                choice === rightChoice && observer.onError(e);
            }, function() {
                choiceR();
                choice === rightChoice && observer.onCompleted();
            });
            leftSubscription.setDisposable(leftSource.subscribe(leftSubscribe));
            rightSubscription.setDisposable(rightSource.subscribe(rightSubscribe));
            return new BinaryDisposable(leftSubscription, rightSubscription);
        });
    };
    function amb(p, c) {
        return p.amb(c);
    }
    /**
   * Propagates the observable sequence or Promise that reacts first.
   * @returns {Observable} An observable sequence that surfaces any of the given sequences, whichever reacted first.
   */ Observable.amb = function() {
        var acc = observableNever(), items;
        if (Array.isArray(arguments[0])) items = arguments[0];
        else {
            var len = arguments.length;
            items = new Array(items);
            for(var i = 0; i < len; i++)items[i] = arguments[i];
        }
        for(var i = 0, len = items.length; i < len; i++)acc = amb(acc, items[i]);
        return acc;
    };
    var CatchObservable = function(__super__) {
        inherits(CatchObservable, __super__);
        function CatchObservable(source, fn) {
            this.source = source;
            this._fn = fn;
            __super__.call(this);
        }
        CatchObservable.prototype.subscribeCore = function(o) {
            var d1 = new SingleAssignmentDisposable(), subscription = new SerialDisposable();
            subscription.setDisposable(d1);
            d1.setDisposable(this.source.subscribe(new CatchObserver(o, subscription, this._fn)));
            return subscription;
        };
        return CatchObservable;
    }(ObservableBase);
    var CatchObserver = function(__super__) {
        inherits(CatchObserver, __super__);
        function CatchObserver(o, s, fn) {
            this._o = o;
            this._s = s;
            this._fn = fn;
            __super__.call(this);
        }
        CatchObserver.prototype.next = function(x) {
            this._o.onNext(x);
        };
        CatchObserver.prototype.completed = function() {
            return this._o.onCompleted();
        };
        CatchObserver.prototype.error = function(e) {
            var result = tryCatch(this._fn)(e);
            if (result === errorObj) return this._o.onError(result.e);
            isPromise(result) && (result = observableFromPromise(result));
            var d = new SingleAssignmentDisposable();
            this._s.setDisposable(d);
            d.setDisposable(result.subscribe(this._o));
        };
        return CatchObserver;
    }(AbstractObserver);
    /**
   * Continues an observable sequence that is terminated by an exception with the next observable sequence.
   * @param {Mixed} handlerOrSecond Exception handler function that returns an observable sequence given the error that occurred in the first sequence, or a second observable sequence used to produce results when an error occurred in the first sequence.
   * @returns {Observable} An observable sequence containing the first sequence's elements, followed by the elements of the handler sequence in case an exception occurred.
   */ observableProto['catch'] = function(handlerOrSecond) {
        return isFunction(handlerOrSecond) ? new CatchObservable(this, handlerOrSecond) : observableCatch([
            this,
            handlerOrSecond
        ]);
    };
    /**
   * Continues an observable sequence that is terminated by an exception with the next observable sequence.
   * @param {Array | Arguments} args Arguments or an array to use as the next sequence if an error occurs.
   * @returns {Observable} An observable sequence containing elements from consecutive source sequences until a source sequence terminates successfully.
   */ var observableCatch = Observable['catch'] = function() {
        var items;
        if (Array.isArray(arguments[0])) items = arguments[0];
        else {
            var len = arguments.length;
            items = new Array(len);
            for(var i = 0; i < len; i++)items[i] = arguments[i];
        }
        return enumerableOf(items).catchError();
    };
    /**
   * Merges the specified observable sequences into one observable sequence by using the selector function whenever any of the observable sequences or Promises produces an element.
   * This can be in the form of an argument list of observables or an array.
   *
   * @example
   * 1 - obs = observable.combineLatest(obs1, obs2, obs3, function (o1, o2, o3) { return o1 + o2 + o3; });
   * 2 - obs = observable.combineLatest([obs1, obs2, obs3], function (o1, o2, o3) { return o1 + o2 + o3; });
   * @returns {Observable} An observable sequence containing the result of combining elements of the sources using the specified result selector function.
   */ observableProto.combineLatest = function() {
        var len = arguments.length, args = new Array(len);
        for(var i = 0; i < len; i++)args[i] = arguments[i];
        if (Array.isArray(args[0])) args[0].unshift(this);
        else args.unshift(this);
        return combineLatest.apply(this, args);
    };
    function falseFactory() {
        return false;
    }
    function argumentsToArray() {
        var len = arguments.length, args = new Array(len);
        for(var i = 0; i < len; i++)args[i] = arguments[i];
        return args;
    }
    var CombineLatestObservable = function(__super__) {
        inherits(CombineLatestObservable, __super__);
        function CombineLatestObservable(params, cb) {
            this._params = params;
            this._cb = cb;
            __super__.call(this);
        }
        CombineLatestObservable.prototype.subscribeCore = function(observer) {
            var len = this._params.length, subscriptions = new Array(len);
            var state = {
                hasValue: arrayInitialize(len, falseFactory),
                hasValueAll: false,
                isDone: arrayInitialize(len, falseFactory),
                values: new Array(len)
            };
            for(var i = 0; i < len; i++){
                var source = this._params[i], sad = new SingleAssignmentDisposable();
                subscriptions[i] = sad;
                isPromise(source) && (source = observableFromPromise(source));
                sad.setDisposable(source.subscribe(new CombineLatestObserver(observer, i, this._cb, state)));
            }
            return new NAryDisposable(subscriptions);
        };
        return CombineLatestObservable;
    }(ObservableBase);
    var CombineLatestObserver = function(__super__) {
        inherits(CombineLatestObserver, __super__);
        function CombineLatestObserver(o, i, cb, state) {
            this._o = o;
            this._i = i;
            this._cb = cb;
            this._state = state;
            __super__.call(this);
        }
        function notTheSame(i) {
            return function(x, j) {
                return j !== i;
            };
        }
        CombineLatestObserver.prototype.next = function(x) {
            this._state.values[this._i] = x;
            this._state.hasValue[this._i] = true;
            if (this._state.hasValueAll || (this._state.hasValueAll = this._state.hasValue.every(identity))) {
                var res = tryCatch(this._cb).apply(null, this._state.values);
                if (res === errorObj) return this._o.onError(res.e);
                this._o.onNext(res);
            } else if (this._state.isDone.filter(notTheSame(this._i)).every(identity)) this._o.onCompleted();
        };
        CombineLatestObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        CombineLatestObserver.prototype.completed = function() {
            this._state.isDone[this._i] = true;
            this._state.isDone.every(identity) && this._o.onCompleted();
        };
        return CombineLatestObserver;
    }(AbstractObserver);
    /**
  * Merges the specified observable sequences into one observable sequence by using the selector function whenever any of the observable sequences or Promises produces an element.
  *
  * @example
  * 1 - obs = Rx.Observable.combineLatest(obs1, obs2, obs3, function (o1, o2, o3) { return o1 + o2 + o3; });
  * 2 - obs = Rx.Observable.combineLatest([obs1, obs2, obs3], function (o1, o2, o3) { return o1 + o2 + o3; });
  * @returns {Observable} An observable sequence containing the result of combining elements of the sources using the specified result selector function.
  */ var combineLatest = Observable.combineLatest = function() {
        var len = arguments.length, args = new Array(len);
        for(var i = 0; i < len; i++)args[i] = arguments[i];
        var resultSelector = isFunction(args[len - 1]) ? args.pop() : argumentsToArray;
        Array.isArray(args[0]) && (args = args[0]);
        return new CombineLatestObservable(args, resultSelector);
    };
    /**
   * Concatenates all the observable sequences.  This takes in either an array or variable arguments to concatenate.
   * @returns {Observable} An observable sequence that contains the elements of each given sequence, in sequential order.
   */ observableProto.concat = function() {
        for(var args = [], i = 0, len = arguments.length; i < len; i++)args.push(arguments[i]);
        args.unshift(this);
        return observableConcat.apply(null, args);
    };
    var ConcatObserver = function(__super__) {
        inherits(ConcatObserver, __super__);
        function ConcatObserver(s, fn) {
            this._s = s;
            this._fn = fn;
            __super__.call(this);
        }
        ConcatObserver.prototype.next = function(x) {
            this._s.o.onNext(x);
        };
        ConcatObserver.prototype.error = function(e) {
            this._s.o.onError(e);
        };
        ConcatObserver.prototype.completed = function() {
            this._s.i++;
            this._fn(this._s);
        };
        return ConcatObserver;
    }(AbstractObserver);
    var ConcatObservable = function(__super__) {
        inherits(ConcatObservable, __super__);
        function ConcatObservable(sources) {
            this._sources = sources;
            __super__.call(this);
        }
        function scheduleRecursive(state, recurse) {
            if (state.disposable.isDisposed) return;
            if (state.i === state.sources.length) return state.o.onCompleted();
            // Check if promise
            var currentValue = state.sources[state.i];
            isPromise(currentValue) && (currentValue = observableFromPromise(currentValue));
            var d = new SingleAssignmentDisposable();
            state.subscription.setDisposable(d);
            d.setDisposable(currentValue.subscribe(new ConcatObserver(state, recurse)));
        }
        ConcatObservable.prototype.subscribeCore = function(o) {
            var subscription = new SerialDisposable();
            var disposable = disposableCreate(noop);
            var state = {
                o: o,
                i: 0,
                subscription: subscription,
                disposable: disposable,
                sources: this._sources
            };
            var cancelable = immediateScheduler.scheduleRecursive(state, scheduleRecursive);
            return new NAryDisposable([
                subscription,
                disposable,
                cancelable
            ]);
        };
        return ConcatObservable;
    }(ObservableBase);
    /**
   * Concatenates all the observable sequences.
   * @param {Array | Arguments} args Arguments or an array to concat to the observable sequence.
   * @returns {Observable} An observable sequence that contains the elements of each given sequence, in sequential order.
   */ var observableConcat = Observable.concat = function() {
        var args;
        if (Array.isArray(arguments[0])) args = arguments[0];
        else {
            args = new Array(arguments.length);
            for(var i = 0, len = arguments.length; i < len; i++)args[i] = arguments[i];
        }
        return new ConcatObservable(args);
    };
    /**
   * Concatenates an observable sequence of observable sequences.
   * @returns {Observable} An observable sequence that contains the elements of each observed inner sequence, in sequential order.
   */ observableProto.concatAll = function() {
        return this.merge(1);
    };
    var MergeObservable = function(__super__) {
        inherits(MergeObservable, __super__);
        function MergeObservable(source, maxConcurrent) {
            this.source = source;
            this.maxConcurrent = maxConcurrent;
            __super__.call(this);
        }
        MergeObservable.prototype.subscribeCore = function(observer) {
            var g = new CompositeDisposable();
            g.add(this.source.subscribe(new MergeObserver(observer, this.maxConcurrent, g)));
            return g;
        };
        return MergeObservable;
    }(ObservableBase);
    var MergeObserver = function(__super__) {
        function MergeObserver(o, max, g) {
            this.o = o;
            this.max = max;
            this.g = g;
            this.done = false;
            this.q = [];
            this.activeCount = 0;
            __super__.call(this);
        }
        inherits(MergeObserver, __super__);
        MergeObserver.prototype.handleSubscribe = function(xs) {
            var sad = new SingleAssignmentDisposable();
            this.g.add(sad);
            isPromise(xs) && (xs = observableFromPromise(xs));
            sad.setDisposable(xs.subscribe(new InnerObserver(this, sad)));
        };
        MergeObserver.prototype.next = function(innerSource) {
            if (this.activeCount < this.max) {
                this.activeCount++;
                this.handleSubscribe(innerSource);
            } else this.q.push(innerSource);
        };
        MergeObserver.prototype.error = function(e) {
            this.o.onError(e);
        };
        MergeObserver.prototype.completed = function() {
            this.done = true;
            this.activeCount === 0 && this.o.onCompleted();
        };
        function InnerObserver(parent, sad) {
            this.parent = parent;
            this.sad = sad;
            __super__.call(this);
        }
        inherits(InnerObserver, __super__);
        InnerObserver.prototype.next = function(x) {
            this.parent.o.onNext(x);
        };
        InnerObserver.prototype.error = function(e) {
            this.parent.o.onError(e);
        };
        InnerObserver.prototype.completed = function() {
            this.parent.g.remove(this.sad);
            if (this.parent.q.length > 0) this.parent.handleSubscribe(this.parent.q.shift());
            else {
                this.parent.activeCount--;
                this.parent.done && this.parent.activeCount === 0 && this.parent.o.onCompleted();
            }
        };
        return MergeObserver;
    }(AbstractObserver);
    /**
  * Merges an observable sequence of observable sequences into an observable sequence, limiting the number of concurrent subscriptions to inner sequences.
  * Or merges two observable sequences into a single observable sequence.
  * @param {Mixed} [maxConcurrentOrOther] Maximum number of inner observable sequences being subscribed to concurrently or the second observable sequence.
  * @returns {Observable} The observable sequence that merges the elements of the inner sequences.
  */ observableProto.merge = function(maxConcurrentOrOther) {
        return typeof maxConcurrentOrOther !== 'number' ? observableMerge(this, maxConcurrentOrOther) : new MergeObservable(this, maxConcurrentOrOther);
    };
    /**
   * Merges all the observable sequences into a single observable sequence.
   * The scheduler is optional and if not specified, the immediate scheduler is used.
   * @returns {Observable} The observable sequence that merges the elements of the observable sequences.
   */ var observableMerge = Observable.merge = function() {
        var scheduler, sources = [], i, len = arguments.length;
        if (!arguments[0]) {
            scheduler = immediateScheduler;
            for(i = 1; i < len; i++)sources.push(arguments[i]);
        } else if (isScheduler(arguments[0])) {
            scheduler = arguments[0];
            for(i = 1; i < len; i++)sources.push(arguments[i]);
        } else {
            scheduler = immediateScheduler;
            for(i = 0; i < len; i++)sources.push(arguments[i]);
        }
        if (Array.isArray(sources[0])) sources = sources[0];
        return observableOf(scheduler, sources).mergeAll();
    };
    var CompositeError = Rx.CompositeError = function(errors) {
        this.innerErrors = errors;
        this.message = 'This contains multiple errors. Check the innerErrors';
        Error.call(this);
    };
    CompositeError.prototype = Object.create(Error.prototype);
    CompositeError.prototype.name = 'CompositeError';
    var MergeDelayErrorObservable = function(__super__) {
        inherits(MergeDelayErrorObservable, __super__);
        function MergeDelayErrorObservable(source) {
            this.source = source;
            __super__.call(this);
        }
        MergeDelayErrorObservable.prototype.subscribeCore = function(o) {
            var group = new CompositeDisposable(), m = new SingleAssignmentDisposable(), state = {
                isStopped: false,
                errors: [],
                o: o
            };
            group.add(m);
            m.setDisposable(this.source.subscribe(new MergeDelayErrorObserver(group, state)));
            return group;
        };
        return MergeDelayErrorObservable;
    }(ObservableBase);
    var MergeDelayErrorObserver = function(__super__) {
        inherits(MergeDelayErrorObserver, __super__);
        function MergeDelayErrorObserver(group, state) {
            this._group = group;
            this._state = state;
            __super__.call(this);
        }
        function setCompletion(o, errors) {
            if (errors.length === 0) o.onCompleted();
            else if (errors.length === 1) o.onError(errors[0]);
            else o.onError(new CompositeError(errors));
        }
        MergeDelayErrorObserver.prototype.next = function(x) {
            var inner = new SingleAssignmentDisposable();
            this._group.add(inner);
            // Check for promises support
            isPromise(x) && (x = observableFromPromise(x));
            inner.setDisposable(x.subscribe(new InnerObserver(inner, this._group, this._state)));
        };
        MergeDelayErrorObserver.prototype.error = function(e) {
            this._state.errors.push(e);
            this._state.isStopped = true;
            this._group.length === 1 && setCompletion(this._state.o, this._state.errors);
        };
        MergeDelayErrorObserver.prototype.completed = function() {
            this._state.isStopped = true;
            this._group.length === 1 && setCompletion(this._state.o, this._state.errors);
        };
        inherits(InnerObserver, __super__);
        function InnerObserver(inner, group, state) {
            this._inner = inner;
            this._group = group;
            this._state = state;
            __super__.call(this);
        }
        InnerObserver.prototype.next = function(x) {
            this._state.o.onNext(x);
        };
        InnerObserver.prototype.error = function(e) {
            this._state.errors.push(e);
            this._group.remove(this._inner);
            this._state.isStopped && this._group.length === 1 && setCompletion(this._state.o, this._state.errors);
        };
        InnerObserver.prototype.completed = function() {
            this._group.remove(this._inner);
            this._state.isStopped && this._group.length === 1 && setCompletion(this._state.o, this._state.errors);
        };
        return MergeDelayErrorObserver;
    }(AbstractObserver);
    /**
  * Flattens an Observable that emits Observables into one Observable, in a way that allows an Observer to
  * receive all successfully emitted items from all of the source Observables without being interrupted by
  * an error notification from one of them.
  *
  * This behaves like Observable.prototype.mergeAll except that if any of the merged Observables notify of an
  * error via the Observer's onError, mergeDelayError will refrain from propagating that
  * error notification until all of the merged Observables have finished emitting items.
  * @param {Array | Arguments} args Arguments or an array to merge.
  * @returns {Observable} an Observable that emits all of the items emitted by the Observables emitted by the Observable
  */ Observable.mergeDelayError = function() {
        var args;
        if (Array.isArray(arguments[0])) args = arguments[0];
        else {
            var len = arguments.length;
            args = new Array(len);
            for(var i = 0; i < len; i++)args[i] = arguments[i];
        }
        var source = observableOf(null, args);
        return new MergeDelayErrorObservable(source);
    };
    var MergeAllObservable = function(__super__) {
        inherits(MergeAllObservable, __super__);
        function MergeAllObservable(source) {
            this.source = source;
            __super__.call(this);
        }
        MergeAllObservable.prototype.subscribeCore = function(o) {
            var g = new CompositeDisposable(), m = new SingleAssignmentDisposable();
            g.add(m);
            m.setDisposable(this.source.subscribe(new MergeAllObserver(o, g)));
            return g;
        };
        return MergeAllObservable;
    }(ObservableBase);
    var MergeAllObserver = function(__super__) {
        function MergeAllObserver(o, g) {
            this.o = o;
            this.g = g;
            this.done = false;
            __super__.call(this);
        }
        inherits(MergeAllObserver, __super__);
        MergeAllObserver.prototype.next = function(innerSource) {
            var sad = new SingleAssignmentDisposable();
            this.g.add(sad);
            isPromise(innerSource) && (innerSource = observableFromPromise(innerSource));
            sad.setDisposable(innerSource.subscribe(new InnerObserver(this, sad)));
        };
        MergeAllObserver.prototype.error = function(e) {
            this.o.onError(e);
        };
        MergeAllObserver.prototype.completed = function() {
            this.done = true;
            this.g.length === 1 && this.o.onCompleted();
        };
        function InnerObserver(parent, sad) {
            this.parent = parent;
            this.sad = sad;
            __super__.call(this);
        }
        inherits(InnerObserver, __super__);
        InnerObserver.prototype.next = function(x) {
            this.parent.o.onNext(x);
        };
        InnerObserver.prototype.error = function(e) {
            this.parent.o.onError(e);
        };
        InnerObserver.prototype.completed = function() {
            this.parent.g.remove(this.sad);
            this.parent.done && this.parent.g.length === 1 && this.parent.o.onCompleted();
        };
        return MergeAllObserver;
    }(AbstractObserver);
    /**
  * Merges an observable sequence of observable sequences into an observable sequence.
  * @returns {Observable} The observable sequence that merges the elements of the inner sequences.
  */ observableProto.mergeAll = function() {
        return new MergeAllObservable(this);
    };
    /**
   * Continues an observable sequence that is terminated normally or by an exception with the next observable sequence.
   * @param {Observable} second Second observable sequence used to produce results after the first sequence terminates.
   * @returns {Observable} An observable sequence that concatenates the first and second sequence, even if the first sequence terminates exceptionally.
   */ observableProto.onErrorResumeNext = function(second) {
        if (!second) throw new Error('Second observable is required');
        return onErrorResumeNext([
            this,
            second
        ]);
    };
    var OnErrorResumeNextObservable = function(__super__) {
        inherits(OnErrorResumeNextObservable, __super__);
        function OnErrorResumeNextObservable(sources) {
            this.sources = sources;
            __super__.call(this);
        }
        function scheduleMethod(state, recurse) {
            if (state.pos < state.sources.length) {
                var current = state.sources[state.pos++];
                isPromise(current) && (current = observableFromPromise(current));
                var d = new SingleAssignmentDisposable();
                state.subscription.setDisposable(d);
                d.setDisposable(current.subscribe(new OnErrorResumeNextObserver(state, recurse)));
            } else state.o.onCompleted();
        }
        OnErrorResumeNextObservable.prototype.subscribeCore = function(o) {
            var subscription = new SerialDisposable(), state = {
                pos: 0,
                subscription: subscription,
                o: o,
                sources: this.sources
            }, cancellable = immediateScheduler.scheduleRecursive(state, scheduleMethod);
            return new BinaryDisposable(subscription, cancellable);
        };
        return OnErrorResumeNextObservable;
    }(ObservableBase);
    var OnErrorResumeNextObserver = function(__super__) {
        inherits(OnErrorResumeNextObserver, __super__);
        function OnErrorResumeNextObserver(state, recurse) {
            this._state = state;
            this._recurse = recurse;
            __super__.call(this);
        }
        OnErrorResumeNextObserver.prototype.next = function(x) {
            this._state.o.onNext(x);
        };
        OnErrorResumeNextObserver.prototype.error = function() {
            this._recurse(this._state);
        };
        OnErrorResumeNextObserver.prototype.completed = function() {
            this._recurse(this._state);
        };
        return OnErrorResumeNextObserver;
    }(AbstractObserver);
    /**
   * Continues an observable sequence that is terminated normally or by an exception with the next observable sequence.
   * @returns {Observable} An observable sequence that concatenates the source sequences, even if a sequence terminates exceptionally.
   */ var onErrorResumeNext = Observable.onErrorResumeNext = function() {
        var sources = [];
        if (Array.isArray(arguments[0])) sources = arguments[0];
        else {
            var len = arguments.length;
            sources = new Array(len);
            for(var i = 0; i < len; i++)sources[i] = arguments[i];
        }
        return new OnErrorResumeNextObservable(sources);
    };
    var SkipUntilObservable = function(__super__) {
        inherits(SkipUntilObservable, __super__);
        function SkipUntilObservable(source, other) {
            this._s = source;
            this._o = isPromise(other) ? observableFromPromise(other) : other;
            this._open = false;
            __super__.call(this);
        }
        SkipUntilObservable.prototype.subscribeCore = function(o) {
            var leftSubscription = new SingleAssignmentDisposable();
            leftSubscription.setDisposable(this._s.subscribe(new SkipUntilSourceObserver(o, this)));
            isPromise(this._o) && (this._o = observableFromPromise(this._o));
            var rightSubscription = new SingleAssignmentDisposable();
            rightSubscription.setDisposable(this._o.subscribe(new SkipUntilOtherObserver(o, this, rightSubscription)));
            return new BinaryDisposable(leftSubscription, rightSubscription);
        };
        return SkipUntilObservable;
    }(ObservableBase);
    var SkipUntilSourceObserver = function(__super__) {
        inherits(SkipUntilSourceObserver, __super__);
        function SkipUntilSourceObserver(o, p) {
            this._o = o;
            this._p = p;
            __super__.call(this);
        }
        SkipUntilSourceObserver.prototype.next = function(x) {
            this._p._open && this._o.onNext(x);
        };
        SkipUntilSourceObserver.prototype.error = function(err) {
            this._o.onError(err);
        };
        SkipUntilSourceObserver.prototype.onCompleted = function() {
            this._p._open && this._o.onCompleted();
        };
        return SkipUntilSourceObserver;
    }(AbstractObserver);
    var SkipUntilOtherObserver = function(__super__) {
        inherits(SkipUntilOtherObserver, __super__);
        function SkipUntilOtherObserver(o, p, r) {
            this._o = o;
            this._p = p;
            this._r = r;
            __super__.call(this);
        }
        SkipUntilOtherObserver.prototype.next = function() {
            this._p._open = true;
            this._r.dispose();
        };
        SkipUntilOtherObserver.prototype.error = function(err) {
            this._o.onError(err);
        };
        SkipUntilOtherObserver.prototype.onCompleted = function() {
            this._r.dispose();
        };
        return SkipUntilOtherObserver;
    }(AbstractObserver);
    /**
   * Returns the values from the source observable sequence only after the other observable sequence produces a value.
   * @param {Observable | Promise} other The observable sequence or Promise that triggers propagation of elements of the source sequence.
   * @returns {Observable} An observable sequence containing the elements of the source sequence starting from the point the other sequence triggered propagation.
   */ observableProto.skipUntil = function(other) {
        return new SkipUntilObservable(this, other);
    };
    var SwitchObservable = function(__super__) {
        inherits(SwitchObservable, __super__);
        function SwitchObservable(source) {
            this.source = source;
            __super__.call(this);
        }
        SwitchObservable.prototype.subscribeCore = function(o) {
            var inner = new SerialDisposable(), s = this.source.subscribe(new SwitchObserver(o, inner));
            return new BinaryDisposable(s, inner);
        };
        inherits(SwitchObserver, AbstractObserver);
        function SwitchObserver(o, inner) {
            this.o = o;
            this.inner = inner;
            this.stopped = false;
            this.latest = 0;
            this.hasLatest = false;
            AbstractObserver.call(this);
        }
        SwitchObserver.prototype.next = function(innerSource) {
            var d = new SingleAssignmentDisposable(), id = ++this.latest;
            this.hasLatest = true;
            this.inner.setDisposable(d);
            isPromise(innerSource) && (innerSource = observableFromPromise(innerSource));
            d.setDisposable(innerSource.subscribe(new InnerObserver(this, id)));
        };
        SwitchObserver.prototype.error = function(e) {
            this.o.onError(e);
        };
        SwitchObserver.prototype.completed = function() {
            this.stopped = true;
            !this.hasLatest && this.o.onCompleted();
        };
        inherits(InnerObserver, AbstractObserver);
        function InnerObserver(parent, id) {
            this.parent = parent;
            this.id = id;
            AbstractObserver.call(this);
        }
        InnerObserver.prototype.next = function(x) {
            this.parent.latest === this.id && this.parent.o.onNext(x);
        };
        InnerObserver.prototype.error = function(e) {
            this.parent.latest === this.id && this.parent.o.onError(e);
        };
        InnerObserver.prototype.completed = function() {
            if (this.parent.latest === this.id) {
                this.parent.hasLatest = false;
                this.parent.stopped && this.parent.o.onCompleted();
            }
        };
        return SwitchObservable;
    }(ObservableBase);
    /**
  * Transforms an observable sequence of observable sequences into an observable sequence producing values only from the most recent observable sequence.
  * @returns {Observable} The observable sequence that at any point in time produces the elements of the most recent inner observable sequence that has been received.
  */ observableProto['switch'] = observableProto.switchLatest = function() {
        return new SwitchObservable(this);
    };
    var TakeUntilObservable = function(__super__) {
        inherits(TakeUntilObservable, __super__);
        function TakeUntilObservable(source, other) {
            this.source = source;
            this.other = isPromise(other) ? observableFromPromise(other) : other;
            __super__.call(this);
        }
        TakeUntilObservable.prototype.subscribeCore = function(o) {
            return new BinaryDisposable(this.source.subscribe(o), this.other.subscribe(new TakeUntilObserver(o)));
        };
        return TakeUntilObservable;
    }(ObservableBase);
    var TakeUntilObserver = function(__super__) {
        inherits(TakeUntilObserver, __super__);
        function TakeUntilObserver(o) {
            this._o = o;
            __super__.call(this);
        }
        TakeUntilObserver.prototype.next = function() {
            this._o.onCompleted();
        };
        TakeUntilObserver.prototype.error = function(err) {
            this._o.onError(err);
        };
        TakeUntilObserver.prototype.onCompleted = noop;
        return TakeUntilObserver;
    }(AbstractObserver);
    /**
   * Returns the values from the source observable sequence until the other observable sequence produces a value.
   * @param {Observable | Promise} other Observable sequence or Promise that terminates propagation of elements of the source sequence.
   * @returns {Observable} An observable sequence containing the elements of the source sequence up to the point the other sequence interrupted further propagation.
   */ observableProto.takeUntil = function(other) {
        return new TakeUntilObservable(this, other);
    };
    function falseFactory() {
        return false;
    }
    function argumentsToArray() {
        var len = arguments.length, args = new Array(len);
        for(var i = 0; i < len; i++)args[i] = arguments[i];
        return args;
    }
    var WithLatestFromObservable = function(__super__) {
        inherits(WithLatestFromObservable, __super__);
        function WithLatestFromObservable(source, sources, resultSelector) {
            this._s = source;
            this._ss = sources;
            this._cb = resultSelector;
            __super__.call(this);
        }
        WithLatestFromObservable.prototype.subscribeCore = function(o) {
            var len = this._ss.length;
            var state = {
                hasValue: arrayInitialize(len, falseFactory),
                hasValueAll: false,
                values: new Array(len)
            };
            var n = this._ss.length, subscriptions = new Array(n + 1);
            for(var i = 0; i < n; i++){
                var other = this._ss[i], sad = new SingleAssignmentDisposable();
                isPromise(other) && (other = observableFromPromise(other));
                sad.setDisposable(other.subscribe(new WithLatestFromOtherObserver(o, i, state)));
                subscriptions[i] = sad;
            }
            var outerSad = new SingleAssignmentDisposable();
            outerSad.setDisposable(this._s.subscribe(new WithLatestFromSourceObserver(o, this._cb, state)));
            subscriptions[n] = outerSad;
            return new NAryDisposable(subscriptions);
        };
        return WithLatestFromObservable;
    }(ObservableBase);
    var WithLatestFromOtherObserver = function(__super__) {
        inherits(WithLatestFromOtherObserver, __super__);
        function WithLatestFromOtherObserver(o, i, state) {
            this._o = o;
            this._i = i;
            this._state = state;
            __super__.call(this);
        }
        WithLatestFromOtherObserver.prototype.next = function(x) {
            this._state.values[this._i] = x;
            this._state.hasValue[this._i] = true;
            this._state.hasValueAll = this._state.hasValue.every(identity);
        };
        WithLatestFromOtherObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        WithLatestFromOtherObserver.prototype.completed = noop;
        return WithLatestFromOtherObserver;
    }(AbstractObserver);
    var WithLatestFromSourceObserver = function(__super__) {
        inherits(WithLatestFromSourceObserver, __super__);
        function WithLatestFromSourceObserver(o, cb, state) {
            this._o = o;
            this._cb = cb;
            this._state = state;
            __super__.call(this);
        }
        WithLatestFromSourceObserver.prototype.next = function(x) {
            var allValues = [
                x
            ].concat(this._state.values);
            if (!this._state.hasValueAll) return;
            var res = tryCatch(this._cb).apply(null, allValues);
            if (res === errorObj) return this._o.onError(res.e);
            this._o.onNext(res);
        };
        WithLatestFromSourceObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        WithLatestFromSourceObserver.prototype.completed = function() {
            this._o.onCompleted();
        };
        return WithLatestFromSourceObserver;
    }(AbstractObserver);
    /**
   * Merges the specified observable sequences into one observable sequence by using the selector function only when the (first) source observable sequence produces an element.
   * @returns {Observable} An observable sequence containing the result of combining elements of the sources using the specified result selector function.
   */ observableProto.withLatestFrom = function() {
        if (arguments.length === 0) throw new Error('invalid arguments');
        var len = arguments.length, args = new Array(len);
        for(var i = 0; i < len; i++)args[i] = arguments[i];
        var resultSelector = isFunction(args[len - 1]) ? args.pop() : argumentsToArray;
        Array.isArray(args[0]) && (args = args[0]);
        return new WithLatestFromObservable(this, args, resultSelector);
    };
    function falseFactory() {
        return false;
    }
    function emptyArrayFactory() {
        return [];
    }
    var ZipObservable = function(__super__) {
        inherits(ZipObservable, __super__);
        function ZipObservable(sources, resultSelector) {
            this._s = sources;
            this._cb = resultSelector;
            __super__.call(this);
        }
        ZipObservable.prototype.subscribeCore = function(observer) {
            var n = this._s.length, subscriptions = new Array(n), done = arrayInitialize(n, falseFactory), q = arrayInitialize(n, emptyArrayFactory);
            for(var i = 0; i < n; i++){
                var source = this._s[i], sad = new SingleAssignmentDisposable();
                subscriptions[i] = sad;
                isPromise(source) && (source = observableFromPromise(source));
                sad.setDisposable(source.subscribe(new ZipObserver(observer, i, this, q, done)));
            }
            return new NAryDisposable(subscriptions);
        };
        return ZipObservable;
    }(ObservableBase);
    var ZipObserver = function(__super__) {
        inherits(ZipObserver, __super__);
        function ZipObserver(o, i, p, q, d) {
            this._o = o;
            this._i = i;
            this._p = p;
            this._q = q;
            this._d = d;
            __super__.call(this);
        }
        function notEmpty(x) {
            return x.length > 0;
        }
        function shiftEach(x) {
            return x.shift();
        }
        function notTheSame(i) {
            return function(x, j) {
                return j !== i;
            };
        }
        ZipObserver.prototype.next = function(x) {
            this._q[this._i].push(x);
            if (this._q.every(notEmpty)) {
                var queuedValues = this._q.map(shiftEach);
                var res = tryCatch(this._p._cb).apply(null, queuedValues);
                if (res === errorObj) return this._o.onError(res.e);
                this._o.onNext(res);
            } else if (this._d.filter(notTheSame(this._i)).every(identity)) this._o.onCompleted();
        };
        ZipObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        ZipObserver.prototype.completed = function() {
            this._d[this._i] = true;
            this._d.every(identity) && this._o.onCompleted();
        };
        return ZipObserver;
    }(AbstractObserver);
    /**
   * Merges the specified observable sequences into one observable sequence by using the selector function whenever all of the observable sequences or an array have produced an element at a corresponding index.
   * The last element in the arguments must be a function to invoke for each series of elements at corresponding indexes in the args.
   * @returns {Observable} An observable sequence containing the result of combining elements of the args using the specified result selector function.
   */ observableProto.zip = function() {
        if (arguments.length === 0) throw new Error('invalid arguments');
        var len = arguments.length, args = new Array(len);
        for(var i = 0; i < len; i++)args[i] = arguments[i];
        var resultSelector = isFunction(args[len - 1]) ? args.pop() : argumentsToArray;
        Array.isArray(args[0]) && (args = args[0]);
        var parent = this;
        args.unshift(parent);
        return new ZipObservable(args, resultSelector);
    };
    /**
   * Merges the specified observable sequences into one observable sequence by using the selector function whenever all of the observable sequences have produced an element at a corresponding index.
   * @param arguments Observable sources.
   * @param {Function} resultSelector Function to invoke for each series of elements at corresponding indexes in the sources.
   * @returns {Observable} An observable sequence containing the result of combining elements of the sources using the specified result selector function.
   */ Observable.zip = function() {
        var len = arguments.length, args = new Array(len);
        for(var i = 0; i < len; i++)args[i] = arguments[i];
        if (Array.isArray(args[0])) args = isFunction(args[1]) ? args[0].concat(args[1]) : args[0];
        var first = args.shift();
        return first.zip.apply(first, args);
    };
    function falseFactory() {
        return false;
    }
    function emptyArrayFactory() {
        return [];
    }
    function argumentsToArray() {
        var len = arguments.length, args = new Array(len);
        for(var i = 0; i < len; i++)args[i] = arguments[i];
        return args;
    }
    var ZipIterableObservable = function(__super__) {
        inherits(ZipIterableObservable, __super__);
        function ZipIterableObservable(sources, cb) {
            this.sources = sources;
            this._cb = cb;
            __super__.call(this);
        }
        ZipIterableObservable.prototype.subscribeCore = function(o) {
            var sources = this.sources, len = sources.length, subscriptions = new Array(len);
            var state = {
                q: arrayInitialize(len, emptyArrayFactory),
                done: arrayInitialize(len, falseFactory),
                cb: this._cb,
                o: o
            };
            for(var i = 0; i < len; i++)(function(i) {
                var source = sources[i], sad = new SingleAssignmentDisposable();
                (isArrayLike(source) || isIterable(source)) && (source = observableFrom(source));
                subscriptions[i] = sad;
                sad.setDisposable(source.subscribe(new ZipIterableObserver(state, i)));
            })(i);
            return new NAryDisposable(subscriptions);
        };
        return ZipIterableObservable;
    }(ObservableBase);
    var ZipIterableObserver = function(__super__) {
        inherits(ZipIterableObserver, __super__);
        function ZipIterableObserver(s, i) {
            this._s = s;
            this._i = i;
            __super__.call(this);
        }
        function notEmpty(x) {
            return x.length > 0;
        }
        function shiftEach(x) {
            return x.shift();
        }
        function notTheSame(i) {
            return function(x, j) {
                return j !== i;
            };
        }
        ZipIterableObserver.prototype.next = function(x) {
            this._s.q[this._i].push(x);
            if (this._s.q.every(notEmpty)) {
                var queuedValues = this._s.q.map(shiftEach), res = tryCatch(this._s.cb).apply(null, queuedValues);
                if (res === errorObj) return this._s.o.onError(res.e);
                this._s.o.onNext(res);
            } else if (this._s.done.filter(notTheSame(this._i)).every(identity)) this._s.o.onCompleted();
        };
        ZipIterableObserver.prototype.error = function(e) {
            this._s.o.onError(e);
        };
        ZipIterableObserver.prototype.completed = function() {
            this._s.done[this._i] = true;
            this._s.done.every(identity) && this._s.o.onCompleted();
        };
        return ZipIterableObserver;
    }(AbstractObserver);
    /**
 * Merges the specified observable sequences into one observable sequence by using the selector function whenever all of the observable sequences or an array have produced an element at a corresponding index.
 * The last element in the arguments must be a function to invoke for each series of elements at corresponding indexes in the args.
 * @returns {Observable} An observable sequence containing the result of combining elements of the args using the specified result selector function.
 */ observableProto.zipIterable = function() {
        if (arguments.length === 0) throw new Error('invalid arguments');
        var len = arguments.length, args = new Array(len);
        for(var i = 0; i < len; i++)args[i] = arguments[i];
        var resultSelector = isFunction(args[len - 1]) ? args.pop() : argumentsToArray;
        var parent = this;
        args.unshift(parent);
        return new ZipIterableObservable(args, resultSelector);
    };
    function asObservable(source) {
        return function subscribe(o) {
            return source.subscribe(o);
        };
    }
    /**
   *  Hides the identity of an observable sequence.
   * @returns {Observable} An observable sequence that hides the identity of the source sequence.
   */ observableProto.asObservable = function() {
        return new AnonymousObservable(asObservable(this), this);
    };
    function toArray(x) {
        return x.toArray();
    }
    function notEmpty(x) {
        return x.length > 0;
    }
    /**
   *  Projects each element of an observable sequence into zero or more buffers which are produced based on element count information.
   * @param {Number} count Length of each buffer.
   * @param {Number} [skip] Number of elements to skip between creation of consecutive buffers. If not provided, defaults to the count.
   * @returns {Observable} An observable sequence of buffers.
   */ observableProto.bufferWithCount = observableProto.bufferCount = function(count, skip) {
        typeof skip !== 'number' && (skip = count);
        return this.windowWithCount(count, skip).flatMap(toArray).filter(notEmpty);
    };
    var DematerializeObservable = function(__super__) {
        inherits(DematerializeObservable, __super__);
        function DematerializeObservable(source) {
            this.source = source;
            __super__.call(this);
        }
        DematerializeObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new DematerializeObserver(o));
        };
        return DematerializeObservable;
    }(ObservableBase);
    var DematerializeObserver = function(__super__) {
        inherits(DematerializeObserver, __super__);
        function DematerializeObserver(o) {
            this._o = o;
            __super__.call(this);
        }
        DematerializeObserver.prototype.next = function(x) {
            x.accept(this._o);
        };
        DematerializeObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        DematerializeObserver.prototype.completed = function() {
            this._o.onCompleted();
        };
        return DematerializeObserver;
    }(AbstractObserver);
    /**
   * Dematerializes the explicit notification values of an observable sequence as implicit notifications.
   * @returns {Observable} An observable sequence exhibiting the behavior corresponding to the source sequence's notification values.
   */ observableProto.dematerialize = function() {
        return new DematerializeObservable(this);
    };
    var DistinctUntilChangedObservable = function(__super__) {
        inherits(DistinctUntilChangedObservable, __super__);
        function DistinctUntilChangedObservable(source, keyFn, comparer) {
            this.source = source;
            this.keyFn = keyFn;
            this.comparer = comparer;
            __super__.call(this);
        }
        DistinctUntilChangedObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new DistinctUntilChangedObserver(o, this.keyFn, this.comparer));
        };
        return DistinctUntilChangedObservable;
    }(ObservableBase);
    var DistinctUntilChangedObserver = function(__super__) {
        inherits(DistinctUntilChangedObserver, __super__);
        function DistinctUntilChangedObserver(o, keyFn, comparer) {
            this.o = o;
            this.keyFn = keyFn;
            this.comparer = comparer;
            this.hasCurrentKey = false;
            this.currentKey = null;
            __super__.call(this);
        }
        DistinctUntilChangedObserver.prototype.next = function(x) {
            var key = x, comparerEquals;
            if (isFunction(this.keyFn)) {
                key = tryCatch(this.keyFn)(x);
                if (key === errorObj) return this.o.onError(key.e);
            }
            if (this.hasCurrentKey) {
                comparerEquals = tryCatch(this.comparer)(this.currentKey, key);
                if (comparerEquals === errorObj) return this.o.onError(comparerEquals.e);
            }
            if (!this.hasCurrentKey || !comparerEquals) {
                this.hasCurrentKey = true;
                this.currentKey = key;
                this.o.onNext(x);
            }
        };
        DistinctUntilChangedObserver.prototype.error = function(e) {
            this.o.onError(e);
        };
        DistinctUntilChangedObserver.prototype.completed = function() {
            this.o.onCompleted();
        };
        return DistinctUntilChangedObserver;
    }(AbstractObserver);
    /**
  *  Returns an observable sequence that contains only distinct contiguous elements according to the keyFn and the comparer.
  * @param {Function} [keyFn] A function to compute the comparison key for each element. If not provided, it projects the value.
  * @param {Function} [comparer] Equality comparer for computed key values. If not provided, defaults to an equality comparer function.
  * @returns {Observable} An observable sequence only containing the distinct contiguous elements, based on a computed key value, from the source sequence.
  */ observableProto.distinctUntilChanged = function(keyFn, comparer) {
        comparer || (comparer = defaultComparer);
        return new DistinctUntilChangedObservable(this, keyFn, comparer);
    };
    var TapObservable = function(__super__) {
        inherits(TapObservable, __super__);
        function TapObservable(source, observerOrOnNext, onError, onCompleted) {
            this.source = source;
            this._oN = observerOrOnNext;
            this._oE = onError;
            this._oC = onCompleted;
            __super__.call(this);
        }
        TapObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new InnerObserver(o, this));
        };
        inherits(InnerObserver, AbstractObserver);
        function InnerObserver(o, p) {
            this.o = o;
            this.t = !p._oN || isFunction(p._oN) ? observerCreate(p._oN || noop, p._oE || noop, p._oC || noop) : p._oN;
            this.isStopped = false;
            AbstractObserver.call(this);
        }
        InnerObserver.prototype.next = function(x) {
            var res = tryCatch(this.t.onNext).call(this.t, x);
            if (res === errorObj) this.o.onError(res.e);
            this.o.onNext(x);
        };
        InnerObserver.prototype.error = function(err) {
            var res = tryCatch(this.t.onError).call(this.t, err);
            if (res === errorObj) return this.o.onError(res.e);
            this.o.onError(err);
        };
        InnerObserver.prototype.completed = function() {
            var res = tryCatch(this.t.onCompleted).call(this.t);
            if (res === errorObj) return this.o.onError(res.e);
            this.o.onCompleted();
        };
        return TapObservable;
    }(ObservableBase);
    /**
  *  Invokes an action for each element in the observable sequence and invokes an action upon graceful or exceptional termination of the observable sequence.
  *  This method can be used for debugging, logging, etc. of query behavior by intercepting the message stream to run arbitrary actions for messages on the pipeline.
  * @param {Function | Observer} observerOrOnNext Action to invoke for each element in the observable sequence or an o.
  * @param {Function} [onError]  Action to invoke upon exceptional termination of the observable sequence. Used if only the observerOrOnNext parameter is also a function.
  * @param {Function} [onCompleted]  Action to invoke upon graceful termination of the observable sequence. Used if only the observerOrOnNext parameter is also a function.
  * @returns {Observable} The source sequence with the side-effecting behavior applied.
  */ observableProto['do'] = observableProto.tap = observableProto.doAction = function(observerOrOnNext, onError, onCompleted) {
        return new TapObservable(this, observerOrOnNext, onError, onCompleted);
    };
    /**
  *  Invokes an action for each element in the observable sequence.
  *  This method can be used for debugging, logging, etc. of query behavior by intercepting the message stream to run arbitrary actions for messages on the pipeline.
  * @param {Function} onNext Action to invoke for each element in the observable sequence.
  * @param {Any} [thisArg] Object to use as this when executing callback.
  * @returns {Observable} The source sequence with the side-effecting behavior applied.
  */ observableProto.doOnNext = observableProto.tapOnNext = function(onNext, thisArg) {
        return this.tap(typeof thisArg !== 'undefined' ? function(x) {
            onNext.call(thisArg, x);
        } : onNext);
    };
    /**
  *  Invokes an action upon exceptional termination of the observable sequence.
  *  This method can be used for debugging, logging, etc. of query behavior by intercepting the message stream to run arbitrary actions for messages on the pipeline.
  * @param {Function} onError Action to invoke upon exceptional termination of the observable sequence.
  * @param {Any} [thisArg] Object to use as this when executing callback.
  * @returns {Observable} The source sequence with the side-effecting behavior applied.
  */ observableProto.doOnError = observableProto.tapOnError = function(onError, thisArg) {
        return this.tap(noop, typeof thisArg !== 'undefined' ? function(e) {
            onError.call(thisArg, e);
        } : onError);
    };
    /**
  *  Invokes an action upon graceful termination of the observable sequence.
  *  This method can be used for debugging, logging, etc. of query behavior by intercepting the message stream to run arbitrary actions for messages on the pipeline.
  * @param {Function} onCompleted Action to invoke upon graceful termination of the observable sequence.
  * @param {Any} [thisArg] Object to use as this when executing callback.
  * @returns {Observable} The source sequence with the side-effecting behavior applied.
  */ observableProto.doOnCompleted = observableProto.tapOnCompleted = function(onCompleted, thisArg) {
        return this.tap(noop, null, typeof thisArg !== 'undefined' ? function() {
            onCompleted.call(thisArg);
        } : onCompleted);
    };
    var FinallyObservable = function(__super__) {
        inherits(FinallyObservable, __super__);
        function FinallyObservable(source, fn, thisArg) {
            this.source = source;
            this._fn = bindCallback(fn, thisArg, 0);
            __super__.call(this);
        }
        FinallyObservable.prototype.subscribeCore = function(o) {
            var d = tryCatch(this.source.subscribe).call(this.source, o);
            if (d === errorObj) {
                this._fn();
                thrower(d.e);
            }
            return new FinallyDisposable(d, this._fn);
        };
        function FinallyDisposable(s, fn) {
            this.isDisposed = false;
            this._s = s;
            this._fn = fn;
        }
        FinallyDisposable.prototype.dispose = function() {
            if (!this.isDisposed) {
                var res = tryCatch(this._s.dispose).call(this._s);
                this._fn();
                res === errorObj && thrower(res.e);
            }
        };
        return FinallyObservable;
    }(ObservableBase);
    /**
   *  Invokes a specified action after the source observable sequence terminates gracefully or exceptionally.
   * @param {Function} finallyAction Action to invoke after the source observable sequence terminates.
   * @returns {Observable} Source sequence with the action-invoking termination behavior applied.
   */ observableProto['finally'] = function(action, thisArg) {
        return new FinallyObservable(this, action, thisArg);
    };
    var IgnoreElementsObservable = function(__super__) {
        inherits(IgnoreElementsObservable, __super__);
        function IgnoreElementsObservable(source) {
            this.source = source;
            __super__.call(this);
        }
        IgnoreElementsObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new InnerObserver(o));
        };
        function InnerObserver(o) {
            this.o = o;
            this.isStopped = false;
        }
        InnerObserver.prototype.onNext = noop;
        InnerObserver.prototype.onError = function(err) {
            if (!this.isStopped) {
                this.isStopped = true;
                this.o.onError(err);
            }
        };
        InnerObserver.prototype.onCompleted = function() {
            if (!this.isStopped) {
                this.isStopped = true;
                this.o.onCompleted();
            }
        };
        InnerObserver.prototype.dispose = function() {
            this.isStopped = true;
        };
        InnerObserver.prototype.fail = function(e) {
            if (!this.isStopped) {
                this.isStopped = true;
                this.observer.onError(e);
                return true;
            }
            return false;
        };
        return IgnoreElementsObservable;
    }(ObservableBase);
    /**
   *  Ignores all elements in an observable sequence leaving only the termination messages.
   * @returns {Observable} An empty observable sequence that signals termination, successful or exceptional, of the source sequence.
   */ observableProto.ignoreElements = function() {
        return new IgnoreElementsObservable(this);
    };
    var MaterializeObservable = function(__super__) {
        inherits(MaterializeObservable, __super__);
        function MaterializeObservable(source, fn) {
            this.source = source;
            __super__.call(this);
        }
        MaterializeObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new MaterializeObserver(o));
        };
        return MaterializeObservable;
    }(ObservableBase);
    var MaterializeObserver = function(__super__) {
        inherits(MaterializeObserver, __super__);
        function MaterializeObserver(o) {
            this._o = o;
            __super__.call(this);
        }
        MaterializeObserver.prototype.next = function(x) {
            this._o.onNext(notificationCreateOnNext(x));
        };
        MaterializeObserver.prototype.error = function(e) {
            this._o.onNext(notificationCreateOnError(e));
            this._o.onCompleted();
        };
        MaterializeObserver.prototype.completed = function() {
            this._o.onNext(notificationCreateOnCompleted());
            this._o.onCompleted();
        };
        return MaterializeObserver;
    }(AbstractObserver);
    /**
   *  Materializes the implicit notifications of an observable sequence as explicit notification values.
   * @returns {Observable} An observable sequence containing the materialized notification values from the source sequence.
   */ observableProto.materialize = function() {
        return new MaterializeObservable(this);
    };
    /**
   *  Repeats the observable sequence a specified number of times. If the repeat count is not specified, the sequence repeats indefinitely.
   * @param {Number} [repeatCount]  Number of times to repeat the sequence. If not provided, repeats the sequence indefinitely.
   * @returns {Observable} The observable sequence producing the elements of the given sequence repeatedly.
   */ observableProto.repeat = function(repeatCount) {
        return enumerableRepeat(this, repeatCount).concat();
    };
    /**
   *  Repeats the source observable sequence the specified number of times or until it successfully terminates. If the retry count is not specified, it retries indefinitely.
   *  Note if you encounter an error and want it to retry once, then you must use .retry(2);
   *
   * @example
   *  var res = retried = retry.repeat();
   *  var res = retried = retry.repeat(2);
   * @param {Number} [retryCount]  Number of times to retry the sequence. If not provided, retry the sequence indefinitely.
   * @returns {Observable} An observable sequence producing the elements of the given sequence repeatedly until it terminates successfully.
   */ observableProto.retry = function(retryCount) {
        return enumerableRepeat(this, retryCount).catchError();
    };
    function repeat(value) {
        return {
            '@@iterator': function() {
                return {
                    next: function() {
                        return {
                            done: false,
                            value: value
                        };
                    }
                };
            }
        };
    }
    var RetryWhenObservable = function(__super__) {
        function createDisposable(state) {
            return {
                isDisposed: false,
                dispose: function() {
                    if (!this.isDisposed) {
                        this.isDisposed = true;
                        state.isDisposed = true;
                    }
                }
            };
        }
        function RetryWhenObservable(source, notifier) {
            this.source = source;
            this._notifier = notifier;
            __super__.call(this);
        }
        inherits(RetryWhenObservable, __super__);
        RetryWhenObservable.prototype.subscribeCore = function(o) {
            var exceptions = new Subject(), notifier = new Subject(), handled = this._notifier(exceptions), notificationDisposable = handled.subscribe(notifier);
            var e = this.source['@@iterator']();
            var state = {
                isDisposed: false
            }, lastError, subscription = new SerialDisposable();
            var cancelable = currentThreadScheduler.scheduleRecursive(null, function(_, recurse) {
                if (state.isDisposed) return;
                var currentItem = e.next();
                if (currentItem.done) {
                    if (lastError) o.onError(lastError);
                    else o.onCompleted();
                    return;
                }
                // Check if promise
                var currentValue = currentItem.value;
                isPromise(currentValue) && (currentValue = observableFromPromise(currentValue));
                var outer = new SingleAssignmentDisposable();
                var inner = new SingleAssignmentDisposable();
                subscription.setDisposable(new BinaryDisposable(inner, outer));
                outer.setDisposable(currentValue.subscribe(function(x) {
                    o.onNext(x);
                }, function(exn) {
                    inner.setDisposable(notifier.subscribe(recurse, function(ex) {
                        o.onError(ex);
                    }, function() {
                        o.onCompleted();
                    }));
                    exceptions.onNext(exn);
                    outer.dispose();
                }, function() {
                    o.onCompleted();
                }));
            });
            return new NAryDisposable([
                notificationDisposable,
                subscription,
                cancelable,
                createDisposable(state)
            ]);
        };
        return RetryWhenObservable;
    }(ObservableBase);
    observableProto.retryWhen = function(notifier) {
        return new RetryWhenObservable(repeat(this), notifier);
    };
    function repeat(value) {
        return {
            '@@iterator': function() {
                return {
                    next: function() {
                        return {
                            done: false,
                            value: value
                        };
                    }
                };
            }
        };
    }
    var RepeatWhenObservable = function(__super__) {
        function createDisposable(state) {
            return {
                isDisposed: false,
                dispose: function() {
                    if (!this.isDisposed) {
                        this.isDisposed = true;
                        state.isDisposed = true;
                    }
                }
            };
        }
        function RepeatWhenObservable(source, notifier) {
            this.source = source;
            this._notifier = notifier;
            __super__.call(this);
        }
        inherits(RepeatWhenObservable, __super__);
        RepeatWhenObservable.prototype.subscribeCore = function(o) {
            var completions = new Subject(), notifier = new Subject(), handled = this._notifier(completions), notificationDisposable = handled.subscribe(notifier);
            var e = this.source['@@iterator']();
            var state = {
                isDisposed: false
            }, lastError, subscription = new SerialDisposable();
            var cancelable = currentThreadScheduler.scheduleRecursive(null, function(_, recurse) {
                if (state.isDisposed) return;
                var currentItem = e.next();
                if (currentItem.done) {
                    if (lastError) o.onError(lastError);
                    else o.onCompleted();
                    return;
                }
                // Check if promise
                var currentValue = currentItem.value;
                isPromise(currentValue) && (currentValue = observableFromPromise(currentValue));
                var outer = new SingleAssignmentDisposable();
                var inner = new SingleAssignmentDisposable();
                subscription.setDisposable(new BinaryDisposable(inner, outer));
                outer.setDisposable(currentValue.subscribe(function(x) {
                    o.onNext(x);
                }, function(exn) {
                    o.onError(exn);
                }, function() {
                    inner.setDisposable(notifier.subscribe(recurse, function(ex) {
                        o.onError(ex);
                    }, function() {
                        o.onCompleted();
                    }));
                    completions.onNext(null);
                    outer.dispose();
                }));
            });
            return new NAryDisposable([
                notificationDisposable,
                subscription,
                cancelable,
                createDisposable(state)
            ]);
        };
        return RepeatWhenObservable;
    }(ObservableBase);
    observableProto.repeatWhen = function(notifier) {
        return new RepeatWhenObservable(repeat(this), notifier);
    };
    var ScanObservable = function(__super__) {
        inherits(ScanObservable, __super__);
        function ScanObservable(source, accumulator, hasSeed, seed) {
            this.source = source;
            this.accumulator = accumulator;
            this.hasSeed = hasSeed;
            this.seed = seed;
            __super__.call(this);
        }
        ScanObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new ScanObserver(o, this));
        };
        return ScanObservable;
    }(ObservableBase);
    var ScanObserver = function(__super__) {
        inherits(ScanObserver, __super__);
        function ScanObserver(o, parent) {
            this._o = o;
            this._p = parent;
            this._fn = parent.accumulator;
            this._hs = parent.hasSeed;
            this._s = parent.seed;
            this._ha = false;
            this._a = null;
            this._hv = false;
            this._i = 0;
            __super__.call(this);
        }
        ScanObserver.prototype.next = function(x) {
            !this._hv && (this._hv = true);
            if (this._ha) this._a = tryCatch(this._fn)(this._a, x, this._i, this._p);
            else {
                this._a = this._hs ? tryCatch(this._fn)(this._s, x, this._i, this._p) : x;
                this._ha = true;
            }
            if (this._a === errorObj) return this._o.onError(this._a.e);
            this._o.onNext(this._a);
            this._i++;
        };
        ScanObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        ScanObserver.prototype.completed = function() {
            !this._hv && this._hs && this._o.onNext(this._s);
            this._o.onCompleted();
        };
        return ScanObserver;
    }(AbstractObserver);
    /**
  *  Applies an accumulator function over an observable sequence and returns each intermediate result. The optional seed value is used as the initial accumulator value.
  *  For aggregation behavior with no intermediate results, see Observable.aggregate.
  * @param {Mixed} [seed] The initial accumulator value.
  * @param {Function} accumulator An accumulator function to be invoked on each element.
  * @returns {Observable} An observable sequence containing the accumulated values.
  */ observableProto.scan = function() {
        var hasSeed = false, seed, accumulator = arguments[0];
        if (arguments.length === 2) {
            hasSeed = true;
            seed = arguments[1];
        }
        return new ScanObservable(this, accumulator, hasSeed, seed);
    };
    var SkipLastObservable = function(__super__) {
        inherits(SkipLastObservable, __super__);
        function SkipLastObservable(source, c) {
            this.source = source;
            this._c = c;
            __super__.call(this);
        }
        SkipLastObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new SkipLastObserver(o, this._c));
        };
        return SkipLastObservable;
    }(ObservableBase);
    var SkipLastObserver = function(__super__) {
        inherits(SkipLastObserver, __super__);
        function SkipLastObserver(o, c) {
            this._o = o;
            this._c = c;
            this._q = [];
            __super__.call(this);
        }
        SkipLastObserver.prototype.next = function(x) {
            this._q.push(x);
            this._q.length > this._c && this._o.onNext(this._q.shift());
        };
        SkipLastObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        SkipLastObserver.prototype.completed = function() {
            this._o.onCompleted();
        };
        return SkipLastObserver;
    }(AbstractObserver);
    /**
   *  Bypasses a specified number of elements at the end of an observable sequence.
   * @description
   *  This operator accumulates a queue with a length enough to store the first `count` elements. As more elements are
   *  received, elements are taken from the front of the queue and produced on the result sequence. This causes elements to be delayed.
   * @param count Number of elements to bypass at the end of the source sequence.
   * @returns {Observable} An observable sequence containing the source sequence elements except for the bypassed ones at the end.
   */ observableProto.skipLast = function(count) {
        if (count < 0) throw new ArgumentOutOfRangeError();
        return new SkipLastObservable(this, count);
    };
    /**
   *  Prepends a sequence of values to an observable sequence with an optional scheduler and an argument list of values to prepend.
   *  @example
   *  var res = source.startWith(1, 2, 3);
   *  var res = source.startWith(Rx.Scheduler.timeout, 1, 2, 3);
   * @param {Arguments} args The specified values to prepend to the observable sequence
   * @returns {Observable} The source sequence prepended with the specified values.
   */ observableProto.startWith = function() {
        var values, scheduler, start = 0;
        if (!!arguments.length && isScheduler(arguments[0])) {
            scheduler = arguments[0];
            start = 1;
        } else scheduler = immediateScheduler;
        for(var args = [], i = start, len = arguments.length; i < len; i++)args.push(arguments[i]);
        return observableConcat.apply(null, [
            observableFromArray(args, scheduler),
            this
        ]);
    };
    var TakeLastObserver = function(__super__) {
        inherits(TakeLastObserver, __super__);
        function TakeLastObserver(o, c) {
            this._o = o;
            this._c = c;
            this._q = [];
            __super__.call(this);
        }
        TakeLastObserver.prototype.next = function(x) {
            this._q.push(x);
            this._q.length > this._c && this._q.shift();
        };
        TakeLastObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        TakeLastObserver.prototype.completed = function() {
            while(this._q.length > 0)this._o.onNext(this._q.shift());
            this._o.onCompleted();
        };
        return TakeLastObserver;
    }(AbstractObserver);
    /**
   *  Returns a specified number of contiguous elements from the end of an observable sequence.
   * @description
   *  This operator accumulates a buffer with a length enough to store elements count elements. Upon completion of
   *  the source sequence, this buffer is drained on the result sequence. This causes the elements to be delayed.
   * @param {Number} count Number of elements to take from the end of the source sequence.
   * @returns {Observable} An observable sequence containing the specified number of elements from the end of the source sequence.
   */ observableProto.takeLast = function(count) {
        if (count < 0) throw new ArgumentOutOfRangeError();
        var source = this;
        return new AnonymousObservable(function(o) {
            return source.subscribe(new TakeLastObserver(o, count));
        }, source);
    };
    var TakeLastBufferObserver = function(__super__) {
        inherits(TakeLastBufferObserver, __super__);
        function TakeLastBufferObserver(o, c) {
            this._o = o;
            this._c = c;
            this._q = [];
            __super__.call(this);
        }
        TakeLastBufferObserver.prototype.next = function(x) {
            this._q.push(x);
            this._q.length > this._c && this._q.shift();
        };
        TakeLastBufferObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        TakeLastBufferObserver.prototype.completed = function() {
            this._o.onNext(this._q);
            this._o.onCompleted();
        };
        return TakeLastBufferObserver;
    }(AbstractObserver);
    /**
   *  Returns an array with the specified number of contiguous elements from the end of an observable sequence.
   *
   * @description
   *  This operator accumulates a buffer with a length enough to store count elements. Upon completion of the
   *  source sequence, this buffer is produced on the result sequence.
   * @param {Number} count Number of elements to take from the end of the source sequence.
   * @returns {Observable} An observable sequence containing a single array with the specified number of elements from the end of the source sequence.
   */ observableProto.takeLastBuffer = function(count) {
        if (count < 0) throw new ArgumentOutOfRangeError();
        var source = this;
        return new AnonymousObservable(function(o) {
            return source.subscribe(new TakeLastBufferObserver(o, count));
        }, source);
    };
    /**
   *  Projects each element of an observable sequence into zero or more windows which are produced based on element count information.
   * @param {Number} count Length of each window.
   * @param {Number} [skip] Number of elements to skip between creation of consecutive windows. If not specified, defaults to the count.
   * @returns {Observable} An observable sequence of windows.
   */ observableProto.windowWithCount = observableProto.windowCount = function(count, skip) {
        var source = this;
        +count || (count = 0);
        Math.abs(count) === Infinity && (count = 0);
        if (count <= 0) throw new ArgumentOutOfRangeError();
        skip == null && (skip = count);
        +skip || (skip = 0);
        Math.abs(skip) === Infinity && (skip = 0);
        if (skip <= 0) throw new ArgumentOutOfRangeError();
        return new AnonymousObservable(function(observer) {
            var m = new SingleAssignmentDisposable(), refCountDisposable = new RefCountDisposable(m), n = 0, q = [];
            function createWindow() {
                var s = new Subject();
                q.push(s);
                observer.onNext(addRef(s, refCountDisposable));
            }
            createWindow();
            m.setDisposable(source.subscribe(function(x) {
                for(var i = 0, len = q.length; i < len; i++)q[i].onNext(x);
                var c = n - count + 1;
                c >= 0 && c % skip === 0 && q.shift().onCompleted();
                ++n % skip === 0 && createWindow();
            }, function(e) {
                while(q.length > 0)q.shift().onError(e);
                observer.onError(e);
            }, function() {
                while(q.length > 0)q.shift().onCompleted();
                observer.onCompleted();
            }));
            return refCountDisposable;
        }, source);
    };
    observableProto.flatMapConcat = observableProto.concatMap = function(selector, resultSelector, thisArg) {
        return new FlatMapObservable(this, selector, resultSelector, thisArg).merge(1);
    };
    /**
   * Projects each notification of an observable sequence to an observable sequence and concats the resulting observable sequences into one observable sequence.
   * @param {Function} onNext A transform function to apply to each element; the second parameter of the function represents the index of the source element.
   * @param {Function} onError A transform function to apply when an error occurs in the source sequence.
   * @param {Function} onCompleted A transform function to apply when the end of the source sequence is reached.
   * @param {Any} [thisArg] An optional "this" to use to invoke each transform.
   * @returns {Observable} An observable sequence whose elements are the result of invoking the one-to-many transform function corresponding to each notification in the input sequence.
   */ observableProto.concatMapObserver = observableProto.selectConcatObserver = function(onNext, onError, onCompleted, thisArg) {
        var source = this, onNextFunc = bindCallback(onNext, thisArg, 2), onErrorFunc = bindCallback(onError, thisArg, 1), onCompletedFunc = bindCallback(onCompleted, thisArg, 0);
        return new AnonymousObservable(function(observer) {
            var index = 0;
            return source.subscribe(function(x) {
                var result;
                try {
                    result = onNextFunc(x, index++);
                } catch (e) {
                    observer.onError(e);
                    return;
                }
                isPromise(result) && (result = observableFromPromise(result));
                observer.onNext(result);
            }, function(err) {
                var result;
                try {
                    result = onErrorFunc(err);
                } catch (e) {
                    observer.onError(e);
                    return;
                }
                isPromise(result) && (result = observableFromPromise(result));
                observer.onNext(result);
                observer.onCompleted();
            }, function() {
                var result;
                try {
                    result = onCompletedFunc();
                } catch (e) {
                    observer.onError(e);
                    return;
                }
                isPromise(result) && (result = observableFromPromise(result));
                observer.onNext(result);
                observer.onCompleted();
            });
        }, this).concatAll();
    };
    var DefaultIfEmptyObserver = function(__super__) {
        inherits(DefaultIfEmptyObserver, __super__);
        function DefaultIfEmptyObserver(o, d) {
            this._o = o;
            this._d = d;
            this._f = false;
            __super__.call(this);
        }
        DefaultIfEmptyObserver.prototype.next = function(x) {
            this._f = true;
            this._o.onNext(x);
        };
        DefaultIfEmptyObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        DefaultIfEmptyObserver.prototype.completed = function() {
            !this._f && this._o.onNext(this._d);
            this._o.onCompleted();
        };
        return DefaultIfEmptyObserver;
    }(AbstractObserver);
    /**
   *  Returns the elements of the specified sequence or the specified value in a singleton sequence if the sequence is empty.
   *
   *  var res = obs = xs.defaultIfEmpty();
   *  2 - obs = xs.defaultIfEmpty(false);
   *
   * @memberOf Observable#
   * @param defaultValue The value to return if the sequence is empty. If not provided, this defaults to null.
   * @returns {Observable} An observable sequence that contains the specified default value if the source is empty; otherwise, the elements of the source itself.
   */ observableProto.defaultIfEmpty = function(defaultValue) {
        var source = this;
        defaultValue === undefined && (defaultValue = null);
        return new AnonymousObservable(function(o) {
            return source.subscribe(new DefaultIfEmptyObserver(o, defaultValue));
        }, source);
    };
    // Swap out for Array.findIndex
    function arrayIndexOfComparer(array, item, comparer) {
        for(var i = 0, len = array.length; i < len; i++){
            if (comparer(array[i], item)) return i;
        }
        return -1;
    }
    function HashSet(comparer) {
        this.comparer = comparer;
        this.set = [];
    }
    HashSet.prototype.push = function(value) {
        var retValue = arrayIndexOfComparer(this.set, value, this.comparer) === -1;
        retValue && this.set.push(value);
        return retValue;
    };
    var DistinctObservable = function(__super__) {
        inherits(DistinctObservable, __super__);
        function DistinctObservable(source, keyFn, cmpFn) {
            this.source = source;
            this._keyFn = keyFn;
            this._cmpFn = cmpFn;
            __super__.call(this);
        }
        DistinctObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new DistinctObserver(o, this._keyFn, this._cmpFn));
        };
        return DistinctObservable;
    }(ObservableBase);
    var DistinctObserver = function(__super__) {
        inherits(DistinctObserver, __super__);
        function DistinctObserver(o, keyFn, cmpFn) {
            this._o = o;
            this._keyFn = keyFn;
            this._h = new HashSet(cmpFn);
            __super__.call(this);
        }
        DistinctObserver.prototype.next = function(x) {
            var key = x;
            if (isFunction(this._keyFn)) {
                key = tryCatch(this._keyFn)(x);
                if (key === errorObj) return this._o.onError(key.e);
            }
            this._h.push(key) && this._o.onNext(x);
        };
        DistinctObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        DistinctObserver.prototype.completed = function() {
            this._o.onCompleted();
        };
        return DistinctObserver;
    }(AbstractObserver);
    /**
   *  Returns an observable sequence that contains only distinct elements according to the keySelector and the comparer.
   *  Usage of this operator should be considered carefully due to the maintenance of an internal lookup structure which can grow large.
   *
   * @example
   *  var res = obs = xs.distinct();
   *  2 - obs = xs.distinct(function (x) { return x.id; });
   *  2 - obs = xs.distinct(function (x) { return x.id; }, function (a,b) { return a === b; });
   * @param {Function} [keySelector]  A function to compute the comparison key for each element.
   * @param {Function} [comparer]  Used to compare items in the collection.
   * @returns {Observable} An observable sequence only containing the distinct elements, based on a computed key value, from the source sequence.
   */ observableProto.distinct = function(keySelector, comparer) {
        comparer || (comparer = defaultComparer);
        return new DistinctObservable(this, keySelector, comparer);
    };
    var MapObservable = function(__super__) {
        inherits(MapObservable, __super__);
        function MapObservable(source, selector, thisArg) {
            this.source = source;
            this.selector = bindCallback(selector, thisArg, 3);
            __super__.call(this);
        }
        function innerMap(selector, self1) {
            return function(x, i, o) {
                return selector.call(this, self1.selector(x, i, o), i, o);
            };
        }
        MapObservable.prototype.internalMap = function(selector, thisArg) {
            return new MapObservable(this.source, innerMap(selector, this), thisArg);
        };
        MapObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new InnerObserver(o, this.selector, this));
        };
        inherits(InnerObserver, AbstractObserver);
        function InnerObserver(o, selector, source) {
            this.o = o;
            this.selector = selector;
            this.source = source;
            this.i = 0;
            AbstractObserver.call(this);
        }
        InnerObserver.prototype.next = function(x) {
            var result = tryCatch(this.selector)(x, this.i++, this.source);
            if (result === errorObj) return this.o.onError(result.e);
            this.o.onNext(result);
        };
        InnerObserver.prototype.error = function(e) {
            this.o.onError(e);
        };
        InnerObserver.prototype.completed = function() {
            this.o.onCompleted();
        };
        return MapObservable;
    }(ObservableBase);
    /**
  * Projects each element of an observable sequence into a new form by incorporating the element's index.
  * @param {Function} selector A transform function to apply to each source element; the second parameter of the function represents the index of the source element.
  * @param {Any} [thisArg] Object to use as this when executing callback.
  * @returns {Observable} An observable sequence whose elements are the result of invoking the transform function on each element of source.
  */ observableProto.map = observableProto.select = function(selector, thisArg) {
        var selectorFn = typeof selector === 'function' ? selector : function() {
            return selector;
        };
        return this instanceof MapObservable ? this.internalMap(selectorFn, thisArg) : new MapObservable(this, selectorFn, thisArg);
    };
    function plucker(args, len) {
        return function mapper(x) {
            var currentProp = x;
            for(var i = 0; i < len; i++){
                var p = currentProp[args[i]];
                if (typeof p !== 'undefined') currentProp = p;
                else return undefined;
            }
            return currentProp;
        };
    }
    /**
   * Retrieves the value of a specified nested property from all elements in
   * the Observable sequence.
   * @param {Arguments} arguments The nested properties to pluck.
   * @returns {Observable} Returns a new Observable sequence of property values.
   */ observableProto.pluck = function() {
        var len = arguments.length, args = new Array(len);
        if (len === 0) throw new Error('List of properties cannot be empty.');
        for(var i = 0; i < len; i++)args[i] = arguments[i];
        return this.map(plucker(args, len));
    };
    /**
   * Projects each notification of an observable sequence to an observable sequence and merges the resulting observable sequences into one observable sequence.
   * @param {Function} onNext A transform function to apply to each element; the second parameter of the function represents the index of the source element.
   * @param {Function} onError A transform function to apply when an error occurs in the source sequence.
   * @param {Function} onCompleted A transform function to apply when the end of the source sequence is reached.
   * @param {Any} [thisArg] An optional "this" to use to invoke each transform.
   * @returns {Observable} An observable sequence whose elements are the result of invoking the one-to-many transform function corresponding to each notification in the input sequence.
   */ observableProto.flatMapObserver = observableProto.selectManyObserver = function(onNext, onError, onCompleted, thisArg) {
        var source = this;
        return new AnonymousObservable(function(observer) {
            var index = 0;
            return source.subscribe(function(x) {
                var result;
                try {
                    result = onNext.call(thisArg, x, index++);
                } catch (e) {
                    observer.onError(e);
                    return;
                }
                isPromise(result) && (result = observableFromPromise(result));
                observer.onNext(result);
            }, function(err) {
                var result;
                try {
                    result = onError.call(thisArg, err);
                } catch (e) {
                    observer.onError(e);
                    return;
                }
                isPromise(result) && (result = observableFromPromise(result));
                observer.onNext(result);
                observer.onCompleted();
            }, function() {
                var result;
                try {
                    result = onCompleted.call(thisArg);
                } catch (e) {
                    observer.onError(e);
                    return;
                }
                isPromise(result) && (result = observableFromPromise(result));
                observer.onNext(result);
                observer.onCompleted();
            });
        }, source).mergeAll();
    };
    observableProto.flatMap = observableProto.selectMany = observableProto.mergeMap = function(selector, resultSelector, thisArg) {
        return new FlatMapObservable(this, selector, resultSelector, thisArg).mergeAll();
    };
    observableProto.flatMapLatest = observableProto.switchMap = function(selector, resultSelector, thisArg) {
        return new FlatMapObservable(this, selector, resultSelector, thisArg).switchLatest();
    };
    var SkipObservable = function(__super__) {
        inherits(SkipObservable, __super__);
        function SkipObservable(source, count) {
            this.source = source;
            this._count = count;
            __super__.call(this);
        }
        SkipObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new SkipObserver(o, this._count));
        };
        function SkipObserver(o, c) {
            this._o = o;
            this._r = c;
            AbstractObserver.call(this);
        }
        inherits(SkipObserver, AbstractObserver);
        SkipObserver.prototype.next = function(x) {
            if (this._r <= 0) this._o.onNext(x);
            else this._r--;
        };
        SkipObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        SkipObserver.prototype.completed = function() {
            this._o.onCompleted();
        };
        return SkipObservable;
    }(ObservableBase);
    /**
   * Bypasses a specified number of elements in an observable sequence and then returns the remaining elements.
   * @param {Number} count The number of elements to skip before returning the remaining elements.
   * @returns {Observable} An observable sequence that contains the elements that occur after the specified index in the input sequence.
   */ observableProto.skip = function(count) {
        if (count < 0) throw new ArgumentOutOfRangeError();
        return new SkipObservable(this, count);
    };
    var SkipWhileObservable = function(__super__) {
        inherits(SkipWhileObservable, __super__);
        function SkipWhileObservable(source, fn) {
            this.source = source;
            this._fn = fn;
            __super__.call(this);
        }
        SkipWhileObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new SkipWhileObserver(o, this));
        };
        return SkipWhileObservable;
    }(ObservableBase);
    var SkipWhileObserver = function(__super__) {
        inherits(SkipWhileObserver, __super__);
        function SkipWhileObserver(o, p) {
            this._o = o;
            this._p = p;
            this._i = 0;
            this._r = false;
            __super__.call(this);
        }
        SkipWhileObserver.prototype.next = function(x) {
            if (!this._r) {
                var res = tryCatch(this._p._fn)(x, this._i++, this._p);
                if (res === errorObj) return this._o.onError(res.e);
                this._r = !res;
            }
            this._r && this._o.onNext(x);
        };
        SkipWhileObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        SkipWhileObserver.prototype.completed = function() {
            this._o.onCompleted();
        };
        return SkipWhileObserver;
    }(AbstractObserver);
    /**
   *  Bypasses elements in an observable sequence as long as a specified condition is true and then returns the remaining elements.
   *  The element's index is used in the logic of the predicate function.
   *
   *  var res = source.skipWhile(function (value) { return value < 10; });
   *  var res = source.skipWhile(function (value, index) { return value < 10 || index < 10; });
   * @param {Function} predicate A function to test each element for a condition; the second parameter of the function represents the index of the source element.
   * @param {Any} [thisArg] Object to use as this when executing callback.
   * @returns {Observable} An observable sequence that contains the elements from the input sequence starting at the first element in the linear series that does not pass the test specified by predicate.
   */ observableProto.skipWhile = function(predicate, thisArg) {
        var fn = bindCallback(predicate, thisArg, 3);
        return new SkipWhileObservable(this, fn);
    };
    var TakeObservable = function(__super__) {
        inherits(TakeObservable, __super__);
        function TakeObservable(source, count) {
            this.source = source;
            this._count = count;
            __super__.call(this);
        }
        TakeObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new TakeObserver(o, this._count));
        };
        function TakeObserver(o, c) {
            this._o = o;
            this._c = c;
            this._r = c;
            AbstractObserver.call(this);
        }
        inherits(TakeObserver, AbstractObserver);
        TakeObserver.prototype.next = function(x) {
            if (this._r-- > 0) {
                this._o.onNext(x);
                this._r <= 0 && this._o.onCompleted();
            }
        };
        TakeObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        TakeObserver.prototype.completed = function() {
            this._o.onCompleted();
        };
        return TakeObservable;
    }(ObservableBase);
    /**
   *  Returns a specified number of contiguous elements from the start of an observable sequence, using the specified scheduler for the edge case of take(0).
   * @param {Number} count The number of elements to return.
   * @param {Scheduler} [scheduler] Scheduler used to produce an OnCompleted message in case <paramref name="count count</paramref> is set to 0.
   * @returns {Observable} An observable sequence that contains the specified number of elements from the start of the input sequence.
   */ observableProto.take = function(count, scheduler) {
        if (count < 0) throw new ArgumentOutOfRangeError();
        if (count === 0) return observableEmpty(scheduler);
        return new TakeObservable(this, count);
    };
    var TakeWhileObservable = function(__super__) {
        inherits(TakeWhileObservable, __super__);
        function TakeWhileObservable(source, fn) {
            this.source = source;
            this._fn = fn;
            __super__.call(this);
        }
        TakeWhileObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new TakeWhileObserver(o, this));
        };
        return TakeWhileObservable;
    }(ObservableBase);
    var TakeWhileObserver = function(__super__) {
        inherits(TakeWhileObserver, __super__);
        function TakeWhileObserver(o, p) {
            this._o = o;
            this._p = p;
            this._i = 0;
            this._r = true;
            __super__.call(this);
        }
        TakeWhileObserver.prototype.next = function(x) {
            if (this._r) {
                this._r = tryCatch(this._p._fn)(x, this._i++, this._p);
                if (this._r === errorObj) return this._o.onError(this._r.e);
            }
            if (this._r) this._o.onNext(x);
            else this._o.onCompleted();
        };
        TakeWhileObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        TakeWhileObserver.prototype.completed = function() {
            this._o.onCompleted();
        };
        return TakeWhileObserver;
    }(AbstractObserver);
    /**
   *  Returns elements from an observable sequence as long as a specified condition is true.
   *  The element's index is used in the logic of the predicate function.
   * @param {Function} predicate A function to test each element for a condition; the second parameter of the function represents the index of the source element.
   * @param {Any} [thisArg] Object to use as this when executing callback.
   * @returns {Observable} An observable sequence that contains the elements from the input sequence that occur before the element at which the test no longer passes.
   */ observableProto.takeWhile = function(predicate, thisArg) {
        var fn = bindCallback(predicate, thisArg, 3);
        return new TakeWhileObservable(this, fn);
    };
    var FilterObservable = function(__super__) {
        inherits(FilterObservable, __super__);
        function FilterObservable(source, predicate, thisArg) {
            this.source = source;
            this.predicate = bindCallback(predicate, thisArg, 3);
            __super__.call(this);
        }
        FilterObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new InnerObserver(o, this.predicate, this));
        };
        function innerPredicate(predicate, self1) {
            return function(x, i, o) {
                return self1.predicate(x, i, o) && predicate.call(this, x, i, o);
            };
        }
        FilterObservable.prototype.internalFilter = function(predicate, thisArg) {
            return new FilterObservable(this.source, innerPredicate(predicate, this), thisArg);
        };
        inherits(InnerObserver, AbstractObserver);
        function InnerObserver(o, predicate, source) {
            this.o = o;
            this.predicate = predicate;
            this.source = source;
            this.i = 0;
            AbstractObserver.call(this);
        }
        InnerObserver.prototype.next = function(x) {
            var shouldYield = tryCatch(this.predicate)(x, this.i++, this.source);
            if (shouldYield === errorObj) return this.o.onError(shouldYield.e);
            shouldYield && this.o.onNext(x);
        };
        InnerObserver.prototype.error = function(e) {
            this.o.onError(e);
        };
        InnerObserver.prototype.completed = function() {
            this.o.onCompleted();
        };
        return FilterObservable;
    }(ObservableBase);
    /**
  *  Filters the elements of an observable sequence based on a predicate by incorporating the element's index.
  * @param {Function} predicate A function to test each source element for a condition; the second parameter of the function represents the index of the source element.
  * @param {Any} [thisArg] Object to use as this when executing callback.
  * @returns {Observable} An observable sequence that contains elements from the input sequence that satisfy the condition.
  */ observableProto.filter = observableProto.where = function(predicate, thisArg) {
        return this instanceof FilterObservable ? this.internalFilter(predicate, thisArg) : new FilterObservable(this, predicate, thisArg);
    };
    var TransduceObserver = function(__super__) {
        inherits(TransduceObserver, __super__);
        function TransduceObserver(o, xform) {
            this._o = o;
            this._xform = xform;
            __super__.call(this);
        }
        TransduceObserver.prototype.next = function(x) {
            var res = tryCatch(this._xform['@@transducer/step']).call(this._xform, this._o, x);
            if (res === errorObj) this._o.onError(res.e);
        };
        TransduceObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        TransduceObserver.prototype.completed = function() {
            this._xform['@@transducer/result'](this._o);
        };
        return TransduceObserver;
    }(AbstractObserver);
    function transformForObserver(o) {
        return {
            '@@transducer/init': function() {
                return o;
            },
            '@@transducer/step': function(obs, input) {
                return obs.onNext(input);
            },
            '@@transducer/result': function(obs) {
                return obs.onCompleted();
            }
        };
    }
    /**
   * Executes a transducer to transform the observable sequence
   * @param {Transducer} transducer A transducer to execute
   * @returns {Observable} An Observable sequence containing the results from the transducer.
   */ observableProto.transduce = function(transducer) {
        var source = this;
        return new AnonymousObservable(function(o) {
            var xform = transducer(transformForObserver(o));
            return source.subscribe(new TransduceObserver(o, xform));
        }, source);
    };
    var AnonymousObservable = Rx.AnonymousObservable = function(__super__) {
        inherits(AnonymousObservable, __super__);
        // Fix subscriber to check for undefined or function returned to decorate as Disposable
        function fixSubscriber(subscriber) {
            return subscriber && isFunction(subscriber.dispose) ? subscriber : isFunction(subscriber) ? disposableCreate(subscriber) : disposableEmpty;
        }
        function setDisposable(s, state) {
            var ado = state[0], self1 = state[1];
            var sub = tryCatch(self1.__subscribe).call(self1, ado);
            if (sub === errorObj && !ado.fail(errorObj.e)) thrower(errorObj.e);
            ado.setDisposable(fixSubscriber(sub));
        }
        function AnonymousObservable(subscribe, parent) {
            this.source = parent;
            this.__subscribe = subscribe;
            __super__.call(this);
        }
        AnonymousObservable.prototype._subscribe = function(o) {
            var ado = new AutoDetachObserver(o), state = [
                ado,
                this
            ];
            if (currentThreadScheduler.scheduleRequired()) currentThreadScheduler.schedule(state, setDisposable);
            else setDisposable(null, state);
            return ado;
        };
        return AnonymousObservable;
    }(Observable);
    var AutoDetachObserver = function(__super__) {
        inherits(AutoDetachObserver, __super__);
        function AutoDetachObserver(observer) {
            __super__.call(this);
            this.observer = observer;
            this.m = new SingleAssignmentDisposable();
        }
        var AutoDetachObserverPrototype = AutoDetachObserver.prototype;
        AutoDetachObserverPrototype.next = function(value) {
            var result = tryCatch(this.observer.onNext).call(this.observer, value);
            if (result === errorObj) {
                this.dispose();
                thrower(result.e);
            }
        };
        AutoDetachObserverPrototype.error = function(err) {
            var result = tryCatch(this.observer.onError).call(this.observer, err);
            this.dispose();
            result === errorObj && thrower(result.e);
        };
        AutoDetachObserverPrototype.completed = function() {
            var result = tryCatch(this.observer.onCompleted).call(this.observer);
            this.dispose();
            result === errorObj && thrower(result.e);
        };
        AutoDetachObserverPrototype.setDisposable = function(value) {
            this.m.setDisposable(value);
        };
        AutoDetachObserverPrototype.getDisposable = function() {
            return this.m.getDisposable();
        };
        AutoDetachObserverPrototype.dispose = function() {
            __super__.prototype.dispose.call(this);
            this.m.dispose();
        };
        return AutoDetachObserver;
    }(AbstractObserver);
    var InnerSubscription = function(s, o) {
        this._s = s;
        this._o = o;
    };
    InnerSubscription.prototype.dispose = function() {
        if (!this._s.isDisposed && this._o !== null) {
            var idx = this._s.observers.indexOf(this._o);
            this._s.observers.splice(idx, 1);
            this._o = null;
        }
    };
    /**
   *  Represents an object that is both an observable sequence as well as an observer.
   *  Each notification is broadcasted to all subscribed observers.
   */ var Subject = Rx.Subject = function(__super__) {
        inherits(Subject, __super__);
        function Subject() {
            __super__.call(this);
            this.isDisposed = false;
            this.isStopped = false;
            this.observers = [];
            this.hasError = false;
        }
        addProperties(Subject.prototype, Observer.prototype, {
            _subscribe: function(o) {
                checkDisposed(this);
                if (!this.isStopped) {
                    this.observers.push(o);
                    return new InnerSubscription(this, o);
                }
                if (this.hasError) {
                    o.onError(this.error);
                    return disposableEmpty;
                }
                o.onCompleted();
                return disposableEmpty;
            },
            /**
       * Indicates whether the subject has observers subscribed to it.
       * @returns {Boolean} Indicates whether the subject has observers subscribed to it.
       */ hasObservers: function() {
                checkDisposed(this);
                return this.observers.length > 0;
            },
            /**
       * Notifies all subscribed observers about the end of the sequence.
       */ onCompleted: function() {
                checkDisposed(this);
                if (!this.isStopped) {
                    this.isStopped = true;
                    for(var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++)os[i].onCompleted();
                    this.observers.length = 0;
                }
            },
            /**
       * Notifies all subscribed observers about the exception.
       * @param {Mixed} error The exception to send to all observers.
       */ onError: function(error) {
                checkDisposed(this);
                if (!this.isStopped) {
                    this.isStopped = true;
                    this.error = error;
                    this.hasError = true;
                    for(var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++)os[i].onError(error);
                    this.observers.length = 0;
                }
            },
            /**
       * Notifies all subscribed observers about the arrival of the specified element in the sequence.
       * @param {Mixed} value The value to send to all observers.
       */ onNext: function(value) {
                checkDisposed(this);
                if (!this.isStopped) for(var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++)os[i].onNext(value);
            },
            /**
       * Unsubscribe all observers and release resources.
       */ dispose: function() {
                this.isDisposed = true;
                this.observers = null;
            }
        });
        /**
     * Creates a subject from the specified observer and observable.
     * @param {Observer} observer The observer used to send messages to the subject.
     * @param {Observable} observable The observable used to subscribe to messages sent from the subject.
     * @returns {Subject} Subject implemented using the given observer and observable.
     */ Subject.create = function(observer, observable) {
            return new AnonymousSubject(observer, observable);
        };
        return Subject;
    }(Observable);
    /**
   *  Represents the result of an asynchronous operation.
   *  The last value before the OnCompleted notification, or the error received through OnError, is sent to all subscribed observers.
   */ var AsyncSubject = Rx.AsyncSubject = function(__super__) {
        inherits(AsyncSubject, __super__);
        /**
     * Creates a subject that can only receive one value and that value is cached for all future observations.
     * @constructor
     */ function AsyncSubject() {
            __super__.call(this);
            this.isDisposed = false;
            this.isStopped = false;
            this.hasValue = false;
            this.observers = [];
            this.hasError = false;
        }
        addProperties(AsyncSubject.prototype, Observer.prototype, {
            _subscribe: function(o) {
                checkDisposed(this);
                if (!this.isStopped) {
                    this.observers.push(o);
                    return new InnerSubscription(this, o);
                }
                if (this.hasError) o.onError(this.error);
                else if (this.hasValue) {
                    o.onNext(this.value);
                    o.onCompleted();
                } else o.onCompleted();
                return disposableEmpty;
            },
            /**
       * Indicates whether the subject has observers subscribed to it.
       * @returns {Boolean} Indicates whether the subject has observers subscribed to it.
       */ hasObservers: function() {
                checkDisposed(this);
                return this.observers.length > 0;
            },
            /**
       * Notifies all subscribed observers about the end of the sequence, also causing the last received value to be sent out (if any).
       */ onCompleted: function() {
                var i, len;
                checkDisposed(this);
                if (!this.isStopped) {
                    this.isStopped = true;
                    var os = cloneArray(this.observers), len = os.length;
                    if (this.hasValue) for(i = 0; i < len; i++){
                        var o = os[i];
                        o.onNext(this.value);
                        o.onCompleted();
                    }
                    else for(i = 0; i < len; i++)os[i].onCompleted();
                    this.observers.length = 0;
                }
            },
            /**
       * Notifies all subscribed observers about the error.
       * @param {Mixed} error The Error to send to all observers.
       */ onError: function(error) {
                checkDisposed(this);
                if (!this.isStopped) {
                    this.isStopped = true;
                    this.hasError = true;
                    this.error = error;
                    for(var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++)os[i].onError(error);
                    this.observers.length = 0;
                }
            },
            /**
       * Sends a value to the subject. The last value received before successful termination will be sent to all subscribed and future observers.
       * @param {Mixed} value The value to store in the subject.
       */ onNext: function(value) {
                checkDisposed(this);
                if (this.isStopped) return;
                this.value = value;
                this.hasValue = true;
            },
            /**
       * Unsubscribe all observers and release resources.
       */ dispose: function() {
                this.isDisposed = true;
                this.observers = null;
                this.error = null;
                this.value = null;
            }
        });
        return AsyncSubject;
    }(Observable);
    var AnonymousSubject = Rx.AnonymousSubject = function(__super__) {
        inherits(AnonymousSubject, __super__);
        function AnonymousSubject(observer, observable) {
            this.observer = observer;
            this.observable = observable;
            __super__.call(this);
        }
        addProperties(AnonymousSubject.prototype, Observer.prototype, {
            _subscribe: function(o) {
                return this.observable.subscribe(o);
            },
            onCompleted: function() {
                this.observer.onCompleted();
            },
            onError: function(error) {
                this.observer.onError(error);
            },
            onNext: function(value) {
                this.observer.onNext(value);
            }
        });
        return AnonymousSubject;
    }(Observable);
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        root.Rx = Rx;
        define(function() {
            return Rx;
        });
    } else if (freeExports && freeModule) {
        // in Node.js or RingoJS
        if (moduleExports) (freeModule.exports = Rx).Rx = Rx;
        else freeExports.Rx = Rx;
    } else // in a browser or Rhino
    root.Rx = Rx;
    // All code before this point will be filtered from stack traces.
    var rEndingLine = captureLine();
}).call(this);

});

parcelRegister("9Jej3", function(module, exports) {
// Copyright (c) Microsoft, All rights reserved. See License.txt in the project root for license information.

(function(factory) {
    var objectTypes = {
        'function': true,
        'object': true
    };
    function checkGlobal(value) {
        return value && value.Object === Object ? value : null;
    }
    var freeExports = objectTypes["object"] && exports && !exports.nodeType ? exports : null;
    var freeModule = objectTypes["object"] && module && !module.nodeType ? module : null;
    var freeGlobal = checkGlobal(freeExports && freeModule && typeof $parcel$global === 'object' && $parcel$global);
    var freeSelf = checkGlobal(objectTypes[typeof self] && self);
    var freeWindow = checkGlobal(objectTypes[typeof window] && window);
    var moduleExports = freeModule && freeModule.exports === freeExports ? freeExports : null;
    var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
    var root = freeGlobal || freeWindow !== (thisGlobal && thisGlobal.window) && freeWindow || freeSelf || thisGlobal || Function('return this')();
    // Because of build optimizers
    if (typeof define === 'function' && define.amd) define([
        './rx'
    ], function(Rx, exports1) {
        return factory(root, exports1, Rx);
    });
    else if (module && module.exports === freeExports) module.exports = factory(root, module.exports, (parcelRequire("kTZM9")));
    else root.Rx = factory(root, {}, root.Rx);
}).call(this, function(root, exp, Rx, undefined) {
    // References
    var Observable = Rx.Observable, observableProto = Observable.prototype, BinaryDisposable = Rx.BinaryDisposable, AnonymousObservable = Rx.AnonymousObservable, AbstractObserver = Rx.internals.AbstractObserver, disposableEmpty = Rx.Disposable.empty, helpers = Rx.helpers, defaultComparer = helpers.defaultComparer, identity = helpers.identity, defaultSubComparer = helpers.defaultSubComparer, isFunction = helpers.isFunction, isPromise = helpers.isPromise, isArrayLike = helpers.isArrayLike, isIterable = helpers.isIterable, inherits = Rx.internals.inherits, observableFromPromise = Observable.fromPromise, observableFrom = Observable.from, bindCallback = Rx.internals.bindCallback, EmptyError = Rx.EmptyError, ObservableBase = Rx.ObservableBase, ArgumentOutOfRangeError = Rx.ArgumentOutOfRangeError;
    var errorObj = {
        e: {}
    };
    function tryCatcherGen(tryCatchTarget) {
        return function tryCatcher() {
            try {
                return tryCatchTarget.apply(this, arguments);
            } catch (e) {
                errorObj.e = e;
                return errorObj;
            }
        };
    }
    var tryCatch = Rx.internals.tryCatch = function tryCatch(fn) {
        if (!isFunction(fn)) throw new TypeError('fn must be a function');
        return tryCatcherGen(fn);
    };
    function thrower(e) {
        throw e;
    }
    var ExtremaByObservable = function(__super__) {
        inherits(ExtremaByObservable, __super__);
        function ExtremaByObservable(source, k, c) {
            this.source = source;
            this._k = k;
            this._c = c;
            __super__.call(this);
        }
        ExtremaByObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new ExtremaByObserver(o, this._k, this._c));
        };
        return ExtremaByObservable;
    }(ObservableBase);
    var ExtremaByObserver = function(__super__) {
        inherits(ExtremaByObserver, __super__);
        function ExtremaByObserver(o, k, c) {
            this._o = o;
            this._k = k;
            this._c = c;
            this._v = null;
            this._hv = false;
            this._l = [];
            __super__.call(this);
        }
        ExtremaByObserver.prototype.next = function(x) {
            var key = tryCatch(this._k)(x);
            if (key === errorObj) return this._o.onError(key.e);
            var comparison = 0;
            if (!this._hv) {
                this._hv = true;
                this._v = key;
            } else {
                comparison = tryCatch(this._c)(key, this._v);
                if (comparison === errorObj) return this._o.onError(comparison.e);
            }
            if (comparison > 0) {
                this._v = key;
                this._l = [];
            }
            if (comparison >= 0) this._l.push(x);
        };
        ExtremaByObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        ExtremaByObserver.prototype.completed = function() {
            this._o.onNext(this._l);
            this._o.onCompleted();
        };
        return ExtremaByObserver;
    }(AbstractObserver);
    function firstOnly(x) {
        if (x.length === 0) throw new EmptyError();
        return x[0];
    }
    var ReduceObservable = function(__super__) {
        inherits(ReduceObservable, __super__);
        function ReduceObservable(source, accumulator, hasSeed, seed) {
            this.source = source;
            this.accumulator = accumulator;
            this.hasSeed = hasSeed;
            this.seed = seed;
            __super__.call(this);
        }
        ReduceObservable.prototype.subscribeCore = function(observer) {
            return this.source.subscribe(new ReduceObserver(observer, this));
        };
        return ReduceObservable;
    }(ObservableBase);
    var ReduceObserver = function(__super__) {
        inherits(ReduceObserver, __super__);
        function ReduceObserver(o, parent) {
            this._o = o;
            this._p = parent;
            this._fn = parent.accumulator;
            this._hs = parent.hasSeed;
            this._s = parent.seed;
            this._ha = false;
            this._a = null;
            this._hv = false;
            this._i = 0;
            __super__.call(this);
        }
        ReduceObserver.prototype.next = function(x) {
            !this._hv && (this._hv = true);
            if (this._ha) this._a = tryCatch(this._fn)(this._a, x, this._i, this._p);
            else {
                this._a = this._hs ? tryCatch(this._fn)(this._s, x, this._i, this._p) : x;
                this._ha = true;
            }
            if (this._a === errorObj) return this._o.onError(this._a.e);
            this._i++;
        };
        ReduceObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        ReduceObserver.prototype.completed = function() {
            this._hv && this._o.onNext(this._a);
            !this._hv && this._hs && this._o.onNext(this._s);
            !this._hv && !this._hs && this._o.onError(new EmptyError());
            this._o.onCompleted();
        };
        return ReduceObserver;
    }(AbstractObserver);
    /**
  * Applies an accumulator function over an observable sequence, returning the result of the aggregation as a single element in the result sequence. The specified seed value is used as the initial accumulator value.
  * For aggregation behavior with incremental intermediate results, see Observable.scan.
  * @param {Function} accumulator An accumulator function to be invoked on each element.
  * @param {Any} [seed] The initial accumulator value.
  * @returns {Observable} An observable sequence containing a single element with the final accumulator value.
  */ observableProto.reduce = function() {
        var hasSeed = false, seed, accumulator = arguments[0];
        if (arguments.length === 2) {
            hasSeed = true;
            seed = arguments[1];
        }
        return new ReduceObservable(this, accumulator, hasSeed, seed);
    };
    var SomeObservable = function(__super__) {
        inherits(SomeObservable, __super__);
        function SomeObservable(source, fn) {
            this.source = source;
            this._fn = fn;
            __super__.call(this);
        }
        SomeObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new SomeObserver(o, this._fn, this.source));
        };
        return SomeObservable;
    }(ObservableBase);
    var SomeObserver = function(__super__) {
        inherits(SomeObserver, __super__);
        function SomeObserver(o, fn, s) {
            this._o = o;
            this._fn = fn;
            this._s = s;
            this._i = 0;
            __super__.call(this);
        }
        SomeObserver.prototype.next = function(x) {
            var result = tryCatch(this._fn)(x, this._i++, this._s);
            if (result === errorObj) return this._o.onError(result.e);
            if (Boolean(result)) {
                this._o.onNext(true);
                this._o.onCompleted();
            }
        };
        SomeObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        SomeObserver.prototype.completed = function() {
            this._o.onNext(false);
            this._o.onCompleted();
        };
        return SomeObserver;
    }(AbstractObserver);
    /**
   * Determines whether any element of an observable sequence satisfies a condition if present, else if any items are in the sequence.
   * @param {Function} [predicate] A function to test each element for a condition.
   * @returns {Observable} An observable sequence containing a single element determining whether any elements in the source sequence pass the test in the specified predicate if given, else if any items are in the sequence.
   */ observableProto.some = function(predicate, thisArg) {
        var fn = bindCallback(predicate, thisArg, 3);
        return new SomeObservable(this, fn);
    };
    var IsEmptyObservable = function(__super__) {
        inherits(IsEmptyObservable, __super__);
        function IsEmptyObservable(source) {
            this.source = source;
            __super__.call(this);
        }
        IsEmptyObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new IsEmptyObserver(o));
        };
        return IsEmptyObservable;
    }(ObservableBase);
    var IsEmptyObserver = function(__super__) {
        inherits(IsEmptyObserver, __super__);
        function IsEmptyObserver(o) {
            this._o = o;
            __super__.call(this);
        }
        IsEmptyObserver.prototype.next = function() {
            this._o.onNext(false);
            this._o.onCompleted();
        };
        IsEmptyObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        IsEmptyObserver.prototype.completed = function() {
            this._o.onNext(true);
            this._o.onCompleted();
        };
        return IsEmptyObserver;
    }(AbstractObserver);
    /**
   * Determines whether an observable sequence is empty.
   * @returns {Observable} An observable sequence containing a single element determining whether the source sequence is empty.
   */ observableProto.isEmpty = function() {
        return new IsEmptyObservable(this);
    };
    var EveryObservable = function(__super__) {
        inherits(EveryObservable, __super__);
        function EveryObservable(source, fn) {
            this.source = source;
            this._fn = fn;
            __super__.call(this);
        }
        EveryObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new EveryObserver(o, this._fn, this.source));
        };
        return EveryObservable;
    }(ObservableBase);
    var EveryObserver = function(__super__) {
        inherits(EveryObserver, __super__);
        function EveryObserver(o, fn, s) {
            this._o = o;
            this._fn = fn;
            this._s = s;
            this._i = 0;
            __super__.call(this);
        }
        EveryObserver.prototype.next = function(x) {
            var result = tryCatch(this._fn)(x, this._i++, this._s);
            if (result === errorObj) return this._o.onError(result.e);
            if (!Boolean(result)) {
                this._o.onNext(false);
                this._o.onCompleted();
            }
        };
        EveryObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        EveryObserver.prototype.completed = function() {
            this._o.onNext(true);
            this._o.onCompleted();
        };
        return EveryObserver;
    }(AbstractObserver);
    /**
   * Determines whether all elements of an observable sequence satisfy a condition.
   * @param {Function} [predicate] A function to test each element for a condition.
   * @param {Any} [thisArg] Object to use as this when executing callback.
   * @returns {Observable} An observable sequence containing a single element determining whether all elements in the source sequence pass the test in the specified predicate.
   */ observableProto.every = function(predicate, thisArg) {
        var fn = bindCallback(predicate, thisArg, 3);
        return new EveryObservable(this, fn);
    };
    var IncludesObservable = function(__super__) {
        inherits(IncludesObservable, __super__);
        function IncludesObservable(source, elem, idx) {
            var n = +idx || 0;
            Math.abs(n) === Infinity && (n = 0);
            this.source = source;
            this._elem = elem;
            this._n = n;
            __super__.call(this);
        }
        IncludesObservable.prototype.subscribeCore = function(o) {
            if (this._n < 0) {
                o.onNext(false);
                o.onCompleted();
                return disposableEmpty;
            }
            return this.source.subscribe(new IncludesObserver(o, this._elem, this._n));
        };
        return IncludesObservable;
    }(ObservableBase);
    var IncludesObserver = function(__super__) {
        inherits(IncludesObserver, __super__);
        function IncludesObserver(o, elem, n) {
            this._o = o;
            this._elem = elem;
            this._n = n;
            this._i = 0;
            __super__.call(this);
        }
        function comparer(a, b) {
            return a === 0 && b === 0 || a === b || isNaN(a) && isNaN(b);
        }
        IncludesObserver.prototype.next = function(x) {
            if (this._i++ >= this._n && comparer(x, this._elem)) {
                this._o.onNext(true);
                this._o.onCompleted();
            }
        };
        IncludesObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        IncludesObserver.prototype.completed = function() {
            this._o.onNext(false);
            this._o.onCompleted();
        };
        return IncludesObserver;
    }(AbstractObserver);
    /**
   * Determines whether an observable sequence includes a specified element with an optional equality comparer.
   * @param searchElement The value to locate in the source sequence.
   * @param {Number} [fromIndex] An equality comparer to compare elements.
   * @returns {Observable} An observable sequence containing a single element determining whether the source sequence includes an element that has the specified value from the given index.
   */ observableProto.includes = function(searchElement, fromIndex) {
        return new IncludesObservable(this, searchElement, fromIndex);
    };
    var CountObservable = function(__super__) {
        inherits(CountObservable, __super__);
        function CountObservable(source, fn) {
            this.source = source;
            this._fn = fn;
            __super__.call(this);
        }
        CountObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new CountObserver(o, this._fn, this.source));
        };
        return CountObservable;
    }(ObservableBase);
    var CountObserver = function(__super__) {
        inherits(CountObserver, __super__);
        function CountObserver(o, fn, s) {
            this._o = o;
            this._fn = fn;
            this._s = s;
            this._i = 0;
            this._c = 0;
            __super__.call(this);
        }
        CountObserver.prototype.next = function(x) {
            if (this._fn) {
                var result = tryCatch(this._fn)(x, this._i++, this._s);
                if (result === errorObj) return this._o.onError(result.e);
                Boolean(result) && this._c++;
            } else this._c++;
        };
        CountObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        CountObserver.prototype.completed = function() {
            this._o.onNext(this._c);
            this._o.onCompleted();
        };
        return CountObserver;
    }(AbstractObserver);
    /**
   * Returns an observable sequence containing a value that represents how many elements in the specified observable sequence satisfy a condition if provided, else the count of items.
   * @example
   * res = source.count();
   * res = source.count(function (x) { return x > 3; });
   * @param {Function} [predicate]A function to test each element for a condition.
   * @param {Any} [thisArg] Object to use as this when executing callback.
   * @returns {Observable} An observable sequence containing a single element with a number that represents how many elements in the input sequence satisfy the condition in the predicate function if provided, else the count of items in the sequence.
   */ observableProto.count = function(predicate, thisArg) {
        var fn = bindCallback(predicate, thisArg, 3);
        return new CountObservable(this, fn);
    };
    var IndexOfObservable = function(__super__) {
        inherits(IndexOfObservable, __super__);
        function IndexOfObservable(source, e, n) {
            this.source = source;
            this._e = e;
            this._n = n;
            __super__.call(this);
        }
        IndexOfObservable.prototype.subscribeCore = function(o) {
            if (this._n < 0) {
                o.onNext(-1);
                o.onCompleted();
                return disposableEmpty;
            }
            return this.source.subscribe(new IndexOfObserver(o, this._e, this._n));
        };
        return IndexOfObservable;
    }(ObservableBase);
    var IndexOfObserver = function(__super__) {
        inherits(IndexOfObserver, __super__);
        function IndexOfObserver(o, e, n) {
            this._o = o;
            this._e = e;
            this._n = n;
            this._i = 0;
            __super__.call(this);
        }
        IndexOfObserver.prototype.next = function(x) {
            if (this._i >= this._n && x === this._e) {
                this._o.onNext(this._i);
                this._o.onCompleted();
            }
            this._i++;
        };
        IndexOfObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        IndexOfObserver.prototype.completed = function() {
            this._o.onNext(-1);
            this._o.onCompleted();
        };
        return IndexOfObserver;
    }(AbstractObserver);
    /**
   * Returns the first index at which a given element can be found in the observable sequence, or -1 if it is not present.
   * @param {Any} searchElement Element to locate in the array.
   * @param {Number} [fromIndex] The index to start the search.  If not specified, defaults to 0.
   * @returns {Observable} And observable sequence containing the first index at which a given element can be found in the observable sequence, or -1 if it is not present.
   */ observableProto.indexOf = function(searchElement, fromIndex) {
        var n = +fromIndex || 0;
        Math.abs(n) === Infinity && (n = 0);
        return new IndexOfObservable(this, searchElement, n);
    };
    var SumObservable = function(__super__) {
        inherits(SumObservable, __super__);
        function SumObservable(source, fn) {
            this.source = source;
            this._fn = fn;
            __super__.call(this);
        }
        SumObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new SumObserver(o, this._fn, this.source));
        };
        return SumObservable;
    }(ObservableBase);
    var SumObserver = function(__super__) {
        inherits(SumObserver, __super__);
        function SumObserver(o, fn, s) {
            this._o = o;
            this._fn = fn;
            this._s = s;
            this._i = 0;
            this._c = 0;
            __super__.call(this);
        }
        SumObserver.prototype.next = function(x) {
            if (this._fn) {
                var result = tryCatch(this._fn)(x, this._i++, this._s);
                if (result === errorObj) return this._o.onError(result.e);
                this._c += result;
            } else this._c += x;
        };
        SumObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        SumObserver.prototype.completed = function() {
            this._o.onNext(this._c);
            this._o.onCompleted();
        };
        return SumObserver;
    }(AbstractObserver);
    /**
   * Computes the sum of a sequence of values that are obtained by invoking an optional transform function on each element of the input sequence, else if not specified computes the sum on each item in the sequence.
   * @param {Function} [selector] A transform function to apply to each element.
   * @param {Any} [thisArg] Object to use as this when executing callback.
   * @returns {Observable} An observable sequence containing a single element with the sum of the values in the source sequence.
   */ observableProto.sum = function(keySelector, thisArg) {
        var fn = bindCallback(keySelector, thisArg, 3);
        return new SumObservable(this, fn);
    };
    /**
   * Returns the elements in an observable sequence with the minimum key value according to the specified comparer.
   * @example
   * var res = source.minBy(function (x) { return x.value; });
   * var res = source.minBy(function (x) { return x.value; }, function (x, y) { return x - y; });
   * @param {Function} keySelector Key selector function.
   * @param {Function} [comparer] Comparer used to compare key values.
   * @returns {Observable} An observable sequence containing a list of zero or more elements that have a minimum key value.
   */ observableProto.minBy = function(keySelector, comparer) {
        comparer || (comparer = defaultSubComparer);
        return new ExtremaByObservable(this, keySelector, function(x, y) {
            return comparer(x, y) * -1;
        });
    };
    /**
   * Returns the minimum element in an observable sequence according to the optional comparer else a default greater than less than check.
   * @example
   * var res = source.min();
   * var res = source.min(function (x, y) { return x.value - y.value; });
   * @param {Function} [comparer] Comparer used to compare elements.
   * @returns {Observable} An observable sequence containing a single element with the minimum element in the source sequence.
   */ observableProto.min = function(comparer) {
        return this.minBy(identity, comparer).map(firstOnly);
    };
    /**
   * Returns the elements in an observable sequence with the maximum  key value according to the specified comparer.
   * @example
   * var res = source.maxBy(function (x) { return x.value; });
   * var res = source.maxBy(function (x) { return x.value; }, function (x, y) { return x - y;; });
   * @param {Function} keySelector Key selector function.
   * @param {Function} [comparer]  Comparer used to compare key values.
   * @returns {Observable} An observable sequence containing a list of zero or more elements that have a maximum key value.
   */ observableProto.maxBy = function(keySelector, comparer) {
        comparer || (comparer = defaultSubComparer);
        return new ExtremaByObservable(this, keySelector, comparer);
    };
    /**
   * Returns the maximum value in an observable sequence according to the specified comparer.
   * @example
   * var res = source.max();
   * var res = source.max(function (x, y) { return x.value - y.value; });
   * @param {Function} [comparer] Comparer used to compare elements.
   * @returns {Observable} An observable sequence containing a single element with the maximum element in the source sequence.
   */ observableProto.max = function(comparer) {
        return this.maxBy(identity, comparer).map(firstOnly);
    };
    var AverageObservable = function(__super__) {
        inherits(AverageObservable, __super__);
        function AverageObservable(source, fn) {
            this.source = source;
            this._fn = fn;
            __super__.call(this);
        }
        AverageObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new AverageObserver(o, this._fn, this.source));
        };
        return AverageObservable;
    }(ObservableBase);
    var AverageObserver = function(__super__) {
        inherits(AverageObserver, __super__);
        function AverageObserver(o, fn, s) {
            this._o = o;
            this._fn = fn;
            this._s = s;
            this._c = 0;
            this._t = 0;
            __super__.call(this);
        }
        AverageObserver.prototype.next = function(x) {
            if (this._fn) {
                var r = tryCatch(this._fn)(x, this._c++, this._s);
                if (r === errorObj) return this._o.onError(r.e);
                this._t += r;
            } else {
                this._c++;
                this._t += x;
            }
        };
        AverageObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        AverageObserver.prototype.completed = function() {
            if (this._c === 0) return this._o.onError(new EmptyError());
            this._o.onNext(this._t / this._c);
            this._o.onCompleted();
        };
        return AverageObserver;
    }(AbstractObserver);
    /**
   * Computes the average of an observable sequence of values that are in the sequence or obtained by invoking a transform function on each element of the input sequence if present.
   * @param {Function} [selector] A transform function to apply to each element.
   * @param {Any} [thisArg] Object to use as this when executing callback.
   * @returns {Observable} An observable sequence containing a single element with the average of the sequence of values.
   */ observableProto.average = function(keySelector, thisArg) {
        var source = this, fn;
        if (isFunction(keySelector)) fn = bindCallback(keySelector, thisArg, 3);
        return new AverageObservable(source, fn);
    };
    /**
   *  Determines whether two sequences are equal by comparing the elements pairwise using a specified equality comparer.
   *
   * @example
   * var res = res = source.sequenceEqual([1,2,3]);
   * var res = res = source.sequenceEqual([{ value: 42 }], function (x, y) { return x.value === y.value; });
   * 3 - res = source.sequenceEqual(Rx.Observable.returnValue(42));
   * 4 - res = source.sequenceEqual(Rx.Observable.returnValue({ value: 42 }), function (x, y) { return x.value === y.value; });
   * @param {Observable} second Second observable sequence or array to compare.
   * @param {Function} [comparer] Comparer used to compare elements of both sequences.
   * @returns {Observable} An observable sequence that contains a single element which indicates whether both sequences are of equal length and their corresponding elements are equal according to the specified equality comparer.
   */ observableProto.sequenceEqual = function(second, comparer) {
        var first = this;
        comparer || (comparer = defaultComparer);
        return new AnonymousObservable(function(o) {
            var donel = false, doner = false, ql = [], qr = [];
            var subscription1 = first.subscribe(function(x) {
                if (qr.length > 0) {
                    var v = qr.shift();
                    var equal = tryCatch(comparer)(v, x);
                    if (equal === errorObj) return o.onError(equal.e);
                    if (!equal) {
                        o.onNext(false);
                        o.onCompleted();
                    }
                } else if (doner) {
                    o.onNext(false);
                    o.onCompleted();
                } else ql.push(x);
            }, function(e) {
                o.onError(e);
            }, function() {
                donel = true;
                if (ql.length === 0) {
                    if (qr.length > 0) {
                        o.onNext(false);
                        o.onCompleted();
                    } else if (doner) {
                        o.onNext(true);
                        o.onCompleted();
                    }
                }
            });
            (isArrayLike(second) || isIterable(second)) && (second = observableFrom(second));
            isPromise(second) && (second = observableFromPromise(second));
            var subscription2 = second.subscribe(function(x) {
                if (ql.length > 0) {
                    var v = ql.shift();
                    var equal = tryCatch(comparer)(v, x);
                    if (equal === errorObj) return o.onError(equal.e);
                    if (!equal) {
                        o.onNext(false);
                        o.onCompleted();
                    }
                } else if (donel) {
                    o.onNext(false);
                    o.onCompleted();
                } else qr.push(x);
            }, function(e) {
                o.onError(e);
            }, function() {
                doner = true;
                if (qr.length === 0) {
                    if (ql.length > 0) {
                        o.onNext(false);
                        o.onCompleted();
                    } else if (donel) {
                        o.onNext(true);
                        o.onCompleted();
                    }
                }
            });
            return new BinaryDisposable(subscription1, subscription2);
        }, first);
    };
    var ElementAtObservable = function(__super__) {
        inherits(ElementAtObservable, __super__);
        function ElementAtObservable(source, i, d) {
            this.source = source;
            this._i = i;
            this._d = d;
            __super__.call(this);
        }
        ElementAtObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new ElementAtObserver(o, this._i, this._d));
        };
        return ElementAtObservable;
    }(ObservableBase);
    var ElementAtObserver = function(__super__) {
        inherits(ElementAtObserver, __super__);
        function ElementAtObserver(o, i, d) {
            this._o = o;
            this._i = i;
            this._d = d;
            __super__.call(this);
        }
        ElementAtObserver.prototype.next = function(x) {
            if (this._i-- === 0) {
                this._o.onNext(x);
                this._o.onCompleted();
            }
        };
        ElementAtObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        ElementAtObserver.prototype.completed = function() {
            if (this._d === undefined) this._o.onError(new ArgumentOutOfRangeError());
            else {
                this._o.onNext(this._d);
                this._o.onCompleted();
            }
        };
        return ElementAtObserver;
    }(AbstractObserver);
    /**
   * Returns the element at a specified index in a sequence or default value if not found.
   * @param {Number} index The zero-based index of the element to retrieve.
   * @param {Any} [defaultValue] The default value to use if elementAt does not find a value.
   * @returns {Observable} An observable sequence that produces the element at the specified position in the source sequence.
   */ observableProto.elementAt = function(index, defaultValue) {
        if (index < 0) throw new ArgumentOutOfRangeError();
        return new ElementAtObservable(this, index, defaultValue);
    };
    var SingleObserver = function(__super__) {
        inherits(SingleObserver, __super__);
        function SingleObserver(o, obj, s) {
            this._o = o;
            this._obj = obj;
            this._s = s;
            this._i = 0;
            this._hv = false;
            this._v = null;
            __super__.call(this);
        }
        SingleObserver.prototype.next = function(x) {
            var shouldYield = false;
            if (this._obj.predicate) {
                var res = tryCatch(this._obj.predicate)(x, this._i++, this._s);
                if (res === errorObj) return this._o.onError(res.e);
                Boolean(res) && (shouldYield = true);
            } else if (!this._obj.predicate) shouldYield = true;
            if (shouldYield) {
                if (this._hv) return this._o.onError(new Error('Sequence contains more than one matching element'));
                this._hv = true;
                this._v = x;
            }
        };
        SingleObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        SingleObserver.prototype.completed = function() {
            if (this._hv) {
                this._o.onNext(this._v);
                this._o.onCompleted();
            } else if (this._obj.defaultValue === undefined) this._o.onError(new EmptyError());
            else {
                this._o.onNext(this._obj.defaultValue);
                this._o.onCompleted();
            }
        };
        return SingleObserver;
    }(AbstractObserver);
    /**
     * Returns the only element of an observable sequence that satisfies the condition in the optional predicate, and reports an exception if there is not exactly one element in the observable sequence.
     * @returns {Observable} Sequence containing the single element in the observable sequence that satisfies the condition in the predicate.
     */ observableProto.single = function(predicate, thisArg) {
        var obj = {}, source = this;
        if (typeof arguments[0] === 'object') obj = arguments[0];
        else obj = {
            predicate: arguments[0],
            thisArg: arguments[1],
            defaultValue: arguments[2]
        };
        if (isFunction(obj.predicate)) {
            var fn = obj.predicate;
            obj.predicate = bindCallback(fn, obj.thisArg, 3);
        }
        return new AnonymousObservable(function(o) {
            return source.subscribe(new SingleObserver(o, obj, source));
        }, source);
    };
    var FirstObservable = function(__super__) {
        inherits(FirstObservable, __super__);
        function FirstObservable(source, obj) {
            this.source = source;
            this._obj = obj;
            __super__.call(this);
        }
        FirstObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new FirstObserver(o, this._obj, this.source));
        };
        return FirstObservable;
    }(ObservableBase);
    var FirstObserver = function(__super__) {
        inherits(FirstObserver, __super__);
        function FirstObserver(o, obj, s) {
            this._o = o;
            this._obj = obj;
            this._s = s;
            this._i = 0;
            __super__.call(this);
        }
        FirstObserver.prototype.next = function(x) {
            if (this._obj.predicate) {
                var res = tryCatch(this._obj.predicate)(x, this._i++, this._s);
                if (res === errorObj) return this._o.onError(res.e);
                if (Boolean(res)) {
                    this._o.onNext(x);
                    this._o.onCompleted();
                }
            } else if (!this._obj.predicate) {
                this._o.onNext(x);
                this._o.onCompleted();
            }
        };
        FirstObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        FirstObserver.prototype.completed = function() {
            if (this._obj.defaultValue === undefined) this._o.onError(new EmptyError());
            else {
                this._o.onNext(this._obj.defaultValue);
                this._o.onCompleted();
            }
        };
        return FirstObserver;
    }(AbstractObserver);
    /**
   * Returns the first element of an observable sequence that satisfies the condition in the predicate if present else the first item in the sequence.
   * @returns {Observable} Sequence containing the first element in the observable sequence that satisfies the condition in the predicate if provided, else the first item in the sequence.
   */ observableProto.first = function() {
        var obj = {}, source = this;
        if (typeof arguments[0] === 'object') obj = arguments[0];
        else obj = {
            predicate: arguments[0],
            thisArg: arguments[1],
            defaultValue: arguments[2]
        };
        if (isFunction(obj.predicate)) {
            var fn = obj.predicate;
            obj.predicate = bindCallback(fn, obj.thisArg, 3);
        }
        return new FirstObservable(this, obj);
    };
    var LastObservable = function(__super__) {
        inherits(LastObservable, __super__);
        function LastObservable(source, obj) {
            this.source = source;
            this._obj = obj;
            __super__.call(this);
        }
        LastObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new LastObserver(o, this._obj, this.source));
        };
        return LastObservable;
    }(ObservableBase);
    var LastObserver = function(__super__) {
        inherits(LastObserver, __super__);
        function LastObserver(o, obj, s) {
            this._o = o;
            this._obj = obj;
            this._s = s;
            this._i = 0;
            this._hv = false;
            this._v = null;
            __super__.call(this);
        }
        LastObserver.prototype.next = function(x) {
            var shouldYield = false;
            if (this._obj.predicate) {
                var res = tryCatch(this._obj.predicate)(x, this._i++, this._s);
                if (res === errorObj) return this._o.onError(res.e);
                Boolean(res) && (shouldYield = true);
            } else if (!this._obj.predicate) shouldYield = true;
            if (shouldYield) {
                this._hv = true;
                this._v = x;
            }
        };
        LastObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        LastObserver.prototype.completed = function() {
            if (this._hv) {
                this._o.onNext(this._v);
                this._o.onCompleted();
            } else if (this._obj.defaultValue === undefined) this._o.onError(new EmptyError());
            else {
                this._o.onNext(this._obj.defaultValue);
                this._o.onCompleted();
            }
        };
        return LastObserver;
    }(AbstractObserver);
    /**
   * Returns the last element of an observable sequence that satisfies the condition in the predicate if specified, else the last element.
   * @returns {Observable} Sequence containing the last element in the observable sequence that satisfies the condition in the predicate.
   */ observableProto.last = function() {
        var obj = {}, source = this;
        if (typeof arguments[0] === 'object') obj = arguments[0];
        else obj = {
            predicate: arguments[0],
            thisArg: arguments[1],
            defaultValue: arguments[2]
        };
        if (isFunction(obj.predicate)) {
            var fn = obj.predicate;
            obj.predicate = bindCallback(fn, obj.thisArg, 3);
        }
        return new LastObservable(this, obj);
    };
    var FindValueObserver = function(__super__) {
        inherits(FindValueObserver, __super__);
        function FindValueObserver(observer, source, callback, yieldIndex) {
            this._o = observer;
            this._s = source;
            this._cb = callback;
            this._y = yieldIndex;
            this._i = 0;
            __super__.call(this);
        }
        FindValueObserver.prototype.next = function(x) {
            var shouldRun = tryCatch(this._cb)(x, this._i, this._s);
            if (shouldRun === errorObj) return this._o.onError(shouldRun.e);
            if (shouldRun) {
                this._o.onNext(this._y ? this._i : x);
                this._o.onCompleted();
            } else this._i++;
        };
        FindValueObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        FindValueObserver.prototype.completed = function() {
            this._y && this._o.onNext(-1);
            this._o.onCompleted();
        };
        return FindValueObserver;
    }(AbstractObserver);
    function findValue(source, predicate, thisArg, yieldIndex) {
        var callback = bindCallback(predicate, thisArg, 3);
        return new AnonymousObservable(function(o) {
            return source.subscribe(new FindValueObserver(o, source, callback, yieldIndex));
        }, source);
    }
    /**
   * Searches for an element that matches the conditions defined by the specified predicate, and returns the first occurrence within the entire Observable sequence.
   * @param {Function} predicate The predicate that defines the conditions of the element to search for.
   * @param {Any} [thisArg] Object to use as `this` when executing the predicate.
   * @returns {Observable} An Observable sequence with the first element that matches the conditions defined by the specified predicate, if found; otherwise, undefined.
   */ observableProto.find = function(predicate, thisArg) {
        return findValue(this, predicate, thisArg, false);
    };
    /**
   * Searches for an element that matches the conditions defined by the specified predicate, and returns
   * an Observable sequence with the zero-based index of the first occurrence within the entire Observable sequence.
   * @param {Function} predicate The predicate that defines the conditions of the element to search for.
   * @param {Any} [thisArg] Object to use as `this` when executing the predicate.
   * @returns {Observable} An Observable sequence with the zero-based index of the first occurrence of an element that matches the conditions defined by match, if found; otherwise, –1.
  */ observableProto.findIndex = function(predicate, thisArg) {
        return findValue(this, predicate, thisArg, true);
    };
    var ToSetObservable = function(__super__) {
        inherits(ToSetObservable, __super__);
        function ToSetObservable(source) {
            this.source = source;
            __super__.call(this);
        }
        ToSetObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new ToSetObserver(o));
        };
        return ToSetObservable;
    }(ObservableBase);
    var ToSetObserver = function(__super__) {
        inherits(ToSetObserver, __super__);
        function ToSetObserver(o) {
            this._o = o;
            this._s = new root.Set();
            __super__.call(this);
        }
        ToSetObserver.prototype.next = function(x) {
            this._s.add(x);
        };
        ToSetObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        ToSetObserver.prototype.completed = function() {
            this._o.onNext(this._s);
            this._o.onCompleted();
        };
        return ToSetObserver;
    }(AbstractObserver);
    /**
   * Converts the observable sequence to a Set if it exists.
   * @returns {Observable} An observable sequence with a single value of a Set containing the values from the observable sequence.
   */ observableProto.toSet = function() {
        if (typeof root.Set === 'undefined') throw new TypeError();
        return new ToSetObservable(this);
    };
    var ToMapObservable = function(__super__) {
        inherits(ToMapObservable, __super__);
        function ToMapObservable(source, k, e) {
            this.source = source;
            this._k = k;
            this._e = e;
            __super__.call(this);
        }
        ToMapObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new ToMapObserver(o, this._k, this._e));
        };
        return ToMapObservable;
    }(ObservableBase);
    var ToMapObserver = function(__super__) {
        inherits(ToMapObserver, __super__);
        function ToMapObserver(o, k, e) {
            this._o = o;
            this._k = k;
            this._e = e;
            this._m = new root.Map();
            __super__.call(this);
        }
        ToMapObserver.prototype.next = function(x) {
            var key = tryCatch(this._k)(x);
            if (key === errorObj) return this._o.onError(key.e);
            var elem = x;
            if (this._e) {
                elem = tryCatch(this._e)(x);
                if (elem === errorObj) return this._o.onError(elem.e);
            }
            this._m.set(key, elem);
        };
        ToMapObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        ToMapObserver.prototype.completed = function() {
            this._o.onNext(this._m);
            this._o.onCompleted();
        };
        return ToMapObserver;
    }(AbstractObserver);
    /**
  * Converts the observable sequence to a Map if it exists.
  * @param {Function} keySelector A function which produces the key for the Map.
  * @param {Function} [elementSelector] An optional function which produces the element for the Map. If not present, defaults to the value from the observable sequence.
  * @returns {Observable} An observable sequence with a single value of a Map containing the values from the observable sequence.
  */ observableProto.toMap = function(keySelector, elementSelector) {
        if (typeof root.Map === 'undefined') throw new TypeError();
        return new ToMapObservable(this, keySelector, elementSelector);
    };
    var SliceObservable = function(__super__) {
        inherits(SliceObservable, __super__);
        function SliceObservable(source, b, e) {
            this.source = source;
            this._b = b;
            this._e = e;
            __super__.call(this);
        }
        SliceObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new SliceObserver(o, this._b, this._e));
        };
        return SliceObservable;
    }(ObservableBase);
    var SliceObserver = function(__super__) {
        inherits(SliceObserver, __super__);
        function SliceObserver(o, b, e) {
            this._o = o;
            this._b = b;
            this._e = e;
            this._i = 0;
            __super__.call(this);
        }
        SliceObserver.prototype.next = function(x) {
            if (this._i >= this._b) {
                if (this._e === this._i) this._o.onCompleted();
                else this._o.onNext(x);
            }
            this._i++;
        };
        SliceObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        SliceObserver.prototype.completed = function() {
            this._o.onCompleted();
        };
        return SliceObserver;
    }(AbstractObserver);
    /*
  * The slice() method returns a shallow copy of a portion of an Observable into a new Observable object.
  * Unlike the array version, this does not support negative numbers for being or end.
  * @param {Number} [begin] Zero-based index at which to begin extraction. If omitted, this will default to zero.
  * @param {Number} [end] Zero-based index at which to end extraction. slice extracts up to but not including end.
  * If omitted, this will emit the rest of the Observable object.
  * @returns {Observable} A shallow copy of a portion of an Observable into a new Observable object.
  */ observableProto.slice = function(begin, end) {
        var start = begin || 0;
        if (start < 0) throw new Rx.ArgumentOutOfRangeError();
        if (typeof end === 'number' && end < start) throw new Rx.ArgumentOutOfRangeError();
        return new SliceObservable(this, start, end);
    };
    var LastIndexOfObservable = function(__super__) {
        inherits(LastIndexOfObservable, __super__);
        function LastIndexOfObservable(source, e, n) {
            this.source = source;
            this._e = e;
            this._n = n;
            __super__.call(this);
        }
        LastIndexOfObservable.prototype.subscribeCore = function(o) {
            if (this._n < 0) {
                o.onNext(-1);
                o.onCompleted();
                return disposableEmpty;
            }
            return this.source.subscribe(new LastIndexOfObserver(o, this._e, this._n));
        };
        return LastIndexOfObservable;
    }(ObservableBase);
    var LastIndexOfObserver = function(__super__) {
        inherits(LastIndexOfObserver, __super__);
        function LastIndexOfObserver(o, e, n) {
            this._o = o;
            this._e = e;
            this._n = n;
            this._v = 0;
            this._hv = false;
            this._i = 0;
            __super__.call(this);
        }
        LastIndexOfObserver.prototype.next = function(x) {
            if (this._i >= this._n && x === this._e) {
                this._hv = true;
                this._v = this._i;
            }
            this._i++;
        };
        LastIndexOfObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        LastIndexOfObserver.prototype.completed = function() {
            if (this._hv) this._o.onNext(this._v);
            else this._o.onNext(-1);
            this._o.onCompleted();
        };
        return LastIndexOfObserver;
    }(AbstractObserver);
    /**
   * Returns the last index at which a given element can be found in the observable sequence, or -1 if it is not present.
   * @param {Any} searchElement Element to locate in the array.
   * @param {Number} [fromIndex] The index to start the search.  If not specified, defaults to 0.
   * @returns {Observable} And observable sequence containing the last index at which a given element can be found in the observable sequence, or -1 if it is not present.
   */ observableProto.lastIndexOf = function(searchElement, fromIndex) {
        var n = +fromIndex || 0;
        Math.abs(n) === Infinity && (n = 0);
        return new LastIndexOfObservable(this, searchElement, n);
    };
    return Rx;
});

});

parcelRegister("h0tkF", function(module, exports) {
// Copyright (c) Microsoft, All rights reserved. See License.txt in the project root for license information.

(function(factory) {
    var objectTypes = {
        'function': true,
        'object': true
    };
    function checkGlobal(value) {
        return value && value.Object === Object ? value : null;
    }
    var freeExports = objectTypes["object"] && exports && !exports.nodeType ? exports : null;
    var freeModule = objectTypes["object"] && module && !module.nodeType ? module : null;
    var freeGlobal = checkGlobal(freeExports && freeModule && typeof $parcel$global === 'object' && $parcel$global);
    var freeSelf = checkGlobal(objectTypes[typeof self] && self);
    var freeWindow = checkGlobal(objectTypes[typeof window] && window);
    var moduleExports = freeModule && freeModule.exports === freeExports ? freeExports : null;
    var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
    var root = freeGlobal || freeWindow !== (thisGlobal && thisGlobal.window) && freeWindow || freeSelf || thisGlobal || Function('return this')();
    // Because of build optimizers
    if (typeof define === 'function' && define.amd) define([
        './rx.binding',
        'exports'
    ], function(Rx, exports1) {
        root.Rx = factory(root, exports1, Rx);
        return root.Rx;
    });
    else if (module && module.exports === freeExports) module.exports = factory(root, module.exports, (parcelRequire("kTZM9")));
    else root.Rx = factory(root, {}, root.Rx);
}).call(this, function(root, exp, Rx, undefined) {
    // Aliases
    var Observable = Rx.Observable, observableFromPromise = Observable.fromPromise, observableThrow = Observable.throwError, AnonymousObservable = Rx.AnonymousObservable, ObservableBase = Rx.ObservableBase, AsyncSubject = Rx.AsyncSubject, disposableCreate = Rx.Disposable.create, CompositeDisposable = Rx.CompositeDisposable, immediateScheduler = Rx.Scheduler.immediate, defaultScheduler = Rx.Scheduler['default'], inherits = Rx.internals.inherits, isScheduler = Rx.Scheduler.isScheduler, isPromise = Rx.helpers.isPromise, isFunction = Rx.helpers.isFunction, isIterable = Rx.helpers.isIterable, isArrayLike = Rx.helpers.isArrayLike;
    var errorObj = {
        e: {}
    };
    function tryCatcherGen(tryCatchTarget) {
        return function tryCatcher() {
            try {
                return tryCatchTarget.apply(this, arguments);
            } catch (e) {
                errorObj.e = e;
                return errorObj;
            }
        };
    }
    var tryCatch = Rx.internals.tryCatch = function tryCatch(fn) {
        if (!isFunction(fn)) throw new TypeError('fn must be a function');
        return tryCatcherGen(fn);
    };
    function thrower(e) {
        throw e;
    }
    Observable.wrap = function(fn) {
        function createObservable() {
            return Observable.spawn.call(this, fn.apply(this, arguments));
        }
        createObservable.__generatorFunction__ = fn;
        return createObservable;
    };
    var spawn = Observable.spawn = function() {
        var gen = arguments[0], self1 = this, args = [];
        for(var i = 1, len = arguments.length; i < len; i++)args.push(arguments[i]);
        return new AnonymousObservable(function(o) {
            var g = new CompositeDisposable();
            if (isFunction(gen)) gen = gen.apply(self1, args);
            if (!gen || !isFunction(gen.next)) {
                o.onNext(gen);
                return o.onCompleted();
            }
            function processGenerator(res) {
                var ret = tryCatch(gen.next).call(gen, res);
                if (ret === errorObj) return o.onError(ret.e);
                next(ret);
            }
            processGenerator();
            function onError(err) {
                var ret = tryCatch(gen.next).call(gen, err);
                if (ret === errorObj) return o.onError(ret.e);
                next(ret);
            }
            function next(ret) {
                if (ret.done) {
                    o.onNext(ret.value);
                    o.onCompleted();
                    return;
                }
                var obs = toObservable.call(self1, ret.value);
                var value = null;
                var hasValue = false;
                if (Observable.isObservable(obs)) g.add(obs.subscribe(function(val) {
                    hasValue = true;
                    value = val;
                }, onError, function() {
                    hasValue && processGenerator(value);
                }));
                else onError(new TypeError('type not supported'));
            }
            return g;
        });
    };
    function toObservable(obj) {
        if (!obj) return obj;
        if (Observable.isObservable(obj)) return obj;
        if (isPromise(obj)) return Observable.fromPromise(obj);
        if (isGeneratorFunction(obj) || isGenerator(obj)) return spawn.call(this, obj);
        if (isFunction(obj)) return thunkToObservable.call(this, obj);
        if (isArrayLike(obj) || isIterable(obj)) return arrayToObservable.call(this, obj);
        if (isObject(obj)) return objectToObservable.call(this, obj);
        return obj;
    }
    function arrayToObservable(obj) {
        return Observable.from(obj).concatMap(function(o) {
            if (Observable.isObservable(o) || isObject(o)) return toObservable.call(null, o);
            else return Rx.Observable.just(o);
        }).toArray();
    }
    function objectToObservable(obj) {
        var results = new obj.constructor(), keys = Object.keys(obj), observables = [];
        for(var i = 0, len = keys.length; i < len; i++){
            var key = keys[i];
            var observable = toObservable.call(this, obj[key]);
            if (observable && Observable.isObservable(observable)) defer(observable, key);
            else results[key] = obj[key];
        }
        return Observable.forkJoin.apply(Observable, observables).map(function() {
            return results;
        });
        function defer(observable, key) {
            results[key] = undefined;
            observables.push(observable.map(function(next) {
                results[key] = next;
            }));
        }
    }
    function thunkToObservable(fn) {
        var self1 = this;
        return new AnonymousObservable(function(o) {
            fn.call(self1, function() {
                var err = arguments[0], res = arguments[1];
                if (err) return o.onError(err);
                if (arguments.length > 2) {
                    var args = [];
                    for(var i = 1, len = arguments.length; i < len; i++)args.push(arguments[i]);
                    res = args;
                }
                o.onNext(res);
                o.onCompleted();
            });
        });
    }
    function isGenerator(obj) {
        return isFunction(obj.next) && isFunction(obj['throw']);
    }
    function isGeneratorFunction(obj) {
        var ctor = obj.constructor;
        if (!ctor) return false;
        if (ctor.name === 'GeneratorFunction' || ctor.displayName === 'GeneratorFunction') return true;
        return isGenerator(ctor.prototype);
    }
    function isObject(val) {
        return Object == val.constructor;
    }
    /**
   * Invokes the specified function asynchronously on the specified scheduler, surfacing the result through an observable sequence.
   *
   * @example
   * var res = Rx.Observable.start(function () { console.log('hello'); });
   * var res = Rx.Observable.start(function () { console.log('hello'); }, Rx.Scheduler.timeout);
   * var res = Rx.Observable.start(function () { this.log('hello'); }, Rx.Scheduler.timeout, console);
   *
   * @param {Function} func Function to run asynchronously.
   * @param {Scheduler} [scheduler]  Scheduler to run the function on. If not specified, defaults to Scheduler.timeout.
   * @param [context]  The context for the func parameter to be executed.  If not specified, defaults to undefined.
   * @returns {Observable} An observable sequence exposing the function's result value, or an exception.
   *
   * Remarks
   * * The function is called immediately, not during the subscription of the resulting sequence.
   * * Multiple subscriptions to the resulting sequence can observe the function's result.
   */ Observable.start = function(func, context, scheduler) {
        return observableToAsync(func, context, scheduler)();
    };
    /**
   * Converts the function into an asynchronous function. Each invocation of the resulting asynchronous function causes an invocation of the original synchronous function on the specified scheduler.
   * @param {Function} function Function to convert to an asynchronous function.
   * @param {Scheduler} [scheduler] Scheduler to run the function on. If not specified, defaults to Scheduler.timeout.
   * @param {Mixed} [context] The context for the func parameter to be executed.  If not specified, defaults to undefined.
   * @returns {Function} Asynchronous function.
   */ var observableToAsync = Observable.toAsync = function(func, context, scheduler) {
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        return function() {
            var args = arguments, subject = new AsyncSubject();
            scheduler.schedule(null, function() {
                var result;
                try {
                    result = func.apply(context, args);
                } catch (e) {
                    subject.onError(e);
                    return;
                }
                subject.onNext(result);
                subject.onCompleted();
            });
            return subject.asObservable();
        };
    };
    function createCbObservable(fn, ctx, selector, args) {
        var o = new AsyncSubject();
        args.push(createCbHandler(o, ctx, selector));
        fn.apply(ctx, args);
        return o.asObservable();
    }
    function createCbHandler(o, ctx, selector) {
        return function handler() {
            var len = arguments.length, results = new Array(len);
            for(var i = 0; i < len; i++)results[i] = arguments[i];
            if (isFunction(selector)) {
                results = tryCatch(selector).apply(ctx, results);
                if (results === errorObj) return o.onError(results.e);
                o.onNext(results);
            } else if (results.length <= 1) o.onNext(results[0]);
            else o.onNext(results);
            o.onCompleted();
        };
    }
    /**
 * Converts a callback function to an observable sequence.
 *
 * @param {Function} fn Function with a callback as the last parameter to convert to an Observable sequence.
 * @param {Mixed} [ctx] The context for the func parameter to be executed.  If not specified, defaults to undefined.
 * @param {Function} [selector] A selector which takes the arguments from the callback to produce a single item to yield on next.
 * @returns {Function} A function, when executed with the required parameters minus the callback, produces an Observable sequence with a single value of the arguments to the callback as an array.
 */ Observable.fromCallback = function(fn, ctx, selector) {
        return function() {
            typeof ctx === 'undefined' && (ctx = this);
            var len = arguments.length, args = new Array(len);
            for(var i = 0; i < len; i++)args[i] = arguments[i];
            return createCbObservable(fn, ctx, selector, args);
        };
    };
    function createNodeObservable(fn, ctx, selector, args) {
        var o = new AsyncSubject();
        args.push(createNodeHandler(o, ctx, selector));
        fn.apply(ctx, args);
        return o.asObservable();
    }
    function createNodeHandler(o, ctx, selector) {
        return function handler() {
            var err = arguments[0];
            if (err) return o.onError(err);
            var len = arguments.length, results = [];
            for(var i = 1; i < len; i++)results[i - 1] = arguments[i];
            if (isFunction(selector)) {
                var results = tryCatch(selector).apply(ctx, results);
                if (results === errorObj) return o.onError(results.e);
                o.onNext(results);
            } else if (results.length <= 1) o.onNext(results[0]);
            else o.onNext(results);
            o.onCompleted();
        };
    }
    /**
 * Converts a Node.js callback style function to an observable sequence.  This must be in function (err, ...) format.
 * @param {Function} fn The function to call
 * @param {Mixed} [ctx] The context for the func parameter to be executed.  If not specified, defaults to undefined.
 * @param {Function} [selector] A selector which takes the arguments from the callback minus the error to produce a single item to yield on next.
 * @returns {Function} An async function which when applied, returns an observable sequence with the callback arguments as an array.
 */ Observable.fromNodeCallback = function(fn, ctx, selector) {
        return function() {
            typeof ctx === 'undefined' && (ctx = this);
            var len = arguments.length, args = new Array(len);
            for(var i = 0; i < len; i++)args[i] = arguments[i];
            return createNodeObservable(fn, ctx, selector, args);
        };
    };
    function isNodeList(el) {
        if (root.StaticNodeList) // IE8 Specific
        // instanceof is slower than Object#toString, but Object#toString will not work as intended in IE8
        return el instanceof root.StaticNodeList || el instanceof root.NodeList;
        else return Object.prototype.toString.call(el) === '[object NodeList]';
    }
    function ListenDisposable(e, n, fn) {
        this._e = e;
        this._n = n;
        this._fn = fn;
        this._e.addEventListener(this._n, this._fn, false);
        this.isDisposed = false;
    }
    ListenDisposable.prototype.dispose = function() {
        if (!this.isDisposed) {
            this._e.removeEventListener(this._n, this._fn, false);
            this.isDisposed = true;
        }
    };
    function createEventListener(el, eventName, handler) {
        var disposables = new CompositeDisposable();
        // Asume NodeList or HTMLCollection
        var elemToString = Object.prototype.toString.call(el);
        if (isNodeList(el) || elemToString === '[object HTMLCollection]') for(var i = 0, len = el.length; i < len; i++)disposables.add(createEventListener(el.item(i), eventName, handler));
        else if (el) disposables.add(new ListenDisposable(el, eventName, handler));
        return disposables;
    }
    /**
   * Configuration option to determine whether to use native events only
   */ Rx.config.useNativeEvents = false;
    var EventObservable = function(__super__) {
        inherits(EventObservable, __super__);
        function EventObservable(el, name, fn) {
            this._el = el;
            this._n = name;
            this._fn = fn;
            __super__.call(this);
        }
        function createHandler(o, fn) {
            return function handler() {
                var results = arguments[0];
                if (isFunction(fn)) {
                    results = tryCatch(fn).apply(null, arguments);
                    if (results === errorObj) return o.onError(results.e);
                }
                o.onNext(results);
            };
        }
        EventObservable.prototype.subscribeCore = function(o) {
            return createEventListener(this._el, this._n, createHandler(o, this._fn));
        };
        return EventObservable;
    }(ObservableBase);
    /**
   * Creates an observable sequence by adding an event listener to the matching DOMElement or each item in the NodeList.
   * @param {Object} element The DOMElement or NodeList to attach a listener.
   * @param {String} eventName The event name to attach the observable sequence.
   * @param {Function} [selector] A selector which takes the arguments from the event handler to produce a single item to yield on next.
   * @returns {Observable} An observable sequence of events from the specified element and the specified event.
   */ Observable.fromEvent = function(element, eventName, selector) {
        // Node.js specific
        if (element.addListener) return fromEventPattern(function(h) {
            element.addListener(eventName, h);
        }, function(h) {
            element.removeListener(eventName, h);
        }, selector);
        // Use only if non-native events are allowed
        if (!Rx.config.useNativeEvents) {
            // Handles jq, Angular.js, Zepto, Marionette, Ember.js
            if (typeof element.on === 'function' && typeof element.off === 'function') return fromEventPattern(function(h) {
                element.on(eventName, h);
            }, function(h) {
                element.off(eventName, h);
            }, selector);
        }
        return new EventObservable(element, eventName, selector).publish().refCount();
    };
    var EventPatternObservable = function(__super__) {
        inherits(EventPatternObservable, __super__);
        function EventPatternObservable(add, del, fn) {
            this._add = add;
            this._del = del;
            this._fn = fn;
            __super__.call(this);
        }
        function createHandler(o, fn) {
            return function handler() {
                var results = arguments[0];
                if (isFunction(fn)) {
                    results = tryCatch(fn).apply(null, arguments);
                    if (results === errorObj) return o.onError(results.e);
                }
                o.onNext(results);
            };
        }
        EventPatternObservable.prototype.subscribeCore = function(o) {
            var fn = createHandler(o, this._fn);
            var returnValue = this._add(fn);
            return new EventPatternDisposable(this._del, fn, returnValue);
        };
        function EventPatternDisposable(del, fn, ret) {
            this._del = del;
            this._fn = fn;
            this._ret = ret;
            this.isDisposed = false;
        }
        EventPatternDisposable.prototype.dispose = function() {
            if (!this.isDisposed) {
                isFunction(this._del) && this._del(this._fn, this._ret);
                this.isDisposed = true;
            }
        };
        return EventPatternObservable;
    }(ObservableBase);
    /**
   * Creates an observable sequence from an event emitter via an addHandler/removeHandler pair.
   * @param {Function} addHandler The function to add a handler to the emitter.
   * @param {Function} [removeHandler] The optional function to remove a handler from an emitter.
   * @param {Function} [selector] A selector which takes the arguments from the event handler to produce a single item to yield on next.
   * @returns {Observable} An observable sequence which wraps an event from an event emitter
   */ var fromEventPattern = Observable.fromEventPattern = function(addHandler, removeHandler, selector) {
        return new EventPatternObservable(addHandler, removeHandler, selector).publish().refCount();
    };
    /**
   * Invokes the asynchronous function, surfacing the result through an observable sequence.
   * @param {Function} functionAsync Asynchronous function which returns a Promise to run.
   * @returns {Observable} An observable sequence exposing the function's result value, or an exception.
   */ Observable.startAsync = function(functionAsync) {
        var promise = tryCatch(functionAsync)();
        if (promise === errorObj) return observableThrow(promise.e);
        return observableFromPromise(promise);
    };
    return Rx;
});

});

parcelRegister("j0Xoo", function(module, exports) {
// Copyright (c) Microsoft, All rights reserved. See License.txt in the project root for license information.

(function(factory) {
    var objectTypes = {
        'function': true,
        'object': true
    };
    function checkGlobal(value) {
        return value && value.Object === Object ? value : null;
    }
    var freeExports = objectTypes["object"] && exports && !exports.nodeType ? exports : null;
    var freeModule = objectTypes["object"] && module && !module.nodeType ? module : null;
    var freeGlobal = checkGlobal(freeExports && freeModule && typeof $parcel$global === 'object' && $parcel$global);
    var freeSelf = checkGlobal(objectTypes[typeof self] && self);
    var freeWindow = checkGlobal(objectTypes[typeof window] && window);
    var moduleExports = freeModule && freeModule.exports === freeExports ? freeExports : null;
    var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
    var root = freeGlobal || freeWindow !== (thisGlobal && thisGlobal.window) && freeWindow || freeSelf || thisGlobal || Function('return this')();
    // Because of build optimizers
    if (typeof define === 'function' && define.amd) define([
        './rx'
    ], function(Rx, exports1) {
        return factory(root, exports1, Rx);
    });
    else if (module && module.exports === freeExports) module.exports = factory(root, module.exports, (parcelRequire("kTZM9")));
    else root.Rx = factory(root, {}, root.Rx);
}).call(this, function(root, exp, Rx, undefined) {
    // References
    var Observable = Rx.Observable, observableProto = Observable.prototype, AnonymousObservable = Rx.AnonymousObservable, AbstractObserver = Rx.internals.AbstractObserver, CompositeDisposable = Rx.CompositeDisposable, BinaryDisposable = Rx.BinaryDisposable, NAryDisposable = Rx.NAryDisposable, Notification = Rx.Notification, Subject = Rx.Subject, Observer = Rx.Observer, disposableEmpty = Rx.Disposable.empty, disposableCreate = Rx.Disposable.create, inherits = Rx.internals.inherits, addProperties = Rx.internals.addProperties, defaultScheduler = Rx.Scheduler['default'], currentThreadScheduler = Rx.Scheduler.currentThread, identity = Rx.helpers.identity, isScheduler = Rx.Scheduler.isScheduler, isFunction = Rx.helpers.isFunction, checkDisposed = Rx.Disposable.checkDisposed;
    var errorObj = {
        e: {}
    };
    function tryCatcherGen(tryCatchTarget) {
        return function tryCatcher() {
            try {
                return tryCatchTarget.apply(this, arguments);
            } catch (e) {
                errorObj.e = e;
                return errorObj;
            }
        };
    }
    var tryCatch = Rx.internals.tryCatch = function tryCatch(fn) {
        if (!isFunction(fn)) throw new TypeError('fn must be a function');
        return tryCatcherGen(fn);
    };
    function thrower(e) {
        throw e;
    }
    /**
  * Used to pause and resume streams.
  */ Rx.Pauser = function(__super__) {
        inherits(Pauser, __super__);
        function Pauser() {
            __super__.call(this);
        }
        /**
     * Pauses the underlying sequence.
     */ Pauser.prototype.pause = function() {
            this.onNext(false);
        };
        /**
    * Resumes the underlying sequence.
    */ Pauser.prototype.resume = function() {
            this.onNext(true);
        };
        return Pauser;
    }(Subject);
    var PausableObservable = function(__super__) {
        inherits(PausableObservable, __super__);
        function PausableObservable(source, pauser) {
            this.source = source;
            this.controller = new Subject();
            this.paused = true;
            if (pauser && pauser.subscribe) this.pauser = this.controller.merge(pauser);
            else this.pauser = this.controller;
            __super__.call(this);
        }
        PausableObservable.prototype._subscribe = function(o) {
            var conn = this.source.publish(), subscription = conn.subscribe(o), connection = disposableEmpty;
            var pausable = this.pauser.startWith(!this.paused).distinctUntilChanged().subscribe(function(b) {
                if (b) connection = conn.connect();
                else {
                    connection.dispose();
                    connection = disposableEmpty;
                }
            });
            return new NAryDisposable([
                subscription,
                connection,
                pausable
            ]);
        };
        PausableObservable.prototype.pause = function() {
            this.paused = true;
            this.controller.onNext(false);
        };
        PausableObservable.prototype.resume = function() {
            this.paused = false;
            this.controller.onNext(true);
        };
        return PausableObservable;
    }(Observable);
    /**
   * Pauses the underlying observable sequence based upon the observable sequence which yields true/false.
   * @example
   * var pauser = new Rx.Subject();
   * var source = Rx.Observable.interval(100).pausable(pauser);
   * @param {Observable} pauser The observable sequence used to pause the underlying sequence.
   * @returns {Observable} The observable sequence which is paused based upon the pauser.
   */ observableProto.pausable = function(pauser) {
        return new PausableObservable(this, pauser);
    };
    function combineLatestSource(source, subject, resultSelector) {
        return new AnonymousObservable(function(o) {
            var hasValue = [
                false,
                false
            ], hasValueAll = false, isDone = false, values = new Array(2), err;
            function next(x, i) {
                values[i] = x;
                hasValue[i] = true;
                if (hasValueAll || (hasValueAll = hasValue.every(identity))) {
                    if (err) return o.onError(err);
                    var res = tryCatch(resultSelector).apply(null, values);
                    if (res === errorObj) return o.onError(res.e);
                    o.onNext(res);
                }
                isDone && values[1] && o.onCompleted();
            }
            return new BinaryDisposable(source.subscribe(function(x) {
                next(x, 0);
            }, function(e) {
                if (values[1]) o.onError(e);
                else err = e;
            }, function() {
                isDone = true;
                values[1] && o.onCompleted();
            }), subject.subscribe(function(x) {
                next(x, 1);
            }, function(e) {
                o.onError(e);
            }, function() {
                isDone = true;
                next(true, 1);
            }));
        }, source);
    }
    var PausableBufferedObservable = function(__super__) {
        inherits(PausableBufferedObservable, __super__);
        function PausableBufferedObservable(source, pauser) {
            this.source = source;
            this.controller = new Subject();
            this.paused = true;
            if (pauser && pauser.subscribe) this.pauser = this.controller.merge(pauser);
            else this.pauser = this.controller;
            __super__.call(this);
        }
        PausableBufferedObservable.prototype._subscribe = function(o) {
            var q = [], previousShouldFire;
            function drainQueue() {
                while(q.length > 0)o.onNext(q.shift());
            }
            var subscription = combineLatestSource(this.source, this.pauser.startWith(!this.paused).distinctUntilChanged(), function(data, shouldFire) {
                return {
                    data: data,
                    shouldFire: shouldFire
                };
            }).subscribe(function(results) {
                if (previousShouldFire !== undefined && results.shouldFire !== previousShouldFire) {
                    previousShouldFire = results.shouldFire;
                    // change in shouldFire
                    if (results.shouldFire) drainQueue();
                } else {
                    previousShouldFire = results.shouldFire;
                    // new data
                    if (results.shouldFire) o.onNext(results.data);
                    else q.push(results.data);
                }
            }, function(err) {
                drainQueue();
                o.onError(err);
            }, function() {
                drainQueue();
                o.onCompleted();
            });
            return subscription;
        };
        PausableBufferedObservable.prototype.pause = function() {
            this.paused = true;
            this.controller.onNext(false);
        };
        PausableBufferedObservable.prototype.resume = function() {
            this.paused = false;
            this.controller.onNext(true);
        };
        return PausableBufferedObservable;
    }(Observable);
    /**
   * Pauses the underlying observable sequence based upon the observable sequence which yields true/false,
   * and yields the values that were buffered while paused.
   * @example
   * var pauser = new Rx.Subject();
   * var source = Rx.Observable.interval(100).pausableBuffered(pauser);
   * @param {Observable} pauser The observable sequence used to pause the underlying sequence.
   * @returns {Observable} The observable sequence which is paused based upon the pauser.
   */ observableProto.pausableBuffered = function(pauser) {
        return new PausableBufferedObservable(this, pauser);
    };
    var ControlledObservable = function(__super__) {
        inherits(ControlledObservable, __super__);
        function ControlledObservable(source, enableQueue, scheduler) {
            __super__.call(this);
            this.subject = new ControlledSubject(enableQueue, scheduler);
            this.source = source.multicast(this.subject).refCount();
        }
        ControlledObservable.prototype._subscribe = function(o) {
            return this.source.subscribe(o);
        };
        ControlledObservable.prototype.request = function(numberOfItems) {
            return this.subject.request(numberOfItems == null ? -1 : numberOfItems);
        };
        return ControlledObservable;
    }(Observable);
    var ControlledSubject = function(__super__) {
        inherits(ControlledSubject, __super__);
        function ControlledSubject(enableQueue, scheduler) {
            enableQueue == null && (enableQueue = true);
            __super__.call(this);
            this.subject = new Subject();
            this.enableQueue = enableQueue;
            this.queue = enableQueue ? [] : null;
            this.requestedCount = 0;
            this.requestedDisposable = null;
            this.error = null;
            this.hasFailed = false;
            this.hasCompleted = false;
            this.scheduler = scheduler || currentThreadScheduler;
        }
        addProperties(ControlledSubject.prototype, Observer, {
            _subscribe: function(o) {
                return this.subject.subscribe(o);
            },
            onCompleted: function() {
                this.hasCompleted = true;
                if (!this.enableQueue || this.queue.length === 0) {
                    this.subject.onCompleted();
                    this.disposeCurrentRequest();
                } else this.queue.push(Notification.createOnCompleted());
            },
            onError: function(error) {
                this.hasFailed = true;
                this.error = error;
                if (!this.enableQueue || this.queue.length === 0) {
                    this.subject.onError(error);
                    this.disposeCurrentRequest();
                } else this.queue.push(Notification.createOnError(error));
            },
            onNext: function(value) {
                if (this.requestedCount <= 0) this.enableQueue && this.queue.push(Notification.createOnNext(value));
                else {
                    this.requestedCount-- === 0 && this.disposeCurrentRequest();
                    this.subject.onNext(value);
                }
            },
            _processRequest: function(numberOfItems) {
                if (this.enableQueue) while(this.queue.length > 0 && (numberOfItems > 0 || this.queue[0].kind !== 'N')){
                    var first = this.queue.shift();
                    first.accept(this.subject);
                    if (first.kind === 'N') numberOfItems--;
                    else {
                        this.disposeCurrentRequest();
                        this.queue = [];
                    }
                }
                return numberOfItems;
            },
            request: function(number) {
                this.disposeCurrentRequest();
                var self1 = this;
                this.requestedDisposable = this.scheduler.schedule(number, function(s, i) {
                    var remaining = self1._processRequest(i);
                    var stopped = self1.hasCompleted || self1.hasFailed;
                    if (!stopped && remaining > 0) {
                        self1.requestedCount = remaining;
                        return disposableCreate(function() {
                            self1.requestedCount = 0;
                        });
                    // Scheduled item is still in progress. Return a new
                    // disposable to allow the request to be interrupted
                    // via dispose.
                    }
                });
                return this.requestedDisposable;
            },
            disposeCurrentRequest: function() {
                if (this.requestedDisposable) {
                    this.requestedDisposable.dispose();
                    this.requestedDisposable = null;
                }
            }
        });
        return ControlledSubject;
    }(Observable);
    /**
   * Attaches a controller to the observable sequence with the ability to queue.
   * @example
   * var source = Rx.Observable.interval(100).controlled();
   * source.request(3); // Reads 3 values
   * @param {bool} enableQueue truthy value to determine if values should be queued pending the next request
   * @param {Scheduler} scheduler determines how the requests will be scheduled
   * @returns {Observable} The observable sequence which only propagates values on request.
   */ observableProto.controlled = function(enableQueue, scheduler) {
        if (enableQueue && isScheduler(enableQueue)) {
            scheduler = enableQueue;
            enableQueue = true;
        }
        if (enableQueue == null) enableQueue = true;
        return new ControlledObservable(this, enableQueue, scheduler);
    };
    var StopAndWaitObservable = function(__super__) {
        inherits(StopAndWaitObservable, __super__);
        function StopAndWaitObservable(source) {
            __super__.call(this);
            this.source = source;
        }
        function scheduleMethod(s, self1) {
            return self1.source.request(1);
        }
        StopAndWaitObservable.prototype._subscribe = function(o) {
            this.subscription = this.source.subscribe(new StopAndWaitObserver(o, this, this.subscription));
            return new BinaryDisposable(this.subscription, defaultScheduler.schedule(this, scheduleMethod));
        };
        var StopAndWaitObserver = function(__sub__) {
            inherits(StopAndWaitObserver, __sub__);
            function StopAndWaitObserver(observer, observable, cancel) {
                __sub__.call(this);
                this.observer = observer;
                this.observable = observable;
                this.cancel = cancel;
                this.scheduleDisposable = null;
            }
            StopAndWaitObserver.prototype.completed = function() {
                this.observer.onCompleted();
                this.dispose();
            };
            StopAndWaitObserver.prototype.error = function(error) {
                this.observer.onError(error);
                this.dispose();
            };
            function innerScheduleMethod(s, self1) {
                return self1.observable.source.request(1);
            }
            StopAndWaitObserver.prototype.next = function(value) {
                this.observer.onNext(value);
                this.scheduleDisposable = defaultScheduler.schedule(this, innerScheduleMethod);
            };
            StopAndWaitObserver.dispose = function() {
                this.observer = null;
                if (this.cancel) {
                    this.cancel.dispose();
                    this.cancel = null;
                }
                if (this.scheduleDisposable) {
                    this.scheduleDisposable.dispose();
                    this.scheduleDisposable = null;
                }
                __sub__.prototype.dispose.call(this);
            };
            return StopAndWaitObserver;
        }(AbstractObserver);
        return StopAndWaitObservable;
    }(Observable);
    /**
   * Attaches a stop and wait observable to the current observable.
   * @returns {Observable} A stop and wait observable.
   */ ControlledObservable.prototype.stopAndWait = function() {
        return new StopAndWaitObservable(this);
    };
    var WindowedObservable = function(__super__) {
        inherits(WindowedObservable, __super__);
        function WindowedObservable(source, windowSize) {
            __super__.call(this);
            this.source = source;
            this.windowSize = windowSize;
        }
        function scheduleMethod(s, self1) {
            return self1.source.request(self1.windowSize);
        }
        WindowedObservable.prototype._subscribe = function(o) {
            this.subscription = this.source.subscribe(new WindowedObserver(o, this, this.subscription));
            return new BinaryDisposable(this.subscription, defaultScheduler.schedule(this, scheduleMethod));
        };
        var WindowedObserver = function(__sub__) {
            inherits(WindowedObserver, __sub__);
            function WindowedObserver(observer, observable, cancel) {
                this.observer = observer;
                this.observable = observable;
                this.cancel = cancel;
                this.received = 0;
                this.scheduleDisposable = null;
                __sub__.call(this);
            }
            WindowedObserver.prototype.completed = function() {
                this.observer.onCompleted();
                this.dispose();
            };
            WindowedObserver.prototype.error = function(error) {
                this.observer.onError(error);
                this.dispose();
            };
            function innerScheduleMethod(s, self1) {
                return self1.observable.source.request(self1.observable.windowSize);
            }
            WindowedObserver.prototype.next = function(value) {
                this.observer.onNext(value);
                this.received = ++this.received % this.observable.windowSize;
                this.received === 0 && (this.scheduleDisposable = defaultScheduler.schedule(this, innerScheduleMethod));
            };
            WindowedObserver.prototype.dispose = function() {
                this.observer = null;
                if (this.cancel) {
                    this.cancel.dispose();
                    this.cancel = null;
                }
                if (this.scheduleDisposable) {
                    this.scheduleDisposable.dispose();
                    this.scheduleDisposable = null;
                }
                __sub__.prototype.dispose.call(this);
            };
            return WindowedObserver;
        }(AbstractObserver);
        return WindowedObservable;
    }(Observable);
    /**
   * Creates a sliding windowed observable based upon the window size.
   * @param {Number} windowSize The number of items in the window
   * @returns {Observable} A windowed observable based upon the window size.
   */ ControlledObservable.prototype.windowed = function(windowSize) {
        return new WindowedObservable(this, windowSize);
    };
    /**
   * Pipes the existing Observable sequence into a Node.js Stream.
   * @param {Stream} dest The destination Node.js stream.
   * @returns {Stream} The destination stream.
   */ observableProto.pipe = function(dest) {
        var source = this.pausableBuffered();
        function onDrain() {
            source.resume();
        }
        dest.addListener('drain', onDrain);
        source.subscribe(function(x) {
            !dest.write(x) && source.pause();
        }, function(err) {
            dest.emit('error', err);
        }, function() {
            // Hack check because STDIO is not closable
            !dest._isStdio && dest.end();
            dest.removeListener('drain', onDrain);
        });
        source.resume();
        return dest;
    };
    return Rx;
});

});

parcelRegister("8XdE1", function(module, exports) {
// Copyright (c) Microsoft, All rights reserved. See License.txt in the project root for license information.

(function(factory) {
    var objectTypes = {
        'function': true,
        'object': true
    };
    function checkGlobal(value) {
        return value && value.Object === Object ? value : null;
    }
    var freeExports = objectTypes["object"] && exports && !exports.nodeType ? exports : null;
    var freeModule = objectTypes["object"] && module && !module.nodeType ? module : null;
    var freeGlobal = checkGlobal(freeExports && freeModule && typeof $parcel$global === 'object' && $parcel$global);
    var freeSelf = checkGlobal(objectTypes[typeof self] && self);
    var freeWindow = checkGlobal(objectTypes[typeof window] && window);
    var moduleExports = freeModule && freeModule.exports === freeExports ? freeExports : null;
    var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
    var root = freeGlobal || freeWindow !== (thisGlobal && thisGlobal.window) && freeWindow || freeSelf || thisGlobal || Function('return this')();
    // Because of build optimizers
    if (typeof define === 'function' && define.amd) define([
        './rx'
    ], function(Rx, exports1) {
        return factory(root, exports1, Rx);
    });
    else if (module && module.exports === freeExports) module.exports = factory(root, module.exports, (parcelRequire("kTZM9")));
    else root.Rx = factory(root, {}, root.Rx);
}).call(this, function(root, exp, Rx, undefined) {
    var Observable = Rx.Observable, observableProto = Observable.prototype, AnonymousObservable = Rx.AnonymousObservable, ObservableBase = Rx.ObservableBase, Subject = Rx.Subject, AsyncSubject = Rx.AsyncSubject, Observer = Rx.Observer, ScheduledObserver = Rx.internals.ScheduledObserver, disposableCreate = Rx.Disposable.create, disposableEmpty = Rx.Disposable.empty, BinaryDisposable = Rx.BinaryDisposable, currentThreadScheduler = Rx.Scheduler.currentThread, isFunction = Rx.helpers.isFunction, inherits = Rx.internals.inherits, addProperties = Rx.internals.addProperties, checkDisposed = Rx.Disposable.checkDisposed;
    // Utilities
    function cloneArray(arr) {
        var len = arr.length, a = new Array(len);
        for(var i = 0; i < len; i++)a[i] = arr[i];
        return a;
    }
    var MulticastObservable = function(__super__) {
        inherits(MulticastObservable, __super__);
        function MulticastObservable(source, fn1, fn2) {
            this.source = source;
            this._fn1 = fn1;
            this._fn2 = fn2;
            __super__.call(this);
        }
        MulticastObservable.prototype.subscribeCore = function(o) {
            var connectable = this.source.multicast(this._fn1());
            return new BinaryDisposable(this._fn2(connectable).subscribe(o), connectable.connect());
        };
        return MulticastObservable;
    }(ObservableBase);
    /**
   * Multicasts the source sequence notifications through an instantiated subject into all uses of the sequence within a selector function. Each
   * subscription to the resulting sequence causes a separate multicast invocation, exposing the sequence resulting from the selector function's
   * invocation. For specializations with fixed subject types, see Publish, PublishLast, and Replay.
   *
   * @example
   * 1 - res = source.multicast(observable);
   * 2 - res = source.multicast(function () { return new Subject(); }, function (x) { return x; });
   *
   * @param {Function|Subject} subjectOrSubjectSelector
   * Factory function to create an intermediate subject through which the source sequence's elements will be multicast to the selector function.
   * Or:
   * Subject to push source elements into.
   *
   * @param {Function} [selector] Optional selector function which can use the multicasted source sequence subject to the policies enforced by the created subject. Specified only if <paramref name="subjectOrSubjectSelector" is a factory function.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence within a selector function.
   */ observableProto.multicast = function(subjectOrSubjectSelector, selector) {
        return isFunction(subjectOrSubjectSelector) ? new MulticastObservable(this, subjectOrSubjectSelector, selector) : new ConnectableObservable(this, subjectOrSubjectSelector);
    };
    /**
   * Returns an observable sequence that is the result of invoking the selector on a connectable observable sequence that shares a single subscription to the underlying sequence.
   * This operator is a specialization of Multicast using a regular Subject.
   *
   * @example
   * var resres = source.publish();
   * var res = source.publish(function (x) { return x; });
   *
   * @param {Function} [selector] Selector function which can use the multicasted source sequence as many times as needed, without causing multiple subscriptions to the source sequence. Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence within a selector function.
   */ observableProto.publish = function(selector) {
        return selector && isFunction(selector) ? this.multicast(function() {
            return new Subject();
        }, selector) : this.multicast(new Subject());
    };
    /**
   * Returns an observable sequence that shares a single subscription to the underlying sequence.
   * This operator is a specialization of publish which creates a subscription when the number of observers goes from zero to one, then shares that subscription with all subsequent observers until the number of observers returns to zero, at which point the subscription is disposed.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence.
   */ observableProto.share = function() {
        return this.publish().refCount();
    };
    /**
   * Returns an observable sequence that is the result of invoking the selector on a connectable observable sequence that shares a single subscription to the underlying sequence containing only the last notification.
   * This operator is a specialization of Multicast using a AsyncSubject.
   *
   * @example
   * var res = source.publishLast();
   * var res = source.publishLast(function (x) { return x; });
   *
   * @param selector [Optional] Selector function which can use the multicasted source sequence as many times as needed, without causing multiple subscriptions to the source sequence. Subscribers to the given source will only receive the last notification of the source.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence within a selector function.
   */ observableProto.publishLast = function(selector) {
        return selector && isFunction(selector) ? this.multicast(function() {
            return new AsyncSubject();
        }, selector) : this.multicast(new AsyncSubject());
    };
    /**
   * Returns an observable sequence that is the result of invoking the selector on a connectable observable sequence that shares a single subscription to the underlying sequence and starts with initialValue.
   * This operator is a specialization of Multicast using a BehaviorSubject.
   *
   * @example
   * var res = source.publishValue(42);
   * var res = source.publishValue(function (x) { return x.select(function (y) { return y * y; }) }, 42);
   *
   * @param {Function} [selector] Optional selector function which can use the multicasted source sequence as many times as needed, without causing multiple subscriptions to the source sequence. Subscribers to the given source will receive immediately receive the initial value, followed by all notifications of the source from the time of the subscription on.
   * @param {Mixed} initialValue Initial value received by observers upon subscription.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence within a selector function.
   */ observableProto.publishValue = function(initialValueOrSelector, initialValue) {
        return arguments.length === 2 ? this.multicast(function() {
            return new BehaviorSubject(initialValue);
        }, initialValueOrSelector) : this.multicast(new BehaviorSubject(initialValueOrSelector));
    };
    /**
   * Returns an observable sequence that shares a single subscription to the underlying sequence and starts with an initialValue.
   * This operator is a specialization of publishValue which creates a subscription when the number of observers goes from zero to one, then shares that subscription with all subsequent observers until the number of observers returns to zero, at which point the subscription is disposed.
   * @param {Mixed} initialValue Initial value received by observers upon subscription.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence.
   */ observableProto.shareValue = function(initialValue) {
        return this.publishValue(initialValue).refCount();
    };
    /**
   * Returns an observable sequence that is the result of invoking the selector on a connectable observable sequence that shares a single subscription to the underlying sequence replaying notifications subject to a maximum time length for the replay buffer.
   * This operator is a specialization of Multicast using a ReplaySubject.
   *
   * @example
   * var res = source.replay(null, 3);
   * var res = source.replay(null, 3, 500);
   * var res = source.replay(null, 3, 500, scheduler);
   * var res = source.replay(function (x) { return x.take(6).repeat(); }, 3, 500, scheduler);
   *
   * @param selector [Optional] Selector function which can use the multicasted source sequence as many times as needed, without causing multiple subscriptions to the source sequence. Subscribers to the given source will receive all the notifications of the source subject to the specified replay buffer trimming policy.
   * @param bufferSize [Optional] Maximum element count of the replay buffer.
   * @param windowSize [Optional] Maximum time length of the replay buffer.
   * @param scheduler [Optional] Scheduler where connected observers within the selector function will be invoked on.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence within a selector function.
   */ observableProto.replay = function(selector, bufferSize, windowSize, scheduler) {
        return selector && isFunction(selector) ? this.multicast(function() {
            return new ReplaySubject(bufferSize, windowSize, scheduler);
        }, selector) : this.multicast(new ReplaySubject(bufferSize, windowSize, scheduler));
    };
    /**
   * Returns an observable sequence that shares a single subscription to the underlying sequence replaying notifications subject to a maximum time length for the replay buffer.
   * This operator is a specialization of replay which creates a subscription when the number of observers goes from zero to one, then shares that subscription with all subsequent observers until the number of observers returns to zero, at which point the subscription is disposed.
   *
   * @example
   * var res = source.shareReplay(3);
   * var res = source.shareReplay(3, 500);
   * var res = source.shareReplay(3, 500, scheduler);
   *

   * @param bufferSize [Optional] Maximum element count of the replay buffer.
   * @param window [Optional] Maximum time length of the replay buffer.
   * @param scheduler [Optional] Scheduler where connected observers within the selector function will be invoked on.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence.
   */ observableProto.shareReplay = function(bufferSize, windowSize, scheduler) {
        return this.replay(null, bufferSize, windowSize, scheduler).refCount();
    };
    var InnerSubscription = function(s, o) {
        this._s = s;
        this._o = o;
    };
    InnerSubscription.prototype.dispose = function() {
        if (!this._s.isDisposed && this._o !== null) {
            var idx = this._s.observers.indexOf(this._o);
            this._s.observers.splice(idx, 1);
            this._o = null;
        }
    };
    /**
   *  Represents a value that changes over time.
   *  Observers can subscribe to the subject to receive the last (or initial) value and all subsequent notifications.
   */ var BehaviorSubject = Rx.BehaviorSubject = function(__super__) {
        inherits(BehaviorSubject, __super__);
        function BehaviorSubject(value) {
            __super__.call(this);
            this.value = value;
            this.observers = [];
            this.isDisposed = false;
            this.isStopped = false;
            this.hasError = false;
        }
        addProperties(BehaviorSubject.prototype, Observer.prototype, {
            _subscribe: function(o) {
                checkDisposed(this);
                if (!this.isStopped) {
                    this.observers.push(o);
                    o.onNext(this.value);
                    return new InnerSubscription(this, o);
                }
                if (this.hasError) o.onError(this.error);
                else o.onCompleted();
                return disposableEmpty;
            },
            /**
       * Gets the current value or throws an exception.
       * Value is frozen after onCompleted is called.
       * After onError is called always throws the specified exception.
       * An exception is always thrown after dispose is called.
       * @returns {Mixed} The initial value passed to the constructor until onNext is called; after which, the last value passed to onNext.
       */ getValue: function() {
                checkDisposed(this);
                if (this.hasError) thrower(this.error);
                return this.value;
            },
            /**
       * Indicates whether the subject has observers subscribed to it.
       * @returns {Boolean} Indicates whether the subject has observers subscribed to it.
       */ hasObservers: function() {
                checkDisposed(this);
                return this.observers.length > 0;
            },
            /**
       * Notifies all subscribed observers about the end of the sequence.
       */ onCompleted: function() {
                checkDisposed(this);
                if (this.isStopped) return;
                this.isStopped = true;
                for(var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++)os[i].onCompleted();
                this.observers.length = 0;
            },
            /**
       * Notifies all subscribed observers about the exception.
       * @param {Mixed} error The exception to send to all observers.
       */ onError: function(error) {
                checkDisposed(this);
                if (this.isStopped) return;
                this.isStopped = true;
                this.hasError = true;
                this.error = error;
                for(var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++)os[i].onError(error);
                this.observers.length = 0;
            },
            /**
       * Notifies all subscribed observers about the arrival of the specified element in the sequence.
       * @param {Mixed} value The value to send to all observers.
       */ onNext: function(value) {
                checkDisposed(this);
                if (this.isStopped) return;
                this.value = value;
                for(var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++)os[i].onNext(value);
            },
            /**
       * Unsubscribe all observers and release resources.
       */ dispose: function() {
                this.isDisposed = true;
                this.observers = null;
                this.value = null;
                this.error = null;
            }
        });
        return BehaviorSubject;
    }(Observable);
    /**
   * Represents an object that is both an observable sequence as well as an observer.
   * Each notification is broadcasted to all subscribed and future observers, subject to buffer trimming policies.
   */ var ReplaySubject = Rx.ReplaySubject = function(__super__) {
        var maxSafeInteger = Math.pow(2, 53) - 1;
        function createRemovableDisposable(subject, observer) {
            return disposableCreate(function() {
                observer.dispose();
                !subject.isDisposed && subject.observers.splice(subject.observers.indexOf(observer), 1);
            });
        }
        inherits(ReplaySubject, __super__);
        /**
     *  Initializes a new instance of the ReplaySubject class with the specified buffer size, window size and scheduler.
     *  @param {Number} [bufferSize] Maximum element count of the replay buffer.
     *  @param {Number} [windowSize] Maximum time length of the replay buffer.
     *  @param {Scheduler} [scheduler] Scheduler the observers are invoked on.
     */ function ReplaySubject(bufferSize, windowSize, scheduler) {
            this.bufferSize = bufferSize == null ? maxSafeInteger : bufferSize;
            this.windowSize = windowSize == null ? maxSafeInteger : windowSize;
            this.scheduler = scheduler || currentThreadScheduler;
            this.q = [];
            this.observers = [];
            this.isStopped = false;
            this.isDisposed = false;
            this.hasError = false;
            this.error = null;
            __super__.call(this);
        }
        addProperties(ReplaySubject.prototype, Observer.prototype, {
            _subscribe: function(o) {
                checkDisposed(this);
                var so = new ScheduledObserver(this.scheduler, o), subscription = createRemovableDisposable(this, so);
                this._trim(this.scheduler.now());
                this.observers.push(so);
                for(var i = 0, len = this.q.length; i < len; i++)so.onNext(this.q[i].value);
                if (this.hasError) so.onError(this.error);
                else if (this.isStopped) so.onCompleted();
                so.ensureActive();
                return subscription;
            },
            /**
       * Indicates whether the subject has observers subscribed to it.
       * @returns {Boolean} Indicates whether the subject has observers subscribed to it.
       */ hasObservers: function() {
                checkDisposed(this);
                return this.observers.length > 0;
            },
            _trim: function(now) {
                while(this.q.length > this.bufferSize)this.q.shift();
                while(this.q.length > 0 && now - this.q[0].interval > this.windowSize)this.q.shift();
            },
            /**
       * Notifies all subscribed observers about the arrival of the specified element in the sequence.
       * @param {Mixed} value The value to send to all observers.
       */ onNext: function(value) {
                checkDisposed(this);
                if (this.isStopped) return;
                var now = this.scheduler.now();
                this.q.push({
                    interval: now,
                    value: value
                });
                this._trim(now);
                for(var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++){
                    var observer = os[i];
                    observer.onNext(value);
                    observer.ensureActive();
                }
            },
            /**
       * Notifies all subscribed observers about the exception.
       * @param {Mixed} error The exception to send to all observers.
       */ onError: function(error) {
                checkDisposed(this);
                if (this.isStopped) return;
                this.isStopped = true;
                this.error = error;
                this.hasError = true;
                var now = this.scheduler.now();
                this._trim(now);
                for(var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++){
                    var observer = os[i];
                    observer.onError(error);
                    observer.ensureActive();
                }
                this.observers.length = 0;
            },
            /**
       * Notifies all subscribed observers about the end of the sequence.
       */ onCompleted: function() {
                checkDisposed(this);
                if (this.isStopped) return;
                this.isStopped = true;
                var now = this.scheduler.now();
                this._trim(now);
                for(var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++){
                    var observer = os[i];
                    observer.onCompleted();
                    observer.ensureActive();
                }
                this.observers.length = 0;
            },
            /**
       * Unsubscribe all observers and release resources.
       */ dispose: function() {
                this.isDisposed = true;
                this.observers = null;
            }
        });
        return ReplaySubject;
    }(Observable);
    var RefCountObservable = function(__super__) {
        inherits(RefCountObservable, __super__);
        function RefCountObservable(source) {
            this.source = source;
            this._count = 0;
            this._connectableSubscription = null;
            __super__.call(this);
        }
        RefCountObservable.prototype.subscribeCore = function(o) {
            var subscription = this.source.subscribe(o);
            ++this._count === 1 && (this._connectableSubscription = this.source.connect());
            return new RefCountDisposable(this, subscription);
        };
        function RefCountDisposable(p, s) {
            this._p = p;
            this._s = s;
            this.isDisposed = false;
        }
        RefCountDisposable.prototype.dispose = function() {
            if (!this.isDisposed) {
                this.isDisposed = true;
                this._s.dispose();
                --this._p._count === 0 && this._p._connectableSubscription.dispose();
            }
        };
        return RefCountObservable;
    }(ObservableBase);
    var ConnectableObservable = Rx.ConnectableObservable = function(__super__) {
        inherits(ConnectableObservable, __super__);
        function ConnectableObservable(source, subject) {
            this.source = source;
            this._connection = null;
            this._source = source.asObservable();
            this._subject = subject;
            __super__.call(this);
        }
        function ConnectDisposable(parent, subscription) {
            this._p = parent;
            this._s = subscription;
        }
        ConnectDisposable.prototype.dispose = function() {
            if (this._s) {
                this._s.dispose();
                this._s = null;
                this._p._connection = null;
            }
        };
        ConnectableObservable.prototype.connect = function() {
            if (!this._connection) {
                if (this._subject.isStopped) return disposableEmpty;
                var subscription = this._source.subscribe(this._subject);
                this._connection = new ConnectDisposable(this, subscription);
            }
            return this._connection;
        };
        ConnectableObservable.prototype._subscribe = function(o) {
            return this._subject.subscribe(o);
        };
        ConnectableObservable.prototype.refCount = function() {
            return new RefCountObservable(this);
        };
        return ConnectableObservable;
    }(Observable);
    /**
   * Returns an observable sequence that shares a single subscription to the underlying sequence. This observable sequence
   * can be resubscribed to, even if all prior subscriptions have ended. (unlike `.publish().refCount()`)
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source.
   */ observableProto.singleInstance = function() {
        var source = this, hasObservable = false, observable;
        function getObservable() {
            if (!hasObservable) {
                hasObservable = true;
                observable = source['finally'](function() {
                    hasObservable = false;
                }).publish().refCount();
            }
            return observable;
        }
        return new AnonymousObservable(function(o) {
            return getObservable().subscribe(o);
        });
    };
    return Rx;
});

});

parcelRegister("eQzqz", function(module, exports) {
// Copyright (c) Microsoft, All rights reserved. See License.txt in the project root for license information.

(function(factory) {
    var objectTypes = {
        'function': true,
        'object': true
    };
    function checkGlobal(value) {
        return value && value.Object === Object ? value : null;
    }
    var freeExports = objectTypes["object"] && exports && !exports.nodeType ? exports : null;
    var freeModule = objectTypes["object"] && module && !module.nodeType ? module : null;
    var freeGlobal = checkGlobal(freeExports && freeModule && typeof $parcel$global === 'object' && $parcel$global);
    var freeSelf = checkGlobal(objectTypes[typeof self] && self);
    var freeWindow = checkGlobal(objectTypes[typeof window] && window);
    var moduleExports = freeModule && freeModule.exports === freeExports ? freeExports : null;
    var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
    var root = freeGlobal || freeWindow !== (thisGlobal && thisGlobal.window) && freeWindow || freeSelf || thisGlobal || Function('return this')();
    // Because of build optimizers
    if (typeof define === 'function' && define.amd) define([
        './rx'
    ], function(Rx, exports1) {
        return factory(root, exports1, Rx);
    });
    else if (module && module.exports === freeExports) module.exports = factory(root, module.exports, (parcelRequire("kTZM9")));
    else root.Rx = factory(root, {}, root.Rx);
}).call(this, function(root, exp, Rx, undefined) {
    var Observable = Rx.Observable, ObservableBase = Rx.ObservableBase, AbstractObserver = Rx.internals.AbstractObserver, CompositeDisposable = Rx.CompositeDisposable, BinaryDisposable = Rx.BinaryDisposable, RefCountDisposable = Rx.RefCountDisposable, SingleAssignmentDisposable = Rx.SingleAssignmentDisposable, SerialDisposable = Rx.SerialDisposable, Subject = Rx.Subject, observableProto = Observable.prototype, observableEmpty = Observable.empty, observableNever = Observable.never, AnonymousObservable = Rx.AnonymousObservable, addRef = Rx.internals.addRef, inherits = Rx.internals.inherits, bindCallback = Rx.internals.bindCallback, noop = Rx.helpers.noop, isPromise = Rx.helpers.isPromise, isFunction = Rx.helpers.isFunction, observableFromPromise = Observable.fromPromise;
    var errorObj = {
        e: {}
    };
    function tryCatcherGen(tryCatchTarget) {
        return function tryCatcher() {
            try {
                return tryCatchTarget.apply(this, arguments);
            } catch (e) {
                errorObj.e = e;
                return errorObj;
            }
        };
    }
    var tryCatch = Rx.internals.tryCatch = function tryCatch(fn) {
        if (!isFunction(fn)) throw new TypeError('fn must be a function');
        return tryCatcherGen(fn);
    };
    function thrower(e) {
        throw e;
    }
    var Map = root.Map || function() {
        function Map() {
            this.size = 0;
            this._values = [];
            this._keys = [];
        }
        Map.prototype['delete'] = function(key) {
            var i = this._keys.indexOf(key);
            if (i === -1) return false;
            this._values.splice(i, 1);
            this._keys.splice(i, 1);
            this.size--;
            return true;
        };
        Map.prototype.get = function(key) {
            var i = this._keys.indexOf(key);
            return i === -1 ? undefined : this._values[i];
        };
        Map.prototype.set = function(key, value) {
            var i = this._keys.indexOf(key);
            if (i === -1) {
                this._keys.push(key);
                this._values.push(value);
                this.size++;
            } else this._values[i] = value;
            return this;
        };
        Map.prototype.forEach = function(cb, thisArg) {
            for(var i = 0; i < this.size; i++)cb.call(thisArg, this._values[i], this._keys[i]);
        };
        return Map;
    }();
    /**
   *  Correlates the elements of two sequences based on overlapping durations.
   *
   *  @param {Observable} right The right observable sequence to join elements for.
   *  @param {Function} leftDurationSelector A function to select the duration (expressed as an observable sequence) of each element of the left observable sequence, used to determine overlap.
   *  @param {Function} rightDurationSelector A function to select the duration (expressed as an observable sequence) of each element of the right observable sequence, used to determine overlap.
   *  @param {Function} resultSelector A function invoked to compute a result element for any two overlapping elements of the left and right observable sequences. The parameters passed to the function correspond with the elements from the left and right source sequences for which overlap occurs.
   *  @returns {Observable} An observable sequence that contains result elements computed from source elements that have an overlapping duration.
   */ observableProto.join = function(right, leftDurationSelector, rightDurationSelector, resultSelector) {
        var left = this;
        return new AnonymousObservable(function(o) {
            var group = new CompositeDisposable();
            var leftDone = false, rightDone = false;
            var leftId = 0, rightId = 0;
            var leftMap = new Map(), rightMap = new Map();
            var handleError = function(e) {
                o.onError(e);
            };
            group.add(left.subscribe(function(value) {
                var id = leftId++, md = new SingleAssignmentDisposable();
                leftMap.set(id, value);
                group.add(md);
                var duration = tryCatch(leftDurationSelector)(value);
                if (duration === errorObj) return o.onError(duration.e);
                md.setDisposable(duration.take(1).subscribe(noop, handleError, function() {
                    leftMap['delete'](id) && leftMap.size === 0 && leftDone && o.onCompleted();
                    group.remove(md);
                }));
                rightMap.forEach(function(v) {
                    var result = tryCatch(resultSelector)(value, v);
                    if (result === errorObj) return o.onError(result.e);
                    o.onNext(result);
                });
            }, handleError, function() {
                leftDone = true;
                (rightDone || leftMap.size === 0) && o.onCompleted();
            }));
            group.add(right.subscribe(function(value) {
                var id = rightId++, md = new SingleAssignmentDisposable();
                rightMap.set(id, value);
                group.add(md);
                var duration = tryCatch(rightDurationSelector)(value);
                if (duration === errorObj) return o.onError(duration.e);
                md.setDisposable(duration.take(1).subscribe(noop, handleError, function() {
                    rightMap['delete'](id) && rightMap.size === 0 && rightDone && o.onCompleted();
                    group.remove(md);
                }));
                leftMap.forEach(function(v) {
                    var result = tryCatch(resultSelector)(v, value);
                    if (result === errorObj) return o.onError(result.e);
                    o.onNext(result);
                });
            }, handleError, function() {
                rightDone = true;
                (leftDone || rightMap.size === 0) && o.onCompleted();
            }));
            return group;
        }, left);
    };
    /**
   *  Correlates the elements of two sequences based on overlapping durations, and groups the results.
   *
   *  @param {Observable} right The right observable sequence to join elements for.
   *  @param {Function} leftDurationSelector A function to select the duration (expressed as an observable sequence) of each element of the left observable sequence, used to determine overlap.
   *  @param {Function} rightDurationSelector A function to select the duration (expressed as an observable sequence) of each element of the right observable sequence, used to determine overlap.
   *  @param {Function} resultSelector A function invoked to compute a result element for any element of the left sequence with overlapping elements from the right observable sequence. The first parameter passed to the function is an element of the left sequence. The second parameter passed to the function is an observable sequence with elements from the right sequence that overlap with the left sequence's element.
   *  @returns {Observable} An observable sequence that contains result elements computed from source elements that have an overlapping duration.
   */ observableProto.groupJoin = function(right, leftDurationSelector, rightDurationSelector, resultSelector) {
        var left = this;
        return new AnonymousObservable(function(o) {
            var group = new CompositeDisposable();
            var r = new RefCountDisposable(group);
            var leftMap = new Map(), rightMap = new Map();
            var leftId = 0, rightId = 0;
            var handleError = function(e) {
                return function(v) {
                    v.onError(e);
                };
            };
            function handleError(e) {}
            group.add(left.subscribe(function(value) {
                var s = new Subject();
                var id = leftId++;
                leftMap.set(id, s);
                var result = tryCatch(resultSelector)(value, addRef(s, r));
                if (result === errorObj) {
                    leftMap.forEach(handleError(result.e));
                    return o.onError(result.e);
                }
                o.onNext(result);
                rightMap.forEach(function(v) {
                    s.onNext(v);
                });
                var md = new SingleAssignmentDisposable();
                group.add(md);
                var duration = tryCatch(leftDurationSelector)(value);
                if (duration === errorObj) {
                    leftMap.forEach(handleError(duration.e));
                    return o.onError(duration.e);
                }
                md.setDisposable(duration.take(1).subscribe(noop, function(e) {
                    leftMap.forEach(handleError(e));
                    o.onError(e);
                }, function() {
                    leftMap['delete'](id) && s.onCompleted();
                    group.remove(md);
                }));
            }, function(e) {
                leftMap.forEach(handleError(e));
                o.onError(e);
            }, function() {
                o.onCompleted();
            }));
            group.add(right.subscribe(function(value) {
                var id = rightId++;
                rightMap.set(id, value);
                var md = new SingleAssignmentDisposable();
                group.add(md);
                var duration = tryCatch(rightDurationSelector)(value);
                if (duration === errorObj) {
                    leftMap.forEach(handleError(duration.e));
                    return o.onError(duration.e);
                }
                md.setDisposable(duration.take(1).subscribe(noop, function(e) {
                    leftMap.forEach(handleError(e));
                    o.onError(e);
                }, function() {
                    rightMap['delete'](id);
                    group.remove(md);
                }));
                leftMap.forEach(function(v) {
                    v.onNext(value);
                });
            }, function(e) {
                leftMap.forEach(handleError(e));
                o.onError(e);
            }));
            return r;
        }, left);
    };
    function toArray(x) {
        return x.toArray();
    }
    /**
   *  Projects each element of an observable sequence into zero or more buffers.
   *  @param {Mixed} bufferOpeningsOrClosingSelector Observable sequence whose elements denote the creation of new windows, or, a function invoked to define the boundaries of the produced windows (a new window is started when the previous one is closed, resulting in non-overlapping windows).
   *  @param {Function} [bufferClosingSelector] A function invoked to define the closing of each produced window. If a closing selector function is specified for the first parameter, this parameter is ignored.
   *  @returns {Observable} An observable sequence of windows.
   */ observableProto.buffer = function() {
        return this.window.apply(this, arguments).flatMap(toArray);
    };
    /**
   *  Projects each element of an observable sequence into zero or more windows.
   *
   *  @param {Mixed} windowOpeningsOrClosingSelector Observable sequence whose elements denote the creation of new windows, or, a function invoked to define the boundaries of the produced windows (a new window is started when the previous one is closed, resulting in non-overlapping windows).
   *  @param {Function} [windowClosingSelector] A function invoked to define the closing of each produced window. If a closing selector function is specified for the first parameter, this parameter is ignored.
   *  @returns {Observable} An observable sequence of windows.
   */ observableProto.window = function(windowOpeningsOrClosingSelector, windowClosingSelector) {
        if (arguments.length === 1 && typeof arguments[0] !== 'function') return observableWindowWithBoundaries.call(this, windowOpeningsOrClosingSelector);
        return typeof windowOpeningsOrClosingSelector === 'function' ? observableWindowWithClosingSelector.call(this, windowOpeningsOrClosingSelector) : observableWindowWithOpenings.call(this, windowOpeningsOrClosingSelector, windowClosingSelector);
    };
    function observableWindowWithOpenings(windowOpenings, windowClosingSelector) {
        return windowOpenings.groupJoin(this, windowClosingSelector, observableEmpty, function(_, win) {
            return win;
        });
    }
    function observableWindowWithBoundaries(windowBoundaries) {
        var source = this;
        return new AnonymousObservable(function(observer) {
            var win = new Subject(), d = new CompositeDisposable(), r = new RefCountDisposable(d);
            observer.onNext(addRef(win, r));
            d.add(source.subscribe(function(x) {
                win.onNext(x);
            }, function(err) {
                win.onError(err);
                observer.onError(err);
            }, function() {
                win.onCompleted();
                observer.onCompleted();
            }));
            isPromise(windowBoundaries) && (windowBoundaries = observableFromPromise(windowBoundaries));
            d.add(windowBoundaries.subscribe(function(w) {
                win.onCompleted();
                win = new Subject();
                observer.onNext(addRef(win, r));
            }, function(err) {
                win.onError(err);
                observer.onError(err);
            }, function() {
                win.onCompleted();
                observer.onCompleted();
            }));
            return r;
        }, source);
    }
    function observableWindowWithClosingSelector(windowClosingSelector) {
        var source = this;
        return new AnonymousObservable(function(observer) {
            var m = new SerialDisposable(), d = new CompositeDisposable(m), r = new RefCountDisposable(d), win = new Subject();
            observer.onNext(addRef(win, r));
            d.add(source.subscribe(function(x) {
                win.onNext(x);
            }, function(err) {
                win.onError(err);
                observer.onError(err);
            }, function() {
                win.onCompleted();
                observer.onCompleted();
            }));
            function createWindowClose() {
                var windowClose;
                try {
                    windowClose = windowClosingSelector();
                } catch (e) {
                    observer.onError(e);
                    return;
                }
                isPromise(windowClose) && (windowClose = observableFromPromise(windowClose));
                var m1 = new SingleAssignmentDisposable();
                m.setDisposable(m1);
                m1.setDisposable(windowClose.take(1).subscribe(noop, function(err) {
                    win.onError(err);
                    observer.onError(err);
                }, function() {
                    win.onCompleted();
                    win = new Subject();
                    observer.onNext(addRef(win, r));
                    createWindowClose();
                }));
            }
            createWindowClose();
            return r;
        }, source);
    }
    var PairwiseObservable = function(__super__) {
        inherits(PairwiseObservable, __super__);
        function PairwiseObservable(source) {
            this.source = source;
            __super__.call(this);
        }
        PairwiseObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new PairwiseObserver(o));
        };
        return PairwiseObservable;
    }(ObservableBase);
    var PairwiseObserver = function(__super__) {
        inherits(PairwiseObserver, __super__);
        function PairwiseObserver(o) {
            this._o = o;
            this._p = null;
            this._hp = false;
            __super__.call(this);
        }
        PairwiseObserver.prototype.next = function(x) {
            if (this._hp) this._o.onNext([
                this._p,
                x
            ]);
            else this._hp = true;
            this._p = x;
        };
        PairwiseObserver.prototype.error = function(err) {
            this._o.onError(err);
        };
        PairwiseObserver.prototype.completed = function() {
            this._o.onCompleted();
        };
        return PairwiseObserver;
    }(AbstractObserver);
    /**
   * Returns a new observable that triggers on the second and subsequent triggerings of the input observable.
   * The Nth triggering of the input observable passes the arguments from the N-1th and Nth triggering as a pair.
   * The argument passed to the N-1th triggering is held in hidden internal state until the Nth triggering occurs.
   * @returns {Observable} An observable that triggers on successive pairs of observations from the input observable as an array.
   */ observableProto.pairwise = function() {
        return new PairwiseObservable(this);
    };
    /**
   * Returns two observables which partition the observations of the source by the given function.
   * The first will trigger observations for those values for which the predicate returns true.
   * The second will trigger observations for those values where the predicate returns false.
   * The predicate is executed once for each subscribed observer.
   * Both also propagate all error observations arising from the source and each completes
   * when the source completes.
   * @param {Function} predicate
   *    The function to determine which output Observable will trigger a particular observation.
   * @returns {Array}
   *    An array of observables. The first triggers when the predicate returns true,
   *    and the second triggers when the predicate returns false.
  */ observableProto.partition = function(predicate, thisArg) {
        var fn = bindCallback(predicate, thisArg, 3);
        return [
            this.filter(predicate, thisArg),
            this.filter(function(x, i, o) {
                return !fn(x, i, o);
            })
        ];
    };
    /**
   *  Groups the elements of an observable sequence according to a specified key selector function and comparer and selects the resulting elements by using a specified function.
   *
   * @example
   *  var res = observable.groupBy(function (x) { return x.id; });
   *  2 - observable.groupBy(function (x) { return x.id; }), function (x) { return x.name; });
   *  3 - observable.groupBy(function (x) { return x.id; }), function (x) { return x.name; }, function (x) { return x.toString(); });
   * @param {Function} keySelector A function to extract the key for each element.
   * @param {Function} [elementSelector]  A function to map each source element to an element in an observable group.
   * @returns {Observable} A sequence of observable groups, each of which corresponds to a unique key value, containing all elements that share that same key value.
   */ observableProto.groupBy = function(keySelector, elementSelector) {
        return this.groupByUntil(keySelector, elementSelector, observableNever);
    };
    /**
     *  Groups the elements of an observable sequence according to a specified key selector function.
     *  A duration selector function is used to control the lifetime of groups. When a group expires, it receives an OnCompleted notification. When a new element with the same
     *  key value as a reclaimed group occurs, the group will be reborn with a new lifetime request.
     *
     * @example
     *  var res = observable.groupByUntil(function (x) { return x.id; }, null,  function () { return Rx.Observable.never(); });
     *  2 - observable.groupBy(function (x) { return x.id; }), function (x) { return x.name; },  function () { return Rx.Observable.never(); });
     *  3 - observable.groupBy(function (x) { return x.id; }), function (x) { return x.name; },  function () { return Rx.Observable.never(); }, function (x) { return x.toString(); });
     * @param {Function} keySelector A function to extract the key for each element.
     * @param {Function} durationSelector A function to signal the expiration of a group.
     * @returns {Observable}
     *  A sequence of observable groups, each of which corresponds to a unique key value, containing all elements that share that same key value.
     *  If a group's lifetime expires, a new group with the same key value can be created once an element with such a key value is encoutered.
     *
     */ observableProto.groupByUntil = function(keySelector, elementSelector, durationSelector) {
        var source = this;
        return new AnonymousObservable(function(o) {
            var map = new Map(), groupDisposable = new CompositeDisposable(), refCountDisposable = new RefCountDisposable(groupDisposable), handleError = function(e) {
                return function(item) {
                    item.onError(e);
                };
            };
            groupDisposable.add(source.subscribe(function(x) {
                var key = tryCatch(keySelector)(x);
                if (key === errorObj) {
                    map.forEach(handleError(key.e));
                    return o.onError(key.e);
                }
                var fireNewMapEntry = false, writer = map.get(key);
                if (writer === undefined) {
                    writer = new Subject();
                    map.set(key, writer);
                    fireNewMapEntry = true;
                }
                if (fireNewMapEntry) {
                    var group = new GroupedObservable(key, writer, refCountDisposable), durationGroup = new GroupedObservable(key, writer);
                    var duration = tryCatch(durationSelector)(durationGroup);
                    if (duration === errorObj) {
                        map.forEach(handleError(duration.e));
                        return o.onError(duration.e);
                    }
                    o.onNext(group);
                    var md = new SingleAssignmentDisposable();
                    groupDisposable.add(md);
                    md.setDisposable(duration.take(1).subscribe(noop, function(e) {
                        map.forEach(handleError(e));
                        o.onError(e);
                    }, function() {
                        if (map['delete'](key)) writer.onCompleted();
                        groupDisposable.remove(md);
                    }));
                }
                var element = x;
                if (isFunction(elementSelector)) {
                    element = tryCatch(elementSelector)(x);
                    if (element === errorObj) {
                        map.forEach(handleError(element.e));
                        return o.onError(element.e);
                    }
                }
                writer.onNext(element);
            }, function(e) {
                map.forEach(handleError(e));
                o.onError(e);
            }, function() {
                map.forEach(function(item) {
                    item.onCompleted();
                });
                o.onCompleted();
            }));
            return refCountDisposable;
        }, source);
    };
    var UnderlyingObservable = function(__super__) {
        inherits(UnderlyingObservable, __super__);
        function UnderlyingObservable(m, u) {
            this._m = m;
            this._u = u;
            __super__.call(this);
        }
        UnderlyingObservable.prototype.subscribeCore = function(o) {
            return new BinaryDisposable(this._m.getDisposable(), this._u.subscribe(o));
        };
        return UnderlyingObservable;
    }(ObservableBase);
    var GroupedObservable = function(__super__) {
        inherits(GroupedObservable, __super__);
        function GroupedObservable(key, underlyingObservable, mergedDisposable) {
            __super__.call(this);
            this.key = key;
            this.underlyingObservable = !mergedDisposable ? underlyingObservable : new UnderlyingObservable(mergedDisposable, underlyingObservable);
        }
        GroupedObservable.prototype._subscribe = function(o) {
            return this.underlyingObservable.subscribe(o);
        };
        return GroupedObservable;
    }(Observable);
    return Rx;
});

});

parcelRegister("e1JUm", function(module, exports) {
// Copyright (c) Microsoft, All rights reserved. See License.txt in the project root for license information.

(function(factory) {
    var objectTypes = {
        'function': true,
        'object': true
    };
    function checkGlobal(value) {
        return value && value.Object === Object ? value : null;
    }
    var freeExports = objectTypes["object"] && exports && !exports.nodeType ? exports : null;
    var freeModule = objectTypes["object"] && module && !module.nodeType ? module : null;
    var freeGlobal = checkGlobal(freeExports && freeModule && typeof $parcel$global === 'object' && $parcel$global);
    var freeSelf = checkGlobal(objectTypes[typeof self] && self);
    var freeWindow = checkGlobal(objectTypes[typeof window] && window);
    var moduleExports = freeModule && freeModule.exports === freeExports ? freeExports : null;
    var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
    var root = freeGlobal || freeWindow !== (thisGlobal && thisGlobal.window) && freeWindow || freeSelf || thisGlobal || Function('return this')();
    // Because of build optimizers
    if (typeof define === 'function' && define.amd) define([
        './rx'
    ], function(Rx, exports1) {
        return factory(root, exports1, Rx);
    });
    else if (module && module.exports === freeExports) module.exports = factory(root, module.exports, (parcelRequire("kTZM9")));
    else root.Rx = factory(root, {}, root.Rx);
}).call(this, function(root, exp, Rx, undefined) {
    // Aliases
    var Observable = Rx.Observable, observableProto = Observable.prototype, ObservableBase = Rx.ObservableBase, AbstractObserver = Rx.internals.AbstractObserver, FlatMapObservable = Rx.FlatMapObservable, observableConcat = Observable.concat, observableDefer = Observable.defer, observableEmpty = Observable.empty, disposableEmpty = Rx.Disposable.empty, CompositeDisposable = Rx.CompositeDisposable, SerialDisposable = Rx.SerialDisposable, SingleAssignmentDisposable = Rx.SingleAssignmentDisposable, Enumerable = Rx.internals.Enumerable, enumerableOf = Enumerable.of, currentThreadScheduler = Rx.Scheduler.currentThread, AsyncSubject = Rx.AsyncSubject, Observer = Rx.Observer, inherits = Rx.internals.inherits, addProperties = Rx.internals.addProperties, helpers = Rx.helpers, noop = helpers.noop, isPromise = helpers.isPromise, isFunction = helpers.isFunction, isIterable = Rx.helpers.isIterable, isArrayLike = Rx.helpers.isArrayLike, isScheduler = Rx.Scheduler.isScheduler, observableFromPromise = Observable.fromPromise;
    var errorObj = {
        e: {}
    };
    function tryCatcherGen(tryCatchTarget) {
        return function tryCatcher() {
            try {
                return tryCatchTarget.apply(this, arguments);
            } catch (e) {
                errorObj.e = e;
                return errorObj;
            }
        };
    }
    var tryCatch = Rx.internals.tryCatch = function tryCatch(fn) {
        if (!isFunction(fn)) throw new TypeError('fn must be a function');
        return tryCatcherGen(fn);
    };
    function thrower(e) {
        throw e;
    }
    // Shim in iterator support
    var $iterator$ = typeof Symbol === 'function' && Symbol.iterator || '_es6shim_iterator_';
    // Bug for mozilla version
    if (root.Set && typeof new root.Set()['@@iterator'] === 'function') $iterator$ = '@@iterator';
    var doneEnumerator = Rx.doneEnumerator = {
        done: true,
        value: undefined
    };
    var isIterable = Rx.helpers.isIterable = function(o) {
        return o && o[$iterator$] !== undefined;
    };
    var isArrayLike = Rx.helpers.isArrayLike = function(o) {
        return o && o.length !== undefined;
    };
    Rx.helpers.iterator = $iterator$;
    var WhileEnumerable = function(__super__) {
        inherits(WhileEnumerable, __super__);
        function WhileEnumerable(c, s) {
            this.c = c;
            this.s = s;
        }
        WhileEnumerable.prototype[$iterator$] = function() {
            var self1 = this;
            return {
                next: function() {
                    return self1.c() ? {
                        done: false,
                        value: self1.s
                    } : {
                        done: true,
                        value: void 0
                    };
                }
            };
        };
        return WhileEnumerable;
    }(Enumerable);
    function enumerableWhile(condition, source) {
        return new WhileEnumerable(condition, source);
    }
    /**
   *  Returns an observable sequence that is the result of invoking the selector on the source sequence, without sharing subscriptions.
   *  This operator allows for a fluent style of writing queries that use the same sequence multiple times.
   *
   * @param {Function} selector Selector function which can use the source sequence as many times as needed, without sharing subscriptions to the source sequence.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence within a selector function.
   */ observableProto.letBind = observableProto['let'] = function(func) {
        return func(this);
    };
    /**
   *  Determines whether an observable collection contains values. 
   *
   * @example
   *  1 - res = Rx.Observable.if(condition, obs1);
   *  2 - res = Rx.Observable.if(condition, obs1, obs2);
   *  3 - res = Rx.Observable.if(condition, obs1, scheduler);
   * @param {Function} condition The condition which determines if the thenSource or elseSource will be run.
   * @param {Observable} thenSource The observable sequence or Promise that will be run if the condition function returns true.
   * @param {Observable} [elseSource] The observable sequence or Promise that will be run if the condition function returns false. If this is not provided, it defaults to Rx.Observabe.Empty with the specified scheduler.
   * @returns {Observable} An observable sequence which is either the thenSource or elseSource.
   */ Observable['if'] = function(condition, thenSource, elseSourceOrScheduler) {
        return observableDefer(function() {
            elseSourceOrScheduler || (elseSourceOrScheduler = observableEmpty());
            isPromise(thenSource) && (thenSource = observableFromPromise(thenSource));
            isPromise(elseSourceOrScheduler) && (elseSourceOrScheduler = observableFromPromise(elseSourceOrScheduler));
            // Assume a scheduler for empty only
            typeof elseSourceOrScheduler.now === 'function' && (elseSourceOrScheduler = observableEmpty(elseSourceOrScheduler));
            return condition() ? thenSource : elseSourceOrScheduler;
        });
    };
    /**
   *  Concatenates the observable sequences obtained by running the specified result selector for each element in source.
   * There is an alias for this method called 'forIn' for browsers <IE9
   * @param {Array} sources An array of values to turn into an observable sequence.
   * @param {Function} resultSelector A function to apply to each item in the sources array to turn it into an observable sequence.
   * @returns {Observable} An observable sequence from the concatenated observable sequences.
   */ Observable['for'] = Observable.forIn = function(sources, resultSelector, thisArg) {
        return enumerableOf(sources, resultSelector, thisArg).concat();
    };
    /**
   *  Repeats source as long as condition holds emulating a while loop.
   * There is an alias for this method called 'whileDo' for browsers <IE9
   *
   * @param {Function} condition The condition which determines if the source will be repeated.
   * @param {Observable} source The observable sequence that will be run if the condition function returns true.
   * @returns {Observable} An observable sequence which is repeated as long as the condition holds.
   */ var observableWhileDo = Observable['while'] = Observable.whileDo = function(condition, source) {
        isPromise(source) && (source = observableFromPromise(source));
        return enumerableWhile(condition, source).concat();
    };
    /**
   *  Repeats source as long as condition holds emulating a do while loop.
   *
   * @param {Function} condition The condition which determines if the source will be repeated.
   * @param {Observable} source The observable sequence that will be run if the condition function returns true.
   * @returns {Observable} An observable sequence which is repeated as long as the condition holds.
   */ observableProto.doWhile = function(condition) {
        return observableConcat([
            this,
            observableWhileDo(condition, this)
        ]);
    };
    /**
   *  Uses selector to determine which source in sources to use.
   * @param {Function} selector The function which extracts the value for to test in a case statement.
   * @param {Array} sources A object which has keys which correspond to the case statement labels.
   * @param {Observable} [elseSource] The observable sequence or Promise that will be run if the sources are not matched. If this is not provided, it defaults to Rx.Observabe.empty with the specified scheduler.
   *
   * @returns {Observable} An observable sequence which is determined by a case statement.
   */ Observable['case'] = function(selector, sources, defaultSourceOrScheduler) {
        return observableDefer(function() {
            isPromise(defaultSourceOrScheduler) && (defaultSourceOrScheduler = observableFromPromise(defaultSourceOrScheduler));
            defaultSourceOrScheduler || (defaultSourceOrScheduler = observableEmpty());
            isScheduler(defaultSourceOrScheduler) && (defaultSourceOrScheduler = observableEmpty(defaultSourceOrScheduler));
            var result = sources[selector()];
            isPromise(result) && (result = observableFromPromise(result));
            return result || defaultSourceOrScheduler;
        });
    };
    var ExpandObservable = function(__super__) {
        inherits(ExpandObservable, __super__);
        function ExpandObservable(source, fn, scheduler) {
            this.source = source;
            this._fn = fn;
            this._scheduler = scheduler;
            __super__.call(this);
        }
        function scheduleRecursive(args, recurse) {
            var state = args[0], self1 = args[1];
            var work;
            if (state.q.length > 0) work = state.q.shift();
            else {
                state.isAcquired = false;
                return;
            }
            var m1 = new SingleAssignmentDisposable();
            state.d.add(m1);
            m1.setDisposable(work.subscribe(new ExpandObserver(state, self1, m1)));
            recurse([
                state,
                self1
            ]);
        }
        ExpandObservable.prototype._ensureActive = function(state) {
            var isOwner = false;
            if (state.q.length > 0) {
                isOwner = !state.isAcquired;
                state.isAcquired = true;
            }
            isOwner && state.m.setDisposable(this._scheduler.scheduleRecursive([
                state,
                this
            ], scheduleRecursive));
        };
        ExpandObservable.prototype.subscribeCore = function(o) {
            var m = new SerialDisposable(), d = new CompositeDisposable(m), state = {
                q: [],
                m: m,
                d: d,
                activeCount: 0,
                isAcquired: false,
                o: o
            };
            state.q.push(this.source);
            state.activeCount++;
            this._ensureActive(state);
            return d;
        };
        return ExpandObservable;
    }(ObservableBase);
    var ExpandObserver = function(__super__) {
        inherits(ExpandObserver, __super__);
        function ExpandObserver(state, parent, m1) {
            this._s = state;
            this._p = parent;
            this._m1 = m1;
            __super__.call(this);
        }
        ExpandObserver.prototype.next = function(x) {
            this._s.o.onNext(x);
            var result = tryCatch(this._p._fn)(x);
            if (result === errorObj) return this._s.o.onError(result.e);
            this._s.q.push(result);
            this._s.activeCount++;
            this._p._ensureActive(this._s);
        };
        ExpandObserver.prototype.error = function(e) {
            this._s.o.onError(e);
        };
        ExpandObserver.prototype.completed = function() {
            this._s.d.remove(this._m1);
            this._s.activeCount--;
            this._s.activeCount === 0 && this._s.o.onCompleted();
        };
        return ExpandObserver;
    }(AbstractObserver);
    /**
   *  Expands an observable sequence by recursively invoking selector.
   *
   * @param {Function} selector Selector function to invoke for each produced element, resulting in another sequence to which the selector will be invoked recursively again.
   * @param {Scheduler} [scheduler] Scheduler on which to perform the expansion. If not provided, this defaults to the current thread scheduler.
   * @returns {Observable} An observable sequence containing all the elements produced by the recursive expansion.
   */ observableProto.expand = function(selector, scheduler) {
        isScheduler(scheduler) || (scheduler = currentThreadScheduler);
        return new ExpandObservable(this, selector, scheduler);
    };
    function argumentsToArray() {
        var len = arguments.length, args = new Array(len);
        for(var i = 0; i < len; i++)args[i] = arguments[i];
        return args;
    }
    var ForkJoinObservable = function(__super__) {
        inherits(ForkJoinObservable, __super__);
        function ForkJoinObservable(sources, cb) {
            this._sources = sources;
            this._cb = cb;
            __super__.call(this);
        }
        ForkJoinObservable.prototype.subscribeCore = function(o) {
            if (this._sources.length === 0) {
                o.onCompleted();
                return disposableEmpty;
            }
            var count = this._sources.length;
            var state = {
                finished: false,
                hasResults: new Array(count),
                hasCompleted: new Array(count),
                results: new Array(count)
            };
            var subscriptions = new CompositeDisposable();
            for(var i = 0, len = this._sources.length; i < len; i++){
                var source = this._sources[i];
                isPromise(source) && (source = observableFromPromise(source));
                subscriptions.add(source.subscribe(new ForkJoinObserver(o, state, i, this._cb, subscriptions)));
            }
            return subscriptions;
        };
        return ForkJoinObservable;
    }(ObservableBase);
    var ForkJoinObserver = function(__super__) {
        inherits(ForkJoinObserver, __super__);
        function ForkJoinObserver(o, s, i, cb, subs) {
            this._o = o;
            this._s = s;
            this._i = i;
            this._cb = cb;
            this._subs = subs;
            __super__.call(this);
        }
        ForkJoinObserver.prototype.next = function(x) {
            if (!this._s.finished) {
                this._s.hasResults[this._i] = true;
                this._s.results[this._i] = x;
            }
        };
        ForkJoinObserver.prototype.error = function(e) {
            this._s.finished = true;
            this._o.onError(e);
            this._subs.dispose();
        };
        ForkJoinObserver.prototype.completed = function() {
            if (!this._s.finished) {
                if (!this._s.hasResults[this._i]) return this._o.onCompleted();
                this._s.hasCompleted[this._i] = true;
                for(var i = 0; i < this._s.results.length; i++){
                    if (!this._s.hasCompleted[i]) return;
                }
                this._s.finished = true;
                var res = tryCatch(this._cb).apply(null, this._s.results);
                if (res === errorObj) return this._o.onError(res.e);
                this._o.onNext(res);
                this._o.onCompleted();
            }
        };
        return ForkJoinObserver;
    }(AbstractObserver);
    /**
   *  Runs all observable sequences in parallel and collect their last elements.
   *
   * @example
   *  1 - res = Rx.Observable.forkJoin([obs1, obs2]);
   *  1 - res = Rx.Observable.forkJoin(obs1, obs2, ...);
   * @returns {Observable} An observable sequence with an array collecting the last elements of all the input sequences.
   */ Observable.forkJoin = function() {
        var len = arguments.length, args = new Array(len);
        for(var i = 0; i < len; i++)args[i] = arguments[i];
        var resultSelector = isFunction(args[len - 1]) ? args.pop() : argumentsToArray;
        Array.isArray(args[0]) && (args = args[0]);
        return new ForkJoinObservable(args, resultSelector);
    };
    /**
   *  Runs two observable sequences in parallel and combines their last elemenets.
   * @param {Observable} second Second observable sequence.
   * @param {Function} resultSelector Result selector function to invoke with the last elements of both sequences.
   * @returns {Observable} An observable sequence with the result of calling the selector function with the last elements of both input sequences.
   */ observableProto.forkJoin = function() {
        var len = arguments.length, args = new Array(len);
        for(var i = 0; i < len; i++)args[i] = arguments[i];
        if (Array.isArray(args[0])) args[0].unshift(this);
        else args.unshift(this);
        return Observable.forkJoin.apply(null, args);
    };
    /**
   * Comonadic bind operator.
   * @param {Function} selector A transform function to apply to each element.
   * @param {Object} scheduler Scheduler used to execute the operation. If not specified, defaults to the ImmediateScheduler.
   * @returns {Observable} An observable sequence which results from the comonadic bind operation.
   */ observableProto.manySelect = observableProto.extend = function(selector, scheduler) {
        isScheduler(scheduler) || (scheduler = Rx.Scheduler.immediate);
        var source = this;
        return observableDefer(function() {
            var chain;
            return source.map(function(x) {
                var curr = new ChainObservable(x);
                chain && chain.onNext(x);
                chain = curr;
                return curr;
            }).tap(noop, function(e) {
                chain && chain.onError(e);
            }, function() {
                chain && chain.onCompleted();
            }).observeOn(scheduler).map(selector);
        }, source);
    };
    var ChainObservable = function(__super__) {
        inherits(ChainObservable, __super__);
        function ChainObservable(head) {
            __super__.call(this);
            this.head = head;
            this.tail = new AsyncSubject();
        }
        addProperties(ChainObservable.prototype, Observer, {
            _subscribe: function(o) {
                var g = new CompositeDisposable();
                g.add(currentThreadScheduler.schedule(this, function(_, self1) {
                    o.onNext(self1.head);
                    g.add(self1.tail.mergeAll().subscribe(o));
                }));
                return g;
            },
            onCompleted: function() {
                this.onNext(Observable.empty());
            },
            onError: function(e) {
                this.onNext(Observable['throw'](e));
            },
            onNext: function(v) {
                this.tail.onNext(v);
                this.tail.onCompleted();
            }
        });
        return ChainObservable;
    }(Observable);
    var SwitchFirstObservable = function(__super__) {
        inherits(SwitchFirstObservable, __super__);
        function SwitchFirstObservable(source) {
            this.source = source;
            __super__.call(this);
        }
        SwitchFirstObservable.prototype.subscribeCore = function(o) {
            var m = new SingleAssignmentDisposable(), g = new CompositeDisposable(), state = {
                hasCurrent: false,
                isStopped: false,
                o: o,
                g: g
            };
            g.add(m);
            m.setDisposable(this.source.subscribe(new SwitchFirstObserver(state)));
            return g;
        };
        return SwitchFirstObservable;
    }(ObservableBase);
    var SwitchFirstObserver = function(__super__) {
        inherits(SwitchFirstObserver, __super__);
        function SwitchFirstObserver(state) {
            this._s = state;
            __super__.call(this);
        }
        SwitchFirstObserver.prototype.next = function(x) {
            if (!this._s.hasCurrent) {
                this._s.hasCurrent = true;
                isPromise(x) && (x = observableFromPromise(x));
                var inner = new SingleAssignmentDisposable();
                this._s.g.add(inner);
                inner.setDisposable(x.subscribe(new InnerObserver(this._s, inner)));
            }
        };
        SwitchFirstObserver.prototype.error = function(e) {
            this._s.o.onError(e);
        };
        SwitchFirstObserver.prototype.completed = function() {
            this._s.isStopped = true;
            !this._s.hasCurrent && this._s.g.length === 1 && this._s.o.onCompleted();
        };
        inherits(InnerObserver, __super__);
        function InnerObserver(state, inner) {
            this._s = state;
            this._i = inner;
            __super__.call(this);
        }
        InnerObserver.prototype.next = function(x) {
            this._s.o.onNext(x);
        };
        InnerObserver.prototype.error = function(e) {
            this._s.o.onError(e);
        };
        InnerObserver.prototype.completed = function() {
            this._s.g.remove(this._i);
            this._s.hasCurrent = false;
            this._s.isStopped && this._s.g.length === 1 && this._s.o.onCompleted();
        };
        return SwitchFirstObserver;
    }(AbstractObserver);
    /**
   * Performs a exclusive waiting for the first to finish before subscribing to another observable.
   * Observables that come in between subscriptions will be dropped on the floor.
   * @returns {Observable} A exclusive observable with only the results that happen when subscribed.
   */ observableProto.switchFirst = function() {
        return new SwitchFirstObservable(this);
    };
    observableProto.flatMapFirst = observableProto.exhaustMap = function(selector, resultSelector, thisArg) {
        return new FlatMapObservable(this, selector, resultSelector, thisArg).switchFirst();
    };
    observableProto.flatMapWithMaxConcurrent = observableProto.flatMapMaxConcurrent = function(limit, selector, resultSelector, thisArg) {
        return new FlatMapObservable(this, selector, resultSelector, thisArg).merge(limit);
    };
    return Rx;
});

});

parcelRegister("iCqie", function(module, exports) {
// Copyright (c) Microsoft, All rights reserved. See License.txt in the project root for license information.

(function(factory) {
    var objectTypes = {
        'function': true,
        'object': true
    };
    function checkGlobal(value) {
        return value && value.Object === Object ? value : null;
    }
    var freeExports = objectTypes["object"] && exports && !exports.nodeType ? exports : null;
    var freeModule = objectTypes["object"] && module && !module.nodeType ? module : null;
    var freeGlobal = checkGlobal(freeExports && freeModule && typeof $parcel$global === 'object' && $parcel$global);
    var freeSelf = checkGlobal(objectTypes[typeof self] && self);
    var freeWindow = checkGlobal(objectTypes[typeof window] && window);
    var moduleExports = freeModule && freeModule.exports === freeExports ? freeExports : null;
    var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
    var root = freeGlobal || freeWindow !== (thisGlobal && thisGlobal.window) && freeWindow || freeSelf || thisGlobal || Function('return this')();
    // Because of build optimizers
    if (typeof define === 'function' && define.amd) define([
        './rx'
    ], function(Rx, exports1) {
        return factory(root, exports1, Rx);
    });
    else if (module && module.exports === freeExports) module.exports = factory(root, module.exports, (parcelRequire("kTZM9")));
    else root.Rx = factory(root, {}, root.Rx);
}).call(this, function(root, exp, Rx, undefined) {
    // Aliases
    var Observable = Rx.Observable, observableProto = Observable.prototype, AnonymousObservable = Rx.AnonymousObservable, observableThrow = Observable.throwError, observerCreate = Rx.Observer.create, SingleAssignmentDisposable = Rx.SingleAssignmentDisposable, CompositeDisposable = Rx.CompositeDisposable, AbstractObserver = Rx.internals.AbstractObserver, noop = Rx.helpers.noop, inherits = Rx.internals.inherits, isFunction = Rx.helpers.isFunction;
    var errorObj = {
        e: {}
    };
    function tryCatcherGen(tryCatchTarget) {
        return function tryCatcher() {
            try {
                return tryCatchTarget.apply(this, arguments);
            } catch (e) {
                errorObj.e = e;
                return errorObj;
            }
        };
    }
    var tryCatch = Rx.internals.tryCatch = function tryCatch(fn) {
        if (!isFunction(fn)) throw new TypeError('fn must be a function');
        return tryCatcherGen(fn);
    };
    function thrower(e) {
        throw e;
    }
    var Map = root.Map || function() {
        function Map() {
            this.size = 0;
            this._values = [];
            this._keys = [];
        }
        Map.prototype['delete'] = function(key) {
            var i = this._keys.indexOf(key);
            if (i === -1) return false;
            this._values.splice(i, 1);
            this._keys.splice(i, 1);
            this.size--;
            return true;
        };
        Map.prototype.get = function(key) {
            var i = this._keys.indexOf(key);
            return i === -1 ? undefined : this._values[i];
        };
        Map.prototype.set = function(key, value) {
            var i = this._keys.indexOf(key);
            if (i === -1) {
                this._keys.push(key);
                this._values.push(value);
                this.size++;
            } else this._values[i] = value;
            return this;
        };
        Map.prototype.forEach = function(cb, thisArg) {
            for(var i = 0; i < this.size; i++)cb.call(thisArg, this._values[i], this._keys[i]);
        };
        return Map;
    }();
    /**
   * @constructor
   * Represents a join pattern over observable sequences.
   */ function Pattern(patterns) {
        this.patterns = patterns;
    }
    /**
   *  Creates a pattern that matches the current plan matches and when the specified observable sequences has an available value.
   *  @param other Observable sequence to match in addition to the current pattern.
   *  @return {Pattern} Pattern object that matches when all observable sequences in the pattern have an available value.
   */ Pattern.prototype.and = function(other) {
        return new Pattern(this.patterns.concat(other));
    };
    /**
   *  Matches when all observable sequences in the pattern (specified using a chain of and operators) have an available value and projects the values.
   *  @param {Function} selector Selector that will be invoked with available values from the source sequences, in the same order of the sequences in the pattern.
   *  @return {Plan} Plan that produces the projected values, to be fed (with other plans) to the when operator.
   */ Pattern.prototype.thenDo = function(selector) {
        return new Plan(this, selector);
    };
    function Plan(expression, selector) {
        this.expression = expression;
        this.selector = selector;
    }
    function handleOnError(o) {
        return function(e) {
            o.onError(e);
        };
    }
    function handleOnNext(self1, observer) {
        return function onNext() {
            var result = tryCatch(self1.selector).apply(self1, arguments);
            if (result === errorObj) return observer.onError(result.e);
            observer.onNext(result);
        };
    }
    Plan.prototype.activate = function(externalSubscriptions, observer, deactivate) {
        var joinObservers = [], errHandler = handleOnError(observer);
        for(var i = 0, len = this.expression.patterns.length; i < len; i++)joinObservers.push(planCreateObserver(externalSubscriptions, this.expression.patterns[i], errHandler));
        var activePlan = new ActivePlan(joinObservers, handleOnNext(this, observer), function() {
            for(var j = 0, jlen = joinObservers.length; j < jlen; j++)joinObservers[j].removeActivePlan(activePlan);
            deactivate(activePlan);
        });
        for(i = 0, len = joinObservers.length; i < len; i++)joinObservers[i].addActivePlan(activePlan);
        return activePlan;
    };
    function planCreateObserver(externalSubscriptions, observable, onError) {
        var entry = externalSubscriptions.get(observable);
        if (!entry) {
            var observer = new JoinObserver(observable, onError);
            externalSubscriptions.set(observable, observer);
            return observer;
        }
        return entry;
    }
    function ActivePlan(joinObserverArray, onNext, onCompleted) {
        this.joinObserverArray = joinObserverArray;
        this.onNext = onNext;
        this.onCompleted = onCompleted;
        this.joinObservers = new Map();
        for(var i = 0, len = this.joinObserverArray.length; i < len; i++){
            var joinObserver = this.joinObserverArray[i];
            this.joinObservers.set(joinObserver, joinObserver);
        }
    }
    ActivePlan.prototype.dequeue = function() {
        this.joinObservers.forEach(function(v) {
            v.queue.shift();
        });
    };
    ActivePlan.prototype.match = function() {
        var i, len, hasValues = true;
        for(i = 0, len = this.joinObserverArray.length; i < len; i++)if (this.joinObserverArray[i].queue.length === 0) {
            hasValues = false;
            break;
        }
        if (hasValues) {
            var firstValues = [], isCompleted = false;
            for(i = 0, len = this.joinObserverArray.length; i < len; i++){
                firstValues.push(this.joinObserverArray[i].queue[0]);
                this.joinObserverArray[i].queue[0].kind === 'C' && (isCompleted = true);
            }
            if (isCompleted) this.onCompleted();
            else {
                this.dequeue();
                var values = [];
                for(i = 0, len = firstValues.length; i < firstValues.length; i++)values.push(firstValues[i].value);
                this.onNext.apply(this, values);
            }
        }
    };
    var JoinObserver = function(__super__) {
        inherits(JoinObserver, __super__);
        function JoinObserver(source, onError) {
            __super__.call(this);
            this.source = source;
            this.onError = onError;
            this.queue = [];
            this.activePlans = [];
            this.subscription = new SingleAssignmentDisposable();
            this.isDisposed = false;
        }
        var JoinObserverPrototype = JoinObserver.prototype;
        JoinObserverPrototype.next = function(notification) {
            if (!this.isDisposed) {
                if (notification.kind === 'E') return this.onError(notification.error);
                this.queue.push(notification);
                var activePlans = this.activePlans.slice(0);
                for(var i = 0, len = activePlans.length; i < len; i++)activePlans[i].match();
            }
        };
        JoinObserverPrototype.error = noop;
        JoinObserverPrototype.completed = noop;
        JoinObserverPrototype.addActivePlan = function(activePlan) {
            this.activePlans.push(activePlan);
        };
        JoinObserverPrototype.subscribe = function() {
            this.subscription.setDisposable(this.source.materialize().subscribe(this));
        };
        JoinObserverPrototype.removeActivePlan = function(activePlan) {
            this.activePlans.splice(this.activePlans.indexOf(activePlan), 1);
            this.activePlans.length === 0 && this.dispose();
        };
        JoinObserverPrototype.dispose = function() {
            __super__.prototype.dispose.call(this);
            if (!this.isDisposed) {
                this.isDisposed = true;
                this.subscription.dispose();
            }
        };
        return JoinObserver;
    }(AbstractObserver);
    /**
   *  Creates a pattern that matches when both observable sequences have an available value.
   *
   *  @param right Observable sequence to match with the current sequence.
   *  @return {Pattern} Pattern object that matches when both observable sequences have an available value.
   */ observableProto.and = function(right) {
        return new Pattern([
            this,
            right
        ]);
    };
    /**
   *  Matches when the observable sequence has an available value and projects the value.
   *
   *  @param {Function} selector Selector that will be invoked for values in the source sequence.
   *  @returns {Plan} Plan that produces the projected values, to be fed (with other plans) to the when operator.
   */ observableProto.thenDo = function(selector) {
        return new Pattern([
            this
        ]).thenDo(selector);
    };
    /**
   *  Joins together the results from several patterns.
   *
   *  @param plans A series of plans (specified as an Array of as a series of arguments) created by use of the Then operator on patterns.
   *  @returns {Observable} Observable sequence with the results form matching several patterns.
   */ Observable.when = function() {
        var len = arguments.length, plans;
        if (Array.isArray(arguments[0])) plans = arguments[0];
        else {
            plans = new Array(len);
            for(var i = 0; i < len; i++)plans[i] = arguments[i];
        }
        return new AnonymousObservable(function(o) {
            var activePlans = [], externalSubscriptions = new Map();
            var outObserver = observerCreate(function(x) {
                o.onNext(x);
            }, function(err) {
                externalSubscriptions.forEach(function(v) {
                    v.onError(err);
                });
                o.onError(err);
            }, function(x) {
                o.onCompleted();
            });
            try {
                for(var i = 0, len = plans.length; i < len; i++)activePlans.push(plans[i].activate(externalSubscriptions, outObserver, function(activePlan) {
                    var idx = activePlans.indexOf(activePlan);
                    activePlans.splice(idx, 1);
                    activePlans.length === 0 && o.onCompleted();
                }));
            } catch (e) {
                return observableThrow(e).subscribe(o);
            }
            var group = new CompositeDisposable();
            externalSubscriptions.forEach(function(joinObserver) {
                joinObserver.subscribe();
                group.add(joinObserver);
            });
            return group;
        });
    };
    return Rx;
});

});

parcelRegister("iUbYX", function(module, exports) {
// Copyright (c) Microsoft, All rights reserved. See License.txt in the project root for license information.

(function(factory) {
    var objectTypes = {
        'function': true,
        'object': true
    };
    function checkGlobal(value) {
        return value && value.Object === Object ? value : null;
    }
    var freeExports = objectTypes["object"] && exports && !exports.nodeType ? exports : null;
    var freeModule = objectTypes["object"] && module && !module.nodeType ? module : null;
    var freeGlobal = checkGlobal(freeExports && freeModule && typeof $parcel$global === 'object' && $parcel$global);
    var freeSelf = checkGlobal(objectTypes[typeof self] && self);
    var freeWindow = checkGlobal(objectTypes[typeof window] && window);
    var moduleExports = freeModule && freeModule.exports === freeExports ? freeExports : null;
    var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
    var root = freeGlobal || freeWindow !== (thisGlobal && thisGlobal.window) && freeWindow || freeSelf || thisGlobal || Function('return this')();
    // Because of build optimizers
    if (typeof define === 'function' && define.amd) define([
        './rx'
    ], function(Rx, exports1) {
        return factory(root, exports1, Rx);
    });
    else if (module && module.exports === freeExports) module.exports = factory(root, module.exports, (parcelRequire("kTZM9")));
    else root.Rx = factory(root, {}, root.Rx);
}).call(this, function(root, exp, Rx, undefined) {
    var Observable = Rx.Observable, observableProto = Observable.prototype, AnonymousObservable = Rx.AnonymousObservable, observableNever = Observable.never, isEqual = Rx.internals.isEqual, defaultSubComparer = Rx.helpers.defaultSubComparer;
    /**
   * jortSort checks if your inputs are sorted.  Note that this is only for a sequence with an end.
   * See http://jort.technology/ for full details.
   * @returns {Observable} An observable which has a single value of true if sorted, else false.
   */ observableProto.jortSort = function() {
        return this.jortSortUntil(observableNever());
    };
    /**
   * jortSort checks if your inputs are sorted until another Observable sequence fires.
   * See http://jort.technology/ for full details.
   * @returns {Observable} An observable which has a single value of true if sorted, else false.
   */ observableProto.jortSortUntil = function(other) {
        var source = this;
        return new AnonymousObservable(function(observer) {
            var arr = [];
            return source.takeUntil(other).subscribe(arr.push.bind(arr), observer.onError.bind(observer), function() {
                var sorted = arr.slice(0).sort(defaultSubComparer);
                observer.onNext(isEqual(arr, sorted));
                observer.onCompleted();
            });
        }, source);
    };
    return Rx;
});

});

parcelRegister("5kQMv", function(module, exports) {
// Copyright (c) Microsoft, All rights reserved. See License.txt in the project root for license information.

(function(factory) {
    var objectTypes = {
        'function': true,
        'object': true
    };
    function checkGlobal(value) {
        return value && value.Object === Object ? value : null;
    }
    var freeExports = objectTypes["object"] && exports && !exports.nodeType ? exports : null;
    var freeModule = objectTypes["object"] && module && !module.nodeType ? module : null;
    var freeGlobal = checkGlobal(freeExports && freeModule && typeof $parcel$global === 'object' && $parcel$global);
    var freeSelf = checkGlobal(objectTypes[typeof self] && self);
    var freeWindow = checkGlobal(objectTypes[typeof window] && window);
    var moduleExports = freeModule && freeModule.exports === freeExports ? freeExports : null;
    var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
    var root = freeGlobal || freeWindow !== (thisGlobal && thisGlobal.window) && freeWindow || freeSelf || thisGlobal || Function('return this')();
    // Because of build optimizers
    if (typeof define === 'function' && define.amd) define([
        './rx'
    ], function(Rx, exports1) {
        return factory(root, exports1, Rx);
    });
    else if (module && module.exports === freeExports) module.exports = factory(root, module.exports, (parcelRequire("kTZM9")));
    else root.Rx = factory(root, {}, root.Rx);
}).call(this, function(root, exp, Rx, undefined) {
    // Aliases
    var Scheduler = Rx.Scheduler, ScheduledItem = Rx.internals.ScheduledItem, SchedulePeriodicRecursive = Rx.internals.SchedulePeriodicRecursive, PriorityQueue = Rx.internals.PriorityQueue, inherits = Rx.internals.inherits, defaultSubComparer = Rx.helpers.defaultSubComparer, notImplemented = Rx.helpers.notImplemented;
    /** Provides a set of extension methods for virtual time scheduling. */ var VirtualTimeScheduler = Rx.VirtualTimeScheduler = function(__super__) {
        inherits(VirtualTimeScheduler, __super__);
        /**
     * Creates a new virtual time scheduler with the specified initial clock value and absolute time comparer.
     *
     * @constructor
     * @param {Number} initialClock Initial value for the clock.
     * @param {Function} comparer Comparer to determine causality of events based on absolute time.
     */ function VirtualTimeScheduler(initialClock, comparer) {
            this.clock = initialClock;
            this.comparer = comparer;
            this.isEnabled = false;
            this.queue = new PriorityQueue(1024);
            __super__.call(this);
        }
        var VirtualTimeSchedulerPrototype = VirtualTimeScheduler.prototype;
        VirtualTimeSchedulerPrototype.now = function() {
            return this.toAbsoluteTime(this.clock);
        };
        VirtualTimeSchedulerPrototype.schedule = function(state, action) {
            return this.scheduleAbsolute(state, this.clock, action);
        };
        VirtualTimeSchedulerPrototype.scheduleFuture = function(state, dueTime, action) {
            var dt = dueTime instanceof Date ? this.toRelativeTime(dueTime - this.now()) : this.toRelativeTime(dueTime);
            return this.scheduleRelative(state, dt, action);
        };
        /**
     * Adds a relative time value to an absolute time value.
     * @param {Number} absolute Absolute virtual time value.
     * @param {Number} relative Relative virtual time value to add.
     * @return {Number} Resulting absolute virtual time sum value.
     */ VirtualTimeSchedulerPrototype.add = notImplemented;
        /**
     * Converts an absolute time to a number
     * @param {Any} The absolute time.
     * @returns {Number} The absolute time in ms
     */ VirtualTimeSchedulerPrototype.toAbsoluteTime = notImplemented;
        /**
     * Converts the TimeSpan value to a relative virtual time value.
     * @param {Number} timeSpan TimeSpan value to convert.
     * @return {Number} Corresponding relative virtual time value.
     */ VirtualTimeSchedulerPrototype.toRelativeTime = notImplemented;
        /**
     * Schedules a periodic piece of work by dynamically discovering the scheduler's capabilities. The periodic task will be emulated using recursive scheduling.
     * @param {Mixed} state Initial state passed to the action upon the first iteration.
     * @param {Number} period Period for running the work periodically.
     * @param {Function} action Action to be executed, potentially updating the state.
     * @returns {Disposable} The disposable object used to cancel the scheduled recurring action (best effort).
     */ VirtualTimeSchedulerPrototype.schedulePeriodic = function(state, period, action) {
            var s = new SchedulePeriodicRecursive(this, state, period, action);
            return s.start();
        };
        /**
     * Schedules an action to be executed after dueTime.
     * @param {Mixed} state State passed to the action to be executed.
     * @param {Number} dueTime Relative time after which to execute the action.
     * @param {Function} action Action to be executed.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
     */ VirtualTimeSchedulerPrototype.scheduleRelative = function(state, dueTime, action) {
            var runAt = this.add(this.clock, dueTime);
            return this.scheduleAbsolute(state, runAt, action);
        };
        /**
     * Starts the virtual time scheduler.
     */ VirtualTimeSchedulerPrototype.start = function() {
            if (!this.isEnabled) {
                this.isEnabled = true;
                do {
                    var next = this.getNext();
                    if (next !== null) {
                        this.comparer(next.dueTime, this.clock) > 0 && (this.clock = next.dueTime);
                        next.invoke();
                    } else this.isEnabled = false;
                }while (this.isEnabled);
            }
        };
        /**
     * Stops the virtual time scheduler.
     */ VirtualTimeSchedulerPrototype.stop = function() {
            this.isEnabled = false;
        };
        /**
     * Advances the scheduler's clock to the specified time, running all work till that point.
     * @param {Number} time Absolute time to advance the scheduler's clock to.
     */ VirtualTimeSchedulerPrototype.advanceTo = function(time) {
            var dueToClock = this.comparer(this.clock, time);
            if (this.comparer(this.clock, time) > 0) throw new ArgumentOutOfRangeError();
            if (dueToClock === 0) return;
            if (!this.isEnabled) {
                this.isEnabled = true;
                do {
                    var next = this.getNext();
                    if (next !== null && this.comparer(next.dueTime, time) <= 0) {
                        this.comparer(next.dueTime, this.clock) > 0 && (this.clock = next.dueTime);
                        next.invoke();
                    } else this.isEnabled = false;
                }while (this.isEnabled);
                this.clock = time;
            }
        };
        /**
     * Advances the scheduler's clock by the specified relative time, running all work scheduled for that timespan.
     * @param {Number} time Relative time to advance the scheduler's clock by.
     */ VirtualTimeSchedulerPrototype.advanceBy = function(time) {
            var dt = this.add(this.clock, time), dueToClock = this.comparer(this.clock, dt);
            if (dueToClock > 0) throw new ArgumentOutOfRangeError();
            if (dueToClock === 0) return;
            this.advanceTo(dt);
        };
        /**
     * Advances the scheduler's clock by the specified relative time.
     * @param {Number} time Relative time to advance the scheduler's clock by.
     */ VirtualTimeSchedulerPrototype.sleep = function(time) {
            var dt = this.add(this.clock, time);
            if (this.comparer(this.clock, dt) >= 0) throw new ArgumentOutOfRangeError();
            this.clock = dt;
        };
        /**
     * Gets the next scheduled item to be executed.
     * @returns {ScheduledItem} The next scheduled item.
     */ VirtualTimeSchedulerPrototype.getNext = function() {
            while(this.queue.length > 0){
                var next = this.queue.peek();
                if (next.isCancelled()) this.queue.dequeue();
                else return next;
            }
            return null;
        };
        /**
     * Schedules an action to be executed at dueTime.
     * @param {Mixed} state State passed to the action to be executed.
     * @param {Number} dueTime Absolute time at which to execute the action.
     * @param {Function} action Action to be executed.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
     */ VirtualTimeSchedulerPrototype.scheduleAbsolute = function(state, dueTime, action) {
            var self1 = this;
            function run(scheduler, state1) {
                self1.queue.remove(si);
                return action(scheduler, state1);
            }
            var si = new ScheduledItem(this, state, run, dueTime, this.comparer);
            this.queue.enqueue(si);
            return si.disposable;
        };
        return VirtualTimeScheduler;
    }(Scheduler);
    /** Provides a virtual time scheduler that uses Date for absolute time and number for relative time. */ Rx.HistoricalScheduler = function(__super__) {
        inherits(HistoricalScheduler, __super__);
        /**
     * Creates a new historical scheduler with the specified initial clock value.
     * @constructor
     * @param {Number} initialClock Initial value for the clock.
     * @param {Function} comparer Comparer to determine causality of events based on absolute time.
     */ function HistoricalScheduler(initialClock, comparer) {
            var clock = initialClock == null ? 0 : initialClock;
            var cmp = comparer || defaultSubComparer;
            __super__.call(this, clock, cmp);
        }
        var HistoricalSchedulerProto = HistoricalScheduler.prototype;
        /**
     * Adds a relative time value to an absolute time value.
     * @param {Number} absolute Absolute virtual time value.
     * @param {Number} relative Relative virtual time value to add.
     * @return {Number} Resulting absolute virtual time sum value.
     */ HistoricalSchedulerProto.add = function(absolute, relative) {
            return absolute + relative;
        };
        HistoricalSchedulerProto.toAbsoluteTime = function(absolute) {
            return new Date(absolute).getTime();
        };
        /**
     * Converts the TimeSpan value to a relative virtual time value.
     * @memberOf HistoricalScheduler
     * @param {Number} timeSpan TimeSpan value to convert.
     * @return {Number} Corresponding relative virtual time value.
     */ HistoricalSchedulerProto.toRelativeTime = function(timeSpan) {
            return timeSpan;
        };
        return HistoricalScheduler;
    }(Rx.VirtualTimeScheduler);
    return Rx;
});

});

parcelRegister("7kgSk", function(module, exports) {
// Copyright (c) Microsoft, All rights reserved. See License.txt in the project root for license information.

(function(factory) {
    var objectTypes = {
        'function': true,
        'object': true
    };
    function checkGlobal(value) {
        return value && value.Object === Object ? value : null;
    }
    var freeExports = objectTypes["object"] && exports && !exports.nodeType ? exports : null;
    var freeModule = objectTypes["object"] && module && !module.nodeType ? module : null;
    var freeGlobal = checkGlobal(freeExports && freeModule && typeof $parcel$global === 'object' && $parcel$global);
    var freeSelf = checkGlobal(objectTypes[typeof self] && self);
    var freeWindow = checkGlobal(objectTypes[typeof window] && window);
    var moduleExports = freeModule && freeModule.exports === freeExports ? freeExports : null;
    var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
    var root = freeGlobal || freeWindow !== (thisGlobal && thisGlobal.window) && freeWindow || freeSelf || thisGlobal || Function('return this')();
    // Because of build optimizers
    if (typeof define === 'function' && define.amd) define([
        './rx.virtualtime',
        'exports'
    ], function(Rx, exports1) {
        root.Rx = factory(root, exports1, Rx);
        return root.Rx;
    });
    else if (module && module.exports === freeExports) module.exports = factory(root, module.exports, (parcelRequire("kTZM9")));
    else root.Rx = factory(root, {}, root.Rx);
}).call(this, function(root, exp, Rx, undefined) {
    // Defaults
    var Observer = Rx.Observer, Observable = Rx.Observable, Notification = Rx.Notification, VirtualTimeScheduler = Rx.VirtualTimeScheduler, Disposable = Rx.Disposable, disposableEmpty = Disposable.empty, disposableCreate = Disposable.create, CompositeDisposable = Rx.CompositeDisposable, inherits = Rx.internals.inherits, defaultComparer = Rx.internals.isEqual;
    function OnNextPredicate(predicate) {
        this.predicate = predicate;
    }
    OnNextPredicate.prototype.equals = function(other) {
        if (other === this) return true;
        if (other == null) return false;
        if (other.kind !== 'N') return false;
        return this.predicate(other.value);
    };
    function OnErrorPredicate(predicate) {
        this.predicate = predicate;
    }
    OnErrorPredicate.prototype.equals = function(other) {
        if (other === this) return true;
        if (other == null) return false;
        if (other.kind !== 'E') return false;
        return this.predicate(other.error);
    };
    var ReactiveTest = Rx.ReactiveTest = {
        /** Default virtual time used for creation of observable sequences in unit tests. */ created: 100,
        /** Default virtual time used to subscribe to observable sequences in unit tests. */ subscribed: 200,
        /** Default virtual time used to dispose subscriptions in unit tests. */ disposed: 1000,
        /**
   * Factory method for an OnNext notification record at a given time with a given value or a predicate function.
   *
   * 1 - ReactiveTest.onNext(200, 42);
   * 2 - ReactiveTest.onNext(200, function (x) { return x.length == 2; });
   *
   * @param ticks Recorded virtual time the OnNext notification occurs.
   * @param value Recorded value stored in the OnNext notification or a predicate.
   * @return Recorded OnNext notification.
   */ onNext: function(ticks, value) {
            return typeof value === 'function' ? new Recorded(ticks, new OnNextPredicate(value)) : new Recorded(ticks, Notification.createOnNext(value));
        },
        /**
   * Factory method for an OnError notification record at a given time with a given error.
   *
   * 1 - ReactiveTest.onNext(200, new Error('error'));
   * 2 - ReactiveTest.onNext(200, function (e) { return e.message === 'error'; });
   *
   * @param ticks Recorded virtual time the OnError notification occurs.
   * @param exception Recorded exception stored in the OnError notification.
   * @return Recorded OnError notification.
   */ onError: function(ticks, error) {
            return typeof error === 'function' ? new Recorded(ticks, new OnErrorPredicate(error)) : new Recorded(ticks, Notification.createOnError(error));
        },
        /**
   * Factory method for an OnCompleted notification record at a given time.
   *
   * @param ticks Recorded virtual time the OnCompleted notification occurs.
   * @return Recorded OnCompleted notification.
   */ onCompleted: function(ticks) {
            return new Recorded(ticks, Notification.createOnCompleted());
        },
        /**
   * Factory method for a subscription record based on a given subscription and disposal time.
   *
   * @param start Virtual time indicating when the subscription was created.
   * @param end Virtual time indicating when the subscription was disposed.
   * @return Subscription object.
   */ subscribe: function(start, end) {
            return new Subscription(start, end);
        }
    };
    /**
   * Creates a new object recording the production of the specified value at the given virtual time.
   *
   * @constructor
   * @param {Number} time Virtual time the value was produced on.
   * @param {Mixed} value Value that was produced.
   * @param {Function} comparer An optional comparer.
   */ var Recorded = Rx.Recorded = function(time, value, comparer) {
        this.time = time;
        this.value = value;
        this.comparer = comparer || defaultComparer;
    };
    /**
   * Checks whether the given recorded object is equal to the current instance.
   *
   * @param {Recorded} other Recorded object to check for equality.
   * @returns {Boolean} true if both objects are equal; false otherwise.
   */ Recorded.prototype.equals = function(other) {
        return this.time === other.time && this.comparer(this.value, other.value);
    };
    /**
   * Returns a string representation of the current Recorded value.
   *
   * @returns {String} String representation of the current Recorded value.
   */ Recorded.prototype.toString = function() {
        return this.value.toString() + '@' + this.time;
    };
    /**
   * Creates a new subscription object with the given virtual subscription and unsubscription time.
   *
   * @constructor
   * @param {Number} subscribe Virtual time at which the subscription occurred.
   * @param {Number} unsubscribe Virtual time at which the unsubscription occurred.
   */ var Subscription = Rx.Subscription = function(start, end) {
        this.subscribe = start;
        this.unsubscribe = end || Number.MAX_VALUE;
    };
    /**
   * Checks whether the given subscription is equal to the current instance.
   * @param other Subscription object to check for equality.
   * @returns {Boolean} true if both objects are equal; false otherwise.
   */ Subscription.prototype.equals = function(other) {
        return this.subscribe === other.subscribe && this.unsubscribe === other.unsubscribe;
    };
    /**
   * Returns a string representation of the current Subscription value.
   * @returns {String} String representation of the current Subscription value.
   */ Subscription.prototype.toString = function() {
        return '(' + this.subscribe + ', ' + (this.unsubscribe === Number.MAX_VALUE ? 'Infinite' : this.unsubscribe) + ')';
    };
    var MockDisposable = Rx.MockDisposable = function(scheduler) {
        this.scheduler = scheduler;
        this.disposes = [];
        this.disposes.push(this.scheduler.clock);
    };
    MockDisposable.prototype.dispose = function() {
        this.disposes.push(this.scheduler.clock);
    };
    var MockObserver = function(__super__) {
        inherits(MockObserver, __super__);
        function MockObserver(scheduler) {
            __super__.call(this);
            this.scheduler = scheduler;
            this.messages = [];
        }
        var MockObserverPrototype = MockObserver.prototype;
        MockObserverPrototype.onNext = function(value) {
            this.messages.push(new Recorded(this.scheduler.clock, Notification.createOnNext(value)));
        };
        MockObserverPrototype.onError = function(e) {
            this.messages.push(new Recorded(this.scheduler.clock, Notification.createOnError(e)));
        };
        MockObserverPrototype.onCompleted = function() {
            this.messages.push(new Recorded(this.scheduler.clock, Notification.createOnCompleted()));
        };
        return MockObserver;
    }(Observer);
    function MockPromise(scheduler, messages) {
        var self1 = this;
        this.scheduler = scheduler;
        this.messages = messages;
        this.subscriptions = [];
        this.observers = [];
        for(var i = 0, len = this.messages.length; i < len; i++){
            var message = this.messages[i], notification = message.value;
            (function(innerNotification) {
                scheduler.scheduleAbsolute(null, message.time, function() {
                    var obs = self1.observers.slice(0);
                    for(var j = 0, jLen = obs.length; j < jLen; j++)innerNotification.accept(obs[j]);
                    return disposableEmpty;
                });
            })(notification);
        }
    }
    MockPromise.prototype.then = function(onResolved, onRejected) {
        var self1 = this;
        this.subscriptions.push(new Subscription(this.scheduler.clock));
        var index = this.subscriptions.length - 1;
        var newPromise;
        var observer = Rx.Observer.create(function(x) {
            var retValue = onResolved(x);
            if (retValue && typeof retValue.then === 'function') newPromise = retValue;
            else {
                var ticks = self1.scheduler.clock;
                newPromise = new MockPromise(self1.scheduler, [
                    Rx.ReactiveTest.onNext(ticks, undefined),
                    Rx.ReactiveTest.onCompleted(ticks)
                ]);
            }
            var idx = self1.observers.indexOf(observer);
            self1.observers.splice(idx, 1);
            self1.subscriptions[index] = new Subscription(self1.subscriptions[index].subscribe, self1.scheduler.clock);
        }, function(err) {
            onRejected(err);
            var idx = self1.observers.indexOf(observer);
            self1.observers.splice(idx, 1);
            self1.subscriptions[index] = new Subscription(self1.subscriptions[index].subscribe, self1.scheduler.clock);
        });
        this.observers.push(observer);
        return newPromise || new MockPromise(this.scheduler, this.messages);
    };
    var HotObservable = function(__super__) {
        inherits(HotObservable, __super__);
        function HotObservable(scheduler, messages) {
            __super__.call(this);
            var message, notification, observable = this;
            this.scheduler = scheduler;
            this.messages = messages;
            this.subscriptions = [];
            this.observers = [];
            for(var i = 0, len = this.messages.length; i < len; i++){
                message = this.messages[i];
                notification = message.value;
                (function(innerNotification) {
                    scheduler.scheduleAbsolute(null, message.time, function() {
                        var obs = observable.observers.slice(0);
                        for(var j = 0, jLen = obs.length; j < jLen; j++)innerNotification.accept(obs[j]);
                        return disposableEmpty;
                    });
                })(notification);
            }
        }
        HotObservable.prototype._subscribe = function(o) {
            var observable = this;
            this.observers.push(o);
            this.subscriptions.push(new Subscription(this.scheduler.clock));
            var index = this.subscriptions.length - 1;
            return disposableCreate(function() {
                var idx = observable.observers.indexOf(o);
                observable.observers.splice(idx, 1);
                observable.subscriptions[index] = new Subscription(observable.subscriptions[index].subscribe, observable.scheduler.clock);
            });
        };
        return HotObservable;
    }(Observable);
    var ColdObservable = function(__super__) {
        inherits(ColdObservable, __super__);
        function ColdObservable(scheduler, messages) {
            __super__.call(this);
            this.scheduler = scheduler;
            this.messages = messages;
            this.subscriptions = [];
        }
        ColdObservable.prototype._subscribe = function(o) {
            var message, notification, observable = this;
            this.subscriptions.push(new Subscription(this.scheduler.clock));
            var index = this.subscriptions.length - 1;
            var d = new CompositeDisposable();
            for(var i = 0, len = this.messages.length; i < len; i++){
                message = this.messages[i];
                notification = message.value;
                (function(innerNotification) {
                    d.add(observable.scheduler.scheduleRelative(null, message.time, function() {
                        innerNotification.accept(o);
                        return disposableEmpty;
                    }));
                })(notification);
            }
            return disposableCreate(function() {
                observable.subscriptions[index] = new Subscription(observable.subscriptions[index].subscribe, observable.scheduler.clock);
                d.dispose();
            });
        };
        return ColdObservable;
    }(Observable);
    /** Virtual time scheduler used for testing applications and libraries built using Reactive Extensions. */ Rx.TestScheduler = function(__super__) {
        inherits(TestScheduler, __super__);
        function baseComparer(x, y) {
            return x > y ? 1 : x < y ? -1 : 0;
        }
        function TestScheduler() {
            __super__.call(this, 0, baseComparer);
        }
        /**
     * Schedules an action to be executed at the specified virtual time.
     *
     * @param state State passed to the action to be executed.
     * @param dueTime Absolute virtual time at which to execute the action.
     * @param action Action to be executed.
     * @return Disposable object used to cancel the scheduled action (best effort).
     */ TestScheduler.prototype.scheduleAbsolute = function(state, dueTime, action) {
            dueTime <= this.clock && (dueTime = this.clock + 1);
            return __super__.prototype.scheduleAbsolute.call(this, state, dueTime, action);
        };
        /**
     * Adds a relative virtual time to an absolute virtual time value.
     *
     * @param absolute Absolute virtual time value.
     * @param relative Relative virtual time value to add.
     * @return Resulting absolute virtual time sum value.
     */ TestScheduler.prototype.add = function(absolute, relative) {
            return absolute + relative;
        };
        /**
     * Converts the absolute virtual time value to a DateTimeOffset value.
     *
     * @param absolute Absolute virtual time value to convert.
     * @return Corresponding DateTimeOffset value.
     */ TestScheduler.prototype.toAbsoluteTime = function(absolute) {
            return new Date(absolute).getTime();
        };
        /**
     * Converts the TimeSpan value to a relative virtual time value.
     *
     * @param timeSpan TimeSpan value to convert.
     * @return Corresponding relative virtual time value.
     */ TestScheduler.prototype.toRelativeTime = function(timeSpan) {
            return timeSpan;
        };
        /**
     * Starts the test scheduler and uses the specified virtual times to invoke the factory function, subscribe to the resulting sequence, and dispose the subscription.
     *
     * @param create Factory method to create an observable sequence.
     * @param created Virtual time at which to invoke the factory to create an observable sequence.
     * @param subscribed Virtual time at which to subscribe to the created observable sequence.
     * @param disposed Virtual time at which to dispose the subscription.
     * @return Observer with timestamped recordings of notification messages that were received during the virtual time window when the subscription to the source sequence was active.
     */ TestScheduler.prototype.startScheduler = function(createFn, settings) {
            settings || (settings = {});
            settings.created == null && (settings.created = ReactiveTest.created);
            settings.subscribed == null && (settings.subscribed = ReactiveTest.subscribed);
            settings.disposed == null && (settings.disposed = ReactiveTest.disposed);
            var observer = this.createObserver(), source, subscription;
            this.scheduleAbsolute(null, settings.created, function() {
                source = createFn();
                return disposableEmpty;
            });
            this.scheduleAbsolute(null, settings.subscribed, function() {
                subscription = source.subscribe(observer);
                return disposableEmpty;
            });
            this.scheduleAbsolute(null, settings.disposed, function() {
                subscription.dispose();
                return disposableEmpty;
            });
            this.start();
            return observer;
        };
        /**
     * Creates a hot observable using the specified timestamped notification messages either as an array or arguments.
     * @param messages Notifications to surface through the created sequence at their specified absolute virtual times.
     * @return Hot observable sequence that can be used to assert the timing of subscriptions and notifications.
     */ TestScheduler.prototype.createHotObservable = function() {
            var len = arguments.length, args;
            if (Array.isArray(arguments[0])) args = arguments[0];
            else {
                args = new Array(len);
                for(var i = 0; i < len; i++)args[i] = arguments[i];
            }
            return new HotObservable(this, args);
        };
        /**
     * Creates a cold observable using the specified timestamped notification messages either as an array or arguments.
     * @param messages Notifications to surface through the created sequence at their specified virtual time offsets from the sequence subscription time.
     * @return Cold observable sequence that can be used to assert the timing of subscriptions and notifications.
     */ TestScheduler.prototype.createColdObservable = function() {
            var len = arguments.length, args;
            if (Array.isArray(arguments[0])) args = arguments[0];
            else {
                args = new Array(len);
                for(var i = 0; i < len; i++)args[i] = arguments[i];
            }
            return new ColdObservable(this, args);
        };
        /**
     * Creates a resolved promise with the given value and ticks
     * @param {Number} ticks The absolute time of the resolution.
     * @param {Any} value The value to yield at the given tick.
     * @returns {MockPromise} A mock Promise which fulfills with the given value.
     */ TestScheduler.prototype.createResolvedPromise = function(ticks, value) {
            return new MockPromise(this, [
                Rx.ReactiveTest.onNext(ticks, value),
                Rx.ReactiveTest.onCompleted(ticks)
            ]);
        };
        /**
     * Creates a rejected promise with the given reason and ticks
     * @param {Number} ticks The absolute time of the resolution.
     * @param {Any} reason The reason for rejection to yield at the given tick.
     * @returns {MockPromise} A mock Promise which rejects with the given reason.
     */ TestScheduler.prototype.createRejectedPromise = function(ticks, reason) {
            return new MockPromise(this, [
                Rx.ReactiveTest.onError(ticks, reason)
            ]);
        };
        /**
     * Creates an observer that records received notification messages and timestamps those.
     * @return Observer that can be used to assert the timing of received notifications.
     */ TestScheduler.prototype.createObserver = function() {
            return new MockObserver(this);
        };
        return TestScheduler;
    }(VirtualTimeScheduler);
    return Rx;
});

});

parcelRegister("5QABN", function(module, exports) {
// Copyright (c) Microsoft, All rights reserved. See License.txt in the project root for license information.

(function(factory) {
    var objectTypes = {
        'function': true,
        'object': true
    };
    function checkGlobal(value) {
        return value && value.Object === Object ? value : null;
    }
    var freeExports = objectTypes["object"] && exports && !exports.nodeType ? exports : null;
    var freeModule = objectTypes["object"] && module && !module.nodeType ? module : null;
    var freeGlobal = checkGlobal(freeExports && freeModule && typeof $parcel$global === 'object' && $parcel$global);
    var freeSelf = checkGlobal(objectTypes[typeof self] && self);
    var freeWindow = checkGlobal(objectTypes[typeof window] && window);
    var moduleExports = freeModule && freeModule.exports === freeExports ? freeExports : null;
    var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
    var root = freeGlobal || freeWindow !== (thisGlobal && thisGlobal.window) && freeWindow || freeSelf || thisGlobal || Function('return this')();
    // Because of build optimizers
    if (typeof define === 'function' && define.amd) define([
        './rx'
    ], function(Rx, exports1) {
        return factory(root, exports1, Rx);
    });
    else if (module && module.exports === freeExports) module.exports = factory(root, module.exports, (parcelRequire("kTZM9")));
    else root.Rx = factory(root, {}, root.Rx);
}).call(this, function(root, exp, Rx, undefined) {
    // Refernces
    var inherits = Rx.internals.inherits, AbstractObserver = Rx.internals.AbstractObserver, Observable = Rx.Observable, observableProto = Observable.prototype, AnonymousObservable = Rx.AnonymousObservable, ObservableBase = Rx.ObservableBase, observableDefer = Observable.defer, observableEmpty = Observable.empty, observableNever = Observable.never, observableThrow = Observable['throw'], observableFromArray = Observable.fromArray, defaultScheduler = Rx.Scheduler['default'], SingleAssignmentDisposable = Rx.SingleAssignmentDisposable, SerialDisposable = Rx.SerialDisposable, CompositeDisposable = Rx.CompositeDisposable, BinaryDisposable = Rx.BinaryDisposable, RefCountDisposable = Rx.RefCountDisposable, Subject = Rx.Subject, addRef = Rx.internals.addRef, normalizeTime = Rx.Scheduler.normalize, helpers = Rx.helpers, isPromise = helpers.isPromise, isFunction = helpers.isFunction, isScheduler = Rx.Scheduler.isScheduler, observableFromPromise = Observable.fromPromise;
    var errorObj = {
        e: {}
    };
    function tryCatcherGen(tryCatchTarget) {
        return function tryCatcher() {
            try {
                return tryCatchTarget.apply(this, arguments);
            } catch (e) {
                errorObj.e = e;
                return errorObj;
            }
        };
    }
    var tryCatch = Rx.internals.tryCatch = function tryCatch(fn) {
        if (!isFunction(fn)) throw new TypeError('fn must be a function');
        return tryCatcherGen(fn);
    };
    function thrower(e) {
        throw e;
    }
    var TimerObservable = function(__super__) {
        inherits(TimerObservable, __super__);
        function TimerObservable(dt, s) {
            this._dt = dt;
            this._s = s;
            __super__.call(this);
        }
        TimerObservable.prototype.subscribeCore = function(o) {
            return this._s.scheduleFuture(o, this._dt, scheduleMethod);
        };
        function scheduleMethod(s, o) {
            o.onNext(0);
            o.onCompleted();
        }
        return TimerObservable;
    }(ObservableBase);
    function _observableTimer(dueTime, scheduler) {
        return new TimerObservable(dueTime, scheduler);
    }
    function observableTimerDateAndPeriod(dueTime, period, scheduler) {
        return new AnonymousObservable(function(observer) {
            var d = dueTime, p = normalizeTime(period);
            return scheduler.scheduleRecursiveFuture(0, d, function(count, self1) {
                if (p > 0) {
                    var now = scheduler.now();
                    d = new Date(d.getTime() + p);
                    d.getTime() <= now && (d = new Date(now + p));
                }
                observer.onNext(count);
                self1(count + 1, new Date(d));
            });
        });
    }
    function observableTimerTimeSpanAndPeriod(dueTime, period, scheduler) {
        return dueTime === period ? new AnonymousObservable(function(observer) {
            return scheduler.schedulePeriodic(0, period, function(count) {
                observer.onNext(count);
                return count + 1;
            });
        }) : observableDefer(function() {
            return observableTimerDateAndPeriod(new Date(scheduler.now() + dueTime), period, scheduler);
        });
    }
    /**
   *  Returns an observable sequence that produces a value after each period.
   *
   * @example
   *  1 - res = Rx.Observable.interval(1000);
   *  2 - res = Rx.Observable.interval(1000, Rx.Scheduler.timeout);
   *
   * @param {Number} period Period for producing the values in the resulting sequence (specified as an integer denoting milliseconds).
   * @param {Scheduler} [scheduler] Scheduler to run the timer on. If not specified, Rx.Scheduler.timeout is used.
   * @returns {Observable} An observable sequence that produces a value after each period.
   */ var observableinterval = Observable.interval = function(period, scheduler) {
        return observableTimerTimeSpanAndPeriod(period, period, isScheduler(scheduler) ? scheduler : defaultScheduler);
    };
    /**
   *  Returns an observable sequence that produces a value after dueTime has elapsed and then after each period.
   * @param {Number} dueTime Absolute (specified as a Date object) or relative time (specified as an integer denoting milliseconds) at which to produce the first value.
   * @param {Mixed} [periodOrScheduler]  Period to produce subsequent values (specified as an integer denoting milliseconds), or the scheduler to run the timer on. If not specified, the resulting timer is not recurring.
   * @param {Scheduler} [scheduler]  Scheduler to run the timer on. If not specified, the timeout scheduler is used.
   * @returns {Observable} An observable sequence that produces a value after due time has elapsed and then each period.
   */ var observableTimer = Observable.timer = function(dueTime, periodOrScheduler, scheduler) {
        var period;
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        if (periodOrScheduler != null && typeof periodOrScheduler === 'number') period = periodOrScheduler;
        else if (isScheduler(periodOrScheduler)) scheduler = periodOrScheduler;
        if ((dueTime instanceof Date || typeof dueTime === 'number') && period === undefined) return _observableTimer(dueTime, scheduler);
        if (dueTime instanceof Date && period !== undefined) return observableTimerDateAndPeriod(dueTime, periodOrScheduler, scheduler);
        return observableTimerTimeSpanAndPeriod(dueTime, period, scheduler);
    };
    function observableDelayRelative(source, dueTime, scheduler) {
        return new AnonymousObservable(function(o) {
            var active = false, cancelable = new SerialDisposable(), exception = null, q = [], running = false, subscription;
            subscription = source.materialize().timestamp(scheduler).subscribe(function(notification) {
                var d, shouldRun;
                if (notification.value.kind === 'E') {
                    q = [];
                    q.push(notification);
                    exception = notification.value.error;
                    shouldRun = !running;
                } else {
                    q.push({
                        value: notification.value,
                        timestamp: notification.timestamp + dueTime
                    });
                    shouldRun = !active;
                    active = true;
                }
                if (shouldRun) {
                    if (exception !== null) o.onError(exception);
                    else {
                        d = new SingleAssignmentDisposable();
                        cancelable.setDisposable(d);
                        d.setDisposable(scheduler.scheduleRecursiveFuture(null, dueTime, function(_, self1) {
                            var e, recurseDueTime, result, shouldRecurse;
                            if (exception !== null) return;
                            running = true;
                            do {
                                result = null;
                                if (q.length > 0 && q[0].timestamp - scheduler.now() <= 0) result = q.shift().value;
                                if (result !== null) result.accept(o);
                            }while (result !== null);
                            shouldRecurse = false;
                            recurseDueTime = 0;
                            if (q.length > 0) {
                                shouldRecurse = true;
                                recurseDueTime = Math.max(0, q[0].timestamp - scheduler.now());
                            } else active = false;
                            e = exception;
                            running = false;
                            if (e !== null) o.onError(e);
                            else if (shouldRecurse) self1(null, recurseDueTime);
                        }));
                    }
                }
            });
            return new BinaryDisposable(subscription, cancelable);
        }, source);
    }
    function observableDelayAbsolute(source, dueTime, scheduler) {
        return observableDefer(function() {
            return observableDelayRelative(source, dueTime - scheduler.now(), scheduler);
        });
    }
    function delayWithSelector(source, subscriptionDelay, delayDurationSelector) {
        var subDelay, selector;
        if (isFunction(subscriptionDelay)) selector = subscriptionDelay;
        else {
            subDelay = subscriptionDelay;
            selector = delayDurationSelector;
        }
        return new AnonymousObservable(function(o) {
            var delays = new CompositeDisposable(), atEnd = false, subscription = new SerialDisposable();
            function start() {
                subscription.setDisposable(source.subscribe(function(x) {
                    var delay = tryCatch(selector)(x);
                    if (delay === errorObj) return o.onError(delay.e);
                    var d = new SingleAssignmentDisposable();
                    delays.add(d);
                    d.setDisposable(delay.subscribe(function() {
                        o.onNext(x);
                        delays.remove(d);
                        done();
                    }, function(e) {
                        o.onError(e);
                    }, function() {
                        o.onNext(x);
                        delays.remove(d);
                        done();
                    }));
                }, function(e) {
                    o.onError(e);
                }, function() {
                    atEnd = true;
                    subscription.dispose();
                    done();
                }));
            }
            function done() {
                atEnd && delays.length === 0 && o.onCompleted();
            }
            if (!subDelay) start();
            else subscription.setDisposable(subDelay.subscribe(start, function(e) {
                o.onError(e);
            }, start));
            return new BinaryDisposable(subscription, delays);
        }, source);
    }
    /**
   *  Time shifts the observable sequence by dueTime.
   *  The relative time intervals between the values are preserved.
   *
   * @param {Number} dueTime Absolute (specified as a Date object) or relative time (specified as an integer denoting milliseconds) by which to shift the observable sequence.
   * @param {Scheduler} [scheduler] Scheduler to run the delay timers on. If not specified, the timeout scheduler is used.
   * @returns {Observable} Time-shifted sequence.
   */ observableProto.delay = function() {
        var firstArg = arguments[0];
        if (typeof firstArg === 'number' || firstArg instanceof Date) {
            var dueTime = firstArg, scheduler = arguments[1];
            isScheduler(scheduler) || (scheduler = defaultScheduler);
            return dueTime instanceof Date ? observableDelayAbsolute(this, dueTime, scheduler) : observableDelayRelative(this, dueTime, scheduler);
        } else if (Observable.isObservable(firstArg) || isFunction(firstArg)) return delayWithSelector(this, firstArg, arguments[1]);
        else throw new Error('Invalid arguments');
    };
    var DebounceObservable = function(__super__) {
        inherits(DebounceObservable, __super__);
        function DebounceObservable(source, dt, s) {
            isScheduler(s) || (s = defaultScheduler);
            this.source = source;
            this._dt = dt;
            this._s = s;
            __super__.call(this);
        }
        DebounceObservable.prototype.subscribeCore = function(o) {
            var cancelable = new SerialDisposable();
            return new BinaryDisposable(this.source.subscribe(new DebounceObserver(o, this._dt, this._s, cancelable)), cancelable);
        };
        return DebounceObservable;
    }(ObservableBase);
    var DebounceObserver = function(__super__) {
        inherits(DebounceObserver, __super__);
        function DebounceObserver(observer, dueTime, scheduler, cancelable) {
            this._o = observer;
            this._d = dueTime;
            this._scheduler = scheduler;
            this._c = cancelable;
            this._v = null;
            this._hv = false;
            this._id = 0;
            __super__.call(this);
        }
        function scheduleFuture(s, state) {
            state.self._hv && state.self._id === state.currentId && state.self._o.onNext(state.x);
            state.self._hv = false;
        }
        DebounceObserver.prototype.next = function(x) {
            this._hv = true;
            this._v = x;
            var currentId = ++this._id, d = new SingleAssignmentDisposable();
            this._c.setDisposable(d);
            d.setDisposable(this._scheduler.scheduleFuture(this, this._d, function(_, self1) {
                self1._hv && self1._id === currentId && self1._o.onNext(x);
                self1._hv = false;
            }));
        };
        DebounceObserver.prototype.error = function(e) {
            this._c.dispose();
            this._o.onError(e);
            this._hv = false;
            this._id++;
        };
        DebounceObserver.prototype.completed = function() {
            this._c.dispose();
            this._hv && this._o.onNext(this._v);
            this._o.onCompleted();
            this._hv = false;
            this._id++;
        };
        return DebounceObserver;
    }(AbstractObserver);
    function debounceWithSelector(source, durationSelector) {
        return new AnonymousObservable(function(o) {
            var value, hasValue = false, cancelable = new SerialDisposable(), id = 0;
            var subscription = source.subscribe(function(x) {
                var throttle = tryCatch(durationSelector)(x);
                if (throttle === errorObj) return o.onError(throttle.e);
                isPromise(throttle) && (throttle = observableFromPromise(throttle));
                hasValue = true;
                value = x;
                id++;
                var currentid = id, d = new SingleAssignmentDisposable();
                cancelable.setDisposable(d);
                d.setDisposable(throttle.subscribe(function() {
                    hasValue && id === currentid && o.onNext(value);
                    hasValue = false;
                    d.dispose();
                }, function(e) {
                    o.onError(e);
                }, function() {
                    hasValue && id === currentid && o.onNext(value);
                    hasValue = false;
                    d.dispose();
                }));
            }, function(e) {
                cancelable.dispose();
                o.onError(e);
                hasValue = false;
                id++;
            }, function() {
                cancelable.dispose();
                hasValue && o.onNext(value);
                o.onCompleted();
                hasValue = false;
                id++;
            });
            return new BinaryDisposable(subscription, cancelable);
        }, source);
    }
    observableProto.debounce = function() {
        if (isFunction(arguments[0])) return debounceWithSelector(this, arguments[0]);
        else if (typeof arguments[0] === 'number') return new DebounceObservable(this, arguments[0], arguments[1]);
        else throw new Error('Invalid arguments');
    };
    /**
   *  Projects each element of an observable sequence into zero or more windows which are produced based on timing information.
   * @param {Number} timeSpan Length of each window (specified as an integer denoting milliseconds).
   * @param {Mixed} [timeShiftOrScheduler]  Interval between creation of consecutive windows (specified as an integer denoting milliseconds), or an optional scheduler parameter. If not specified, the time shift corresponds to the timeSpan parameter, resulting in non-overlapping adjacent windows.
   * @param {Scheduler} [scheduler]  Scheduler to run windowing timers on. If not specified, the timeout scheduler is used.
   * @returns {Observable} An observable sequence of windows.
   */ observableProto.windowWithTime = observableProto.windowTime = function(timeSpan, timeShiftOrScheduler, scheduler) {
        var source = this, timeShift;
        timeShiftOrScheduler == null && (timeShift = timeSpan);
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        if (typeof timeShiftOrScheduler === 'number') timeShift = timeShiftOrScheduler;
        else if (isScheduler(timeShiftOrScheduler)) {
            timeShift = timeSpan;
            scheduler = timeShiftOrScheduler;
        }
        return new AnonymousObservable(function(observer) {
            var groupDisposable, nextShift = timeShift, nextSpan = timeSpan, q = [], refCountDisposable, timerD = new SerialDisposable(), totalTime = 0;
            groupDisposable = new CompositeDisposable(timerD), refCountDisposable = new RefCountDisposable(groupDisposable);
            function createTimer() {
                var m = new SingleAssignmentDisposable(), isSpan = false, isShift = false;
                timerD.setDisposable(m);
                if (nextSpan === nextShift) {
                    isSpan = true;
                    isShift = true;
                } else if (nextSpan < nextShift) isSpan = true;
                else isShift = true;
                var newTotalTime = isSpan ? nextSpan : nextShift, ts = newTotalTime - totalTime;
                totalTime = newTotalTime;
                if (isSpan) nextSpan += timeShift;
                if (isShift) nextShift += timeShift;
                m.setDisposable(scheduler.scheduleFuture(null, ts, function() {
                    if (isShift) {
                        var s = new Subject();
                        q.push(s);
                        observer.onNext(addRef(s, refCountDisposable));
                    }
                    isSpan && q.shift().onCompleted();
                    createTimer();
                }));
            }
            q.push(new Subject());
            observer.onNext(addRef(q[0], refCountDisposable));
            createTimer();
            groupDisposable.add(source.subscribe(function(x) {
                for(var i = 0, len = q.length; i < len; i++)q[i].onNext(x);
            }, function(e) {
                for(var i = 0, len = q.length; i < len; i++)q[i].onError(e);
                observer.onError(e);
            }, function() {
                for(var i = 0, len = q.length; i < len; i++)q[i].onCompleted();
                observer.onCompleted();
            }));
            return refCountDisposable;
        }, source);
    };
    /**
   *  Projects each element of an observable sequence into a window that is completed when either it's full or a given amount of time has elapsed.
   * @param {Number} timeSpan Maximum time length of a window.
   * @param {Number} count Maximum element count of a window.
   * @param {Scheduler} [scheduler]  Scheduler to run windowing timers on. If not specified, the timeout scheduler is used.
   * @returns {Observable} An observable sequence of windows.
   */ observableProto.windowWithTimeOrCount = observableProto.windowTimeOrCount = function(timeSpan, count, scheduler) {
        var source = this;
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        return new AnonymousObservable(function(observer) {
            var timerD = new SerialDisposable(), groupDisposable = new CompositeDisposable(timerD), refCountDisposable = new RefCountDisposable(groupDisposable), n = 0, windowId = 0, s = new Subject();
            function createTimer(id) {
                var m = new SingleAssignmentDisposable();
                timerD.setDisposable(m);
                m.setDisposable(scheduler.scheduleFuture(null, timeSpan, function() {
                    if (id !== windowId) return;
                    n = 0;
                    var newId = ++windowId;
                    s.onCompleted();
                    s = new Subject();
                    observer.onNext(addRef(s, refCountDisposable));
                    createTimer(newId);
                }));
            }
            observer.onNext(addRef(s, refCountDisposable));
            createTimer(0);
            groupDisposable.add(source.subscribe(function(x) {
                var newId = 0, newWindow = false;
                s.onNext(x);
                if (++n === count) {
                    newWindow = true;
                    n = 0;
                    newId = ++windowId;
                    s.onCompleted();
                    s = new Subject();
                    observer.onNext(addRef(s, refCountDisposable));
                }
                newWindow && createTimer(newId);
            }, function(e) {
                s.onError(e);
                observer.onError(e);
            }, function() {
                s.onCompleted();
                observer.onCompleted();
            }));
            return refCountDisposable;
        }, source);
    };
    function toArray(x) {
        return x.toArray();
    }
    /**
   *  Projects each element of an observable sequence into zero or more buffers which are produced based on timing information.
   * @param {Number} timeSpan Length of each buffer (specified as an integer denoting milliseconds).
   * @param {Mixed} [timeShiftOrScheduler]  Interval between creation of consecutive buffers (specified as an integer denoting milliseconds), or an optional scheduler parameter. If not specified, the time shift corresponds to the timeSpan parameter, resulting in non-overlapping adjacent buffers.
   * @param {Scheduler} [scheduler]  Scheduler to run buffer timers on. If not specified, the timeout scheduler is used.
   * @returns {Observable} An observable sequence of buffers.
   */ observableProto.bufferWithTime = observableProto.bufferTime = function(timeSpan, timeShiftOrScheduler, scheduler) {
        return this.windowWithTime(timeSpan, timeShiftOrScheduler, scheduler).flatMap(toArray);
    };
    function toArray(x) {
        return x.toArray();
    }
    /**
   *  Projects each element of an observable sequence into a buffer that is completed when either it's full or a given amount of time has elapsed.
   * @param {Number} timeSpan Maximum time length of a buffer.
   * @param {Number} count Maximum element count of a buffer.
   * @param {Scheduler} [scheduler]  Scheduler to run bufferin timers on. If not specified, the timeout scheduler is used.
   * @returns {Observable} An observable sequence of buffers.
   */ observableProto.bufferWithTimeOrCount = observableProto.bufferTimeOrCount = function(timeSpan, count, scheduler) {
        return this.windowWithTimeOrCount(timeSpan, count, scheduler).flatMap(toArray);
    };
    var TimeIntervalObservable = function(__super__) {
        inherits(TimeIntervalObservable, __super__);
        function TimeIntervalObservable(source, s) {
            this.source = source;
            this._s = s;
            __super__.call(this);
        }
        TimeIntervalObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new TimeIntervalObserver(o, this._s));
        };
        return TimeIntervalObservable;
    }(ObservableBase);
    var TimeIntervalObserver = function(__super__) {
        inherits(TimeIntervalObserver, __super__);
        function TimeIntervalObserver(o, s) {
            this._o = o;
            this._s = s;
            this._l = s.now();
            __super__.call(this);
        }
        TimeIntervalObserver.prototype.next = function(x) {
            var now = this._s.now(), span = now - this._l;
            this._l = now;
            this._o.onNext({
                value: x,
                interval: span
            });
        };
        TimeIntervalObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        TimeIntervalObserver.prototype.completed = function() {
            this._o.onCompleted();
        };
        return TimeIntervalObserver;
    }(AbstractObserver);
    /**
   *  Records the time interval between consecutive values in an observable sequence.
   *
   * @example
   *  1 - res = source.timeInterval();
   *  2 - res = source.timeInterval(Rx.Scheduler.timeout);
   *
   * @param [scheduler]  Scheduler used to compute time intervals. If not specified, the timeout scheduler is used.
   * @returns {Observable} An observable sequence with time interval information on values.
   */ observableProto.timeInterval = function(scheduler) {
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        return new TimeIntervalObservable(this, scheduler);
    };
    var TimestampObservable = function(__super__) {
        inherits(TimestampObservable, __super__);
        function TimestampObservable(source, s) {
            this.source = source;
            this._s = s;
            __super__.call(this);
        }
        TimestampObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new TimestampObserver(o, this._s));
        };
        return TimestampObservable;
    }(ObservableBase);
    var TimestampObserver = function(__super__) {
        inherits(TimestampObserver, __super__);
        function TimestampObserver(o, s) {
            this._o = o;
            this._s = s;
            __super__.call(this);
        }
        TimestampObserver.prototype.next = function(x) {
            this._o.onNext({
                value: x,
                timestamp: this._s.now()
            });
        };
        TimestampObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        TimestampObserver.prototype.completed = function() {
            this._o.onCompleted();
        };
        return TimestampObserver;
    }(AbstractObserver);
    /**
   *  Records the timestamp for each value in an observable sequence.
   *
   * @example
   *  1 - res = source.timestamp(); // produces { value: x, timestamp: ts }
   *  2 - res = source.timestamp(Rx.Scheduler.default);
   *
   * @param {Scheduler} [scheduler]  Scheduler used to compute timestamps. If not specified, the default scheduler is used.
   * @returns {Observable} An observable sequence with timestamp information on values.
   */ observableProto.timestamp = function(scheduler) {
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        return new TimestampObservable(this, scheduler);
    };
    var SampleObservable = function(__super__) {
        inherits(SampleObservable, __super__);
        function SampleObservable(source, sampler) {
            this.source = source;
            this._sampler = sampler;
            __super__.call(this);
        }
        SampleObservable.prototype.subscribeCore = function(o) {
            var state = {
                o: o,
                atEnd: false,
                value: null,
                hasValue: false,
                sourceSubscription: new SingleAssignmentDisposable()
            };
            state.sourceSubscription.setDisposable(this.source.subscribe(new SampleSourceObserver(state)));
            return new BinaryDisposable(state.sourceSubscription, this._sampler.subscribe(new SamplerObserver(state)));
        };
        return SampleObservable;
    }(ObservableBase);
    var SamplerObserver = function(__super__) {
        inherits(SamplerObserver, __super__);
        function SamplerObserver(s) {
            this._s = s;
            __super__.call(this);
        }
        SamplerObserver.prototype._handleMessage = function() {
            if (this._s.hasValue) {
                this._s.hasValue = false;
                this._s.o.onNext(this._s.value);
            }
            this._s.atEnd && this._s.o.onCompleted();
        };
        SamplerObserver.prototype.next = function() {
            this._handleMessage();
        };
        SamplerObserver.prototype.error = function(e) {
            this._s.onError(e);
        };
        SamplerObserver.prototype.completed = function() {
            this._handleMessage();
        };
        return SamplerObserver;
    }(AbstractObserver);
    var SampleSourceObserver = function(__super__) {
        inherits(SampleSourceObserver, __super__);
        function SampleSourceObserver(s) {
            this._s = s;
            __super__.call(this);
        }
        SampleSourceObserver.prototype.next = function(x) {
            this._s.hasValue = true;
            this._s.value = x;
        };
        SampleSourceObserver.prototype.error = function(e) {
            this._s.o.onError(e);
        };
        SampleSourceObserver.prototype.completed = function() {
            this._s.atEnd = true;
            this._s.sourceSubscription.dispose();
        };
        return SampleSourceObserver;
    }(AbstractObserver);
    /**
   *  Samples the observable sequence at each interval.
   *
   * @example
   *  1 - res = source.sample(sampleObservable); // Sampler tick sequence
   *  2 - res = source.sample(5000); // 5 seconds
   *  2 - res = source.sample(5000, Rx.Scheduler.timeout); // 5 seconds
   *
   * @param {Mixed} intervalOrSampler Interval at which to sample (specified as an integer denoting milliseconds) or Sampler Observable.
   * @param {Scheduler} [scheduler]  Scheduler to run the sampling timer on. If not specified, the timeout scheduler is used.
   * @returns {Observable} Sampled observable sequence.
   */ observableProto.sample = function(intervalOrSampler, scheduler) {
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        return typeof intervalOrSampler === 'number' ? new SampleObservable(this, observableinterval(intervalOrSampler, scheduler)) : new SampleObservable(this, intervalOrSampler);
    };
    var TimeoutError = Rx.TimeoutError = function(message) {
        this.message = message || 'Timeout has occurred';
        this.name = 'TimeoutError';
        Error.call(this);
    };
    TimeoutError.prototype = Object.create(Error.prototype);
    function timeoutWithSelector(source, firstTimeout, timeoutDurationSelector, other) {
        if (isFunction(firstTimeout)) {
            other = timeoutDurationSelector;
            timeoutDurationSelector = firstTimeout;
            firstTimeout = observableNever();
        }
        Observable.isObservable(other) || (other = observableThrow(new TimeoutError()));
        return new AnonymousObservable(function(o) {
            var subscription = new SerialDisposable(), timer = new SerialDisposable(), original = new SingleAssignmentDisposable();
            subscription.setDisposable(original);
            var id = 0, switched = false;
            function setTimer(timeout) {
                var myId = id, d = new SingleAssignmentDisposable();
                function timerWins() {
                    switched = myId === id;
                    return switched;
                }
                timer.setDisposable(d);
                d.setDisposable(timeout.subscribe(function() {
                    timerWins() && subscription.setDisposable(other.subscribe(o));
                    d.dispose();
                }, function(e) {
                    timerWins() && o.onError(e);
                }, function() {
                    timerWins() && subscription.setDisposable(other.subscribe(o));
                }));
            }
            setTimer(firstTimeout);
            function oWins() {
                var res = !switched;
                if (res) id++;
                return res;
            }
            original.setDisposable(source.subscribe(function(x) {
                if (oWins()) {
                    o.onNext(x);
                    var timeout = tryCatch(timeoutDurationSelector)(x);
                    if (timeout === errorObj) return o.onError(timeout.e);
                    setTimer(isPromise(timeout) ? observableFromPromise(timeout) : timeout);
                }
            }, function(e) {
                oWins() && o.onError(e);
            }, function() {
                oWins() && o.onCompleted();
            }));
            return new BinaryDisposable(subscription, timer);
        }, source);
    }
    function timeout(source, dueTime, other, scheduler) {
        if (isScheduler(other)) {
            scheduler = other;
            other = observableThrow(new TimeoutError());
        }
        if (other instanceof Error) other = observableThrow(other);
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        Observable.isObservable(other) || (other = observableThrow(new TimeoutError()));
        return new AnonymousObservable(function(o) {
            var id = 0, original = new SingleAssignmentDisposable(), subscription = new SerialDisposable(), switched = false, timer = new SerialDisposable();
            subscription.setDisposable(original);
            function createTimer() {
                var myId = id;
                timer.setDisposable(scheduler.scheduleFuture(null, dueTime, function() {
                    switched = id === myId;
                    if (switched) {
                        isPromise(other) && (other = observableFromPromise(other));
                        subscription.setDisposable(other.subscribe(o));
                    }
                }));
            }
            createTimer();
            original.setDisposable(source.subscribe(function(x) {
                if (!switched) {
                    id++;
                    o.onNext(x);
                    createTimer();
                }
            }, function(e) {
                if (!switched) {
                    id++;
                    o.onError(e);
                }
            }, function() {
                if (!switched) {
                    id++;
                    o.onCompleted();
                }
            }));
            return new BinaryDisposable(subscription, timer);
        }, source);
    }
    observableProto.timeout = function() {
        var firstArg = arguments[0];
        if (firstArg instanceof Date || typeof firstArg === 'number') return timeout(this, firstArg, arguments[1], arguments[2]);
        else if (Observable.isObservable(firstArg) || isFunction(firstArg)) return timeoutWithSelector(this, firstArg, arguments[1], arguments[2]);
        else throw new Error('Invalid arguments');
    };
    var GenerateAbsoluteObservable = function(__super__) {
        inherits(GenerateAbsoluteObservable, __super__);
        function GenerateAbsoluteObservable(state, cndFn, itrFn, resFn, timeFn, s) {
            this._state = state;
            this._cndFn = cndFn;
            this._itrFn = itrFn;
            this._resFn = resFn;
            this._timeFn = timeFn;
            this._s = s;
            __super__.call(this);
        }
        function scheduleRecursive(state, recurse) {
            state.hasResult && state.o.onNext(state.result);
            if (state.first) state.first = false;
            else {
                state.newState = tryCatch(state.self._itrFn)(state.newState);
                if (state.newState === errorObj) return state.o.onError(state.newState.e);
            }
            state.hasResult = tryCatch(state.self._cndFn)(state.newState);
            if (state.hasResult === errorObj) return state.o.onError(state.hasResult.e);
            if (state.hasResult) {
                state.result = tryCatch(state.self._resFn)(state.newState);
                if (state.result === errorObj) return state.o.onError(state.result.e);
                var time = tryCatch(state.self._timeFn)(state.newState);
                if (time === errorObj) return state.o.onError(time.e);
                recurse(state, time);
            } else state.o.onCompleted();
        }
        GenerateAbsoluteObservable.prototype.subscribeCore = function(o) {
            var state = {
                o: o,
                self: this,
                newState: this._state,
                first: true,
                hasResult: false
            };
            return this._s.scheduleRecursiveFuture(state, new Date(this._s.now()), scheduleRecursive);
        };
        return GenerateAbsoluteObservable;
    }(ObservableBase);
    /**
   *  GenerateAbsolutes an observable sequence by iterating a state from an initial state until the condition fails.
   *
   * @example
   *  res = source.generateWithAbsoluteTime(0,
   *      function (x) { return return true; },
   *      function (x) { return x + 1; },
   *      function (x) { return x; },
   *      function (x) { return new Date(); }
   *  });
   *
   * @param {Mixed} initialState Initial state.
   * @param {Function} condition Condition to terminate generation (upon returning false).
   * @param {Function} iterate Iteration step function.
   * @param {Function} resultSelector Selector function for results produced in the sequence.
   * @param {Function} timeSelector Time selector function to control the speed of values being produced each iteration, returning Date values.
   * @param {Scheduler} [scheduler]  Scheduler on which to run the generator loop. If not specified, the timeout scheduler is used.
   * @returns {Observable} The generated sequence.
   */ Observable.generateWithAbsoluteTime = function(initialState, condition, iterate, resultSelector, timeSelector, scheduler) {
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        return new GenerateAbsoluteObservable(initialState, condition, iterate, resultSelector, timeSelector, scheduler);
    };
    var GenerateRelativeObservable = function(__super__) {
        inherits(GenerateRelativeObservable, __super__);
        function GenerateRelativeObservable(state, cndFn, itrFn, resFn, timeFn, s) {
            this._state = state;
            this._cndFn = cndFn;
            this._itrFn = itrFn;
            this._resFn = resFn;
            this._timeFn = timeFn;
            this._s = s;
            __super__.call(this);
        }
        function scheduleRecursive(state, recurse) {
            state.hasResult && state.o.onNext(state.result);
            if (state.first) state.first = false;
            else {
                state.newState = tryCatch(state.self._itrFn)(state.newState);
                if (state.newState === errorObj) return state.o.onError(state.newState.e);
            }
            state.hasResult = tryCatch(state.self._cndFn)(state.newState);
            if (state.hasResult === errorObj) return state.o.onError(state.hasResult.e);
            if (state.hasResult) {
                state.result = tryCatch(state.self._resFn)(state.newState);
                if (state.result === errorObj) return state.o.onError(state.result.e);
                var time = tryCatch(state.self._timeFn)(state.newState);
                if (time === errorObj) return state.o.onError(time.e);
                recurse(state, time);
            } else state.o.onCompleted();
        }
        GenerateRelativeObservable.prototype.subscribeCore = function(o) {
            var state = {
                o: o,
                self: this,
                newState: this._state,
                first: true,
                hasResult: false
            };
            return this._s.scheduleRecursiveFuture(state, 0, scheduleRecursive);
        };
        return GenerateRelativeObservable;
    }(ObservableBase);
    /**
   *  Generates an observable sequence by iterating a state from an initial state until the condition fails.
   *
   * @example
   *  res = source.generateWithRelativeTime(0,
   *      function (x) { return return true; },
   *      function (x) { return x + 1; },
   *      function (x) { return x; },
   *      function (x) { return 500; }
   *  );
   *
   * @param {Mixed} initialState Initial state.
   * @param {Function} condition Condition to terminate generation (upon returning false).
   * @param {Function} iterate Iteration step function.
   * @param {Function} resultSelector Selector function for results produced in the sequence.
   * @param {Function} timeSelector Time selector function to control the speed of values being produced each iteration, returning integer values denoting milliseconds.
   * @param {Scheduler} [scheduler]  Scheduler on which to run the generator loop. If not specified, the timeout scheduler is used.
   * @returns {Observable} The generated sequence.
   */ Observable.generateWithRelativeTime = function(initialState, condition, iterate, resultSelector, timeSelector, scheduler) {
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        return new GenerateRelativeObservable(initialState, condition, iterate, resultSelector, timeSelector, scheduler);
    };
    var DelaySubscription = function(__super__) {
        inherits(DelaySubscription, __super__);
        function DelaySubscription(source, dt, s) {
            this.source = source;
            this._dt = dt;
            this._s = s;
            __super__.call(this);
        }
        DelaySubscription.prototype.subscribeCore = function(o) {
            var d = new SerialDisposable();
            d.setDisposable(this._s.scheduleFuture([
                this.source,
                o,
                d
            ], this._dt, scheduleMethod));
            return d;
        };
        function scheduleMethod(s, state) {
            var source = state[0], o = state[1], d = state[2];
            d.setDisposable(source.subscribe(o));
        }
        return DelaySubscription;
    }(ObservableBase);
    /**
   *  Time shifts the observable sequence by delaying the subscription with the specified relative time duration, using the specified scheduler to run timers.
   *
   * @example
   *  1 - res = source.delaySubscription(5000); // 5s
   *  2 - res = source.delaySubscription(5000, Rx.Scheduler.default); // 5 seconds
   *
   * @param {Number} dueTime Relative or absolute time shift of the subscription.
   * @param {Scheduler} [scheduler]  Scheduler to run the subscription delay timer on. If not specified, the timeout scheduler is used.
   * @returns {Observable} Time-shifted sequence.
   */ observableProto.delaySubscription = function(dueTime, scheduler) {
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        return new DelaySubscription(this, dueTime, scheduler);
    };
    var SkipLastWithTimeObservable = function(__super__) {
        inherits(SkipLastWithTimeObservable, __super__);
        function SkipLastWithTimeObservable(source, d, s) {
            this.source = source;
            this._d = d;
            this._s = s;
            __super__.call(this);
        }
        SkipLastWithTimeObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new SkipLastWithTimeObserver(o, this));
        };
        return SkipLastWithTimeObservable;
    }(ObservableBase);
    var SkipLastWithTimeObserver = function(__super__) {
        inherits(SkipLastWithTimeObserver, __super__);
        function SkipLastWithTimeObserver(o, p) {
            this._o = o;
            this._s = p._s;
            this._d = p._d;
            this._q = [];
            __super__.call(this);
        }
        SkipLastWithTimeObserver.prototype.next = function(x) {
            var now = this._s.now();
            this._q.push({
                interval: now,
                value: x
            });
            while(this._q.length > 0 && now - this._q[0].interval >= this._d)this._o.onNext(this._q.shift().value);
        };
        SkipLastWithTimeObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        SkipLastWithTimeObserver.prototype.completed = function() {
            var now = this._s.now();
            while(this._q.length > 0 && now - this._q[0].interval >= this._d)this._o.onNext(this._q.shift().value);
            this._o.onCompleted();
        };
        return SkipLastWithTimeObserver;
    }(AbstractObserver);
    /**
   *  Skips elements for the specified duration from the end of the observable source sequence, using the specified scheduler to run timers.
   * @description
   *  This operator accumulates a queue with a length enough to store elements received during the initial duration window.
   *  As more elements are received, elements older than the specified duration are taken from the queue and produced on the
   *  result sequence. This causes elements to be delayed with duration.
   * @param {Number} duration Duration for skipping elements from the end of the sequence.
   * @param {Scheduler} [scheduler]  Scheduler to run the timer on. If not specified, defaults to Rx.Scheduler.timeout
   * @returns {Observable} An observable sequence with the elements skipped during the specified duration from the end of the source sequence.
   */ observableProto.skipLastWithTime = function(duration, scheduler) {
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        return new SkipLastWithTimeObservable(this, duration, scheduler);
    };
    var TakeLastWithTimeObservable = function(__super__) {
        inherits(TakeLastWithTimeObservable, __super__);
        function TakeLastWithTimeObservable(source, d, s) {
            this.source = source;
            this._d = d;
            this._s = s;
            __super__.call(this);
        }
        TakeLastWithTimeObservable.prototype.subscribeCore = function(o) {
            return this.source.subscribe(new TakeLastWithTimeObserver(o, this._d, this._s));
        };
        return TakeLastWithTimeObservable;
    }(ObservableBase);
    var TakeLastWithTimeObserver = function(__super__) {
        inherits(TakeLastWithTimeObserver, __super__);
        function TakeLastWithTimeObserver(o, d, s) {
            this._o = o;
            this._d = d;
            this._s = s;
            this._q = [];
            __super__.call(this);
        }
        TakeLastWithTimeObserver.prototype.next = function(x) {
            var now = this._s.now();
            this._q.push({
                interval: now,
                value: x
            });
            while(this._q.length > 0 && now - this._q[0].interval >= this._d)this._q.shift();
        };
        TakeLastWithTimeObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        TakeLastWithTimeObserver.prototype.completed = function() {
            var now = this._s.now();
            while(this._q.length > 0){
                var next = this._q.shift();
                if (now - next.interval <= this._d) this._o.onNext(next.value);
            }
            this._o.onCompleted();
        };
        return TakeLastWithTimeObserver;
    }(AbstractObserver);
    /**
   *  Returns elements within the specified duration from the end of the observable source sequence, using the specified schedulers to run timers and to drain the collected elements.
   * @description
   *  This operator accumulates a queue with a length enough to store elements received during the initial duration window.
   *  As more elements are received, elements older than the specified duration are taken from the queue and produced on the
   *  result sequence. This causes elements to be delayed with duration.
   * @param {Number} duration Duration for taking elements from the end of the sequence.
   * @param {Scheduler} [scheduler]  Scheduler to run the timer on. If not specified, defaults to Rx.Scheduler.timeout.
   * @returns {Observable} An observable sequence with the elements taken during the specified duration from the end of the source sequence.
   */ observableProto.takeLastWithTime = function(duration, scheduler) {
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        return new TakeLastWithTimeObservable(this, duration, scheduler);
    };
    /**
   *  Returns an array with the elements within the specified duration from the end of the observable source sequence, using the specified scheduler to run timers.
   * @description
   *  This operator accumulates a queue with a length enough to store elements received during the initial duration window.
   *  As more elements are received, elements older than the specified duration are taken from the queue and produced on the
   *  result sequence. This causes elements to be delayed with duration.
   * @param {Number} duration Duration for taking elements from the end of the sequence.
   * @param {Scheduler} scheduler Scheduler to run the timer on. If not specified, defaults to Rx.Scheduler.timeout.
   * @returns {Observable} An observable sequence containing a single array with the elements taken during the specified duration from the end of the source sequence.
   */ observableProto.takeLastBufferWithTime = function(duration, scheduler) {
        var source = this;
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        return new AnonymousObservable(function(o) {
            var q = [];
            return source.subscribe(function(x) {
                var now = scheduler.now();
                q.push({
                    interval: now,
                    value: x
                });
                while(q.length > 0 && now - q[0].interval >= duration)q.shift();
            }, function(e) {
                o.onError(e);
            }, function() {
                var now = scheduler.now(), res = [];
                while(q.length > 0){
                    var next = q.shift();
                    now - next.interval <= duration && res.push(next.value);
                }
                o.onNext(res);
                o.onCompleted();
            });
        }, source);
    };
    var TakeWithTimeObservable = function(__super__) {
        inherits(TakeWithTimeObservable, __super__);
        function TakeWithTimeObservable(source, d, s) {
            this.source = source;
            this._d = d;
            this._s = s;
            __super__.call(this);
        }
        function scheduleMethod(s, o) {
            o.onCompleted();
        }
        TakeWithTimeObservable.prototype.subscribeCore = function(o) {
            return new BinaryDisposable(this._s.scheduleFuture(o, this._d, scheduleMethod), this.source.subscribe(o));
        };
        return TakeWithTimeObservable;
    }(ObservableBase);
    /**
   *  Takes elements for the specified duration from the start of the observable source sequence, using the specified scheduler to run timers.
   *
   * @example
   *  1 - res = source.takeWithTime(5000,  [optional scheduler]);
   * @description
   *  This operator accumulates a queue with a length enough to store elements received during the initial duration window.
   *  As more elements are received, elements older than the specified duration are taken from the queue and produced on the
   *  result sequence. This causes elements to be delayed with duration.
   * @param {Number} duration Duration for taking elements from the start of the sequence.
   * @param {Scheduler} scheduler Scheduler to run the timer on. If not specified, defaults to Rx.Scheduler.timeout.
   * @returns {Observable} An observable sequence with the elements taken during the specified duration from the start of the source sequence.
   */ observableProto.takeWithTime = function(duration, scheduler) {
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        return new TakeWithTimeObservable(this, duration, scheduler);
    };
    var SkipWithTimeObservable = function(__super__) {
        inherits(SkipWithTimeObservable, __super__);
        function SkipWithTimeObservable(source, d, s) {
            this.source = source;
            this._d = d;
            this._s = s;
            this._open = false;
            __super__.call(this);
        }
        function scheduleMethod(s, self1) {
            self1._open = true;
        }
        SkipWithTimeObservable.prototype.subscribeCore = function(o) {
            return new BinaryDisposable(this._s.scheduleFuture(this, this._d, scheduleMethod), this.source.subscribe(new SkipWithTimeObserver(o, this)));
        };
        return SkipWithTimeObservable;
    }(ObservableBase);
    var SkipWithTimeObserver = function(__super__) {
        inherits(SkipWithTimeObserver, __super__);
        function SkipWithTimeObserver(o, p) {
            this._o = o;
            this._p = p;
            __super__.call(this);
        }
        SkipWithTimeObserver.prototype.next = function(x) {
            this._p._open && this._o.onNext(x);
        };
        SkipWithTimeObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        SkipWithTimeObserver.prototype.completed = function() {
            this._o.onCompleted();
        };
        return SkipWithTimeObserver;
    }(AbstractObserver);
    /**
   *  Skips elements for the specified duration from the start of the observable source sequence, using the specified scheduler to run timers.
   * @description
   *  Specifying a zero value for duration doesn't guarantee no elements will be dropped from the start of the source sequence.
   *  This is a side-effect of the asynchrony introduced by the scheduler, where the action that causes callbacks from the source sequence to be forwarded
   *  may not execute immediately, despite the zero due time.
   *
   *  Errors produced by the source sequence are always forwarded to the result sequence, even if the error occurs before the duration.
   * @param {Number} duration Duration for skipping elements from the start of the sequence.
   * @param {Scheduler} scheduler Scheduler to run the timer on. If not specified, defaults to Rx.Scheduler.timeout.
   * @returns {Observable} An observable sequence with the elements skipped during the specified duration from the start of the source sequence.
   */ observableProto.skipWithTime = function(duration, scheduler) {
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        return new SkipWithTimeObservable(this, duration, scheduler);
    };
    var SkipUntilWithTimeObservable = function(__super__) {
        inherits(SkipUntilWithTimeObservable, __super__);
        function SkipUntilWithTimeObservable(source, startTime, scheduler) {
            this.source = source;
            this._st = startTime;
            this._s = scheduler;
            __super__.call(this);
        }
        function scheduleMethod(s, state) {
            state._open = true;
        }
        SkipUntilWithTimeObservable.prototype.subscribeCore = function(o) {
            this._open = false;
            return new BinaryDisposable(this._s.scheduleFuture(this, this._st, scheduleMethod), this.source.subscribe(new SkipUntilWithTimeObserver(o, this)));
        };
        return SkipUntilWithTimeObservable;
    }(ObservableBase);
    var SkipUntilWithTimeObserver = function(__super__) {
        inherits(SkipUntilWithTimeObserver, __super__);
        function SkipUntilWithTimeObserver(o, p) {
            this._o = o;
            this._p = p;
            __super__.call(this);
        }
        SkipUntilWithTimeObserver.prototype.next = function(x) {
            this._p._open && this._o.onNext(x);
        };
        SkipUntilWithTimeObserver.prototype.error = function(e) {
            this._o.onError(e);
        };
        SkipUntilWithTimeObserver.prototype.completed = function() {
            this._o.onCompleted();
        };
        return SkipUntilWithTimeObserver;
    }(AbstractObserver);
    /**
   *  Skips elements from the observable source sequence until the specified start time, using the specified scheduler to run timers.
   *  Errors produced by the source sequence are always forwarded to the result sequence, even if the error occurs before the start time.
   *
   * @examples
   *  1 - res = source.skipUntilWithTime(new Date(), [scheduler]);
   *  2 - res = source.skipUntilWithTime(5000, [scheduler]);
   * @param {Date|Number} startTime Time to start taking elements from the source sequence. If this value is less than or equal to Date(), no elements will be skipped.
   * @param {Scheduler} [scheduler] Scheduler to run the timer on. If not specified, defaults to Rx.Scheduler.timeout.
   * @returns {Observable} An observable sequence with the elements skipped until the specified start time.
   */ observableProto.skipUntilWithTime = function(startTime, scheduler) {
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        return new SkipUntilWithTimeObservable(this, startTime, scheduler);
    };
    /**
   *  Takes elements for the specified duration until the specified end time, using the specified scheduler to run timers.
   * @param {Number | Date} endTime Time to stop taking elements from the source sequence. If this value is less than or equal to new Date(), the result stream will complete immediately.
   * @param {Scheduler} [scheduler] Scheduler to run the timer on.
   * @returns {Observable} An observable sequence with the elements taken until the specified end time.
   */ observableProto.takeUntilWithTime = function(endTime, scheduler) {
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        var source = this;
        return new AnonymousObservable(function(o) {
            return new BinaryDisposable(scheduler.scheduleFuture(o, endTime, function(_, o) {
                o.onCompleted();
            }), source.subscribe(o));
        }, source);
    };
    /**
   * Returns an Observable that emits only the first item emitted by the source Observable during sequential time windows of a specified duration.
   * @param {Number} windowDuration time to wait before emitting another item after emitting the last item
   * @param {Scheduler} [scheduler] the Scheduler to use internally to manage the timers that handle timeout for each item. If not provided, defaults to Scheduler.timeout.
   * @returns {Observable} An Observable that performs the throttle operation.
   */ observableProto.throttle = function(windowDuration, scheduler) {
        isScheduler(scheduler) || (scheduler = defaultScheduler);
        var duration = +windowDuration || 0;
        if (duration <= 0) throw new RangeError('windowDuration cannot be less or equal zero.');
        var source = this;
        return new AnonymousObservable(function(o) {
            var lastOnNext = 0;
            return source.subscribe(function(x) {
                var now = scheduler.now();
                if (lastOnNext === 0 || now - lastOnNext >= duration) {
                    lastOnNext = now;
                    o.onNext(x);
                }
            }, function(e) {
                o.onError(e);
            }, function() {
                o.onCompleted();
            });
        }, source);
    };
    return Rx;
});

});

parcelRegister("eSj2l", function(module, exports) {
module.exports = JSON.parse("[\"a\",\"abbr\",\"address\",\"area\",\"article\",\"aside\",\"audio\",\"b\",\"base\",\"bdi\",\"bdo\",\"blockquote\",\"body\",\"br\",\"button\",\"canvas\",\"caption\",\"cite\",\"code\",\"col\",\"colgroup\",\"data\",\"datalist\",\"dd\",\"del\",\"details\",\"dfn\",\"dialog\",\"div\",\"dl\",\"dt\",\"em\",\"embed\",\"fieldset\",\"figcaption\",\"figure\",\"footer\",\"form\",\"h1\",\"h2\",\"h3\",\"h4\",\"h5\",\"h6\",\"head\",\"header\",\"hgroup\",\"hr\",\"html\",\"i\",\"iframe\",\"img\",\"input\",\"ins\",\"kbd\",\"keygen\",\"label\",\"legend\",\"li\",\"link\",\"main\",\"map\",\"mark\",\"math\",\"menu\",\"menuitem\",\"meta\",\"meter\",\"nav\",\"noscript\",\"object\",\"ol\",\"optgroup\",\"option\",\"output\",\"p\",\"param\",\"picture\",\"pre\",\"progress\",\"q\",\"rb\",\"rp\",\"rt\",\"rtc\",\"ruby\",\"s\",\"samp\",\"script\",\"section\",\"select\",\"slot\",\"small\",\"source\",\"span\",\"strong\",\"style\",\"sub\",\"summary\",\"sup\",\"svg\",\"table\",\"tbody\",\"td\",\"template\",\"textarea\",\"tfoot\",\"th\",\"thead\",\"time\",\"title\",\"tr\",\"track\",\"u\",\"ul\",\"var\",\"video\",\"wbr\"]");

});

parcelRegister("2FVgl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $1f2bd4450c1bcbb7$var$updateClass(oldVnode, vnode) {
    var cur, name, elm = vnode.elm, oldClass = oldVnode.data.class, klass = vnode.data.class;
    if (!oldClass && !klass) return;
    if (oldClass === klass) return;
    oldClass = oldClass || {};
    klass = klass || {};
    for(name in oldClass)if (!klass[name]) elm.classList.remove(name);
    for(name in klass){
        cur = klass[name];
        if (cur !== oldClass[name]) elm.classList[cur ? 'add' : 'remove'](name);
    }
}
module.exports.classModule = {
    create: $1f2bd4450c1bcbb7$var$updateClass,
    update: $1f2bd4450c1bcbb7$var$updateClass
};
module.exports.default = module.exports.classModule;

});

parcelRegister("d7OtB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $98e3156075192ab8$var$updateProps(oldVnode, vnode) {
    var key, cur, old, elm = vnode.elm, oldProps = oldVnode.data.props, props = vnode.data.props;
    if (!oldProps && !props) return;
    if (oldProps === props) return;
    oldProps = oldProps || {};
    props = props || {};
    for(key in oldProps)if (!props[key]) delete elm[key];
    for(key in props){
        cur = props[key];
        old = oldProps[key];
        if (old !== cur && (key !== 'value' || elm[key] !== cur)) elm[key] = cur;
    }
}
module.exports.propsModule = {
    create: $98e3156075192ab8$var$updateProps,
    update: $98e3156075192ab8$var$updateProps
};
module.exports.default = module.exports.propsModule;

});

parcelRegister("5TEcn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $44b1456b49bd42e1$var$booleanAttrs = [
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "compact",
    "controls",
    "declare",
    "default",
    "defaultchecked",
    "defaultmuted",
    "defaultselected",
    "defer",
    "disabled",
    "draggable",
    "enabled",
    "formnovalidate",
    "hidden",
    "indeterminate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nohref",
    "noresize",
    "noshade",
    "novalidate",
    "nowrap",
    "open",
    "pauseonexit",
    "readonly",
    "required",
    "reversed",
    "scoped",
    "seamless",
    "selected",
    "sortable",
    "spellcheck",
    "translate",
    "truespeed",
    "typemustmatch",
    "visible"
];
var $44b1456b49bd42e1$var$xlinkNS = 'http://www.w3.org/1999/xlink';
var $44b1456b49bd42e1$var$xmlNS = 'http://www.w3.org/XML/1998/namespace';
var $44b1456b49bd42e1$var$colonChar = 58;
var $44b1456b49bd42e1$var$xChar = 120;
var $44b1456b49bd42e1$var$booleanAttrsDict = Object.create(null);
for(var $44b1456b49bd42e1$var$i = 0, $44b1456b49bd42e1$var$len = $44b1456b49bd42e1$var$booleanAttrs.length; $44b1456b49bd42e1$var$i < $44b1456b49bd42e1$var$len; $44b1456b49bd42e1$var$i++)$44b1456b49bd42e1$var$booleanAttrsDict[$44b1456b49bd42e1$var$booleanAttrs[$44b1456b49bd42e1$var$i]] = true;
function $44b1456b49bd42e1$var$updateAttrs(oldVnode, vnode) {
    var key, elm = vnode.elm, oldAttrs = oldVnode.data.attrs, attrs = vnode.data.attrs;
    if (!oldAttrs && !attrs) return;
    if (oldAttrs === attrs) return;
    oldAttrs = oldAttrs || {};
    attrs = attrs || {};
    // update modified attributes, add new attributes
    for(key in attrs){
        var cur = attrs[key];
        var old = oldAttrs[key];
        if (old !== cur) {
            if ($44b1456b49bd42e1$var$booleanAttrsDict[key]) {
                if (cur) elm.setAttribute(key, "");
                else elm.removeAttribute(key);
            } else {
                if (key.charCodeAt(0) !== $44b1456b49bd42e1$var$xChar) elm.setAttribute(key, cur);
                else if (key.charCodeAt(3) === $44b1456b49bd42e1$var$colonChar) // Assume xml namespace
                elm.setAttributeNS($44b1456b49bd42e1$var$xmlNS, key, cur);
                else if (key.charCodeAt(5) === $44b1456b49bd42e1$var$colonChar) // Assume xlink namespace
                elm.setAttributeNS($44b1456b49bd42e1$var$xlinkNS, key, cur);
                else elm.setAttribute(key, cur);
            }
        }
    }
    // remove removed attributes
    // use `in` operator since the previous `for` iteration uses it (.i.e. add even attributes with undefined value)
    // the other option is to remove all attributes with value == undefined
    for(key in oldAttrs)if (!(key in attrs)) elm.removeAttribute(key);
}
module.exports.attributesModule = {
    create: $44b1456b49bd42e1$var$updateAttrs,
    update: $44b1456b49bd42e1$var$updateAttrs
};
module.exports.default = module.exports.attributesModule;

});

parcelRegister("gdvPb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bce68bf1264c9b1a$var$raf = typeof window !== 'undefined' && window.requestAnimationFrame || setTimeout;
var $bce68bf1264c9b1a$var$nextFrame = function(fn) {
    $bce68bf1264c9b1a$var$raf(function() {
        $bce68bf1264c9b1a$var$raf(fn);
    });
};
function $bce68bf1264c9b1a$var$setNextFrame(obj, prop, val) {
    $bce68bf1264c9b1a$var$nextFrame(function() {
        obj[prop] = val;
    });
}
function $bce68bf1264c9b1a$var$updateStyle(oldVnode, vnode) {
    var cur, name, elm = vnode.elm, oldStyle = oldVnode.data.style, style = vnode.data.style;
    if (!oldStyle && !style) return;
    if (oldStyle === style) return;
    oldStyle = oldStyle || {};
    style = style || {};
    var oldHasDel = 'delayed' in oldStyle;
    for(name in oldStyle)if (!style[name]) {
        if (name[0] === '-' && name[1] === '-') elm.style.removeProperty(name);
        else elm.style[name] = '';
    }
    for(name in style){
        cur = style[name];
        if (name === 'delayed' && style.delayed) for(var name2 in style.delayed){
            cur = style.delayed[name2];
            if (!oldHasDel || cur !== oldStyle.delayed[name2]) $bce68bf1264c9b1a$var$setNextFrame(elm.style, name2, cur);
        }
        else if (name !== 'remove' && cur !== oldStyle[name]) {
            if (name[0] === '-' && name[1] === '-') elm.style.setProperty(name, cur);
            else elm.style[name] = cur;
        }
    }
}
function $bce68bf1264c9b1a$var$applyDestroyStyle(vnode) {
    var style, name, elm = vnode.elm, s = vnode.data.style;
    if (!s || !(style = s.destroy)) return;
    for(name in style)elm.style[name] = style[name];
}
function $bce68bf1264c9b1a$var$applyRemoveStyle(vnode, rm) {
    var s = vnode.data.style;
    if (!s || !s.remove) {
        rm();
        return;
    }
    var name, elm = vnode.elm, i = 0, compStyle, style = s.remove, amount = 0, applied = [];
    for(name in style){
        applied.push(name);
        elm.style[name] = style[name];
    }
    compStyle = getComputedStyle(elm);
    var props = compStyle['transition-property'].split(', ');
    for(; i < props.length; ++i)if (applied.indexOf(props[i]) !== -1) amount++;
    elm.addEventListener('transitionend', function(ev) {
        if (ev.target === elm) --amount;
        if (amount === 0) rm();
    });
}
module.exports.styleModule = {
    create: $bce68bf1264c9b1a$var$updateStyle,
    update: $bce68bf1264c9b1a$var$updateStyle,
    destroy: $bce68bf1264c9b1a$var$applyDestroyStyle,
    remove: $bce68bf1264c9b1a$var$applyRemoveStyle
};
module.exports.default = module.exports.styleModule;

});

parcelRegister("lRr5I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $fea38feef864500b$var$invokeHandler(handler, vnode, event) {
    if (typeof handler === "function") // call function handler
    handler.call(vnode, event, vnode);
    else if (typeof handler === "object") {
        // call handler with arguments
        if (typeof handler[0] === "function") {
            // special case for single argument for performance
            if (handler.length === 2) handler[0].call(vnode, handler[1], event, vnode);
            else {
                var args = handler.slice(1);
                args.push(event);
                args.push(vnode);
                handler[0].apply(vnode, args);
            }
        } else // call multiple handlers
        for(var i = 0; i < handler.length; i++)$fea38feef864500b$var$invokeHandler(handler[i]);
    }
}
function $fea38feef864500b$var$handleEvent(event, vnode) {
    var name = event.type, on = vnode.data.on;
    // call event handler(s) if exists
    if (on && on[name]) $fea38feef864500b$var$invokeHandler(on[name], vnode, event);
}
function $fea38feef864500b$var$createListener() {
    return function handler(event) {
        $fea38feef864500b$var$handleEvent(event, handler.vnode);
    };
}
function $fea38feef864500b$var$updateEventListeners(oldVnode, vnode) {
    var oldOn = oldVnode.data.on, oldListener = oldVnode.listener, oldElm = oldVnode.elm, on = vnode && vnode.data.on, elm = vnode && vnode.elm, name;
    // optimization for reused immutable handlers
    if (oldOn === on) return;
    // remove existing listeners which no longer used
    if (oldOn && oldListener) {
        // if element changed or deleted we remove all existing listeners unconditionally
        if (!on) for(name in oldOn)// remove listener if element was changed or existing listeners removed
        oldElm.removeEventListener(name, oldListener, false);
        else {
            for(name in oldOn)// remove listener if existing listener removed
            if (!on[name]) oldElm.removeEventListener(name, oldListener, false);
        }
    }
    // add new listeners which has not already attached
    if (on) {
        // reuse existing listener or create new
        var listener = vnode.listener = oldVnode.listener || $fea38feef864500b$var$createListener();
        // update vnode for listener
        listener.vnode = vnode;
        // if element changed or added we add all needed listeners unconditionally
        if (!oldOn) for(name in on)// add listener if element was changed or new listeners added
        elm.addEventListener(name, listener, false);
        else {
            for(name in on)// add listener if new listener added
            if (!oldOn[name]) elm.addEventListener(name, listener, false);
        }
    }
}
module.exports.eventListenersModule = {
    create: $fea38feef864500b$var$updateEventListeners,
    update: $fea38feef864500b$var$updateEventListeners,
    destroy: $fea38feef864500b$var$updateEventListeners
};
module.exports.default = module.exports.eventListenersModule;

});

parcelRegister("6dWku", function(module, exports) {
'use strict';

var $jjnZg = parcelRequire("jjnZg");
var $488133ff5bd488e2$require$arr = $jjnZg.arr;
var $488133ff5bd488e2$require$obj = $jjnZg.obj;
// initial
const $488133ff5bd488e2$var$initial = {
    mic: false,
    lastAffected: '0',
    baseLength: 0,
    quantize: true,
    recordMode: 'independent',
    channels: {
        0: {
            process: 'empty',
            gain: 0.5,
            layers: 0,
            duration: 0,
            startedAt: 0
        },
        1: {
            process: 'empty',
            gain: 0.5,
            layers: 0,
            duration: 0,
            startedAt: 0
        },
        2: {
            process: 'empty',
            gain: 0.5,
            layers: 0,
            duration: 0,
            startedAt: 0
        },
        3: {
            process: 'empty',
            gain: 0.5,
            layers: 0,
            duration: 0,
            startedAt: 0
        }
    }
};
// actions
const $488133ff5bd488e2$var$set = (key, value)=>(state)=>$488133ff5bd488e2$require$obj.patch(state, key, value);
const $488133ff5bd488e2$var$toggle = (key)=>(state)=>$488133ff5bd488e2$require$obj.patch(state, key, !$488133ff5bd488e2$require$obj.sub(state, key));
const $488133ff5bd488e2$var$arrToggle = (key, value)=>(state)=>$488133ff5bd488e2$require$obj.patch(state, key, $488133ff5bd488e2$require$arr.toggle($488133ff5bd488e2$require$obj.sub(state, key), value));
const $488133ff5bd488e2$var$change = (channel, param, value)=>(state)=>Object.assign($488133ff5bd488e2$require$obj.patch(state, [
            'channels',
            channel,
            param
        ], value), {
            lastAffected: channel
        });
const $488133ff5bd488e2$var$playRec = (channel, currentTime)=>(state)=>Object.assign($488133ff5bd488e2$require$obj.patch(state, [
            'channels',
            channel
        ], {
            layers: [
                'record',
                'overdub'
            ].indexOf(state.channels[channel].process) > -1 ? state.channels[channel].layers + 1 : state.channels[channel].layers,
            process: state.audio.on ? state.channels[channel].process === 'empty' ? 'record' : state.channels[channel].process === 'play' ? 'overdub' : 'play' : state.channels[channel].process,
            startedAt: currentTime
        }), {
            lastAffected: channel
        });
/*
const playRec = channel => state => obj.patch(state, ['channels', channel, 'process'],
	(state.channels[channel].process === 'idle' || state.channels[channel].process === 'play')
		? 'record'
		: 'play'
);
*/ const $488133ff5bd488e2$var$stop = (channel)=>(state)=>Object.assign($488133ff5bd488e2$require$obj.patch(state, [
            'channels',
            channel
        ], {
            layers: [
                'record',
                'overdub'
            ].indexOf(state.channels[channel].process) > -1 ? state.channels[channel].layers + 1 : state.channels[channel].layers,
            process: state.channels[channel].process !== 'empty' ? 'idle' : 'empty'
        }), {
            lastAffected: channel
        });
// layers
const $488133ff5bd488e2$var$clear = (channel)=>(state)=>Object.assign($488133ff5bd488e2$require$obj.patch(state, [
            'channels',
            channel
        ], {
            ...$488133ff5bd488e2$var$initial.channels[0]
        }), {
            lastAffected: channel,
            // if all are clear set baseLength to 0
            baseLength: Object.keys(state.channels).filter((c)=>c !== channel).filter((c)=>state.channels[c].layers > 0).length > 0 ? state.baseLength : 0
        });
const $488133ff5bd488e2$var$stopAll = ()=>(state)=>Object.assign({}, state, {
            channels: Object.keys(state.channels).reduce((channels, channel)=>({
                    ...channels,
                    [channel]: state.channels[channel].process !== 'empty' ? {
                        ...state.channels[channel],
                        process: 'idle'
                    } : state.channels[channel]
                }), {})
        });
const $488133ff5bd488e2$var$playAll = (currentTime)=>(state)=>Object.assign({}, state, {
            channels: Object.keys(state.channels).reduce((channels, channel)=>({
                    ...channels,
                    [channel]: state.channels[channel].process !== 'empty' ? {
                        ...state.channels[channel],
                        process: 'play',
                        startedAt: currentTime
                    } : state.channels[channel]
                }), {})
        });
const $488133ff5bd488e2$var$clearAll = (currentTime)=>(state)=>Object.assign({}, state, {
            channels: $488133ff5bd488e2$var$initial.channels,
            baseLength: $488133ff5bd488e2$var$initial.baseLength,
            lastAffected: $488133ff5bd488e2$var$initial.lastAffected
        });
const $488133ff5bd488e2$var$setBaseLength = (baseLength)=>(state)=>Object.assign({}, state, {
            baseLength: baseLength
        });
const $488133ff5bd488e2$var$ping = ()=>(state)=>state;
module.exports = {
    initial: $488133ff5bd488e2$var$initial,
    set: $488133ff5bd488e2$var$set,
    toggle: $488133ff5bd488e2$var$toggle,
    arrToggle: $488133ff5bd488e2$var$arrToggle,
    change: $488133ff5bd488e2$var$change,
    playRec: $488133ff5bd488e2$var$playRec,
    stop: $488133ff5bd488e2$var$stop,
    clear: $488133ff5bd488e2$var$clear,
    stopAll: $488133ff5bd488e2$var$stopAll,
    playAll: $488133ff5bd488e2$var$playAll,
    clearAll: $488133ff5bd488e2$var$clearAll,
    setBaseLength: $488133ff5bd488e2$var$setBaseLength,
    ping: $488133ff5bd488e2$var$ping
};

});
parcelRegister("jjnZg", function(module, exports) {
/**
 * @module iblokz-data
 * @description Immutable data manipulation utilities for JavaScript
 * @version 1.5.0
 */ /**
 * Object utilities for immutable operations
 * @type {Object}
 */ 
var $f30cz = parcelRequire("f30cz");

var $llUvA = parcelRequire("llUvA");

var $054Xj = parcelRequire("054Xj");

var $cMwYg = parcelRequire("cMwYg");
module.exports = {
    obj: $f30cz,
    arr: $llUvA,
    str: $054Xj,
    fn: $cMwYg
};

});
parcelRegister("f30cz", function(module, exports) {
'use strict';
/**
 * Creates an object with a single key-value pair.
 * @param {string} k - The key
 * @param {*} v - The value
 * @returns {Object} An object with the single key-value pair
 * @example
 * keyValue('name', 'John') // => { name: 'John' }
 */ const $02d3bb03c028877b$var$keyValue = (k, v)=>({
        [k]: v
    });
/**
 * Checks if a value is a plain object literal (not an array, null, or other object type).
 * @param {*} o - The value to check
 * @returns {boolean} True if the value is a plain object literal
 * @example
 * isLiteral({}) // => true
 * isLiteral([]) // => false
 * isLiteral(null) // => false
 */ const $02d3bb03c028877b$var$isLiteral = (o)=>typeof o === 'object' && o !== null && o.constructor === Object;
/**
 * Creates a shallow clone of an object, preserving its prototype.
 * @param {Object} o - The object to clone
 * @returns {Object} A shallow clone of the object
 * @example
 * const obj = { a: 1, b: 2 };
 * const cloned = clone(obj);
 * cloned.a = 3;
 * console.log(obj.a) // => 1 (original unchanged)
 */ const $02d3bb03c028877b$var$clone = (o)=>Object.assign(Object.create(Object.getPrototypeOf(o) || {}), o);
/**
 * Gets a nested value from an object using a path.
 * @param {Object} o - The source object
 * @param {string|Array<string>} p - The path (string key or array of keys for nested access)
 * @returns {*} The value at the path, or undefined if not found
 * @example
 * sub({ a: { b: { c: 1 } } }, ['a', 'b', 'c']) // => 1
 * sub({ a: 1 }, 'a') // => 1
 * sub({ a: 1 }, 'b') // => undefined
 */ const $02d3bb03c028877b$var$sub = (o, p)=>o === undefined || o === null ? undefined : p instanceof Array ? p.length > 1 ? $02d3bb03c028877b$var$sub(o[p[0]], p.slice(1)) : o[p[0]] : o[p];
/**
 * Immutably updates a value in an object at a given path.
 * For nested paths, creates intermediate objects as needed.
 * If the value at the path is a literal object and v is also a literal object, they are merged.
 * @param {Object} o - The source object
 * @param {string|Array<string>} k - The path (string key or array of keys for nested updates)
 * @param {*} v - The value to set
 * @returns {Object} A new object with the value updated at the path
 * @example
 * patch({ a: 1 }, 'b', 2) // => { a: 1, b: 2 }
 * patch({ a: { b: 1 } }, ['a', 'c'], 2) // => { a: { b: 1, c: 2 } }
 * patch({ a: { b: 1 } }, 'a', { c: 2 }) // => { a: { b: 1, c: 2 } } (merged)
 */ const $02d3bb03c028877b$var$patch = (o, k, v)=>Object.assign($02d3bb03c028877b$var$clone(o), k instanceof Array ? $02d3bb03c028877b$var$keyValue(k[0], k.length > 1 ? $02d3bb03c028877b$var$patch(o[k[0]] || {}, k.slice(1), v) : $02d3bb03c028877b$var$isLiteral(o[k[0]]) && Object.assign($02d3bb03c028877b$var$clone(o[k[0]]), v) || v) : $02d3bb03c028877b$var$keyValue(k, $02d3bb03c028877b$var$isLiteral(o[k]) && Object.assign($02d3bb03c028877b$var$clone(o[k]), v) || v));
/**
 * Reduces an object to a single value by iterating over its keys.
 * Similar to Array.reduce, but for objects.
 * @param {Object} o - The object to reduce
 * @param {Function} reduceFn - The reducer function (accumulator, key, value, index, originalObject) => newAccumulator
 * @param {*} [initial] - The initial accumulator value (defaults to first property value)
 * @returns {*} The final accumulated value
 * @example
 * reduce({ a: 1, b: 2, c: 3 }, (sum, key, val) => sum + val, 0) // => 6
 */ const $02d3bb03c028877b$var$reduce = (o, reduceFn, initial)=>Object.keys(o).reduce((accumulator, key, index)=>reduceFn(accumulator, key, o[key], index, o), typeof initial === 'undefined' ? o[Object.keys(o)[0]] // to confirm with the array reduce spec in this case the firts property is used
     : initial);
/**
 * Immutably maps over an object's values.
 * @param {Object} o - The source object
 * @param {Function} mapFn - The mapping function (key, value, index, originalObject) => newValue
 * @returns {Object} A new object with mapped values
 * @example
 * map({ a: 1, b: 2 }, (k, v) => v * 2) // => { a: 2, b: 4 }
 */ const $02d3bb03c028877b$var$map = (o, mapFn)=>$02d3bb03c028877b$var$reduce(o, (o2, key, value, index)=>$02d3bb03c028877b$var$patch(o2, key, mapFn(key, value, index, o)), {});
/**
 * Immutably filters an object's properties based on a predicate.
 * @param {Object} o - The source object
 * @param {Function} filterFn - The filter predicate (key, value, index, originalObject) => boolean
 * @returns {Object} A new object with only properties that pass the predicate
 * @example
 * filter({ a: 1, b: 2, c: 3 }, (k, v) => v > 1) // => { b: 2, c: 3 }
 */ const $02d3bb03c028877b$var$filter = (o, filterFn)=>$02d3bb03c028877b$var$reduce(o, (o2, key, value, index)=>filterFn(key, value, index, o) ? $02d3bb03c028877b$var$patch(o2, key, value) : o2, {});
/**
 * Recursively traverses an object tree and applies a function to leaf values.
 * Non-literal values (primitives, arrays, etc.) are transformed by the function.
 * @param {Object} tree - The object tree to traverse
 * @param {Function} fn - The function to apply to leaf values (key, value, index, parent) => newValue
 * @returns {Object} A new object tree with transformed leaf values
 * @example
 * traverse({ a: { b: 1 }, c: 2 }, (k, v) => v * 2) // => { a: { b: 2 }, c: 4 }
 */ const $02d3bb03c028877b$var$traverse = (tree, fn)=>Object.keys(tree).reduce((o, key, index)=>$02d3bb03c028877b$var$patch(o, key, $02d3bb03c028877b$var$isLiteral(tree[key]) ? $02d3bb03c028877b$var$traverse(tree[key], fn) : fn(key, tree[key], index, tree)), {});
/**
 * Chains multiple method calls on an object.
 * @param {Object} o - The object to call methods on
 * @param {Array<Array>} chain - Array of [methodName, ...args] tuples
 * @returns {*} The result of the final method call
 * @example
 * chainCall([1, 2, 3], [['map', x => x * 2], ['filter', x => x > 2]]) // => [4, 6]
 */ const $02d3bb03c028877b$var$chainCall = (o, chain)=>chain.reduce((o, [prop, ...args])=>o[prop](...args), o);
/**
 * Pattern matching utility that returns a value based on matching a value to cases.
 * Supports nested array paths for partial matching and a 'default' case.
 * @param {*} value - The value to match (can be a string, array path, etc.)
 * @param {Object} cases - Object with cases to match against (supports 'default' key)
 * @returns {*} The matched case value, or false if no match
 * @example
 * _switch('a', { a: 1, b: 2, default: 0 }) // => 1
 * _switch('c', { a: 1, b: 2, default: 0 }) // => 0
 * _switch(['a', 'b'], { a: { b: 1 } }) // => 1
 */ const $02d3bb03c028877b$var$_switch = (value, cases)=>$02d3bb03c028877b$var$sub(cases, value) && $02d3bb03c028877b$var$sub(cases, value)['default'] || $02d3bb03c028877b$var$sub(cases, value) || value instanceof Array && value.length > 1 && $02d3bb03c028877b$var$_switch(value.slice(0, value.length - 1), cases) || cases['default'] || false;
module.exports = {
    keyValue: $02d3bb03c028877b$var$keyValue,
    isLiteral: $02d3bb03c028877b$var$isLiteral,
    clone: $02d3bb03c028877b$var$clone,
    sub: $02d3bb03c028877b$var$sub,
    patch: $02d3bb03c028877b$var$patch,
    reduce: $02d3bb03c028877b$var$reduce,
    map: $02d3bb03c028877b$var$map,
    filter: $02d3bb03c028877b$var$filter,
    traverse: $02d3bb03c028877b$var$traverse,
    chainCall: $02d3bb03c028877b$var$chainCall,
    switch: $02d3bb03c028877b$var$_switch
};

});

parcelRegister("llUvA", function(module, exports) {
'use strict';
/**
 * Immutably adds an item to an array (returns a new array).
 * @param {Array} arr - The source array
 * @param {*} item - The item to add
 * @returns {Array} A new array with the item added at the end
 * @example
 * add([1, 2, 3], 4) // => [1, 2, 3, 4]
 */ const $f8b7648db1f1c5a5$var$add = (arr, item)=>[].concat(arr, [
        item
    ]);
/**
 * Immutably removes the first occurrence of an item from an array.
 * If the item is not found, returns the original array.
 * @param {Array} arr - The source array
 * @param {*} item - The item to remove
 * @returns {Array} A new array with the item removed, or the original array if not found
 * @example
 * remove([1, 2, 3, 2], 2) // => [1, 3, 2]
 * remove([1, 2, 3], 4) // => [1, 2, 3]
 */ const $f8b7648db1f1c5a5$var$remove = (arr, item)=>arr.indexOf(item) > -1 ? [].concat(arr.slice(0, arr.indexOf(item)), arr.slice(arr.indexOf(item) + 1)) : arr;
/**
 * Immutably toggles an item in an array (adds if not present, removes if present).
 * @param {Array} arr - The source array
 * @param {*} item - The item to toggle
 * @returns {Array} A new array with the item toggled
 * @example
 * toggle([1, 2, 3], 2) // => [1, 3]
 * toggle([1, 2, 3], 4) // => [1, 2, 3, 4]
 */ const $f8b7648db1f1c5a5$var$toggle = (arr, item)=>arr.indexOf(item) > -1 ? $f8b7648db1f1c5a5$var$remove(arr, item) : $f8b7648db1f1c5a5$var$add(arr, item);
/**
 * Checks if an array or comma-separated string contains an element.
 * @param {Array|string} a - The array or comma-separated string to check
 * @param {*} el - The element to look for
 * @returns {boolean} True if the element is found, false otherwise
 * @example
 * contains([1, 2, 3], 2) // => true
 * contains('a,b,c', 'b') // => true
 * contains([1, 2, 3], 4) // => false
 */ const $f8b7648db1f1c5a5$var$contains = (a, el)=>[].concat(typeof a === 'string' && a.split(',') || a instanceof Array && a || []).indexOf(el) > -1;
module.exports = {
    add: $f8b7648db1f1c5a5$var$add,
    remove: $f8b7648db1f1c5a5$var$remove,
    toggle: $f8b7648db1f1c5a5$var$toggle,
    contains: $f8b7648db1f1c5a5$var$contains
};

});

parcelRegister("054Xj", function(module, exports) {
'use strict';
/**
 * Capitalizes the first character of a string.
 * @param {string} chunk - The string to capitalize
 * @returns {string} The capitalized string
 * @example
 * capitalize('hello') // => 'Hello'
 */ const $00f44fd4f3d3ff8c$var$capitalize = (chunk)=>chunk.charAt(0).toUpperCase() + chunk.slice(1);
/**
 * Converts a string to camelCase from a delimited format.
 * @param {string} str - The string to convert
 * @param {string} [glue='_'] - The delimiter to split on
 * @returns {string} The camelCase string
 * @example
 * toCamelCase('hello_world') // => 'helloWorld'
 * toCamelCase('hello-world', '-') // => 'helloWorld'
 */ const $00f44fd4f3d3ff8c$var$toCamelCase = (str, glue = '_')=>str.split(glue).map((chunk, i)=>i === 0 ? chunk : $00f44fd4f3d3ff8c$var$capitalize(chunk)).join('');
/**
 * Converts a camelCase string to a delimited format.
 * @param {string} str - The camelCase string to convert
 * @param {string} [glue='_'] - The delimiter to use
 * @returns {string} The delimited string in lowercase
 * @example
 * fromCamelCase('helloWorld') // => 'hello_world'
 * fromCamelCase('helloWorld', '-') // => 'hello-world'
 */ const $00f44fd4f3d3ff8c$var$fromCamelCase = (str, glue = '_')=>str.replace(/([A-Z])/g, ' $1').split(' ').map((chunk)=>chunk.toLowerCase()).join(glue);
/**
 * Converts a singular word to its plural form (basic English rules).
 * @param {string} str - The singular word
 * @returns {string} The plural form
 * @example
 * singularToPlural('category') // => 'categories'
 * singularToPlural('user') // => 'users'
 */ const $00f44fd4f3d3ff8c$var$singularToPlural = (str)=>str.replace(/y$/, 'ie').concat('s');
/**
 * Converts a plural word to its singular form (basic English rules).
 * @param {string} str - The plural word
 * @returns {string} The singular form
 * @example
 * pluralToSingular('categories') // => 'category'
 * pluralToSingular('users') // => 'user'
 */ const $00f44fd4f3d3ff8c$var$pluralToSingular = (str)=>str.replace(/ies$/, 'y').replace(/s$/, '');
/**
 * Converts a string to a document ID format (typically used for database foreign keys).
 * @param {string} str - The string to convert
 * @param {string} [glue='_'] - The delimiter in the input string
 * @param {string} [suffix='Id'] - The suffix to append
 * @param {string} [prefix=''] - The prefix to prepend
 * @returns {string} The document ID string
 * @example
 * toDocumentId('user_roles') // => 'userRoleId'
 * toDocumentId('categories', '_', 'ID', 'ref') // => 'refCategoryID'
 */ const $00f44fd4f3d3ff8c$var$toDocumentId = (str, glue = '_', suffix = 'Id', prefix = '')=>prefix.concat($00f44fd4f3d3ff8c$var$pluralToSingular($00f44fd4f3d3ff8c$var$toCamelCase(str, glue)), suffix);
module.exports = {
    capitalize: $00f44fd4f3d3ff8c$var$capitalize,
    toCamelCase: $00f44fd4f3d3ff8c$var$toCamelCase,
    fromCamelCase: $00f44fd4f3d3ff8c$var$fromCamelCase,
    singularToPlural: $00f44fd4f3d3ff8c$var$singularToPlural,
    pluralToSingular: $00f44fd4f3d3ff8c$var$pluralToSingular,
    toDocumentId: $00f44fd4f3d3ff8c$var$toDocumentId
};

});

parcelRegister("cMwYg", function(module, exports) {
'use strict';

var $f30cz = parcelRequire("f30cz");
/**
 * Creates a left-to-right function composition pipeline.
 * The first function can accept multiple arguments; the remaining functions must be unary.
 * @param {Function} a - The first function in the pipeline (can accept multiple arguments)
 * @param {...Function} fns - The remaining functions to pipe through (each takes one argument)
 * @returns {Function} A function that passes the result through each function from left to right
 * @example
 * const addOne = x => x + 1;
 * const double = x => x * 2;
 * const addOneThenDouble = pipe(addOne, double);
 * addOneThenDouble(3) // => 8 (3 + 1 = 4, 4 * 2 = 8)
 */ const $94e38b133e22c353$var$pipe = (a, ...fns)=>(...args)=>fns.reduce((res, fn)=>fn(res), a(...args));
/**
 * Creates a right-to-left function composition.
 * The rightmost function can accept multiple arguments; the remaining functions must be unary.
 * @param {...Function} fns - Functions to compose (executed right to left)
 * @returns {Function} A function that passes the result through each function from right to left
 * @example
 * const addOne = x => x + 1;
 * const double = x => x * 2;
 * const doubleThenAddOne = compose(addOne, double);
 * doubleThenAddOne(3) // => 7 (3 * 2 = 6, 6 + 1 = 7)
 */ const $94e38b133e22c353$var$compose = (...fns)=>$94e38b133e22c353$var$pipe(fns.slice(-1).pop(), ...fns.reverse().slice(1));
// switch for backwards compatibility
module.exports = {
    compose: $94e38b133e22c353$var$compose,
    pipe: $94e38b133e22c353$var$pipe,
    switch: $f30cz.switch
};

});



parcelRegister("cVcju", function(module, exports) {
'use strict';

var $1VO3A = parcelRequire("1VO3A");
var $96845c124faaba05$require$section = $1VO3A.section;
var $96845c124faaba05$require$button = $1VO3A.button;
var $96845c124faaba05$require$span = $1VO3A.span;
var $96845c124faaba05$require$h1 = $1VO3A.h1;
var $96845c124faaba05$require$h4 = $1VO3A.h4;
var $96845c124faaba05$require$i = $1VO3A.i;
var $96845c124faaba05$require$hr = $1VO3A.hr;
var $96845c124faaba05$require$canvas = $1VO3A.canvas;
var $96845c124faaba05$require$input = $1VO3A.input;
var $96845c124faaba05$require$img = $1VO3A.img;
var $96845c124faaba05$require$fieldset = $1VO3A.fieldset;
var $96845c124faaba05$require$legend = $1VO3A.legend;
var $96845c124faaba05$require$label = $1VO3A.label;
var $96845c124faaba05$require$select = $1VO3A.select;
var $96845c124faaba05$require$option = $1VO3A.option;

var $7TCVA = parcelRequire("7TCVA");
var $96845c124faaba05$require$context = $7TCVA.context;

var $jjnZg = parcelRequire("jjnZg");
var $96845c124faaba05$require$obj = $jjnZg.obj;
var $96845c124faaba05$require$fn = $jjnZg.fn;

var $5oOrw = parcelRequire("5oOrw");

var $fFbkt = parcelRequire("fFbkt");

var $5tckQ = parcelRequire("5tckQ");

var $Wucal = parcelRequire("Wucal");
module.exports = ({ state: state, actions: actions })=>$96845c124faaba05$require$section('#ui', [
        $5oOrw({
            state: state,
            actions: actions
        }),
        $fFbkt({
            state: state,
            actions: actions
        }),
        $5tckQ({
            state: state,
            actions: actions
        }),
        $96845c124faaba05$require$section('.global-controls', [
            $96845c124faaba05$require$button({
                on: {
                    click: ()=>actions.stopAll($96845c124faaba05$require$context.currentTime)
                }
            }, [
                $96845c124faaba05$require$i('.fa.fa-stop'),
                $96845c124faaba05$require$span('Stop All')
            ]),
            $96845c124faaba05$require$button({
                on: {
                    click: ()=>actions.playAll($96845c124faaba05$require$context.currentTime)
                }
            }, [
                $96845c124faaba05$require$i('.fa.fa-play'),
                $96845c124faaba05$require$span('Start All')
            ]),
            $96845c124faaba05$require$button({
                on: {
                    click: ()=>actions.clearAll($96845c124faaba05$require$context.currentTime)
                }
            }, [
                $96845c124faaba05$require$i('.fa.fa-trash-o'),
                $96845c124faaba05$require$span('Clear All')
            ])
        ]),
        $96845c124faaba05$require$section('.channels', Object.keys(state.channels).map((chan)=>$Wucal({
                params: state.channels[chan],
                chan: chan,
                actions: actions
            }))),
        $96845c124faaba05$require$canvas('#visual')
    ]);

});
parcelRegister("1VO3A", function(module, exports) {
'use strict';

var $5zMQd = parcelRequire("5zMQd");

var $ib7up = parcelRequire("ib7up");
var $1681f18b75c77c54$require$h = $ib7up.default;

var $jjnZg = parcelRequire("jjnZg");
var $1681f18b75c77c54$require$obj = $jjnZg.obj;

var $kXou7 = parcelRequire("kXou7");

var $9Q7ox = parcelRequire("9Q7ox");





const $1681f18b75c77c54$var$patch = $5zMQd.init([
    (parcelRequire("2FVgl")).default,
    (parcelRequire("d7OtB")).default,
    (parcelRequire("5TEcn")).default,
    (parcelRequire("gdvPb")).default,
    (parcelRequire("lRr5I")).default // attaches event listeners
]);
const $1681f18b75c77c54$var$patchStream = (stream, dom)=>{
    dom = typeof dom === 'string' ? document.querySelector(dom) : dom;
    stream.scan((vnode, newVnode)=>$1681f18b75c77c54$var$patch(vnode, newVnode), dom).subscribe();
};
const $1681f18b75c77c54$var$hyperHelpers = $kXou7.reduce((o, tag)=>{
    o[tag] = function() {
        return [
            Array.from(arguments)
        ].map($9Q7ox.process).map((args)=>// is the first argument a selector
            args[0] && typeof args[0] === 'string' && args[0].match(/^(\.|#)[a-zA-Z\-_0-9]+/ig) ? [].concat(tag + args[0], args.slice(1)) : [
                tag
            ].concat(args)).map((args)=>$1681f18b75c77c54$require$h.apply(this, args)).pop();
    };
    return o;
}, {});
module.exports = Object.assign({
    h: $1681f18b75c77c54$require$h,
    patch: $1681f18b75c77c54$var$patch,
    patchStream: $1681f18b75c77c54$var$patchStream
}, $1681f18b75c77c54$var$hyperHelpers);

});
parcelRegister("5zMQd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l3G7P = parcelRequire("l3G7P");

var $63vCK = parcelRequire("63vCK");

var $UfQKG = parcelRequire("UfQKG");
function $40f61b781bf850bc$var$isUndef(s) {
    return s === undefined;
}
function $40f61b781bf850bc$var$isDef(s) {
    return s !== undefined;
}
var $40f61b781bf850bc$var$emptyNode = $l3G7P.default('', {}, [], undefined, undefined);
function $40f61b781bf850bc$var$sameVnode(vnode1, vnode2) {
    return vnode1.key === vnode2.key && vnode1.sel === vnode2.sel;
}
function $40f61b781bf850bc$var$isVnode(vnode) {
    return vnode.sel !== undefined;
}
function $40f61b781bf850bc$var$createKeyToOldIdx(children, beginIdx, endIdx) {
    var i, map = {}, key, ch;
    for(i = beginIdx; i <= endIdx; ++i){
        ch = children[i];
        if (ch != null) {
            key = ch.key;
            if (key !== undefined) map[key] = i;
        }
    }
    return map;
}
var $40f61b781bf850bc$var$hooks = [
    'create',
    'update',
    'remove',
    'destroy',
    'pre',
    'post'
];

var $ib7up = parcelRequire("ib7up");
module.exports.h = $ib7up.h;

var $bUER4 = parcelRequire("bUER4");
module.exports.thunk = $bUER4.thunk;
function $40f61b781bf850bc$var$init(modules, domApi) {
    var i, j, cbs = {};
    var api = domApi !== undefined ? domApi : $UfQKG.default;
    for(i = 0; i < $40f61b781bf850bc$var$hooks.length; ++i){
        cbs[$40f61b781bf850bc$var$hooks[i]] = [];
        for(j = 0; j < modules.length; ++j){
            var hook = modules[j][$40f61b781bf850bc$var$hooks[i]];
            if (hook !== undefined) cbs[$40f61b781bf850bc$var$hooks[i]].push(hook);
        }
    }
    function emptyNodeAt(elm) {
        var id = elm.id ? '#' + elm.id : '';
        var c = elm.className ? '.' + elm.className.split(' ').join('.') : '';
        return $l3G7P.default(api.tagName(elm).toLowerCase() + id + c, {}, [], undefined, elm);
    }
    function createRmCb(childElm, listeners) {
        return function rmCb() {
            if (--listeners === 0) {
                var parent_1 = api.parentNode(childElm);
                api.removeChild(parent_1, childElm);
            }
        };
    }
    function createElm(vnode, insertedVnodeQueue) {
        var i, data = vnode.data;
        if (data !== undefined) {
            if ($40f61b781bf850bc$var$isDef(i = data.hook) && $40f61b781bf850bc$var$isDef(i = i.init)) {
                i(vnode);
                data = vnode.data;
            }
        }
        var children = vnode.children, sel = vnode.sel;
        if (sel === '!') {
            if ($40f61b781bf850bc$var$isUndef(vnode.text)) vnode.text = '';
            vnode.elm = api.createComment(vnode.text);
        } else if (sel !== undefined) {
            // Parse selector
            var hashIdx = sel.indexOf('#');
            var dotIdx = sel.indexOf('.', hashIdx);
            var hash = hashIdx > 0 ? hashIdx : sel.length;
            var dot = dotIdx > 0 ? dotIdx : sel.length;
            var tag = hashIdx !== -1 || dotIdx !== -1 ? sel.slice(0, Math.min(hash, dot)) : sel;
            var elm = vnode.elm = $40f61b781bf850bc$var$isDef(data) && $40f61b781bf850bc$var$isDef(i = data.ns) ? api.createElementNS(i, tag) : api.createElement(tag);
            if (hash < dot) elm.setAttribute('id', sel.slice(hash + 1, dot));
            if (dotIdx > 0) elm.setAttribute('class', sel.slice(dot + 1).replace(/\./g, ' '));
            for(i = 0; i < cbs.create.length; ++i)cbs.create[i]($40f61b781bf850bc$var$emptyNode, vnode);
            if ($63vCK.array(children)) for(i = 0; i < children.length; ++i){
                var ch = children[i];
                if (ch != null) api.appendChild(elm, createElm(ch, insertedVnodeQueue));
            }
            else if ($63vCK.primitive(vnode.text)) api.appendChild(elm, api.createTextNode(vnode.text));
            i = vnode.data.hook; // Reuse variable
            if ($40f61b781bf850bc$var$isDef(i)) {
                if (i.create) i.create($40f61b781bf850bc$var$emptyNode, vnode);
                if (i.insert) insertedVnodeQueue.push(vnode);
            }
        } else vnode.elm = api.createTextNode(vnode.text);
        return vnode.elm;
    }
    function addVnodes(parentElm, before, vnodes, startIdx, endIdx, insertedVnodeQueue) {
        for(; startIdx <= endIdx; ++startIdx){
            var ch = vnodes[startIdx];
            if (ch != null) api.insertBefore(parentElm, createElm(ch, insertedVnodeQueue), before);
        }
    }
    function invokeDestroyHook(vnode) {
        var i, j, data = vnode.data;
        if (data !== undefined) {
            if ($40f61b781bf850bc$var$isDef(i = data.hook) && $40f61b781bf850bc$var$isDef(i = i.destroy)) i(vnode);
            for(i = 0; i < cbs.destroy.length; ++i)cbs.destroy[i](vnode);
            if (vnode.children !== undefined) for(j = 0; j < vnode.children.length; ++j){
                i = vnode.children[j];
                if (i != null && typeof i !== "string") invokeDestroyHook(i);
            }
        }
    }
    function removeVnodes(parentElm, vnodes, startIdx, endIdx) {
        for(; startIdx <= endIdx; ++startIdx){
            var i_1 = void 0, listeners = void 0, rm = void 0, ch = vnodes[startIdx];
            if (ch != null) {
                if ($40f61b781bf850bc$var$isDef(ch.sel)) {
                    invokeDestroyHook(ch);
                    listeners = cbs.remove.length + 1;
                    rm = createRmCb(ch.elm, listeners);
                    for(i_1 = 0; i_1 < cbs.remove.length; ++i_1)cbs.remove[i_1](ch, rm);
                    if ($40f61b781bf850bc$var$isDef(i_1 = ch.data) && $40f61b781bf850bc$var$isDef(i_1 = i_1.hook) && $40f61b781bf850bc$var$isDef(i_1 = i_1.remove)) i_1(ch, rm);
                    else rm();
                } else api.removeChild(parentElm, ch.elm);
            }
        }
    }
    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue) {
        var oldStartIdx = 0, newStartIdx = 0;
        var oldEndIdx = oldCh.length - 1;
        var oldStartVnode = oldCh[0];
        var oldEndVnode = oldCh[oldEndIdx];
        var newEndIdx = newCh.length - 1;
        var newStartVnode = newCh[0];
        var newEndVnode = newCh[newEndIdx];
        var oldKeyToIdx;
        var idxInOld;
        var elmToMove;
        var before;
        while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
            if (oldStartVnode == null) oldStartVnode = oldCh[++oldStartIdx]; // Vnode might have been moved left
            else if (oldEndVnode == null) oldEndVnode = oldCh[--oldEndIdx];
            else if (newStartVnode == null) newStartVnode = newCh[++newStartIdx];
            else if (newEndVnode == null) newEndVnode = newCh[--newEndIdx];
            else if ($40f61b781bf850bc$var$sameVnode(oldStartVnode, newStartVnode)) {
                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
                oldStartVnode = oldCh[++oldStartIdx];
                newStartVnode = newCh[++newStartIdx];
            } else if ($40f61b781bf850bc$var$sameVnode(oldEndVnode, newEndVnode)) {
                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
                oldEndVnode = oldCh[--oldEndIdx];
                newEndVnode = newCh[--newEndIdx];
            } else if ($40f61b781bf850bc$var$sameVnode(oldStartVnode, newEndVnode)) {
                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
                api.insertBefore(parentElm, oldStartVnode.elm, api.nextSibling(oldEndVnode.elm));
                oldStartVnode = oldCh[++oldStartIdx];
                newEndVnode = newCh[--newEndIdx];
            } else if ($40f61b781bf850bc$var$sameVnode(oldEndVnode, newStartVnode)) {
                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
                api.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                oldEndVnode = oldCh[--oldEndIdx];
                newStartVnode = newCh[++newStartIdx];
            } else {
                if (oldKeyToIdx === undefined) oldKeyToIdx = $40f61b781bf850bc$var$createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                idxInOld = oldKeyToIdx[newStartVnode.key];
                if ($40f61b781bf850bc$var$isUndef(idxInOld)) {
                    api.insertBefore(parentElm, createElm(newStartVnode, insertedVnodeQueue), oldStartVnode.elm);
                    newStartVnode = newCh[++newStartIdx];
                } else {
                    elmToMove = oldCh[idxInOld];
                    if (elmToMove.sel !== newStartVnode.sel) api.insertBefore(parentElm, createElm(newStartVnode, insertedVnodeQueue), oldStartVnode.elm);
                    else {
                        patchVnode(elmToMove, newStartVnode, insertedVnodeQueue);
                        oldCh[idxInOld] = undefined;
                        api.insertBefore(parentElm, elmToMove.elm, oldStartVnode.elm);
                    }
                    newStartVnode = newCh[++newStartIdx];
                }
            }
        }
        if (oldStartIdx > oldEndIdx) {
            before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
            addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
        } else if (newStartIdx > newEndIdx) removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
    function patchVnode(oldVnode, vnode, insertedVnodeQueue) {
        var i, hook;
        if ($40f61b781bf850bc$var$isDef(i = vnode.data) && $40f61b781bf850bc$var$isDef(hook = i.hook) && $40f61b781bf850bc$var$isDef(i = hook.prepatch)) i(oldVnode, vnode);
        var elm = vnode.elm = oldVnode.elm;
        var oldCh = oldVnode.children;
        var ch = vnode.children;
        if (oldVnode === vnode) return;
        if (vnode.data !== undefined) {
            for(i = 0; i < cbs.update.length; ++i)cbs.update[i](oldVnode, vnode);
            i = vnode.data.hook;
            if ($40f61b781bf850bc$var$isDef(i) && $40f61b781bf850bc$var$isDef(i = i.update)) i(oldVnode, vnode);
        }
        if ($40f61b781bf850bc$var$isUndef(vnode.text)) {
            if ($40f61b781bf850bc$var$isDef(oldCh) && $40f61b781bf850bc$var$isDef(ch)) {
                if (oldCh !== ch) updateChildren(elm, oldCh, ch, insertedVnodeQueue);
            } else if ($40f61b781bf850bc$var$isDef(ch)) {
                if ($40f61b781bf850bc$var$isDef(oldVnode.text)) api.setTextContent(elm, '');
                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            } else if ($40f61b781bf850bc$var$isDef(oldCh)) removeVnodes(elm, oldCh, 0, oldCh.length - 1);
            else if ($40f61b781bf850bc$var$isDef(oldVnode.text)) api.setTextContent(elm, '');
        } else if (oldVnode.text !== vnode.text) api.setTextContent(elm, vnode.text);
        if ($40f61b781bf850bc$var$isDef(hook) && $40f61b781bf850bc$var$isDef(i = hook.postpatch)) i(oldVnode, vnode);
    }
    return function patch(oldVnode, vnode) {
        var i, elm, parent;
        var insertedVnodeQueue = [];
        for(i = 0; i < cbs.pre.length; ++i)cbs.pre[i]();
        if (!$40f61b781bf850bc$var$isVnode(oldVnode)) oldVnode = emptyNodeAt(oldVnode);
        if ($40f61b781bf850bc$var$sameVnode(oldVnode, vnode)) patchVnode(oldVnode, vnode, insertedVnodeQueue);
        else {
            elm = oldVnode.elm;
            parent = api.parentNode(elm);
            createElm(vnode, insertedVnodeQueue);
            if (parent !== null) {
                api.insertBefore(parent, vnode.elm, api.nextSibling(elm));
                removeVnodes(parent, [
                    oldVnode
                ], 0, 0);
            }
        }
        for(i = 0; i < insertedVnodeQueue.length; ++i)insertedVnodeQueue[i].data.hook.insert(insertedVnodeQueue[i]);
        for(i = 0; i < cbs.post.length; ++i)cbs.post[i]();
        return vnode;
    };
}
module.exports.init = $40f61b781bf850bc$var$init;

});
parcelRegister("l3G7P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $f54a8dff3bcfe472$var$vnode(sel, data, children, text, elm) {
    var key = data === undefined ? undefined : data.key;
    return {
        sel: sel,
        data: data,
        children: children,
        text: text,
        elm: elm,
        key: key
    };
}
module.exports.vnode = $f54a8dff3bcfe472$var$vnode;
module.exports.default = $f54a8dff3bcfe472$var$vnode;

});

parcelRegister("63vCK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.array = Array.isArray;
function $468b8db98389fda6$var$primitive(s) {
    return typeof s === 'string' || typeof s === 'number';
}
module.exports.primitive = $468b8db98389fda6$var$primitive;

});

parcelRegister("UfQKG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $0a9186868152e714$var$createElement(tagName) {
    return document.createElement(tagName);
}
function $0a9186868152e714$var$createElementNS(namespaceURI, qualifiedName) {
    return document.createElementNS(namespaceURI, qualifiedName);
}
function $0a9186868152e714$var$createTextNode(text) {
    return document.createTextNode(text);
}
function $0a9186868152e714$var$createComment(text) {
    return document.createComment(text);
}
function $0a9186868152e714$var$insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function $0a9186868152e714$var$removeChild(node, child) {
    node.removeChild(child);
}
function $0a9186868152e714$var$appendChild(node, child) {
    node.appendChild(child);
}
function $0a9186868152e714$var$parentNode(node) {
    return node.parentNode;
}
function $0a9186868152e714$var$nextSibling(node) {
    return node.nextSibling;
}
function $0a9186868152e714$var$tagName(elm) {
    return elm.tagName;
}
function $0a9186868152e714$var$setTextContent(node, text) {
    node.textContent = text;
}
function $0a9186868152e714$var$getTextContent(node) {
    return node.textContent;
}
function $0a9186868152e714$var$isElement(node) {
    return node.nodeType === 1;
}
function $0a9186868152e714$var$isText(node) {
    return node.nodeType === 3;
}
function $0a9186868152e714$var$isComment(node) {
    return node.nodeType === 8;
}
module.exports.htmlDomApi = {
    createElement: $0a9186868152e714$var$createElement,
    createElementNS: $0a9186868152e714$var$createElementNS,
    createTextNode: $0a9186868152e714$var$createTextNode,
    createComment: $0a9186868152e714$var$createComment,
    insertBefore: $0a9186868152e714$var$insertBefore,
    removeChild: $0a9186868152e714$var$removeChild,
    appendChild: $0a9186868152e714$var$appendChild,
    parentNode: $0a9186868152e714$var$parentNode,
    nextSibling: $0a9186868152e714$var$nextSibling,
    tagName: $0a9186868152e714$var$tagName,
    setTextContent: $0a9186868152e714$var$setTextContent,
    getTextContent: $0a9186868152e714$var$getTextContent,
    isElement: $0a9186868152e714$var$isElement,
    isText: $0a9186868152e714$var$isText,
    isComment: $0a9186868152e714$var$isComment
};
module.exports.default = module.exports.htmlDomApi;

});

parcelRegister("ib7up", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l3G7P = parcelRequire("l3G7P");

var $63vCK = parcelRequire("63vCK");
function $d3bf1059e488355b$var$addNS(data, children, sel) {
    data.ns = 'http://www.w3.org/2000/svg';
    if (sel !== 'foreignObject' && children !== undefined) for(var i = 0; i < children.length; ++i){
        var childData = children[i].data;
        if (childData !== undefined) $d3bf1059e488355b$var$addNS(childData, children[i].children, children[i].sel);
    }
}
function $d3bf1059e488355b$var$h(sel, b, c) {
    var data = {}, children, text, i;
    if (c !== undefined) {
        data = b;
        if ($63vCK.array(c)) children = c;
        else if ($63vCK.primitive(c)) text = c;
        else if (c && c.sel) children = [
            c
        ];
    } else if (b !== undefined) {
        if ($63vCK.array(b)) children = b;
        else if ($63vCK.primitive(b)) text = b;
        else if (b && b.sel) children = [
            b
        ];
        else data = b;
    }
    if ($63vCK.array(children)) {
        for(i = 0; i < children.length; ++i)if ($63vCK.primitive(children[i])) children[i] = $l3G7P.vnode(undefined, undefined, undefined, children[i]);
    }
    if (sel[0] === 's' && sel[1] === 'v' && sel[2] === 'g' && (sel.length === 3 || sel[3] === '.' || sel[3] === '#')) $d3bf1059e488355b$var$addNS(data, children, sel);
    return $l3G7P.vnode(sel, data, children, text, undefined);
}
module.exports.h = $d3bf1059e488355b$var$h;
module.exports.default = $d3bf1059e488355b$var$h;

});

parcelRegister("bUER4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ib7up = parcelRequire("ib7up");
function $8ac49da323e5d88b$var$copyToThunk(vnode, thunk) {
    thunk.elm = vnode.elm;
    vnode.data.fn = thunk.data.fn;
    vnode.data.args = thunk.data.args;
    thunk.data = vnode.data;
    thunk.children = vnode.children;
    thunk.text = vnode.text;
    thunk.elm = vnode.elm;
}
function $8ac49da323e5d88b$var$init(thunk) {
    var cur = thunk.data;
    var vnode = cur.fn.apply(undefined, cur.args);
    $8ac49da323e5d88b$var$copyToThunk(vnode, thunk);
}
function $8ac49da323e5d88b$var$prepatch(oldVnode, thunk) {
    var i, old = oldVnode.data, cur = thunk.data;
    var oldArgs = old.args, args = cur.args;
    if (old.fn !== cur.fn || oldArgs.length !== args.length) {
        $8ac49da323e5d88b$var$copyToThunk(cur.fn.apply(undefined, args), thunk);
        return;
    }
    for(i = 0; i < args.length; ++i)if (oldArgs[i] !== args[i]) {
        $8ac49da323e5d88b$var$copyToThunk(cur.fn.apply(undefined, args), thunk);
        return;
    }
    $8ac49da323e5d88b$var$copyToThunk(oldVnode, thunk);
}
module.exports.thunk = function thunk(sel, key, fn, args) {
    if (args === undefined) {
        args = fn;
        fn = key;
        key = undefined;
    }
    return $ib7up.h(sel, {
        key: key,
        hook: {
            init: $8ac49da323e5d88b$var$init,
            prepatch: $8ac49da323e5d88b$var$prepatch
        },
        fn: fn,
        args: args
    });
};
module.exports.default = module.exports.thunk;

});


parcelRegister("kXou7", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eSj2l"));

});

parcelRegister("9Q7ox", function(module, exports) {
'use strict';

var $jjnZg = parcelRequire("jjnZg");
var $729eb4d7cc247132$require$obj = $jjnZg.obj;
const $729eb4d7cc247132$var$strParse = (s)=>s.match(/^[0-9]+$/) ? parseInt(s, 10) : s.match(/^[0-9.]+$/) ? parseFloat(s) : s === 'true' ? true : s === 'false' ? false : s;
const $729eb4d7cc247132$var$process = (args)=>{
    let newArgs = args.slice();
    let selector = newArgs[0] && typeof newArgs[0] === 'string' && newArgs[0] || '';
    if (selector !== '') newArgs = newArgs.slice(1);
    const attrRegExp = /\[[a-z\-0-9]+=("[^"]+"|'[^']+'|[0-9.]+|true|false|[^\]^=^"^']+)\]/ig;
    let attrs = selector && selector.match(attrRegExp);
    selector = selector.replace(attrRegExp, '');
    attrs = attrs && attrs.map && attrs.map((c)=>c.replace(/[[\]("|')]/g, '').split('=')).reduce((o, attr)=>$729eb4d7cc247132$require$obj.patch(o, attr[0], $729eb4d7cc247132$var$strParse(attr[1])), {}) || {};
    if (attrs && Object.keys(attrs).length > 0) {
        if (!newArgs[0] || newArgs[0] && typeof newArgs[0] === 'object' && !(newArgs[0] instanceof Array)) {
            attrs = Object.assign({}, newArgs[0] && newArgs[0].attrs || {}, attrs);
            newArgs[0] = Object.assign({}, newArgs[0] || {}, {
                attrs: attrs
            });
        } else newArgs = [
            {
                attrs: attrs
            }
        ].concat(newArgs);
    }
    if (selector !== '') newArgs = [
        selector
    ].concat(newArgs);
    // console.log(args, newArgs);
    return newArgs;
};
module.exports = {
    strParse: $729eb4d7cc247132$var$strParse,
    process: $729eb4d7cc247132$var$process
};

});


parcelRegister("7TCVA", function(module, exports) {
'use strict';

var $jjnZg = parcelRequire("jjnZg");
var $5bfbddba281c0a5f$require$obj = $jjnZg.obj;
var $5bfbddba281c0a5f$require$fn = $jjnZg.fn;

var $btdM1 = parcelRequire("btdM1");
var $5bfbddba281c0a5f$require$context = $btdM1.context;
var $5bfbddba281c0a5f$require$set = $btdM1.set;
var $5bfbddba281c0a5f$require$isSet = $btdM1.isSet;
var $5bfbddba281c0a5f$require$isGet = $btdM1.isGet;
var $5bfbddba281c0a5f$require$_schedule = $btdM1.schedule;
var $5bfbddba281c0a5f$require$_create = $btdM1.create;
var $5bfbddba281c0a5f$require$_connect = $btdM1.connect;
var $5bfbddba281c0a5f$require$_disconnect = $btdM1.disconnect;

var $eOfJT = parcelRequire("eOfJT");

var $599rR = parcelRequire("599rR");

var $9p9bV = parcelRequire("9p9bV");
const $5bfbddba281c0a5f$var$create = (type, prefs = {}, ctx = $5bfbddba281c0a5f$require$context)=>Object.assign({}, $5bfbddba281c0a5f$require$obj.switch(type, {
        vco: ()=>({
                output: $5bfbddba281c0a5f$require$_create('oscillator')
            }),
        vca: ()=>({
                through: $5bfbddba281c0a5f$require$_create('gain')
            }),
        vcf: ()=>({
                through: $5bfbddba281c0a5f$require$_create('biquadFilter')
            }),
        lfo: ()=>$599rR.create(prefs),
        reverb: ()=>$eOfJT.create(prefs),
        adsr: ()=>$9p9bV.create(prefs)
    })(), {
        type: type,
        out: []
    });
const $5bfbddba281c0a5f$var$cutoffToFreq = (cutoff)=>{
    const minValue = 40;
    const maxValue = $5bfbddba281c0a5f$require$context.sampleRate / 2;
    // Logarithm (base 2) to compute how many octaves fall in the range.
    var numberOfOctaves = Math.log(maxValue / minValue) / Math.LN2;
    // Compute a multiplier from 0 to 1 based on an exponential scale.
    var multiplier = Math.pow(2, numberOfOctaves * (cutoff - 1.0));
    // Get back to the frequency value between min and max.
    return maxValue * multiplier;
};
const $5bfbddba281c0a5f$var$update = (node, prefs)=>$5bfbddba281c0a5f$require$obj.switch(node.type, {
        vco: ()=>($5bfbddba281c0a5f$require$isSet(prefs.type) && $5bfbddba281c0a5f$require$set(node.output, 'type', prefs.type), $5bfbddba281c0a5f$require$isSet(prefs.freq) && $5bfbddba281c0a5f$require$set(node.output.frequency, 'value', prefs.freq), $5bfbddba281c0a5f$require$isSet(prefs.detune) && $5bfbddba281c0a5f$require$set(node.output.detune, 'value', prefs.detune), Object.assign(node, {
                prefs: prefs
            })),
        vca: ()=>($5bfbddba281c0a5f$require$isSet(prefs.gain) && $5bfbddba281c0a5f$require$set(node.through.gain, 'value', prefs.gain), Object.assign(node, {
                prefs: prefs
            })),
        vcf: ()=>($5bfbddba281c0a5f$require$isSet(prefs.type) && $5bfbddba281c0a5f$require$set(node.through, 'type', prefs.type), $5bfbddba281c0a5f$require$isSet(prefs.cutoff) && $5bfbddba281c0a5f$require$_schedule(node.through, 'frequency', [
                $5bfbddba281c0a5f$var$cutoffToFreq(prefs.cutoff)
            ], [
                $5bfbddba281c0a5f$require$context.currentTime + 0.0001
            ]), // set(node.through.frequency, 'value', cutoffToFreq(prefs.cutoff)),
            $5bfbddba281c0a5f$require$isSet(prefs.resonance) && $5bfbddba281c0a5f$require$_schedule(node.through, 'Q', [
                prefs.resonance * 30
            ], [
                $5bfbddba281c0a5f$require$context.currentTime + 0.0001
            ]), Object.assign(node, {
                prefs: prefs
            })),
        reverb: ()=>$eOfJT.update(node, prefs),
        adsr: ()=>$9p9bV.update(node, prefs),
        lfo: ()=>$599rR.update(node, prefs)
    })();
const $5bfbddba281c0a5f$var$connect = (node1, node2)=>!(node1.out && node1.out.indexOf(node2) > -1) ? ($5bfbddba281c0a5f$require$_connect(// input
    $5bfbddba281c0a5f$require$isGet(node1.output) || $5bfbddba281c0a5f$require$isGet(node1.through) || $5bfbddba281c0a5f$require$isSet(node1.connect) && node1, // output
    node2 instanceof AudioParam && node2 || $5bfbddba281c0a5f$require$isGet(node2.input) || $5bfbddba281c0a5f$require$isGet(node2.through) || node2), Object.assign({}, node1, {
        out: [].concat(node1.out || [], [
            node2
        ])
    })) : node1;
const $5bfbddba281c0a5f$var$disconnect = (node1, node2)=>// (console.log('dissconnecting', node1, node2)),
    node1.out.indexOf(node2) > -1 ? ($5bfbddba281c0a5f$require$_disconnect(// input
    $5bfbddba281c0a5f$require$isGet(node1.output) || $5bfbddba281c0a5f$require$isGet(node1.through) || $5bfbddba281c0a5f$require$isSet(node1.connect) && node1, // output
    node2 instanceof AudioParam && node2 || $5bfbddba281c0a5f$require$isGet(node2.input) || $5bfbddba281c0a5f$require$isGet(node2.through) || node2), Object.assign({}, node1, {
        out: [].concat(node1.out.slice(0, node1.out.indexOf(node2)), node1.out.slice(node1.out.indexOf(node2) + 1))
    })) : typeof node2 === 'undefined' ? node1.out.reduce((node1, prevNode)=>$5bfbddba281c0a5f$var$disconnect(node1, prevNode), node1) : node1;
const $5bfbddba281c0a5f$var$reroute = (node1, node2)=>node1.out && node1.out.indexOf(node2) === -1 ? $5bfbddba281c0a5f$var$connect($5bfbddba281c0a5f$var$disconnect(node1), node2) : node1;
const $5bfbddba281c0a5f$var$chain = (...nodes)=>(nodes.forEach((n, i)=>$5bfbddba281c0a5f$require$isSet(n[i + 1]) && $5bfbddba281c0a5f$var$connect(n, nodes[i + 1])), nodes[0]);
const $5bfbddba281c0a5f$var$unchain = (...nodes)=>(nodes.slice().reverse().forEach((n, i)=>$5bfbddba281c0a5f$require$isSet(n[i - 1]) && $5bfbddba281c0a5f$var$disconnect(nodes[i - 1], n)), nodes[0]);
const $5bfbddba281c0a5f$var$start = (node, ...args)=>(node.type === 'lfo' ? $599rR.start(node, ...args) : node.source ? node.source.start(...args) : node.output.start(...args), node);
const $5bfbddba281c0a5f$var$stop = (node, ...args)=>(node.source ? node.source.stop(...args) : node.output.stop(...args), node);
const $5bfbddba281c0a5f$var$schedule = (node, pref, values, times)=>values.length === 1 ? node.through[pref].setValueAtTime(values[0], times[0]) : (node.through[pref].setValueCurveAtTime(new Float32Array(values.slice(0, 2)), times[0], times[1]), values.length > 2 && $5bfbddba281c0a5f$var$schedule(node, pref, values.slice(1), [
        times[0] + times[1]
    ].concat(times.slice(2))));
const $5bfbddba281c0a5f$var$noteToFrequency = function(note) {
    var notes = [
        'A',
        'A#',
        'B',
        'C',
        'C#',
        'D',
        'D#',
        'E',
        'F',
        'F#',
        'G',
        'G#'
    ];
    var keyNumber;
    var octave;
    if (note.length === 3) octave = note.charAt(2);
    else octave = note.charAt(1);
    keyNumber = notes.indexOf(note.slice(0, -1));
    if (keyNumber < 3) keyNumber = keyNumber + 12 + (octave - 1) * 12 + 1;
    else keyNumber = keyNumber + (octave - 1) * 12 + 1;
    return 440 * Math.pow(2, (keyNumber - 49) / 12);
};
module.exports = {
    context: $5bfbddba281c0a5f$require$context,
    create: $5bfbddba281c0a5f$var$create,
    update: $5bfbddba281c0a5f$var$update,
    schedule: $5bfbddba281c0a5f$var$schedule,
    connect: $5bfbddba281c0a5f$var$connect,
    disconnect: $5bfbddba281c0a5f$var$disconnect,
    reroute: $5bfbddba281c0a5f$var$reroute,
    chain: $5bfbddba281c0a5f$var$chain,
    unchain: $5bfbddba281c0a5f$var$unchain,
    noteToFrequency: $5bfbddba281c0a5f$var$noteToFrequency,
    start: $5bfbddba281c0a5f$var$start,
    stop: $5bfbddba281c0a5f$var$stop,
    vco: (prefs)=>$5bfbddba281c0a5f$var$update($5bfbddba281c0a5f$var$create('vco', {}, $5bfbddba281c0a5f$require$context), prefs),
    vcf: (prefs)=>$5bfbddba281c0a5f$var$update($5bfbddba281c0a5f$var$create('vcf', {}, $5bfbddba281c0a5f$require$context), prefs),
    lfo: (prefs)=>$5bfbddba281c0a5f$var$update($5bfbddba281c0a5f$var$create('lfo', {}, $5bfbddba281c0a5f$require$context), prefs),
    vca: (prefs)=>$5bfbddba281c0a5f$var$update($5bfbddba281c0a5f$var$create('vca', {}, $5bfbddba281c0a5f$require$context), prefs),
    adsr: (prefs)=>$5bfbddba281c0a5f$var$create('adsr', prefs, $5bfbddba281c0a5f$require$context),
    noteOn: $9p9bV.noteOn,
    noteOff: $9p9bV.noteOff
};

});
parcelRegister("btdM1", function(module, exports) {
'use strict';

var $jjnZg = parcelRequire("jjnZg");
var $859d1644c16717b3$require$obj = $jjnZg.obj;
var $859d1644c16717b3$require$fn = $jjnZg.fn;
const $859d1644c16717b3$var$context = new (window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.oAudioContext || window.msAudioContext)();
const $859d1644c16717b3$var$set = (o, k, v)=>o[k] = v;
const $859d1644c16717b3$var$isSet = (v)=>v !== undefined;
const $859d1644c16717b3$var$isGet = (v)=>$859d1644c16717b3$var$isSet(v) ? v : null;
const $859d1644c16717b3$var$apply = (o1, o2)=>Object.keys(o2).reduce((o, k)=>$859d1644c16717b3$var$set(o, k, o2[k]), o1);
const $859d1644c16717b3$var$create = (type, ...args)=>// console.log(type),
    $859d1644c16717b3$require$obj.switch(type, {
        oscillator: ()=>$859d1644c16717b3$var$context.createOscillator(...args),
        gain: ()=>$859d1644c16717b3$var$context.createGain(...args),
        biquadFilter: ()=>$859d1644c16717b3$var$context.createBiquadFilter(...args),
        convolver: ()=>$859d1644c16717b3$var$context.createConvolver(...args),
        buffer: ()=>$859d1644c16717b3$var$context.createBuffer(...args),
        bufferSource: ()=>$859d1644c16717b3$var$context.createBufferSource(...args)
    })();
const $859d1644c16717b3$var$update = (node, prefs)=>$859d1644c16717b3$var$apply(node, prefs);
const $859d1644c16717b3$var$connect = (n1, n2)=>// console.log(n1, n2),
    (n1.connect(n2), n1);
const $859d1644c16717b3$var$disconnect = (n1, n2)=>{
    // since there is no way to determine if they are connected
    try {
        n1.disconnect(n2);
    } catch (err) {
        console.log(err);
    }
    return n1;
};
const $859d1644c16717b3$var$chain = (...nodes)=>(nodes.forEach((n, i)=>$859d1644c16717b3$var$isSet(nodes[i + 1]) && $859d1644c16717b3$var$connect(n, nodes[i + 1])), nodes[0]);
const $859d1644c16717b3$var$unchain = (...nodes)=>(nodes.slice().reverse().forEach((n, i)=>$859d1644c16717b3$var$isSet(nodes[i - 1]) && $859d1644c16717b3$var$disconnect(nodes[i - 1], n)), nodes[0]);
const $859d1644c16717b3$var$duration = (seconds)=>$859d1644c16717b3$var$context.sampleRate * seconds;
const $859d1644c16717b3$var$chData = (node, ...args)=>// console.log(node, args),
    node.getChannelData(...args);
const $859d1644c16717b3$var$schedule = (node, pref, values, times)=>values.length === 1 ? node[pref].setValueAtTime(values[0], times[0]) : (node[pref].setValueCurveAtTime(new Float32Array(values.slice(0, 2)), times[0], times[1]), values.length > 2 && $859d1644c16717b3$var$schedule(node, pref, values.slice(1), [
        times[0] + times[1]
    ].concat(times.slice(2))));
module.exports = {
    context: $859d1644c16717b3$var$context,
    set: $859d1644c16717b3$var$set,
    isSet: $859d1644c16717b3$var$isSet,
    isGet: $859d1644c16717b3$var$isGet,
    create: $859d1644c16717b3$var$create,
    update: $859d1644c16717b3$var$update,
    connect: $859d1644c16717b3$var$connect,
    disconnect: $859d1644c16717b3$var$disconnect,
    chain: $859d1644c16717b3$var$chain,
    unchain: $859d1644c16717b3$var$unchain,
    duration: // util
    $859d1644c16717b3$var$duration,
    chData: $859d1644c16717b3$var$chData,
    schedule: $859d1644c16717b3$var$schedule
};

});

parcelRegister("eOfJT", function(module, exports) {
'use strict';

var $jjnZg = parcelRequire("jjnZg");
var $ac81f1a84cf7a39c$require$obj = $jjnZg.obj;
var $ac81f1a84cf7a39c$require$fn = $jjnZg.fn;

var $btdM1 = parcelRequire("btdM1");
var $ac81f1a84cf7a39c$require$context = $btdM1.context;
var $ac81f1a84cf7a39c$require$_create = $btdM1.create;
var $ac81f1a84cf7a39c$require$set = $btdM1.set;
var $ac81f1a84cf7a39c$require$chain = $btdM1.chain;
var $ac81f1a84cf7a39c$require$duration = $btdM1.duration;
var $ac81f1a84cf7a39c$require$chData = $btdM1.chData;
// const {context} = core;
const $ac81f1a84cf7a39c$var$buildImpulse = ({ seconds: seconds, decay: decay })=>{
    let impulse = $ac81f1a84cf7a39c$require$_create('buffer', 2, $ac81f1a84cf7a39c$require$duration(seconds), $ac81f1a84cf7a39c$require$context.sampleRate);
    let channelData = [
        $ac81f1a84cf7a39c$require$chData(impulse, 0),
        $ac81f1a84cf7a39c$require$chData(impulse, 1)
    ];
    for(let i = 0; i < $ac81f1a84cf7a39c$require$duration(seconds); i++){
        channelData[0][i] = (Math.random() * 2 - 1) * Math.pow(1 - i / $ac81f1a84cf7a39c$require$duration(seconds), decay);
        channelData[1][i] = (Math.random() * 2 - 1) * Math.pow(1 - i / $ac81f1a84cf7a39c$require$duration(seconds), decay);
    }
    return impulse;
};
const $ac81f1a84cf7a39c$var$create = (prefs)=>[
        {
            prefs: Object.assign({
                seconds: 3,
                decay: 2,
                wet: 0,
                dry: 1
            }, prefs),
            input: $ac81f1a84cf7a39c$require$_create('gain'),
            output: $ac81f1a84cf7a39c$require$_create('gain'),
            effect: $ac81f1a84cf7a39c$require$_create('convolver'),
            wet: $ac81f1a84cf7a39c$require$_create('gain'),
            dry: $ac81f1a84cf7a39c$require$_create('gain')
        }
    ].map((n)=>($ac81f1a84cf7a39c$require$chain(n.input, n.dry, n.output), $ac81f1a84cf7a39c$require$chain(n.input, n.effect, n.wet, n.output), $ac81f1a84cf7a39c$require$set(n.dry.gain, 'value', n.prefs.dry), $ac81f1a84cf7a39c$require$set(n.wet.gain, 'value', n.prefs.wet), $ac81f1a84cf7a39c$require$set(n.effect, 'buffer', $ac81f1a84cf7a39c$var$buildImpulse(n.prefs)), n)).pop();
const $ac81f1a84cf7a39c$var$update = (n, prefs)=>(//	console.log(prefs, n.prefs),
    (n.prefs.seconds !== prefs.seconds || n.prefs.decay !== prefs.decay) && $ac81f1a84cf7a39c$require$set(n.effect, 'buffer', $ac81f1a84cf7a39c$var$buildImpulse(n.prefs)), n.prefs.dry !== prefs.dry && $ac81f1a84cf7a39c$require$set(n.dry.gain, 'value', prefs.dry), n.prefs.wet !== prefs.wet && $ac81f1a84cf7a39c$require$set(n.wet.gain, 'value', prefs.wet), $ac81f1a84cf7a39c$require$set(n, 'prefs', Object.assign({}, n.prefs, prefs)), n);
module.exports = {
    create: $ac81f1a84cf7a39c$var$create,
    update: $ac81f1a84cf7a39c$var$update
};

});

parcelRegister("599rR", function(module, exports) {
'use strict';

var $jjnZg = parcelRequire("jjnZg");
var $3bf51f3dcffbdd64$require$obj = $jjnZg.obj;
var $3bf51f3dcffbdd64$require$fn = $jjnZg.fn;

var $btdM1 = parcelRequire("btdM1");
var $3bf51f3dcffbdd64$require$context = $btdM1.context;
var $3bf51f3dcffbdd64$require$_create = $btdM1.create;
var $3bf51f3dcffbdd64$require$set = $btdM1.set;
var $3bf51f3dcffbdd64$require$chain = $btdM1.chain;
var $3bf51f3dcffbdd64$require$duration = $btdM1.duration;
var $3bf51f3dcffbdd64$require$chData = $btdM1.chData;
const $3bf51f3dcffbdd64$var$create = (prefs)=>[
        {
            prefs: Object.assign({
                type: 'sawtooth',
                frequency: 5,
                gain: 15
            }, prefs),
            effect: $3bf51f3dcffbdd64$require$_create('oscillator'),
            output: $3bf51f3dcffbdd64$require$_create('gain')
        }
    ].map((n)=>($3bf51f3dcffbdd64$require$chain(n.effect, n.output), $3bf51f3dcffbdd64$require$set(n.effect.frequency, 'value', n.prefs.frequency), $3bf51f3dcffbdd64$require$set(n.output.gain, 'value', n.prefs.gain), $3bf51f3dcffbdd64$require$set(n.effect, 'type', n.prefs.type), n)).pop();
const $3bf51f3dcffbdd64$var$update = (n, prefs)=>($3bf51f3dcffbdd64$require$set(n, 'prefs', Object.assign({}, n.prefs, prefs)), $3bf51f3dcffbdd64$require$set(n.effect.frequency, 'value', n.prefs.frequency), $3bf51f3dcffbdd64$require$set(n.output.gain, 'value', n.prefs.gain), $3bf51f3dcffbdd64$require$set(n.effect, 'type', n.prefs.type), n);
const $3bf51f3dcffbdd64$var$start = (n, ...args)=>(n.effect.start(), n);
// const clone = n => create(null, n.output.buffer);
module.exports = {
    create: $3bf51f3dcffbdd64$var$create,
    update: $3bf51f3dcffbdd64$var$update,
    start: $3bf51f3dcffbdd64$var$start
};

});

parcelRegister("9p9bV", function(module, exports) {
'use strict';

var $jjnZg = parcelRequire("jjnZg");
var $6d8d940a60463784$require$obj = $jjnZg.obj;
var $6d8d940a60463784$require$fn = $jjnZg.fn;

var $btdM1 = parcelRequire("btdM1");
var $6d8d940a60463784$require$context = $btdM1.context;
var $6d8d940a60463784$require$_create = $btdM1.create;
var $6d8d940a60463784$require$set = $btdM1.set;
var $6d8d940a60463784$require$chain = $btdM1.chain;
var $6d8d940a60463784$require$duration = $btdM1.duration;
var $6d8d940a60463784$require$chData = $btdM1.chData;
var $6d8d940a60463784$require$schedule = $btdM1.schedule;
const $6d8d940a60463784$var$create = (prefs)=>[
        {
            prefs: Object.assign({
                volume: 0.41,
                attack: 0.31,
                decay: 0.16,
                sustain: 0.8,
                release: 0.21
            }, prefs),
            through: $6d8d940a60463784$require$_create('gain')
        }
    ].map((n)=>($6d8d940a60463784$require$set(n.through.gain, 'value', 0), n)).pop();
const $6d8d940a60463784$var$update = (n, prefs)=>($6d8d940a60463784$require$set(n, 'prefs', Object.assign({}, n.prefs, prefs)), n);
const $6d8d940a60463784$var$noteOn = (node, velocity, time)=>{
    const now = $6d8d940a60463784$require$context.currentTime;
    time = (time || now) + 0.0001;
    node.through.gain.cancelScheduledValues(0);
    const changes = [].concat(// attack
    node.prefs.attack > 0 ? [
        [
            0,
            time
        ],
        [
            velocity * node.prefs.volume,
            node.prefs.attack
        ]
    ] : [
        [
            velocity * node.prefs.volume,
            time
        ]
    ], // decay
    node.prefs.decay > 0 ? [
        [
            node.prefs.sustain * velocity * node.prefs.volume,
            node.prefs.decay
        ]
    ] : []).reduce((a, c)=>[
            [].concat(a[0], c[0]),
            [].concat(a[1], c[1])
        ], [
        [],
        []
    ]);
    $6d8d940a60463784$require$schedule(node.through, 'gain', changes[0], changes[1]);
    return node;
};
const $6d8d940a60463784$var$noteOff = (node, time)=>{
    const now = $6d8d940a60463784$require$context.currentTime;
    time = time || now + 0.0001;
    setTimeout(()=>(node.through.gain.cancelScheduledValues(0), node.through.gain.setValueCurveAtTime(new Float32Array([
            node.through.gain.value,
            0
        ]), time, node.prefs.release > 0 && node.prefs.release || 0.00001)), (time - now) * 1000);
    return node;
};
module.exports = {
    create: $6d8d940a60463784$var$create,
    update: $6d8d940a60463784$var$update,
    noteOn: $6d8d940a60463784$var$noteOn,
    noteOff: $6d8d940a60463784$var$noteOff
};

});


parcelRegister("5oOrw", function(module, exports) {
'use strict';

var $1VO3A = parcelRequire("1VO3A");
var $3ee6528daf1351b0$require$header = $1VO3A.header;
var $3ee6528daf1351b0$require$section = $1VO3A.section;
var $3ee6528daf1351b0$require$button = $1VO3A.button;
var $3ee6528daf1351b0$require$span = $1VO3A.span;
var $3ee6528daf1351b0$require$h1 = $1VO3A.h1;
var $3ee6528daf1351b0$require$h4 = $1VO3A.h4;
var $3ee6528daf1351b0$require$i = $1VO3A.i;
var $3ee6528daf1351b0$require$hr = $1VO3A.hr;
var $3ee6528daf1351b0$require$canvas = $1VO3A.canvas;
var $3ee6528daf1351b0$require$input = $1VO3A.input;
var $3ee6528daf1351b0$require$img = $1VO3A.img;
var $3ee6528daf1351b0$require$fieldset = $1VO3A.fieldset;
var $3ee6528daf1351b0$require$legend = $1VO3A.legend;
var $3ee6528daf1351b0$require$label = $1VO3A.label;
var $3ee6528daf1351b0$require$select = $1VO3A.select;
var $3ee6528daf1351b0$require$option = $1VO3A.option;

var $7TCVA = parcelRequire("7TCVA");
var $3ee6528daf1351b0$require$context = $7TCVA.context;

var $jjnZg = parcelRequire("jjnZg");
var $3ee6528daf1351b0$require$obj = $jjnZg.obj;
var $3ee6528daf1351b0$require$fn = $jjnZg.fn;
var $3ee6528daf1351b0$require$str = $jjnZg.str;
// components
// console.log(context.state);
const $3ee6528daf1351b0$var$recordModes = [
    'independent',
    'synced'
];
module.exports = ({ state: state, actions: actions })=>$3ee6528daf1351b0$require$header([
        $3ee6528daf1351b0$require$h1('JS Loop Station'),
        $3ee6528daf1351b0$require$button('.toggle.big[title="Monitor On/Off"]', {
            on: {
                click: ()=>actions.toggle('mic')
            }
        }, [
            $3ee6528daf1351b0$require$i({
                class: {
                    'fa': true,
                    'fa-microphone': state.mic,
                    'fa-microphone-slash': !state.mic
                }
            })
        ]),
        $3ee6528daf1351b0$require$button('.toggle[title="Audio Input On/Off"]', {
            on: {
                click: ()=>actions.toggle([
                        'audio',
                        'on'
                    ])
            }
        }, [
            $3ee6528daf1351b0$require$i({
                class: {
                    'fa': true,
                    'fa-toggle-on': state.audio.on,
                    'fa-toggle-off': !state.audio.on
                }
            }),
            $3ee6528daf1351b0$require$span('Audio Input')
        ]),
        $3ee6528daf1351b0$require$button('.toggle[title="Quantize On/Off"]', {
            on: {
                click: ()=>actions.toggle('quantize')
            }
        }, [
            $3ee6528daf1351b0$require$i({
                class: {
                    'fa': true,
                    'fa-check-square-o': state.quantize,
                    'fa-square-o': !state.quantize
                }
            }),
            $3ee6528daf1351b0$require$span('Quantize')
        ]),
        $3ee6528daf1351b0$require$button('.toggle[title="Record Mode"]', {
            on: {
                click: ()=>actions.set('recordMode', $3ee6528daf1351b0$var$recordModes[($3ee6528daf1351b0$var$recordModes.indexOf(state.recordMode) + 1) % $3ee6528daf1351b0$var$recordModes.length])
            }
        }, [
            $3ee6528daf1351b0$require$i('.fa.fa-dot-circle-o'),
            $3ee6528daf1351b0$require$span($3ee6528daf1351b0$require$str.capitalize(state.recordMode))
        ])
    ]);

});

parcelRegister("fFbkt", function(module, exports) {
'use strict';

var $1VO3A = parcelRequire("1VO3A");
var $b673791ca81818a7$require$header = $1VO3A.header;
var $b673791ca81818a7$require$section = $1VO3A.section;
var $b673791ca81818a7$require$button = $1VO3A.button;
var $b673791ca81818a7$require$span = $1VO3A.span;
var $b673791ca81818a7$require$h1 = $1VO3A.h1;
var $b673791ca81818a7$require$h4 = $1VO3A.h4;
var $b673791ca81818a7$require$i = $1VO3A.i;
var $b673791ca81818a7$require$hr = $1VO3A.hr;
var $b673791ca81818a7$require$canvas = $1VO3A.canvas;
var $b673791ca81818a7$require$input = $1VO3A.input;
var $b673791ca81818a7$require$img = $1VO3A.img;
var $b673791ca81818a7$require$fieldset = $1VO3A.fieldset;
var $b673791ca81818a7$require$legend = $1VO3A.legend;
var $b673791ca81818a7$require$label = $1VO3A.label;
var $b673791ca81818a7$require$select = $1VO3A.select;
var $b673791ca81818a7$require$option = $1VO3A.option;

var $7TCVA = parcelRequire("7TCVA");
var $b673791ca81818a7$require$context = $7TCVA.context;

var $jjnZg = parcelRequire("jjnZg");
var $b673791ca81818a7$require$obj = $jjnZg.obj;
var $b673791ca81818a7$require$fn = $jjnZg.fn;
var $b673791ca81818a7$require$str = $jjnZg.str;
// components
module.exports = ({ state: state, actions: actions })=>$b673791ca81818a7$require$fieldset('.audio', [
        $b673791ca81818a7$require$legend($b673791ca81818a7$require$i('.fa.fa-microphone')),
        $b673791ca81818a7$require$label('Input'),
        $b673791ca81818a7$require$select(`[name="audioDevice0"]`, {
            props: {
                value: state.audio.deviceInputs[0]
            },
            on: {
                change: (ev)=>actions.set([
                        'audio',
                        'deviceInputs',
                        0
                    ], ev.target.value)
            }
        }, [].concat(state.audio.devices.map((device, k)=>$b673791ca81818a7$require$option(`[value="${device.deviceId}"]`, {
                attrs: {
                    selected: device.deviceId === state.audio.deviceInputs[0]
                }
            }, device.label)))),
        $b673791ca81818a7$require$select(`[name="audioDevice1"]`, {
            props: {
                value: state.audio.deviceInputs[1]
            },
            on: {
                change: (ev)=>actions.set([
                        'audio',
                        'deviceInputs',
                        1
                    ], ev.target.value)
            }
        }, [].concat(state.audio.devices.map((device, k)=>$b673791ca81818a7$require$option(`[value="${device.deviceId}"]`, {
                attrs: {
                    selected: device.deviceId === state.audio.deviceInputs[1]
                }
            }, device.label)))),
        $b673791ca81818a7$require$select(`[name="audioDevice2"]`, {
            props: {
                value: state.audio.deviceInputs[2]
            },
            on: {
                change: (ev)=>actions.set([
                        'audio',
                        'deviceInputs',
                        2
                    ], ev.target.value)
            }
        }, [].concat(state.audio.devices.map((device, k)=>$b673791ca81818a7$require$option(`[value="${device.deviceId}"]`, {
                attrs: {
                    selected: device.deviceId === state.audio.deviceInputs[2]
                }
            }, device.label)))),
        $b673791ca81818a7$require$select(`[name="audioDevice3"]`, {
            props: {
                value: state.audio.deviceInputs[3]
            },
            on: {
                change: (ev)=>actions.set([
                        'audio',
                        'deviceInputs',
                        3
                    ], ev.target.value)
            }
        }, [].concat(state.audio.devices.map((device, k)=>$b673791ca81818a7$require$option(`[value="${device.deviceId}"]`, {
                attrs: {
                    selected: device.deviceId === state.audio.deviceInputs[3]
                }
            }, device.label))))
    ]);

});

parcelRegister("5tckQ", function(module, exports) {
'use strict';

var $1VO3A = parcelRequire("1VO3A");
var $3fb93ab1dc1fe7be$require$header = $1VO3A.header;
var $3fb93ab1dc1fe7be$require$section = $1VO3A.section;
var $3fb93ab1dc1fe7be$require$button = $1VO3A.button;
var $3fb93ab1dc1fe7be$require$span = $1VO3A.span;
var $3fb93ab1dc1fe7be$require$h1 = $1VO3A.h1;
var $3fb93ab1dc1fe7be$require$h4 = $1VO3A.h4;
var $3fb93ab1dc1fe7be$require$i = $1VO3A.i;
var $3fb93ab1dc1fe7be$require$hr = $1VO3A.hr;
var $3fb93ab1dc1fe7be$require$canvas = $1VO3A.canvas;
var $3fb93ab1dc1fe7be$require$input = $1VO3A.input;
var $3fb93ab1dc1fe7be$require$img = $1VO3A.img;
var $3fb93ab1dc1fe7be$require$fieldset = $1VO3A.fieldset;
var $3fb93ab1dc1fe7be$require$legend = $1VO3A.legend;
var $3fb93ab1dc1fe7be$require$label = $1VO3A.label;
var $3fb93ab1dc1fe7be$require$select = $1VO3A.select;
var $3fb93ab1dc1fe7be$require$option = $1VO3A.option;

var $7TCVA = parcelRequire("7TCVA");
var $3fb93ab1dc1fe7be$require$context = $7TCVA.context;

var $jjnZg = parcelRequire("jjnZg");
var $3fb93ab1dc1fe7be$require$obj = $jjnZg.obj;
var $3fb93ab1dc1fe7be$require$fn = $jjnZg.fn;
var $3fb93ab1dc1fe7be$require$str = $jjnZg.str;
// components
module.exports = ({ state: state, actions: actions })=>$3fb93ab1dc1fe7be$require$fieldset('.midi', [
        $3fb93ab1dc1fe7be$require$legend($3fb93ab1dc1fe7be$require$img(`[src="assets/midi.svg"]`)),
        $3fb93ab1dc1fe7be$require$label('Input'),
        $3fb93ab1dc1fe7be$require$select(`[name="device"]`, {
            props: {
                value: state.midi.device
            },
            on: {
                change: (ev)=>actions.set([
                        'midi',
                        'device'
                    ], ev.target.value)
            }
        }, [].concat($3fb93ab1dc1fe7be$require$option(`[value="-1"]`, {
            attrs: {
                selected: state.midi.device === '-1'
            }
        }, 'Any device'), ($3fb93ab1dc1fe7be$require$obj.sub(state, [
            'midi',
            'devices',
            'inputs'
        ]) || []).map((device, k)=>$3fb93ab1dc1fe7be$require$option(`[value="${device.id}"]`, {
                attrs: {
                    selected: device.id === state.midi.device
                }
            }, device.name)))),
        $3fb93ab1dc1fe7be$require$label('Channel'),
        $3fb93ab1dc1fe7be$require$input(`[name="channel"][type="number"][size="3"]`, {
            props: {
                value: state.midi.channel
            },
            on: {
                input: (ev)=>actions.set([
                        'midi',
                        'channel'
                    ], parseInt(ev.target.value, 10))
            }
        }),
        $3fb93ab1dc1fe7be$require$button('.right', {
            class: {
                on: state.midi.setup
            },
            on: {
                click: ()=>actions.toggle([
                        'midi',
                        'setup'
                    ])
            }
        }, $3fb93ab1dc1fe7be$require$i('.fa.fa-sliders'))
    ]);

});

parcelRegister("Wucal", function(module, exports) {
'use strict';

var $7TCVA = parcelRequire("7TCVA");

var $1VO3A = parcelRequire("1VO3A");
var $0afcd709549b9a91$require$section = $1VO3A.section;
var $0afcd709549b9a91$require$button = $1VO3A.button;
var $0afcd709549b9a91$require$span = $1VO3A.span;
var $0afcd709549b9a91$require$i = $1VO3A.i;
var $0afcd709549b9a91$require$input = $1VO3A.input;
const $0afcd709549b9a91$var$calcProgress = (start, current, duration)=>(current - start) % duration / duration * 100;
module.exports = ({ params: params, chan: chan, actions: actions })=>$0afcd709549b9a91$require$section('.channel', [
        $0afcd709549b9a91$require$button('.stop', {
            on: {
                click: ()=>actions.stop(chan),
                dblclick: ()=>actions.clear(chan)
            }
        }, [
            $0afcd709549b9a91$require$i('.fa.fa-stop')
        ]),
        $0afcd709549b9a91$require$input('.vertical[type="range"]', {
            attrs: {
                min: 0,
                max: 1,
                step: 0.01
            },
            props: {
                value: params.gain
            }
        }),
        $0afcd709549b9a91$require$button('.play-rec.record', {
            style: {
                '--pgPercentage': params.process === 'play' ? $0afcd709549b9a91$var$calcProgress(params.startedAt, $7TCVA.context.currentTime, params.duration) : 0
            },
            class: {
                play: params.process === 'play',
                record: params.process === 'record',
                overdub: params.process === 'overdub'
            },
            on: {
                click: ()=>actions.playRec(chan, $7TCVA.context.currentTime)
            }
        }, '')
    ]);

});


parcelRegister("aBnNP", function(module, exports) {
'use strict';

var $cI1ok = parcelRequire("cI1ok");
const $7b7fd2ce1b08b388$var$$ = $cI1ok.Observable;

var $6Df1y = parcelRequire("6Df1y");

var $kKA2u = parcelRequire("kKA2u");
let $7b7fd2ce1b08b388$var$unhook = ()=>{};
const $7b7fd2ce1b08b388$var$hook = ({ state$: state$, actions: actions })=>{
    let subs = [];
    const analyser$ = $kKA2u.stream.distinctUntilChanged((p)=>p.analyser).filter((p)=>p.analyser).map((pocket)=>pocket.analyser);
    $7b7fd2ce1b08b388$var$$.interval(100).map(()=>document.querySelector('#visual')).withLatestFrom(state$, analyser$, (el, state, analyser)=>({
            el: el,
            state: state,
            analyser: analyser
        })).distinctUntilChanged(({ el: el, state: state, analyser: analyser })=>el + state.audio + analyser).filter(({ el: el, state: state, analyser: analyser })=>el && state.audio && analyser).subscribe(({ el: el, analyser: analyser })=>{
        $6Df1y.visualize(analyser, el.getContext('2d'));
    });
    $7b7fd2ce1b08b388$var$unhook = ()=>subs.forEach((sub)=>sub.unsubscribe());
};
module.exports = {
    hook: $7b7fd2ce1b08b388$var$hook,
    unhook: $7b7fd2ce1b08b388$var$unhook
};

});
parcelRegister("cI1ok", function(module, exports) {

var $kTZM9 = parcelRequire("kTZM9");
parcelRequire("9Jej3");
parcelRequire("h0tkF");
parcelRequire("j0Xoo");
parcelRequire("8XdE1");
parcelRequire("eQzqz");
parcelRequire("e1JUm");
parcelRequire("iCqie");
parcelRequire("iUbYX");
parcelRequire("5kQMv");
parcelRequire("7kgSk");
parcelRequire("5QABN");
module.exports = $kTZM9;

});

parcelRegister("6Df1y", function(module, exports) {
'use strict';
parcelRequire("aklHV");

var $7TCVA = parcelRequire("7TCVA");
var $4d420a124a66418f$require$audioContext = $7TCVA.context;
const $4d420a124a66418f$var$clear = (ctx)=>ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.width);
const $4d420a124a66418f$var$visualize = (analyser, ctx)=>{
    const visualSetting = 'sinewave';
    ctx.canvas.width = ctx.canvas.offsetWidth;
    ctx.canvas.height = ctx.canvas.offsetHeight;
    if (visualSetting === "sinewave") {
        analyser.fftSize = 2048;
        let bufferLength = analyser.fftSize;
        console.log(bufferLength);
        let dataArray = new Uint8Array(bufferLength);
        $4d420a124a66418f$var$clear(ctx);
        const draw = ()=>{
            let drawVisual = requestAnimationFrame(draw);
            analyser.getByteTimeDomainData(dataArray);
            // ctx.fillStyle = '#f7f8ff';
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            // ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            ctx.lineWidth = 2;
            ctx.strokeStyle = 'rgb(0, 0, 0)';
            ctx.beginPath();
            var sliceWidth = Number(ctx.canvas.width) * 1.0 / bufferLength;
            var x = 0;
            for(let i = 0; i < bufferLength; i++){
                var v = dataArray[i] / 128.0;
                var y = v * ctx.canvas.height / 2;
                if (i === 0) ctx.moveTo(x, y);
                else ctx.lineTo(x, y);
                x += sliceWidth;
            }
            ctx.lineTo(ctx.canvas.width, ctx.canvas.height / 2);
            ctx.stroke();
        };
        draw();
    }
};
module.exports = {
    visualize: $4d420a124a66418f$var$visualize
};

});
parcelRegister("aklHV", function(module, exports) {
"use strict";

var $eLP1g = parcelRequire("eLP1g");
module.exports = $eLP1g;

});
parcelRegister("eLP1g", function(module, exports) {
"use strict";

var $6gNd7 = parcelRequire("6gNd7");
/**
 * Creates a working WaveformData based on binary audio data.
 *
 * This is still quite experimental and the result will mostly depend on the
 * level of browser support.
 *
 * ```javascript
 * const xhr = new XMLHttpRequest();
 * const audioContext = new AudioContext();
 *
 * // URL of a CORS MP3/Ogg file
 * xhr.open('GET', 'https://example.com/audio/track.ogg');
 * xhr.responseType = 'arraybuffer';
 *
 * xhr.addEventListener('load', function(progressEvent) {
 *   WaveformData.builders.webaudio(audioContext, progressEvent.target.response,
 *     function(err, waveform) {
 *     if (err) {
 *       console.error(err);
 *       return;
 *     }
 *
 *     console.log(waveform.duration);
 *   });
 * });
 *
 * xhr.send();
 * ```
 *
 * @todo use a Web Worker to offload processing of the binary data
 * @todo or use `SourceBuffer.appendBuffer` and `ProgressEvent` to stream the decoding
 * @todo abstract the number of channels, because it is assumed the audio file is stereo
 * @param {AudioContext|webkitAudioContext} audio_context
 * @param {ArrayBuffer} raw_response
 * @param {callback} what to do once the decoding is done
 * @constructor
 */ function $ac0d07db9ef10e9e$var$fromAudioObjectBuilder(audio_context, raw_response, options, callback) {
    var audioContext = window.AudioContext || window.webkitAudioContext;
    var defaultOptions = {
        scale: 512,
        amplitude_scale: 1.0
    };
    if (!(audio_context instanceof audioContext)) throw new TypeError("First argument should be an AudioContext instance");
    // fromAudioObjectBuilder(audioContext, data, callback) form
    if (typeof options === "function") {
        callback = options;
        options = {};
    } else options = options || {};
    options.scale = options.scale || defaultOptions.scale;
    options.amplitude_scale = options.amplitude_scale || defaultOptions.amplitude_scale;
    if (options.hasOwnProperty("scale_adjuster")) throw new Error("Please rename the 'scale_adjuster' option to 'amplitude_scale'");
    // The following function is a workaround for a Webkit bug where decodeAudioData
    // invokes the errorCallback with null instead of a DOMException.
    // See https://webaudio.github.io/web-audio-api/#dom-baseaudiocontext-decodeaudiodata
    // and http://stackoverflow.com/q/10365335/103396
    function errorCallback(error) {
        if (!error) error = new DOMException("EncodingError");
        callback(error);
    }
    return audio_context.decodeAudioData(raw_response, $6gNd7(options, callback), errorCallback);
}
module.exports = $ac0d07db9ef10e9e$var$fromAudioObjectBuilder;

});
parcelRegister("6gNd7", function(module, exports) {
"use strict";

var $jblUm = parcelRequire("jblUm");

var $edmRl = parcelRequire("edmRl");
/**
 * This callback is executed once the audio has been decoded by the browser and
 * resampled by waveform-data.
 *
 * @callback onAudioResampled
 * @param {WaveformData} waveform_data Waveform instance of the browser decoded audio
 * @param {AudioBuffer} audio_buffer Decoded audio buffer
 */ /**
 * AudioBuffer-based WaveformData generator
 *
 * Adapted from BlockFile::CalcSummary in Audacity, with permission.
 * @see https://code.google.com/p/audacity/source/browse/audacity-src/trunk/src/BlockFile.cpp
 *
 * @param {Object.<{scale: Number, amplitude_scale: Number}>} options
 * @param {onAudioResampled} callback
 * @returns {Function.<AudioBuffer>}
 */ function $490a68ec2ab687ea$var$getAudioDecoder(options, callback) {
    return function onAudioDecoded(audio_buffer) {
        var worker = new $edmRl(function() {
            var INT8_MAX = 127;
            var INT8_MIN = -128;
            function calculateWaveformDataLength(audio_sample_count, scale) {
                var data_length = Math.floor(audio_sample_count / scale);
                var samples_remaining = audio_sample_count - data_length * scale;
                if (samples_remaining > 0) data_length++;
                return data_length;
            }
            this.addEventListener("message", function(evt) {
                var scale = evt.data.scale;
                var amplitude_scale = evt.data.amplitude_scale;
                var audio_buffer = evt.data.audio_buffer;
                var data_length = calculateWaveformDataLength(audio_buffer.length, scale);
                var header_size = 20;
                var data_object = new DataView(new ArrayBuffer(header_size + data_length * 2));
                var channels = audio_buffer.channels;
                var channel;
                var min_value = Infinity, max_value = -Infinity, scale_counter = 0;
                var buffer_length = audio_buffer.length;
                var offset = header_size;
                var i;
                data_object.setInt32(0, 1, true); // Version
                data_object.setUint32(4, 1, true); // Is 8 bit?
                data_object.setInt32(8, audio_buffer.sampleRate, true); // Sample rate
                data_object.setInt32(12, scale, true); // Scale
                data_object.setInt32(16, data_length, true); // Length
                for(i = 0; i < buffer_length; i++){
                    var sample = 0;
                    for(channel = 0; channel < channels.length; ++channel)sample += channels[channel][i];
                    sample = Math.floor(INT8_MAX * sample * amplitude_scale / channels.length);
                    if (sample < min_value) {
                        min_value = sample;
                        if (min_value < INT8_MIN) min_value = INT8_MIN;
                    }
                    if (sample > max_value) {
                        max_value = sample;
                        if (max_value > INT8_MAX) max_value = INT8_MAX;
                    }
                    if (++scale_counter === scale) {
                        data_object.setInt8(offset++, Math.floor(min_value));
                        data_object.setInt8(offset++, Math.floor(max_value));
                        min_value = Infinity;
                        max_value = -Infinity;
                        scale_counter = 0;
                    }
                }
                if (scale_counter > 0) {
                    data_object.setInt8(offset++, Math.floor(min_value));
                    data_object.setInt8(offset++, Math.floor(max_value));
                }
                this.postMessage(data_object);
            });
        });
        worker.addEventListener("message", function(evt) {
            var data_object = evt.data;
            callback(null, new $jblUm(data_object.buffer, $jblUm.adapters.arraybuffer), audio_buffer);
        });
        // Construct a simple object with the necessary AudioBuffer data,
        // as we cannot send an AudioBuffer to a Web Worker.
        var audio_buffer_obj = {
            length: audio_buffer.length,
            sampleRate: audio_buffer.sampleRate,
            channels: []
        };
        // Fill in the channels data.
        for(var channel = 0; channel < audio_buffer.numberOfChannels; ++channel)audio_buffer_obj.channels[channel] = audio_buffer.getChannelData(channel);
        worker.postMessage({
            scale: options.scale,
            amplitude_scale: options.amplitude_scale,
            audio_buffer: audio_buffer_obj
        });
    };
}
module.exports = $490a68ec2ab687ea$var$getAudioDecoder;

});
parcelRegister("jblUm", function(module, exports) {
"use strict";

var $kWDKC = parcelRequire("kWDKC");

$kWDKC.adapters = (parcelRequire("5IvAQ"));
module.exports = $kWDKC;

});
parcelRegister("kWDKC", function(module, exports) {
"use strict";

var $6TXix = parcelRequire("6TXix");

var $9HCGK = parcelRequire("9HCGK");
/**
 * Facade to iterate on audio waveform response.
 *
 * ```javascript
 * var waveform = new WaveformData({ ... }, WaveformData.adapters.object);
 *
 * var json_waveform = new WaveformData(xhr.responseText, WaveformData.adapters.object);
 *
 * var arraybuff_waveform = new WaveformData(
 *   getArrayBufferData(),
 *   WaveformData.adapters.arraybuffer
 * );
 * ```
 *
 * ## Offsets
 *
 * An **offset** is a non-destructive way to iterate on a subset of data.
 *
 * It is the easiest way to **navigate** through data without having to deal
 * with complex calculations. Simply iterate over the data to display them.
 *
 * *Notice*: the default offset is the entire set of data.
 *
 * @param {String|ArrayBuffer|Mixed} response_data Waveform data,
 *   to be consumed by the related adapter.
 * @param {WaveformData.adapter|Function} adapter Backend adapter used to manage
 *   access to the data.
 * @constructor
 */ function $f3f80f2772b5b069$var$WaveformData(response_data, adapter) {
    /**
   * Backend adapter used to manage access to the data.
   *
   * @type {Object}
   */ this.adapter = adapter.fromResponseData(response_data);
    /**
   * Defined segments.
   *
   * ```javascript
   * var waveform = new WaveformData({ ... }, WaveformData.adapters.object);
   *
   * console.log(waveform.segments.speakerA); // -> undefined
   *
   * waveform.set_segment(30, 90, "speakerA");
   *
   * console.log(waveform.segments.speakerA.start); // -> 30
   * ```
   *
   * @type {Object} A hash of `WaveformDataSegment` objects.
   */ this.segments = {};
    /**
   * Defined points.
   *
   * ```javascript
   * var waveform = new WaveformData({ ... }, WaveformData.adapters.object);
   *
   * console.log(waveform.points.speakerA); // -> undefined
   *
   * waveform.set_point(30, "speakerA");
   *
   * console.log(waveform.points.speakerA.timeStamp); // -> 30
   * ```
   *
   * @type {Object} A hash of `WaveformDataPoint` objects.
   */ this.points = {};
    this.offset(0, this.adapter.length);
}
/**
 * Creates an instance of WaveformData by guessing the adapter from the
 * data type. It can also accept an XMLHttpRequest response.
 *
 * ```javascript
 * var xhr = new XMLHttpRequest();
 * xhr.open("GET", "http://example.com/waveforms/track.dat");
 * xhr.responseType = "arraybuffer";
 *
 * xhr.addEventListener("load", function onResponse(progressEvent) {
 *   var waveform = WaveformData.create(progressEvent.target);
 *
 *   console.log(waveform.duration);
 * });
 *
 * xhr.send();
 * ```
 *
 * @static
 * @throws TypeError
 * @param {XMLHttpRequest|Mixed} data
 * @return {WaveformData}
 */ $f3f80f2772b5b069$var$WaveformData.create = function createFromResponseData(data) {
    var adapter = null;
    var xhrData = null;
    if (data && typeof data === "object" && ("responseText" in data || "response" in data)) xhrData = "responseType" in data ? data.response : data.responseText || data.response;
    Object.keys($f3f80f2772b5b069$var$WaveformData.adapters).some(function(adapter_id) {
        if ($f3f80f2772b5b069$var$WaveformData.adapters[adapter_id].isCompatible(xhrData || data)) {
            adapter = $f3f80f2772b5b069$var$WaveformData.adapters[adapter_id];
            return true;
        }
    });
    if (adapter === null) throw new TypeError("Could not detect a WaveformData adapter from the input.");
    return new $f3f80f2772b5b069$var$WaveformData(xhrData || data, adapter);
};
/**
 * Public API for the Waveform Data manager.
 *
 * @namespace WaveformData
 */ $f3f80f2772b5b069$var$WaveformData.prototype = {
    /**
   * Clamp an offset of data upon the whole response body.
   * Pros: it's just a reference, not a new array. So it's fast.
   *
   * ```javascript
   * var waveform = WaveformData.create({ ... });
   *
   * console.log(waveform.offset_length);   // -> 150
   * console.log(waveform.min[0]);          // -> -12
   *
   * waveform.offset(20, 50);
   *
   * console.log(waveform.min.length);      // -> 30
   * console.log(waveform.min[0]);          // -> -9
   * ```
   *
   * @param {Integer} start New beginning of the offset. (inclusive)
   * @param {Integer} end New ending of the offset (exclusive)
   */ offset: function(start, end) {
        var data_length = this.adapter.length;
        if (end < 0) throw new RangeError("End point must be non-negative [" + Number(end) + " < 0]");
        if (end < start) throw new RangeError("End point must not be before the start point [" + Number(end) + " < " + Number(start) + "]");
        if (start < 0) throw new RangeError("Start point must be non-negative [" + Number(start) + " < 0]");
        if (start >= data_length) throw new RangeError("Start point must be within range [" + Number(start) + " >= " + data_length + "]");
        if (end > data_length) end = data_length;
        this.offset_start = start;
        this.offset_end = end;
        this.offset_length = end - start;
    },
    /**
   * Creates a new segment of data.
   * Pretty handy if you need to bookmark a duration and display it according
   * to the current offset.
   *
   * ```javascript
   * var waveform = WaveformData.create({ ... });
   *
   * console.log(Object.keys(waveform.segments));          // -> []
   *
   * waveform.set_segment(10, 120);
   * waveform.set_segment(30, 90, "speakerA");
   *
   * console.log(Object.keys(waveform.segments));          // -> ['default', 'speakerA']
   * console.log(waveform.segments.default.min.length);    // -> 110
   * console.log(waveform.segments.speakerA.min.length);   // -> 60
   * ```
   *
   * @param {Integer} start Beginning of the segment (inclusive)
   * @param {Integer} end Ending of the segment (exclusive)
   * @param {String*} identifier Unique identifier. If nothing is specified,
   *   *default* will be used as a value.
   * @return {WaveformDataSegment}
   */ set_segment: function setSegment(start, end, identifier) {
        if (identifier === undefined || identifier === null || identifier.length === 0) identifier = "default";
        this.segments[identifier] = new $6TXix(this, start, end);
        return this.segments[identifier];
    },
    /**
   * Creates a new point of data.
   * Pretty handy if you need to bookmark a specific point and display it
   * according to the current offset.
   *
   * ```javascript
   * var waveform = WaveformData.create({ ... });
   *
   * console.log(Object.keys(waveform.points)); // -> []
   *
   * waveform.set_point(10);
   * waveform.set_point(30, "speakerA");
   *
   * console.log(Object.keys(waveform.points)); // -> ['default', 'speakerA']
   * ```
   *
   * @param {Integer} timeStamp the time to place the bookmark
   * @param {String*} identifier Unique identifier. If nothing is specified,
   *   *default* will be used as a value.
   * @return {WaveformDataPoint}
   */ set_point: function setPoint(timeStamp, identifier) {
        if (identifier === undefined || identifier === null || identifier.length === 0) identifier = "default";
        this.points[identifier] = new $9HCGK(this, timeStamp);
        return this.points[identifier];
    },
    /**
   * Removes a point of data.
   *
   * ```javascript
   * var waveform = WaveformData.create({ ... });
   *
   * console.log(Object.keys(waveform.points));          // -> []
   *
   * waveform.set_point(30, "speakerA");
   * console.log(Object.keys(waveform.points));          // -> ['speakerA']
   * waveform.remove_point("speakerA");
   * console.log(Object.keys(waveform.points));          // -> []
   * ```
   *
   * @param {String*} identifier Unique identifier. If nothing is specified,
   *   *default* will be used as a value.
   * @return null
   */ remove_point: function removePoint(identifier) {
        if (this.points[identifier]) delete this.points[identifier];
    },
    /**
   * Creates a new WaveformData object with resampled data.
   * Returns a rescaled waveform, to either fit the waveform to a specific
   * width, or to a specific zoom level.
   *
   * **Note**: You may specify either the *width* or the *scale*, but not both.
   * The `scale` will be deduced from the `width` you want to fit the data into.
   *
   * Adapted from Sequence::GetWaveDisplay in Audacity, with permission.
   *
   * ```javascript
   * // ...
   * var waveform = WaveformData.create({ ... });
   *
   * // fitting the data in a 500px wide canvas
   * var resampled_waveform = waveform.resample({ width: 500 });
   *
   * console.log(resampled_waveform.min.length);   // -> 500
   *
   * // zooming out on a 3 times less precise scale
   * var resampled_waveform = waveform.resample({ scale: waveform.adapter.scale * 3 });
   *
   * // partial resampling (to perform fast animations involving a resampling
   * // per animation frame)
   * var partially_resampled_waveform = waveform.resample({ width: 500, from: 0, to: 500 });
   *
   * // ...
   * ```
   *
   * @see https://code.google.com/p/audacity/source/browse/audacity-src/trunk/src/Sequence.cpp
   * @param {Number|{width: Number, scale: Number}} options Either a constraint width or a constraint sample rate
   * @return {WaveformData} New resampled object
   */ resample: function(options) {
        if (typeof options === "number") options = {
            width: options
        };
        options.input_index = typeof options.input_index === "number" ? options.input_index : null;
        options.output_index = typeof options.output_index === "number" ? options.output_index : null;
        options.scale = typeof options.scale === "number" ? options.scale : null;
        options.width = typeof options.width === "number" ? options.width : null;
        var is_partial_resampling = Boolean(options.input_index) || Boolean(options.output_index);
        if (options.input_index != null && options.input_index < 0) throw new RangeError("options.input_index should be a positive integer value. [" + options.input_index + "]");
        if (options.output_index != null && options.output_index < 0) throw new RangeError("options.output_index should be a positive integer value. [" + options.output_index + "]");
        if (options.width != null && options.width <= 0) throw new RangeError("options.width should be a strictly positive integer value. [" + options.width + "]");
        if (options.scale != null && options.scale <= 0) throw new RangeError("options.scale should be a strictly positive integer value. [" + options.scale + "]");
        if (!options.scale && !options.width) throw new RangeError("You should provide either a resampling scale or a width in pixel the data should fit in.");
        var definedPartialOptionsCount = [
            "width",
            "scale",
            "output_index",
            "input_index"
        ].reduce(function(count, key) {
            return count + (options[key] === null ? 0 : 1);
        }, 0);
        if (is_partial_resampling && definedPartialOptionsCount !== 4) throw new Error("Some partial resampling options are missing. You provided " + definedPartialOptionsCount + " of them over 4.");
        var output_data = [];
        var samples_per_pixel = options.scale || Math.floor(this.duration * this.adapter.sample_rate / options.width); // scale we want to reach
        var scale = this.adapter.scale; // scale we are coming from
        var channel_count = 2;
        var input_buffer_size = this.adapter.length; // the amount of data we want to resample i.e. final zoom want to resample all data but for intermediate zoom we want to resample subset
        var input_index = options.input_index || 0; // is this start point? or is this the index at current scale
        var output_index = options.output_index || 0; // is this end point? or is this the index at scale we want to be?
        var min = input_buffer_size ? this.min_sample(input_index) : 0; // min value for peak in waveform
        var max = input_buffer_size ? this.max_sample(input_index) : 0; // max value for peak in waveform
        var min_value = -128;
        var max_value = 127;
        if (samples_per_pixel < scale) throw new Error("Zoom level " + samples_per_pixel + " too low, minimum: " + scale);
        var where, prev_where, stop, value, last_input_index;
        function sample_at_pixel(x) {
            return Math.floor(x * samples_per_pixel);
        }
        function add_sample(min, max) {
            output_data.push(min, max);
        }
        while(input_index < input_buffer_size){
            while(Math.floor(sample_at_pixel(output_index) / scale) <= input_index){
                if (output_index) add_sample(min, max);
                last_input_index = input_index;
                output_index++;
                where = sample_at_pixel(output_index);
                prev_where = sample_at_pixel(output_index - 1);
                if (where !== prev_where) {
                    min = max_value;
                    max = min_value;
                }
            }
            where = sample_at_pixel(output_index);
            stop = Math.floor(where / scale);
            if (stop > input_buffer_size) stop = input_buffer_size;
            while(input_index < stop){
                value = this.min_sample(input_index);
                if (value < min) min = value;
                value = this.max_sample(input_index);
                if (value > max) max = value;
                input_index++;
            }
            if (is_partial_resampling && output_data.length / channel_count >= options.width) break;
        }
        if (is_partial_resampling) {
            if (output_data.length / channel_count > options.width && input_index !== last_input_index) add_sample(min, max);
        } else if (input_index !== last_input_index) add_sample(min, max);
        return new $f3f80f2772b5b069$var$WaveformData({
            version: this.adapter.version,
            samples_per_pixel: samples_per_pixel,
            length: output_data.length / channel_count,
            data: output_data,
            sample_rate: this.adapter.sample_rate
        }, $f3f80f2772b5b069$var$WaveformData.adapters.object);
    },
    /**
   * Returns all the min peaks values.
   *
   * ```javascript
   * var waveform = WaveformData.create({ ... });
   *
   * console.log(waveform.min.length);      // -> 150
   * console.log(waveform.min[0]);          // -> -12
   *
   * waveform.offset(20, 50);
   *
   * console.log(waveform.min.length);      // -> 30
   * console.log(waveform.min[0]);          // -> -9
   * ```
   *
   * @api
   * @return {Array.<Integer>} Min values contained in the offset.
   */ get min () {
        return this.offsetValues(this.offset_start, this.offset_length, 0);
    },
    /**
   * Returns all the max peaks values.
   *
   * ```javascript
   * var waveform = WaveformData.create({ ... });
   *
   * console.log(waveform.max.length);      // -> 150
   * console.log(waveform.max[0]);          // -> 12
   *
   * waveform.offset(20, 50);
   *
   * console.log(waveform.max.length);      // -> 30
   * console.log(waveform.max[0]);          // -> 5
   * ```
   *
   * @api
   * @return {Array.<Integer>} Max values contained in the offset.
   */ get max () {
        return this.offsetValues(this.offset_start, this.offset_length, 1);
    },
    /**
   * Return the unpacked values for a particular offset.
   *
   * @param {Integer} start
   * @param {Integer} length
   * @param {Integer} correction The step to skip for each iteration
   *   (as the response body is [min, max, min, max...])
   * @return {Array.<Integer>}
   */ offsetValues: function getOffsetValues(start, length, correction) {
        var adapter = this.adapter;
        var values = [];
        correction += start * 2; // offset the positioning query
        for(var i = 0; i < length; i++)values.push(adapter.at(i * 2 + correction));
        return values;
    },
    /**
   * Compute the duration in seconds of the audio file.
   *
   * ```javascript
   * var waveform = WaveformData.create({ ... });
   * console.log(waveform.duration);    // -> 10.33333333333
   *
   * waveform.offset(20, 50);
   * console.log(waveform.duration);    // -> 10.33333333333
   * ```
   *
   * @api
   * @return {number} Duration of the audio waveform, in seconds.
   */ get duration () {
        return this.adapter.length * this.adapter.scale / this.adapter.sample_rate;
    },
    /**
   * Return the duration in seconds of the current offset.
   *
   * ```javascript
   * var waveform = WaveformData.create({ ... });
   *
   * console.log(waveform.offset_duration);    // -> 10.33333333333
   *
   * waveform.offset(20, 50);
   *
   * console.log(waveform.offset_duration);    // -> 2.666666666667
   * ```
   *
   * @api
   * @return {number} Duration of the offset, in seconds.
   */ get offset_duration () {
        return this.offset_length * this.adapter.scale / this.adapter.sample_rate;
    },
    /**
   * Return the number of pixels per second.
   *
   * ```javascript
   * var waveform = WaveformData.create({ ... });
   *
   * console.log(waveform.pixels_per_second);       // -> 93.75
   * ```
   *
   * @api
   * @return {number} Number of pixels per second.
   */ get pixels_per_second () {
        return this.adapter.sample_rate / this.adapter.scale;
    },
    /**
   * Return the amount of time represented by a single pixel.
   *
   * ```javascript
   * var waveform = WaveformData.create({ ... });
   *
   * console.log(waveform.seconds_per_pixel);       // -> 0.010666666666666666
   * ```
   *
   * @return {number} Amount of time (in seconds) contained in a pixel.
   */ get seconds_per_pixel () {
        return this.adapter.scale / this.adapter.sample_rate;
    },
    /**
   * Returns a value at a specific offset.
   *
   * ```javascript
   * var waveform = WaveformData.create({ ... });
   *
   * console.log(waveform.at(20));              // -> -7
   * console.log(waveform.at(21));              // -> 12
   * ```
   *
   * @proxy
   * @param {Integer} index
   * @return {number} Offset value
   */ at: function at_sample_proxy(index) {
        return this.adapter.at(index);
    },
    /**
   * Return the pixel location for a certain time.
   *
   * ```javascript
   * var waveform = WaveformData.create({ ... });
   *
   * console.log(waveform.at_time(0.0000000023));       // -> 10
   * ```
   * @param {number} time
   * @return {integer} Index location for a specific time.
   */ at_time: function at_time(time) {
        return Math.floor(time * this.adapter.sample_rate / this.adapter.scale);
    },
    /**
   * Returns the time in seconds for a particular index
   *
   * ```javascript
   * var waveform = WaveformData.create({ ... });
   *
   * console.log(waveform.time(10));                    // -> 0.0000000023
   * ```
   *
   * @param {Integer} index
   * @return {number}
   */ time: function time(index) {
        return index * this.adapter.scale / this.adapter.sample_rate;
    },
    /**
   * Return if a pixel lies within the current offset.
   *
   * ```javascript
   * var waveform = WaveformData.create({ ... });
   *
   * console.log(waveform.in_offset(50));      // -> true
   * console.log(waveform.in_offset(120));     // -> true
   *
   * waveform.offset(100, 150);
   *
   * console.log(waveform.in_offset(50));      // -> false
   * console.log(waveform.in_offset(120));     // -> true
   * ```
   *
   * @param {number} pixel
   * @return {boolean} True if the pixel lies in the current offset, false otherwise.
   */ in_offset: function isInOffset(pixel) {
        return pixel >= this.offset_start && pixel < this.offset_end;
    },
    /**
   * Returns a min value for a specific offset.
   *
   * ```javascript
   * var waveform = WaveformData.create({ ... });
   *
   * console.log(waveform.min_sample(10));      // -> -7
   * ```
   *
   * @param {Integer} offset
   * @return {Number} Offset min value
   */ min_sample: function getMinValue(offset) {
        return this.adapter.at(offset * 2);
    },
    /**
   * Returns a max value for a specific offset.
   *
   * ```javascript
   * var waveform = WaveformData.create({ ... });
   *
   * console.log(waveform.max_sample(10));      // -> 12
   * ```
   *
   * @param {Integer} offset
   * @return {Number} Offset max value
   */ max_sample: function getMaxValue(offset) {
        return this.adapter.at(offset * 2 + 1);
    }
};
/**
 * Available adapters to manage the data backends.
 *
 * @type {Object}
 */ $f3f80f2772b5b069$var$WaveformData.adapters = {};
/**
 * WaveformData Adapter Structure
 *
 * @typedef {{from: Number, to: Number, platforms: {}}}
 */ $f3f80f2772b5b069$var$WaveformData.adapter = function WaveformDataAdapter(response_data) {
    this.data = response_data;
};
module.exports = $f3f80f2772b5b069$var$WaveformData;

});
parcelRegister("6TXix", function(module, exports) {
"use strict";
/**
 * Segments are an easy way to keep track of portions of the described
 * audio file.
 *
 * They return values based on the actual offset. Which means if you change your
 * offset and:
 *
 * * a segment becomes **out of scope**, no data will be returned;
 * * a segment is only **partially included in the offset**, only the visible
 *   parts will be returned;
 * * a segment is **fully included in the offset**, its whole content will be
 *   returned.
 *
 * Segments are created with the `WaveformData.set_segment(from, to, name?)`
 * method.
 *
 * @see WaveformData.prototype.set_segment
 * @param {WaveformData} context WaveformData instance
 * @param {Integer} start Initial start index
 * @param {Integer} end Initial end index
 * @constructor
 */ function $5065e0744353986d$var$WaveformDataSegment(context, start, end) {
    this.context = context;
    /**
   * Start index.
   *
   * ```javascript
   * var waveform = new WaveformData({ ... }, WaveformData.adapters.object);
   * waveform.set_segment(10, 50, "example");
   *
   * console.log(waveform.segments.example.start);  // -> 10
   *
   * waveform.offset(20, 50);
   * console.log(waveform.segments.example.start);  // -> 10
   *
   * waveform.offset(70, 100);
   * console.log(waveform.segments.example.start);  // -> 10
   * ```
   * @type {Integer} Initial starting point of the segment.
   */ this.start = start;
    /**
   * End index.
   *
   * ```javascript
   * var waveform = new WaveformData({ ... }, WaveformData.adapters.object);
   * waveform.set_segment(10, 50, "example");
   *
   * console.log(waveform.segments.example.end);  // -> 50
   *
   * waveform.offset(20, 50);
   * console.log(waveform.segments.example.end);  // -> 50
   *
   * waveform.offset(70, 100);
   * console.log(waveform.segments.example.end);  // -> 50
   * ```
   * @type {Integer} Initial ending point of the segment.
   */ this.end = end;
}
/**
 * @namespace WaveformDataSegment
 */ $5065e0744353986d$var$WaveformDataSegment.prototype = {
    /**
   * Dynamic starting point based on the WaveformData instance offset.
   *
   * ```javascript
   * var waveform = new WaveformData({ ... }, WaveformData.adapters.object);
   * waveform.set_segment(10, 50, "example");
   *
   * console.log(waveform.segments.example.offset_start);  // -> 10
   *
   * waveform.offset(20, 50);
   * console.log(waveform.segments.example.offset_start);  // -> 20
   *
   * waveform.offset(70, 100);
   * console.log(waveform.segments.example.offset_start);  // -> null
   * ```
   *
   * @return {number} Starting point of the segment within the waveform offset. (inclusive)
   */ get offset_start () {
        if (this.start < this.context.offset_start && this.end > this.context.offset_start) return this.context.offset_start;
        if (this.start >= this.context.offset_start && this.start < this.context.offset_end) return this.start;
        return null;
    },
    /**
   * Dynamic ending point based on the WaveformData instance offset.
   *
   * ```javascript
   * var waveform = new WaveformData({ ... }, WaveformData.adapters.object);
   * waveform.set_segment(10, 50, "example");
   *
   * console.log(waveform.segments.example.offset_end);  // -> 50
   *
   * waveform.offset(20, 50);
   * console.log(waveform.segments.example.offset_end);  // -> 50
   *
   * waveform.offset(70, 100);
   * console.log(waveform.segments.example.offset_end);  // -> null
   * ```
   *
   * @return {number} Ending point of the segment within the waveform offset. (exclusive)
   */ get offset_end () {
        if (this.end > this.context.offset_start && this.end <= this.context.offset_end) return this.end;
        if (this.end > this.context.offset_end && this.start < this.context.offset_end) return this.context.offset_end;
        return null;
    },
    /**
   * Dynamic segment length based on the WaveformData instance offset.
   *
   * ```javascript
   * var waveform = new WaveformData({ ... }, WaveformData.adapters.object);
   * waveform.set_segment(10, 50, "example");
   *
   * console.log(waveform.segments.example.offset_length);  // -> 40
   *
   * waveform.offset(20, 50);
   * console.log(waveform.segments.example.offset_length);  // -> 30
   *
   * waveform.offset(70, 100);
   * console.log(waveform.segments.example.offset_length);  // -> 0
   * ```
   *
   * @return {number} Visible length of the segment within the waveform offset.
   */ get offset_length () {
        return this.offset_end - this.offset_start;
    },
    /**
   * Initial length of the segment.
   *
   * ```javascript
   * var waveform = new WaveformData({ ... }, WaveformData.adapters.object);
   * waveform.set_segment(10, 50, "example");
   *
   * console.log(waveform.segments.example.length);  // -> 40
   *
   * waveform.offset(20, 50);
   * console.log(waveform.segments.example.length);  // -> 40
   *
   * waveform.offset(70, 100);
   * console.log(waveform.segments.example.length);  // -> 40
   * ```
   *
   * @return {number} Initial length of the segment.
   */ get length () {
        return this.end - this.start;
    },
    /**
   * Indicates if the segment has some visible part in the actual WaveformData offset.
   *
   * ```javascript
   * var waveform = new WaveformData({ ... }, WaveformData.adapters.object);
   * waveform.set_segment(10, 50, "example");
   *
   * console.log(waveform.segments.example.visible);        // -> true
   *
   * waveform.offset(20, 50);
   * console.log(waveform.segments.example.visible);        // -> true
   *
   * waveform.offset(70, 100);
   * console.log(waveform.segments.example.visible);        // -> false
   * ```
   *
   * @return {Boolean} True if at least partly visible, false otherwise.
   */ get visible () {
        return this.context.in_offset(this.start) || this.context.in_offset(this.end) || this.context.offset_start > this.start && this.context.offset_start < this.end;
    },
    /**
   * Return the minimum values for the segment.
   *
   * ```javascript
   * var waveform = new WaveformData({ ... }, WaveformData.adapters.object);
   * waveform.set_segment(10, 50, "example");
   *
   * console.log(waveform.segments.example.min.length);        // -> 40
   * console.log(waveform.segments.example.min.offset_length); // -> 40
   * console.log(waveform.segments.example.min[0]);            // -> -12
   *
   * waveform.offset(20, 50);
   *
   * console.log(waveform.segments.example.min.length);        // -> 40
   * console.log(waveform.segments.example.min.offset_length); // -> 30
   * console.log(waveform.segments.example.min[0]);            // -> -5
   * ```
   *
   * @return {Array.<Integer>} Min values of the segment.
   */ get min () {
        return this.visible ? this.context.offsetValues(this.offset_start, this.offset_length, 0) : [];
    },
    /**
   * Return the maximum values for the segment.
   *
   * ```javascript
   * var waveform = new WaveformData({ ... }, WaveformData.adapters.object);
   * waveform.set_segment(10, 50, "example");
   *
   * console.log(waveform.segments.example.max.length);        // -> 40
   * console.log(waveform.segments.example.max.offset_length); // -> 40
   * console.log(waveform.segments.example.max[0]);            // -> 5
   *
   * waveform.offset(20, 50);
   *
   * console.log(waveform.segments.example.max.length);        // -> 40
   * console.log(waveform.segments.example.max.offset_length); // -> 30
   * console.log(waveform.segments.example.max[0]);            // -> 11
   * ```
   *
   * @return {Array.<Integer>} Max values of the segment.
   */ get max () {
        return this.visible ? this.context.offsetValues(this.offset_start, this.offset_length, 1) : [];
    }
};
module.exports = $5065e0744353986d$var$WaveformDataSegment;

});

parcelRegister("9HCGK", function(module, exports) {
"use strict";
/**
 * Points are an easy way to keep track bookmarks of the described audio file.
 *
 * They return values based on the actual offset. Which means if you change your offset and:
 *
 * * a point becomes **out of scope**, no data will be returned;
 * * a point is **fully included in the offset**, its whole content will be returned.
 *
 * Points are created with the `WaveformData.set_point(timeStamp, name?)` method.
 *
 * @see WaveformData.prototype.set_point
 * @param {WaveformData} context WaveformData instance
 * @param {Integer} start Initial start index
 * @param {Integer} end Initial end index
 * @constructor
 */ function $710623ea78a1cdf1$var$WaveformDataPoint(context, timeStamp) {
    this.context = context;
    /**
   * Start index.
   *
   * ```javascript
   * var waveform = new WaveformData({ ... }, WaveformData.adapters.object);
   * waveform.set_point(10, "example");
   *
   * console.log(waveform.points.example.timeStamp);  // -> 10
   *
   * waveform.offset(20, 50);
   * console.log(waveform.points.example.timeStamp);  // -> 10
   *
   * waveform.offset(70, 100);
   * console.log(waveform.points.example.timeStamp);  // -> 10
   * ```
   * @type {Integer} Time Stamp of the point
   */ this.timeStamp = timeStamp;
}
/**
 * @namespace WaveformDataPoint
 */ $710623ea78a1cdf1$var$WaveformDataPoint.prototype = {
    /**
   * Indicates if the point has some visible part in the actual WaveformData offset.
   *
   * ```javascript
   * var waveform = new WaveformData({ ... }, WaveformData.adapters.object);
   * waveform.set_point(10, "example");
   *
   * console.log(waveform.points.example.visible);        // -> true
   *
   * waveform.offset(0, 50);
   * console.log(waveform.points.example.visible);        // -> true
   *
   * waveform.offset(70, 100);
   * console.log(waveform.points.example.visible);        // -> false
   * ```
   *
   * @return {Boolean} True if visible, false otherwise.
   */ get visible () {
        return this.context.in_offset(this.timeStamp);
    }
};
module.exports = $710623ea78a1cdf1$var$WaveformDataPoint;

});


parcelRegister("5IvAQ", function(module, exports) {
"use strict";


module.exports = {
    arraybuffer: (parcelRequire("lXvbH")),
    object: (parcelRequire("bWcPw"))
};

});
parcelRegister("lXvbH", function(module, exports) {
"use strict";
/**
 * ArrayBuffer adapter consumes binary waveform data (data format version 1).
 * It is used as a data abstraction layer by `WaveformData`.
 *
 * This is supposed to be the fastest adapter ever:
 * * **Pros**: working directly in memory, everything is done by reference
 *   (including the offsetting)
 * * **Cons**: binary data are hardly readable without data format knowledge
 *   (and this is why this adapter exists).
 *
 * Also, it is recommended to use the `fromResponseData` factory.
 *
 * @see WaveformDataArrayBufferAdapter.fromResponseData
 * @param {DataView} response_data
 * @constructor
 */ function $ffc74ce0e32eeb8a$var$WaveformDataArrayBufferAdapter(response_data) {
    this.data = response_data;
}
/**
 * Detects if a set of data is suitable for the ArrayBuffer adapter.
 * It is used internally by `WaveformData.create` so you should not bother using it.
 *
 * @static
 * @param {Mixed} data
 * @returns {boolean}
 */ $ffc74ce0e32eeb8a$var$WaveformDataArrayBufferAdapter.isCompatible = function isCompatible(data) {
    return data && typeof data === "object" && "byteLength" in data;
};
/**
 * Setup factory to create an adapter based on heterogeneous input formats.
 *
 * It is the preferred way to build an adapter instance.
 *
 * ```javascript
 * var arrayBufferAdapter = WaveformData.adapters.arraybuffer;
 * var xhr = new XMLHttpRequest();
 *
 * // .dat file generated by audiowaveform program
 * xhr.open("GET", "http://example.com/waveforms/track.dat");
 * xhr.responseType = "arraybuffer";
 * xhr.addEventListener("load", function onResponse(progressEvent){
 *  var responseData = progressEvent.target.response;
 *
 *  // doing stuff with the raw data ...
 *  // you only have access to WaveformDataArrayBufferAdapter API
 *  var adapter = arrayBufferAdapter.fromResponseData(responseData);
 *
 *  // or making things easy by using WaveformData ...
 *  // you have access WaveformData API
 *  var waveform = new WaveformData(responseData, arrayBufferAdapter);
 * });
 *
 * xhr.send();
 * ```

 * @static
 * @param {ArrayBuffer} response_data
 * @return {WaveformDataArrayBufferAdapter}
 */ $ffc74ce0e32eeb8a$var$WaveformDataArrayBufferAdapter.fromResponseData = function fromArrayBufferResponseData(response_data) {
    return new $ffc74ce0e32eeb8a$var$WaveformDataArrayBufferAdapter(new DataView(response_data));
};
/**
 * @namespace WaveformDataArrayBufferAdapter
 */ $ffc74ce0e32eeb8a$var$WaveformDataArrayBufferAdapter.prototype = {
    /**
   * Returns the data format version number.
   *
   * @return {Integer} Version number of the consumed data format.
   */ get version () {
        return this.data.getInt32(0, true);
    },
    /**
   * Indicates if the response body is encoded in 8bits.
   *
   * **Notice**: currently the adapter only deals with 8bits encoded data.
   * You should favor that too because of the smaller data network fingerprint.
   *
   * @return {boolean} True if data are declared to be 8bits encoded.
   */ get is_8_bit () {
        return Boolean(this.data.getUint32(4, true));
    },
    /**
   * Indicates if the response body is encoded in 16bits.
   *
   * @return {boolean} True if data are declared to be 16bits encoded.
   */ get is_16_bit () {
        return !this.is_8_bit;
    },
    /**
   * Returns the number of samples per second.
   *
   * @return {Integer} Number of samples per second.
   */ get sample_rate () {
        return this.data.getInt32(8, true);
    },
    /**
   * Returns the scale (number of samples per pixel).
   *
   * @return {Integer} Number of samples per pixel.
   */ get scale () {
        return this.data.getInt32(12, true);
    },
    /**
   * Returns the length of the waveform data (number of data points).
   *
   * @return {Integer} Length of the waveform data.
   */ get length () {
        return this.data.getUint32(16, true);
    },
    /**
   * Returns a value at a specific offset.
   *
   * @param {Integer} index
   * @return {number} waveform value
   */ at: function at_sample(index) {
        return this.data.getInt8(20 + index);
    }
};
module.exports = $ffc74ce0e32eeb8a$var$WaveformDataArrayBufferAdapter;

});

parcelRegister("bWcPw", function(module, exports) {
"use strict";
/**
 * Object adapter consumes stringified JSON or JSON waveform data (data format version 1).
 * It is used as a data abstraction layer by `WaveformData`.
 *
 * This is supposed to be a fallback for browsers not supporting ArrayBuffer:
 * * **Pros**: easy to debug response_data and quite self describing.
 * * **Cons**: slower than ArrayBuffer, more memory consumption.
 *
 * Also, it is recommended to use the `fromResponseData` factory.
 *
 * @see WaveformDataObjectAdapter.fromResponseData
 * @param {String|Object} response_data JSON or stringified JSON
 * @constructor
 */ function $8b0f104830fad8c9$var$WaveformDataObjectAdapter(response_data) {
    this.data = response_data;
}
/**
 * Detects if a set of data is suitable for the Object adapter.
 * It is used internally by `WaveformData.create` so you should not bother using it.
 *
 * @static
 * @param {Mixed} data
 * @returns {boolean}
 */ $8b0f104830fad8c9$var$WaveformDataObjectAdapter.isCompatible = function isCompatible(data) {
    return data && (typeof data === "object" && "sample_rate" in data || typeof data === "string" && "sample_rate" in JSON.parse(data));
};
/**
 * Setup factory to create an adapter based on heterogeneous input formats.
 *
 * It is the preferred way to build an adapter instance.
 *
 * ```javascript
 * var objectAdapter = WaveformData.adapters.object;
 * var xhr = new XMLHttpRequest();
 *
 * // .dat file generated by audiowaveform program
 * xhr.open("GET", "http://example.com/waveforms/track.json");
 * xhr.responseType = "json";
 * xhr.addEventListener("load", function onResponse(progressEvent){
 *  var responseData = progressEvent.target.response;
 *
 *  // doing stuff with the raw data ...
 *  // you only have access to WaveformDataObjectAdapter API
 *  var adapter = objectAdapter.fromResponseData(responseData);
 *
 *  // or making things easy by using WaveformData ...
 *  // you have access WaveformData API
 *  var waveform = new WaveformData(responseData, objectAdapter);
 * });
 *
 * xhr.send();
 * ```

 * @static
 * @param {String|Object} response_data JSON or stringified JSON
 * @return {WaveformDataObjectAdapter}
 */ $8b0f104830fad8c9$var$WaveformDataObjectAdapter.fromResponseData = function fromJSONResponseData(response_data) {
    if (typeof response_data === "string") return new $8b0f104830fad8c9$var$WaveformDataObjectAdapter(JSON.parse(response_data));
    else return new $8b0f104830fad8c9$var$WaveformDataObjectAdapter(response_data);
};
/**
 * @namespace WaveformDataObjectAdapter
 */ $8b0f104830fad8c9$var$WaveformDataObjectAdapter.prototype = {
    /**
   * Returns the data format version number.
   *
   * @return {Integer} Version number of the consumed data format.
   */ get version () {
        return this.data.version || 1;
    },
    /**
   * Indicates if the response body is encoded in 8bits.
   *
   * **Notice**: currently the adapter only deals with 8bits encoded data.
   * You should favor that too because of the smaller data network fingerprint.
   *
   * @return {boolean} True if data are declared to be 8bits encoded.
   */ get is_8_bit () {
        return this.data.bits === 8;
    },
    /**
   * Indicates if the response body is encoded in 16bits.
   *
   * @return {boolean} True if data are declared to be 16bits encoded.
   */ get is_16_bit () {
        return !this.is_8_bit;
    },
    /**
   * Returns the number of samples per second.
   *
   * @return {Integer} Number of samples per second.
   */ get sample_rate () {
        return this.data.sample_rate;
    },
    /**
   * Returns the scale (number of samples per pixel).
   *
   * @return {Integer} Number of samples per pixel.
   */ get scale () {
        return this.data.samples_per_pixel;
    },
    /**
   * Returns the length of the waveform data (number of data points).
   *
   * @return {Integer} Length of the waveform data.
   */ get length () {
        return this.data.length;
    },
    /**
   * Returns a value at a specific offset.
   *
   * @param {Integer} index
   * @return {number} waveform value
   */ at: function at_sample(index) {
        return this.data.data[index];
    }
};
module.exports = $8b0f104830fad8c9$var$WaveformDataObjectAdapter;

});



parcelRegister("edmRl", function(module, exports) {
var $a59402f6e07ae392$var$WORKER_ENABLED = !!($parcel$global === $parcel$global.window && $parcel$global.URL && $parcel$global.Blob && $parcel$global.Worker);
function $a59402f6e07ae392$var$InlineWorker(func, self) {
    var _this = this;
    var functionBody;
    self = self || {};
    if ($a59402f6e07ae392$var$WORKER_ENABLED) {
        functionBody = func.toString().trim().match(/^function\s*\w*\s*\([\w\s,]*\)\s*{([\w\W]*?)}$/)[1];
        return new $parcel$global.Worker($parcel$global.URL.createObjectURL(new $parcel$global.Blob([
            functionBody
        ], {
            type: "text/javascript"
        })));
    }
    function postMessage(data) {
        setTimeout(function() {
            _this.onmessage({
                data: data
            });
        }, 0);
    }
    this.self = self;
    this.self.postMessage = postMessage;
    setTimeout(func.bind(self, self), 0);
}
$a59402f6e07ae392$var$InlineWorker.prototype.postMessage = function postMessage(data) {
    var _this = this;
    setTimeout(function() {
        _this.self.onmessage({
            data: data
        });
    }, 0);
};
module.exports = $a59402f6e07ae392$var$InlineWorker;

});





parcelRegister("kKA2u", function(module, exports) {
'use strict';

var $cI1ok = parcelRequire("cI1ok");
const $f1b40f2750464c98$var$$ = $cI1ok.Observable;

var $jjnZg = parcelRequire("jjnZg");
var $f1b40f2750464c98$require$obj = $jjnZg.obj;
let $f1b40f2750464c98$var$pocket;
let $f1b40f2750464c98$var$reducers$ = new $cI1ok.Subject();
let $f1b40f2750464c98$var$pocket$ = new $cI1ok.BehaviorSubject({});
$f1b40f2750464c98$var$reducers$.scan((pocket, reduce)=>reduce(pocket), {}).subscribe((pocket)=>$f1b40f2750464c98$var$pocket$.onNext(pocket));
$f1b40f2750464c98$var$pocket$.subscribe((_pocket)=>{
    // console.log({pocket});
    $f1b40f2750464c98$var$pocket = _pocket;
});
const $f1b40f2750464c98$var$put = (path, val)=>$f1b40f2750464c98$var$reducers$.onNext((pocket)=>$f1b40f2750464c98$require$obj.patch(pocket, path, val));
const $f1b40f2750464c98$var$get = (path)=>$f1b40f2750464c98$require$obj.sub($f1b40f2750464c98$var$pocket, path);
module.exports = {
    put: $f1b40f2750464c98$var$put,
    get: $f1b40f2750464c98$var$get,
    reducers$: $f1b40f2750464c98$var$reducers$,
    stream: $f1b40f2750464c98$var$pocket$
};

});


parcelRegister("gYqGB", function(module, exports) {
'use strict';

var $jjnZg = parcelRequire("jjnZg");
var $c5b6f33f4618ff08$require$obj = $jjnZg.obj;
var $c5b6f33f4618ff08$require$fn = $jjnZg.fn;

var $cI1ok = parcelRequire("cI1ok");
const $c5b6f33f4618ff08$var$$ = $cI1ok.Observable;

var $kKA2u = parcelRequire("kKA2u");

var $7TCVA = parcelRequire("7TCVA");

var $7pSRt = parcelRequire("7pSRt");

var $3Bdmq = parcelRequire("3Bdmq");

var $6TsbL = parcelRequire("6TsbL");
const $c5b6f33f4618ff08$var$initial = {
    on: true,
    deviceInputs: {
        0: 'default',
        1: 'default',
        2: 'default',
        3: 'default'
    },
    devices: []
};
const $c5b6f33f4618ff08$var$connect = (devices)=>(state)=>$c5b6f33f4618ff08$require$obj.patch(state, 'audio', {
            devices: devices
        });
const $c5b6f33f4618ff08$var$actions = {
    initial: $c5b6f33f4618ff08$var$initial,
    connect: $c5b6f33f4618ff08$var$connect
};
let $c5b6f33f4618ff08$var$unhook = ()=>{};
const $c5b6f33f4618ff08$var$createAnalyser = (context)=>{
    console.log('Creating analyser');
    let analyser = context.createAnalyser();
    analyser.minDecibels = -90;
    analyser.maxDecibels = -10;
    analyser.smoothingTimeConstant = 0.85;
    analyser.connect(context.destination);
    return analyser;
};
const $c5b6f33f4618ff08$var$hook = ({ state$: state$, actions: actions })=>{
    let subs = [];
    // devices
    $c5b6f33f4618ff08$var$$.fromEvent(navigator.mediaDevices, 'devicechange').startWith({}).flatMap(()=>$c5b6f33f4618ff08$var$$.fromPromise(navigator.mediaDevices.enumerateDevices())).map((devices)=>devices.filter((d)=>d.kind === 'audioinput')).subscribe((devices)=>actions.audio.connect(devices));
    const analyser$ = $c5b6f33f4618ff08$var$$.interval(100).map(()=>$7TCVA.context).distinctUntilChanged((context)=>context.state).filter((context)=>context.state !== 'suspended').map($c5b6f33f4618ff08$var$createAnalyser);
    let source = [
        {
            type: 'soundSource',
            node: null,
            stream: null,
            out: []
        },
        {
            type: 'soundSource',
            node: null,
            stream: null,
            out: []
        },
        {
            type: 'soundSource',
            node: null,
            stream: null,
            out: []
        },
        {
            type: 'soundSource',
            node: null,
            stream: null,
            out: []
        }
    ];
    let vca;
    analyser$.subscribe((analyser)=>{
        vca = $7TCVA.vca({
            gain: 0.5
        });
        $kKA2u.put('analyser', analyser);
        $7TCVA.connect(vca, analyser);
    });
    state$.distinctUntilChanged((state)=>state.audio.on + state.audio.deviceInputs)// .filter(state => state.audio.on)
    .subscribe((state)=>{
        [
            0,
            1,
            2,
            3
        ].forEach((index)=>{
            if (state.audio.on) navigator.mediaDevices.getUserMedia({
                audio: {
                    deviceId: state.audio.deviceInputs[index]
                }
            }).then((stream)=>{
                $7TCVA.disconnect(source[index], vca);
                source[index].node = $7TCVA.context.createMediaStreamSource(stream);
                if (state.mic) source[index].node.connect($7TCVA.context.destination);
                source[index].stream = stream;
            });
            else if (source[index].node) {
                source[index].node.disconnect();
                source[index].node = null;
                source[index].stream = null;
            }
        });
    });
    state$.distinctUntilChanged((state)=>state.mic).subscribe((state)=>{
    // if (state.mic) source.node.connect(a.context.destination);
    // else if (source.node) source.node.disconnect();
    });
    let buffers = {};
    let recording = {};
    let blob$ = new $cI1ok.Subject();
    const addNewSample = (channel, buffer, baseLength, quantize = false, triggeredAt)=>{
        // quantize buffer
        let length = buffer.length;
        if (quantize) {
            if (baseLength === 0) {
                length = Number(length / 4).toFixed() * 4;
                actions.setBaseLength(length);
            } else {
                let quant = baseLength / 4;
                length = Number(length / quant).toFixed() * quant;
            }
        }
        console.log({
            buffer: buffer,
            length: length,
            baseLength: baseLength
        });
        let resizedBuffer = $7pSRt.resize(buffer, length);
        console.log(buffer, buffer instanceof AudioBuffer, resizedBuffer, resizedBuffer instanceof AudioBuffer);
        let bufferSource = $7TCVA.context.createBufferSource();
        bufferSource.buffer = resizedBuffer;
        bufferSource.loop = true;
        bufferSource.connect(vca.through);
        bufferSource.start(triggeredAt);
        if (!buffers[channel]) buffers[channel] = [];
        buffers[channel].push(bufferSource);
        actions.set([
            'channels',
            channel,
            'duration'
        ], bufferSource.buffer.duration);
    };
    [
        0,
        1,
        2,
        3
    ].map((channel)=>state$.distinctUntilChanged((state)=>state.channels[channel].process).subscribe((state)=>{
            let triggeredAt = state.channels[channel].startedAt;
            if (state.audio) {
                if (state.channels[channel].process === 'record' || state.channels[channel].process === 'overdub') {
                    console.log(channel, $3Bdmq.record, source[channel].stream);
                    recording[channel] = $3Bdmq.record(source[channel].stream, $7TCVA.context);
                    recording[channel].data$.flatMap((data)=>$6TsbL.load(data, 'arrayBuffer')).flatMap((arrayBuffer)=>$c5b6f33f4618ff08$var$$.fromPromise($7TCVA.context.decodeAudioData(arrayBuffer))).subscribe((buffer)=>addNewSample(channel, buffer, state.baseLength, state.quantize, triggeredAt));
                } else if (state.channels[channel].process === 'play') {
                    if (recording[channel]) {
                        recording[channel].stop();
                        recording[channel] = null;
                    }
                    if (buffers[channel]) buffers[channel] = buffers[channel].map((old)=>{
                        old.stop();
                        let bufferSource = $7TCVA.context.createBufferSource();
                        bufferSource.buffer = old.buffer;
                        bufferSource.loop = true;
                        bufferSource.connect(vca.through);
                        bufferSource.start(triggeredAt);
                        actions.set([
                            'channels',
                            channel,
                            'startedAt'
                        ], $7TCVA.context.currentTime);
                        console.log(bufferSource, old.buffer);
                        return bufferSource;
                    });
                } else {
                    // stop`
                    if (buffers[channel]) buffers[channel].forEach((bufferSource)=>bufferSource.stop());
                    if (state.channels[channel].process === 'empty') buffers[channel] = [];
                }
            }
        }));
    $c5b6f33f4618ff08$var$unhook = ()=>subs.forEach((sub)=>sub.dispose());
};
module.exports = {
    actions: $c5b6f33f4618ff08$var$actions,
    hook: $c5b6f33f4618ff08$var$hook,
    unhook: ()=>$c5b6f33f4618ff08$var$unhook()
};

});
parcelRegister("7pSRt", function(module, exports) {
/**
 * @module  audio-buffer-utils
 */ 'use strict';

var $2BMfG = parcelRequire("2BMfG");

var $3Bjqc = parcelRequire("3Bjqc");

var $2DZYW = parcelRequire("2DZYW");

var $1bIHi = parcelRequire("1bIHi");

var $7LWHU = parcelRequire("7LWHU");
parcelRequire("1Tv42");

var $ZiNL4 = parcelRequire("ZiNL4");
var $56656c8f1af07e0a$var$isNeg = function(number) {
    return number === 0 && 1 / number === -Infinity;
};
var $56656c8f1af07e0a$var$nidx = function negIdx(idx, length) {
    return idx == null ? 0 : $56656c8f1af07e0a$var$isNeg(idx) ? length : idx <= -length ? 0 : idx < 0 ? length + idx % length : Math.min(length, idx);
};
var $56656c8f1af07e0a$var$context;
var $56656c8f1af07e0a$var$utils = {
    create: $56656c8f1af07e0a$var$create,
    copy: $56656c8f1af07e0a$var$copy,
    shallow: $56656c8f1af07e0a$var$shallow,
    clone: $56656c8f1af07e0a$var$clone,
    reverse: $56656c8f1af07e0a$var$reverse,
    invert: $56656c8f1af07e0a$var$invert,
    zero: $56656c8f1af07e0a$var$zero,
    noise: $56656c8f1af07e0a$var$noise,
    equal: $56656c8f1af07e0a$var$equal,
    fill: $56656c8f1af07e0a$var$fill,
    slice: $56656c8f1af07e0a$var$slice,
    concat: $56656c8f1af07e0a$var$concat,
    resize: $56656c8f1af07e0a$var$resize,
    pad: $56656c8f1af07e0a$var$pad,
    padLeft: $56656c8f1af07e0a$var$padLeft,
    padRight: $56656c8f1af07e0a$var$padRight,
    rotate: $56656c8f1af07e0a$var$rotate,
    shift: $56656c8f1af07e0a$var$shift,
    normalize: $56656c8f1af07e0a$var$normalize,
    removeStatic: $56656c8f1af07e0a$var$removeStatic,
    trim: $56656c8f1af07e0a$var$trim,
    trimLeft: $56656c8f1af07e0a$var$trimLeft,
    trimRight: $56656c8f1af07e0a$var$trimRight,
    mix: $56656c8f1af07e0a$var$mix,
    size: $56656c8f1af07e0a$var$size,
    data: $56656c8f1af07e0a$var$data,
    subbuffer: $56656c8f1af07e0a$var$subbuffer,
    repeat: $56656c8f1af07e0a$var$repeat
};
Object.defineProperty($56656c8f1af07e0a$var$utils, 'context', {
    get: function() {
        if (!$56656c8f1af07e0a$var$context) $56656c8f1af07e0a$var$context = $7LWHU();
        return $56656c8f1af07e0a$var$context;
    }
});
module.exports = $56656c8f1af07e0a$var$utils;
/**
 * Create buffer from any argument.
 * Better constructor than audio-buffer.
 */ function $56656c8f1af07e0a$var$create(src, options, sampleRate) {
    var length, data;
    if (typeof options === 'number') options = {
        channels: options
    };
    else if (typeof options === 'string') options = {
        format: options
    };
    else if (!options) options = {};
    if (sampleRate) options.sampleRate = sampleRate;
    options.context = $56656c8f1af07e0a$var$utils.context;
    return $ZiNL4(src, options);
}
/**
 * Copy data from buffer A to buffer B
 */ function $56656c8f1af07e0a$var$copy(from, to, offset) {
    $56656c8f1af07e0a$var$validate(from);
    $56656c8f1af07e0a$var$validate(to);
    offset = offset || 0;
    for(var channel = 0, l = Math.min(from.numberOfChannels, to.numberOfChannels); channel < l; channel++)to.getChannelData(channel).set(from.getChannelData(channel), offset);
    return to;
}
/**
 * Assert argument is AudioBuffer, throw error otherwise.
 */ function $56656c8f1af07e0a$var$validate(buffer) {
    if (!$3Bjqc(buffer)) throw new Error('Argument should be an AudioBuffer instance.');
}
/**
 * Create a buffer with the same characteristics as inBuffer, without copying
 * the data. Contents of resulting buffer are undefined.
 */ function $56656c8f1af07e0a$var$shallow(buffer) {
    $56656c8f1af07e0a$var$validate(buffer);
    //workaround for faster browser creation
    //avoid extra checks & copying inside of AudioBuffer class
    if ($2DZYW) return $56656c8f1af07e0a$var$utils.context.createBuffer(buffer.numberOfChannels, buffer.length, buffer.sampleRate);
    return $56656c8f1af07e0a$var$create(buffer.length, buffer.numberOfChannels, buffer.sampleRate);
}
/**
 * Create clone of a buffer
 */ function $56656c8f1af07e0a$var$clone(buffer) {
    return $56656c8f1af07e0a$var$copy(buffer, $56656c8f1af07e0a$var$shallow(buffer));
}
/**
 * Reverse samples in each channel
 */ function $56656c8f1af07e0a$var$reverse(buffer, target, start, end) {
    $56656c8f1af07e0a$var$validate(buffer);
    //if target buffer is passed
    if (!$3Bjqc(target) && target != null) {
        end = start;
        start = target;
        target = null;
    }
    if (target) {
        $56656c8f1af07e0a$var$validate(target);
        $56656c8f1af07e0a$var$copy(buffer, target);
    } else target = buffer;
    start = start == null ? 0 : $56656c8f1af07e0a$var$nidx(start, buffer.length);
    end = end == null ? buffer.length : $56656c8f1af07e0a$var$nidx(end, buffer.length);
    for(var i = 0, c = target.numberOfChannels; i < c; ++i)target.getChannelData(i).subarray(start, end).reverse();
    return target;
}
/**
 * Invert amplitude of samples in each channel
 */ function $56656c8f1af07e0a$var$invert(buffer, target, start, end) {
    //if target buffer is passed
    if (!$3Bjqc(target) && target != null) {
        end = start;
        start = target;
        target = null;
    }
    return $56656c8f1af07e0a$var$fill(buffer, target, function(sample) {
        return -sample;
    }, start, end);
}
/**
 * Fill with zeros
 */ function $56656c8f1af07e0a$var$zero(buffer, target, start, end) {
    return $56656c8f1af07e0a$var$fill(buffer, target, 0, start, end);
}
/**
 * Fill with white noise
 */ function $56656c8f1af07e0a$var$noise(buffer, target, start, end) {
    return $56656c8f1af07e0a$var$fill(buffer, target, function(sample) {
        return Math.random() * 2 - 1;
    }, start, end);
}
/**
 * Test whether two buffers are the same
 */ function $56656c8f1af07e0a$var$equal(bufferA, bufferB) {
    //walk by all the arguments
    if (arguments.length > 2) {
        for(var i = 0, l = arguments.length - 1; i < l; i++){
            if (!$56656c8f1af07e0a$var$equal(arguments[i], arguments[i + 1])) return false;
        }
        return true;
    }
    $56656c8f1af07e0a$var$validate(bufferA);
    $56656c8f1af07e0a$var$validate(bufferB);
    if (bufferA.length !== bufferB.length || bufferA.numberOfChannels !== bufferB.numberOfChannels) return false;
    for(var channel = 0; channel < bufferA.numberOfChannels; channel++){
        var dataA = bufferA.getChannelData(channel);
        var dataB = bufferB.getChannelData(channel);
        for(var i = 0; i < dataA.length; i++){
            if (dataA[i] !== dataB[i]) return false;
        }
    }
    return true;
}
/**
 * Generic in-place fill/transform
 */ function $56656c8f1af07e0a$var$fill(buffer, target, value, start, end) {
    $56656c8f1af07e0a$var$validate(buffer);
    //if target buffer is passed
    if (!$3Bjqc(target) && target != null) {
        //target is bad argument
        if (typeof value == 'function') target = null;
        else {
            end = start;
            start = value;
            value = target;
            target = null;
        }
    }
    if (target) $56656c8f1af07e0a$var$validate(target);
    else target = buffer;
    //resolve optional start/end args
    start = start == null ? 0 : $56656c8f1af07e0a$var$nidx(start, buffer.length);
    end = end == null ? buffer.length : $56656c8f1af07e0a$var$nidx(end, buffer.length);
    //resolve type of value
    if (!(value instanceof Function)) for(var channel = 0, c = buffer.numberOfChannels; channel < c; channel++){
        var targetData = target.getChannelData(channel);
        for(var i = start; i < end; i++)targetData[i] = value;
    }
    else for(var channel = 0, c = buffer.numberOfChannels; channel < c; channel++){
        var data = buffer.getChannelData(channel), targetData = target.getChannelData(channel);
        for(var i = start; i < end; i++)targetData[i] = value.call(buffer, data[i], i, channel, data);
    }
    return target;
}
/**
 * Repeat buffer
 */ function $56656c8f1af07e0a$var$repeat(buffer, times) {
    $56656c8f1af07e0a$var$validate(buffer);
    if (!times || times < 0) return new $2BMfG(null, {
        length: 0,
        numberOfChannels: buffer.numberOfChannels,
        sampleRate: buffer.sampleRate
    });
    if (times === 1) return buffer;
    var bufs = [];
    for(var i = 0; i < times; i++)bufs.push(buffer);
    return $56656c8f1af07e0a$var$concat(bufs);
}
/**
 * Return sliced buffer
 */ function $56656c8f1af07e0a$var$slice(buffer, start, end) {
    $56656c8f1af07e0a$var$validate(buffer);
    start = start == null ? 0 : $56656c8f1af07e0a$var$nidx(start, buffer.length);
    end = end == null ? buffer.length : $56656c8f1af07e0a$var$nidx(end, buffer.length);
    var data = [];
    for(var channel = 0; channel < buffer.numberOfChannels; channel++){
        var channelData = buffer.getChannelData(channel);
        data.push(channelData.slice(start, end));
    }
    return $56656c8f1af07e0a$var$create(data, buffer.numberOfChannels, buffer.sampleRate);
}
/**
 * Create handle for a buffer from subarrays
 */ function $56656c8f1af07e0a$var$subbuffer(buffer, start, end, channels) {
    $56656c8f1af07e0a$var$validate(buffer);
    if (Array.isArray(start)) {
        channels = start;
        start = 0;
        end = -0;
    } else if (Array.isArray(end)) {
        channels = end;
        end = -0;
    }
    if (!Array.isArray(channels)) {
        channels = Array(buffer.numberOfChannels);
        for(var c = 0; c < buffer.numberOfChannels; c++)channels[c] = c;
    }
    start = start == null ? 0 : $56656c8f1af07e0a$var$nidx(start, buffer.length);
    end = end == null ? buffer.length : $56656c8f1af07e0a$var$nidx(end, buffer.length);
    var data = [];
    for(var i = 0; i < channels.length; i++){
        var channel = channels[i];
        var channelData = buffer.getChannelData(channel);
        data.push(channelData.subarray(start, end));
    }
    //null-context buffer covers web-audio-api buffer functions
    var buf = new $2BMfG(null, {
        length: 0,
        sampleRate: buffer.sampleRate,
        numberOfChannels: buffer.numberOfChannels
    });
    //FIXME: not reliable hack to replace data. Mb use audio-buffer-list?
    buf.length = data[0].length;
    buf._data = null;
    buf._channelData = data;
    buf.duration = buf.length / buf.sampleRate;
    return buf;
}
/**
 * Concat buffer with other buffer(s)
 */ function $56656c8f1af07e0a$var$concat() {
    var list = [];
    for(var i = 0, l = arguments.length; i < l; i++){
        var arg = arguments[i];
        if (Array.isArray(arg)) for(var j = 0; j < arg.length; j++)list.push(arg[j]);
        else list.push(arg);
    }
    var channels = 1;
    var length = 0;
    //FIXME: there might be required more thoughtful resampling, but now I'm lazy sry :(
    var sampleRate = 0;
    for(var i = 0; i < list.length; i++){
        var buf = list[i];
        $56656c8f1af07e0a$var$validate(buf);
        length += buf.length;
        channels = Math.max(buf.numberOfChannels, channels);
        sampleRate = Math.max(buf.sampleRate, sampleRate);
    }
    var data = [];
    for(var channel = 0; channel < channels; channel++){
        var channelData = new Float32Array(length), offset = 0;
        for(var i = 0; i < list.length; i++){
            var buf = list[i];
            if (channel < buf.numberOfChannels) channelData.set(buf.getChannelData(channel), offset);
            offset += buf.length;
        }
        data.push(channelData);
    }
    return $56656c8f1af07e0a$var$create(data, channels, sampleRate);
}
/**
 * Change the length of the buffer, by trimming or filling with zeros
 */ function $56656c8f1af07e0a$var$resize(buffer, length) {
    $56656c8f1af07e0a$var$validate(buffer);
    if (length < buffer.length) return $56656c8f1af07e0a$var$slice(buffer, 0, length);
    return $56656c8f1af07e0a$var$concat(buffer, $56656c8f1af07e0a$var$create(length - buffer.length, buffer.numberOfChannels));
}
/**
 * Pad buffer to required size
 */ function $56656c8f1af07e0a$var$pad(a, b, value) {
    var buffer, length;
    if (typeof a === 'number') {
        buffer = b;
        length = a;
    } else {
        buffer = a;
        length = b;
    }
    value = value || 0;
    $56656c8f1af07e0a$var$validate(buffer);
    //no need to pad
    if (length < buffer.length) return buffer;
    //left-pad
    if (buffer === b) return $56656c8f1af07e0a$var$concat($56656c8f1af07e0a$var$fill($56656c8f1af07e0a$var$create(length - buffer.length, buffer.numberOfChannels), value), buffer);
    //right-pad
    return $56656c8f1af07e0a$var$concat(buffer, $56656c8f1af07e0a$var$fill($56656c8f1af07e0a$var$create(length - buffer.length, buffer.numberOfChannels), value));
}
function $56656c8f1af07e0a$var$padLeft(data, len, value) {
    return $56656c8f1af07e0a$var$pad(len, data, value);
}
function $56656c8f1af07e0a$var$padRight(data, len, value) {
    return $56656c8f1af07e0a$var$pad(data, len, value);
}
/**
 * Shift content of the buffer in circular fashion
 */ function $56656c8f1af07e0a$var$rotate(buffer, offset) {
    $56656c8f1af07e0a$var$validate(buffer);
    for(var channel = 0; channel < buffer.numberOfChannels; channel++){
        var cData = buffer.getChannelData(channel);
        var srcData = cData.slice();
        for(var i = 0, l = cData.length, idx; i < l; i++){
            idx = (offset + (offset + i < 0 ? l + i : i)) % l;
            cData[idx] = srcData[i];
        }
    }
    return buffer;
}
/**
 * Shift content of the buffer
 */ function $56656c8f1af07e0a$var$shift(buffer, offset) {
    $56656c8f1af07e0a$var$validate(buffer);
    for(var channel = 0; channel < buffer.numberOfChannels; channel++){
        var cData = buffer.getChannelData(channel);
        if (offset > 0) for(var i = cData.length - offset; i--;)cData[i + offset] = cData[i];
        else for(var i = -offset, l = cData.length - offset; i < l; i++)cData[i + offset] = cData[i] || 0;
    }
    return buffer;
}
/**
 * Normalize buffer by the maximum value,
 * limit values by the -1..1 range
 */ function $56656c8f1af07e0a$var$normalize(buffer, target, start, end) {
    //resolve optional target arg
    if (!$3Bjqc(target)) {
        end = start;
        start = target;
        target = null;
    }
    start = start == null ? 0 : $56656c8f1af07e0a$var$nidx(start, buffer.length);
    end = end == null ? buffer.length : $56656c8f1af07e0a$var$nidx(end, buffer.length);
    //for every channel bring it to max-min amplitude range
    var max = 0;
    for(var c = 0; c < buffer.numberOfChannels; c++){
        var data = buffer.getChannelData(c);
        for(var i = start; i < end; i++)max = Math.max(Math.abs(data[i]), max);
    }
    var amp = Math.max(1 / max, 1);
    return $56656c8f1af07e0a$var$fill(buffer, target, function(value, i, ch) {
        return $1bIHi(value * amp, -1, 1);
    }, start, end);
}
/**
 * remove DC offset
 */ function $56656c8f1af07e0a$var$removeStatic(buffer, target, start, end) {
    var means = $56656c8f1af07e0a$var$mean(buffer, start, end);
    return $56656c8f1af07e0a$var$fill(buffer, target, function(value, i, ch) {
        return value - means[ch];
    }, start, end);
}
/**
 * Get average level per-channel
 */ function $56656c8f1af07e0a$var$mean(buffer, start, end) {
    $56656c8f1af07e0a$var$validate(buffer);
    start = start == null ? 0 : $56656c8f1af07e0a$var$nidx(start, buffer.length);
    end = end == null ? buffer.length : $56656c8f1af07e0a$var$nidx(end, buffer.length);
    if (end - start < 1) return [];
    var result = [];
    for(var c = 0; c < buffer.numberOfChannels; c++){
        var sum = 0;
        var data = buffer.getChannelData(c);
        for(var i = start; i < end; i++)sum += data[i];
        result.push(sum / (end - start));
    }
    return result;
}
/**
 * Trim sound (remove zeros from the beginning and the end)
 */ function $56656c8f1af07e0a$var$trim(buffer, level) {
    return $56656c8f1af07e0a$var$trimInternal(buffer, level, true, true);
}
function $56656c8f1af07e0a$var$trimLeft(buffer, level) {
    return $56656c8f1af07e0a$var$trimInternal(buffer, level, true, false);
}
function $56656c8f1af07e0a$var$trimRight(buffer, level) {
    return $56656c8f1af07e0a$var$trimInternal(buffer, level, false, true);
}
function $56656c8f1af07e0a$var$trimInternal(buffer, level, trimLeft, trimRight) {
    $56656c8f1af07e0a$var$validate(buffer);
    level = level == null ? 0 : Math.abs(level);
    var start, end;
    if (trimLeft) {
        start = buffer.length;
        //FIXME: replace with indexOF
        for(var channel = 0, c = buffer.numberOfChannels; channel < c; channel++){
            var data = buffer.getChannelData(channel);
            for(var i = 0; i < data.length; i++){
                if (i > start) break;
                if (Math.abs(data[i]) > level) {
                    start = i;
                    break;
                }
            }
        }
    } else start = 0;
    if (trimRight) {
        end = 0;
        //FIXME: replace with lastIndexOf
        for(var channel = 0, c = buffer.numberOfChannels; channel < c; channel++){
            var data = buffer.getChannelData(channel);
            for(var i = data.length - 1; i >= 0; i--){
                if (i < end) break;
                if (Math.abs(data[i]) > level) {
                    end = i + 1;
                    break;
                }
            }
        }
    } else end = buffer.length;
    return $56656c8f1af07e0a$var$slice(buffer, start, end);
}
/**
 * Mix current buffer with the other one.
 * The reason to modify bufferA instead of returning the new buffer
 * is reduced amount of calculations and flexibility.
 * If required, the cloning can be done before mixing, which will be the same.
 */ function $56656c8f1af07e0a$var$mix(bufferA, bufferB, ratio, offset) {
    $56656c8f1af07e0a$var$validate(bufferA);
    $56656c8f1af07e0a$var$validate(bufferB);
    if (ratio == null) ratio = 0.5;
    var fn = ratio instanceof Function ? ratio : function(a, b) {
        return a * (1 - ratio) + b * ratio;
    };
    if (offset == null) offset = 0;
    else if (offset < 0) offset += bufferA.length;
    for(var channel = 0; channel < bufferA.numberOfChannels; channel++){
        var aData = bufferA.getChannelData(channel);
        var bData = bufferB.getChannelData(channel);
        for(var i = offset, j = 0; i < bufferA.length && j < bufferB.length; i++, j++)aData[i] = fn.call(bufferA, aData[i], bData[j], j, channel);
    }
    return bufferA;
}
/**
 * Size of a buffer, in bytes
 */ function $56656c8f1af07e0a$var$size(buffer) {
    $56656c8f1af07e0a$var$validate(buffer);
    return buffer.numberOfChannels * buffer.getChannelData(0).byteLength;
}
/**
 * Return array with buffer’s per-channel data
 */ function $56656c8f1af07e0a$var$data(buffer, data) {
    $56656c8f1af07e0a$var$validate(buffer);
    //ensure output data array, if not defined
    data = data || [];
    //transfer data per-channel
    for(var channel = 0; channel < buffer.numberOfChannels; channel++)if (ArrayBuffer.isView(data[channel])) data[channel].set(buffer.getChannelData(channel));
    else data[channel] = buffer.getChannelData(channel);
    return data;
}

});
parcelRegister("2BMfG", function(module, exports) {
/**
 * AudioBuffer class
 *
 * @module audio-buffer/buffer
 */ 'use strict';

var $7LWHU = parcelRequire("7LWHU");
module.exports = $1e647752402e6cdc$var$AudioBuffer;
/**
 * @constructor
 */ function $1e647752402e6cdc$var$AudioBuffer(context, options) {
    if (!(this instanceof $1e647752402e6cdc$var$AudioBuffer)) return new $1e647752402e6cdc$var$AudioBuffer(context, options);
    //if no options passed
    if (!options) {
        options = context;
        context = options && options.context;
    }
    if (!options) options = {};
    if (context === undefined) context = $7LWHU();
    //detect params
    if (options.numberOfChannels == null) options.numberOfChannels = 1;
    if (options.sampleRate == null) options.sampleRate = context && context.sampleRate || this.sampleRate;
    if (options.length == null) {
        if (options.duration != null) options.length = options.duration * options.sampleRate;
        else options.length = 1;
    }
    //if existing context
    if (context && context.createBuffer) //create WAA buffer
    return context.createBuffer(options.numberOfChannels, Math.ceil(options.length), options.sampleRate);
    //exposed properties
    this.length = Math.ceil(options.length);
    this.numberOfChannels = options.numberOfChannels;
    this.sampleRate = options.sampleRate;
    this.duration = this.length / this.sampleRate;
    //data is stored as a planar sequence
    this._data = new Float32Array(this.length * this.numberOfChannels);
    //channels data is cached as subarrays
    this._channelData = [];
    for(var c = 0; c < this.numberOfChannels; c++)this._channelData.push(this._data.subarray(c * this.length, (c + 1) * this.length));
}
/**
 * Default params
 */ $1e647752402e6cdc$var$AudioBuffer.prototype.numberOfChannels = 1;
$1e647752402e6cdc$var$AudioBuffer.prototype.sampleRate = 44100;
/**
 * Return data associated with the channel.
 *
 * @return {Array} Array containing the data
 */ $1e647752402e6cdc$var$AudioBuffer.prototype.getChannelData = function(channel) {
    if (channel >= this.numberOfChannels || channel < 0 || channel == null) throw Error('Cannot getChannelData: channel number (' + channel + ') exceeds number of channels (' + this.numberOfChannels + ')');
    return this._channelData[channel];
};
/**
 * Place data to the destination buffer, starting from the position
 */ $1e647752402e6cdc$var$AudioBuffer.prototype.copyFromChannel = function(destination, channelNumber, startInChannel) {
    if (startInChannel == null) startInChannel = 0;
    var data = this._channelData[channelNumber];
    for(var i = startInChannel, j = 0; i < this.length && j < destination.length; i++, j++)destination[j] = data[i];
};
/**
 * Place data from the source to the channel, starting (in self) from the position
 */ $1e647752402e6cdc$var$AudioBuffer.prototype.copyToChannel = function(source, channelNumber, startInChannel) {
    var data = this._channelData[channelNumber];
    if (!startInChannel) startInChannel = 0;
    for(var i = startInChannel, j = 0; i < this.length && j < source.length; i++, j++)data[i] = source[j];
};

});
parcelRegister("7LWHU", function(module, exports) {
'use strict';
var $5a8a7632fbab580e$var$cache = {};
module.exports = function getContext(options) {
    if (typeof window === 'undefined') return null;
    var OfflineContext = window.OfflineAudioContext || window.webkitOfflineAudioContext;
    var Context = window.AudioContext || window.webkitAudioContext;
    if (!Context) return null;
    if (typeof options === 'number') options = {
        sampleRate: options
    };
    var sampleRate = options && options.sampleRate;
    if (options && options.offline) {
        if (!OfflineContext) return null;
        return new OfflineContext(options.channels || 2, options.length, sampleRate || 44100);
    }
    //cache by sampleRate, rather strong guess
    var ctx = $5a8a7632fbab580e$var$cache[sampleRate];
    if (ctx) return ctx;
    //several versions of firefox have issues with the
    //constructor argument
    //see: https://bugzilla.mozilla.org/show_bug.cgi?id=1361475
    try {
        ctx = new Context(options);
    } catch (err) {
        ctx = new Context();
    }
    $5a8a7632fbab580e$var$cache[ctx.sampleRate] = $5a8a7632fbab580e$var$cache[sampleRate] = ctx;
    return ctx;
};

});


parcelRegister("3Bjqc", function(module, exports) {
/**
 * @module  is-audio-buffer
 */ 'use strict';
module.exports = function isAudioBuffer(buffer) {
    //the guess is duck-typing
    return buffer != null && typeof buffer.length === 'number' && typeof buffer.sampleRate === 'number' //swims like AudioBuffer
     && typeof buffer.getChannelData === 'function' //quacks like AudioBuffer
     && typeof buffer.duration === 'number';
};

});

parcelRegister("2DZYW", function(module, exports) {
module.exports = true;

});

parcelRegister("1bIHi", function(module, exports) {
module.exports = $0dd97d7c482d7453$var$clamp;
function $0dd97d7c482d7453$var$clamp(value, min, max) {
    return min < max ? value < min ? min : value > max ? max : value : value < max ? max : value > min ? min : value;
}

});

parcelRegister("1Tv42", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};

});

parcelRegister("ZiNL4", function(module, exports) {
/**
 * @module  audio-dtype
 */ 'use strict';

var $2BMfG = parcelRequire("2BMfG");

var $3Bjqc = parcelRequire("3Bjqc");

var $3aHTW = parcelRequire("3aHTW");

var $7LWHU = parcelRequire("7LWHU");

var $evyLq = parcelRequire("evyLq");

var $4eC3c = parcelRequire("4eC3c");

var $dZQxA = parcelRequire("dZQxA");

var $dzE9k = parcelRequire("dzE9k");
module.exports = function createBuffer(source, options) {
    var length, data, channels, sampleRate, format, c, l;
    //src, channels
    if (typeof options === 'number') options = {
        channels: options
    };
    else if (typeof options === 'string') options = {
        format: options
    };
    else if (options === undefined) {
        if ($3aHTW(source)) {
            options = source;
            source = undefined;
        } else options = {};
    }
    options = $dzE9k(options, {
        format: 'format type dtype dataType',
        channels: 'channel channels numberOfChannels channelCount',
        sampleRate: 'sampleRate rate',
        length: 'length size',
        duration: 'duration time'
    });
    //detect options
    channels = options.channels;
    sampleRate = options.sampleRate;
    if (options.format) format = $0b84483753aae3f0$var$getFormat(options.format);
    if (format) {
        if (channels && !format.channels) format.channels = channels;
        else if (format.channels && !channels) channels = format.channels;
        if (!sampleRate && format.sampleRate) sampleRate = format.sampleRate;
    }
    //empty buffer
    if (source == null) {
        if (options.duration != null) {
            if (!sampleRate) sampleRate = 44100;
            length = sampleRate * options.duration;
        } else length = options.length;
    } else if ($3Bjqc(source)) {
        length = source.length;
        if (channels == null) channels = source.numberOfChannels;
        if (sampleRate == null) sampleRate = source.sampleRate;
        if (source._channelData) data = source._channelData.slice(0, channels);
        else {
            data = [];
            for(c = 0, l = channels; c < l; c++)data[c] = source.getChannelData(c);
        }
    } else if (typeof source === 'number') length = source;
    else if (Array.isArray(source) && (Array.isArray(source[0]) || ArrayBuffer.isView(source[0]))) {
        length = source[0].length;
        data = [];
        if (!channels) channels = source.length;
        for(c = 0; c < channels; c++)data[c] = source[c] instanceof Float32Array ? source[c] : new Float32Array(source[c]);
    } else if (source.shape && source.data) {
        if (source.shape) channels = source.shape[1];
        if (!sampleRate && source.format) sampleRate = source.format.sampleRate;
        return createBuffer(source.data, {
            channels: channels,
            sampleRate: sampleRate
        });
    } else {
        if (typeof source === 'string') source = $dZQxA(source);
        if (!format) format = $0b84483753aae3f0$var$getFormat(source);
        if (!channels) channels = format.channels || 1;
        source = $evyLq(source, format, 'float32 planar');
        length = Math.floor(source.length / channels);
        data = [];
        for(c = 0; c < channels; c++)data[c] = source.subarray(c * length, (c + 1) * length);
    }
    //create buffer of proper length
    var audioBuffer = new $2BMfG(options.context === null || length === 0 ? null : options.context || $7LWHU(), {
        length: length == null ? 1 : length,
        numberOfChannels: channels || 1,
        sampleRate: sampleRate || 44100
    });
    //fill channels
    if (data) for(c = 0, l = data.length; c < l; c++)audioBuffer.getChannelData(c).set(data[c]);
    return audioBuffer;
};
function $0b84483753aae3f0$var$getFormat(arg) {
    return typeof arg === 'string' ? $4eC3c.parse(arg) : $4eC3c.detect(arg);
}

});
parcelRegister("3aHTW", function(module, exports) {
'use strict';
var $24f45c217d2b910e$var$toString = Object.prototype.toString;
module.exports = function(x) {
    var prototype;
    return $24f45c217d2b910e$var$toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
};

});

parcelRegister("evyLq", function(module, exports) {
/**
 * @module pcm-convert
 */ 'use strict';

var $foPox = parcelRequire("foPox");

var $7E4wf = parcelRequire("7E4wf");

var $4eC3c = parcelRequire("4eC3c");

var $2ocMU = parcelRequire("2ocMU");

var $3Bjqc = parcelRequire("3Bjqc");
module.exports = $a8feed56d3fab603$var$convert;
function $a8feed56d3fab603$var$convert(buffer, from, to, target) {
    $foPox(buffer, 'First argument should be data');
    $foPox(from, 'Second argument should be format string or object');
    //quick ignore
    if (from === to) return buffer;
    //2-containers case
    if ($a8feed56d3fab603$var$isContainer(from)) {
        target = from;
        to = $4eC3c.detect(target);
        from = $4eC3c.detect(buffer);
    } else if (to === undefined && target === undefined) {
        to = $a8feed56d3fab603$var$getFormat(from);
        from = $4eC3c.detect(buffer);
    } else if ($a8feed56d3fab603$var$isContainer(to)) {
        target = to;
        to = $a8feed56d3fab603$var$getFormat(from);
        from = $4eC3c.detect(buffer);
    } else {
        var inFormat = $a8feed56d3fab603$var$getFormat(from);
        var srcFormat = $4eC3c.detect(buffer);
        srcFormat.dtype = inFormat.type === 'arraybuffer' ? srcFormat.type : inFormat.type;
        from = $2ocMU(inFormat, srcFormat);
        var outFormat = $a8feed56d3fab603$var$getFormat(to);
        var dstFormat = $4eC3c.detect(target);
        if (outFormat.type) dstFormat.dtype = outFormat.type === 'arraybuffer' ? dstFormat.type || from.dtype : outFormat.type;
        to = $2ocMU(outFormat, dstFormat);
    }
    if (to.channels == null && from.channels != null) to.channels = from.channels;
    if (to.type == null) {
        to.type = from.type;
        to.dtype = from.dtype;
    }
    if (to.interleaved != null && from.channels == null) from.channels = 2;
    //ignore same format
    if (from.type === to.type && from.interleaved === to.interleaved && from.endianness === to.endianness) return buffer;
    $a8feed56d3fab603$var$normalize(from);
    $a8feed56d3fab603$var$normalize(to);
    //audio-buffer-list/audio types
    if (buffer.buffers || buffer.buffer && buffer.buffer.buffers) {
        //handle audio
        if (buffer.buffer) buffer = buffer.buffer;
        //handle audiobufferlist
        if (buffer.buffers) buffer = buffer.join();
    }
    var src;
    //convert buffer/alike to arrayBuffer
    if ($3Bjqc(buffer)) {
        if (buffer._data) src = buffer._data;
        else {
            src = new Float32Array(buffer.length * buffer.numberOfChannels);
            for(var c = 0, l = buffer.numberOfChannels; c < l; c++)src.set(buffer.getChannelData(c), buffer.length * c);
        }
    } else if (buffer instanceof ArrayBuffer) src = new $a8feed56d3fab603$var$dtypeClass[from.dtype](buffer);
    else if ($7E4wf(buffer)) {
        if (buffer.byteOffset != null) src = buffer.buffer.slice(buffer.byteOffset, buffer.byteOffset + buffer.byteLength);
        else src = buffer.buffer;
        src = new $a8feed56d3fab603$var$dtypeClass[from.dtype](src);
    } else src = buffer;
    //dst is automatically filled with mapped values
    //but in some cases mapped badly, e. g. float → int(round + rotate)
    var dst = to.type === 'array' ? Array.from(src) : new $a8feed56d3fab603$var$dtypeClass[to.dtype](src);
    //if range differ, we should apply more thoughtful mapping
    if (from.max !== to.max) {
        var fromRange = from.max - from.min, toRange = to.max - to.min;
        for(var i = 0, l = src.length; i < l; i++){
            var value = src[i];
            //ignore not changed range
            //bring to 0..1
            var normalValue = (value - from.min) / fromRange;
            //bring to new format ranges
            value = normalValue * toRange + to.min;
            //clamp (buffers do not like values outside of bounds)
            dst[i] = Math.max(to.min, Math.min(to.max, value));
        }
    }
    //reinterleave, if required
    if (from.interleaved != to.interleaved) {
        var channels = from.channels;
        var len = Math.floor(src.length / channels);
        //deinterleave
        if (from.interleaved && !to.interleaved) dst = dst.map(function(value, idx, data) {
            var offset = idx % len;
            var channel = ~~(idx / len);
            return data[offset * channels + channel];
        });
        else if (!from.interleaved && to.interleaved) dst = dst.map(function(value, idx, data) {
            var offset = ~~(idx / channels);
            var channel = idx % channels;
            return data[channel * len + offset];
        });
    }
    //ensure endianness
    if (to.dtype != 'array' && to.dtype != 'int8' && to.dtype != 'uint8' && from.endianness && to.endianness && from.endianness !== to.endianness) {
        var le = to.endianness === 'le';
        var view = new DataView(dst.buffer);
        var step = dst.BYTES_PER_ELEMENT;
        var methodName = 'set' + to.dtype[0].toUpperCase() + to.dtype.slice(1);
        for(var i = 0, l = dst.length; i < l; i++)view[methodName](i * step, dst[i], le);
    }
    to.type;
    if (target) {
        if (Array.isArray(target)) for(var i = 0; i < dst.length; i++)target[i] = dst[i];
        else if (target instanceof ArrayBuffer) {
            var targetContainer = new $a8feed56d3fab603$var$dtypeClass[to.dtype](target);
            targetContainer.set(dst);
            target = targetContainer;
        } else target.set(dst);
        dst = target;
    }
    if (to.type === 'arraybuffer' || to.type === 'buffer') dst = dst.buffer;
    return dst;
}
function $a8feed56d3fab603$var$getFormat(arg) {
    return typeof arg === 'string' ? $4eC3c.parse(arg) : $4eC3c.detect(arg);
}
function $a8feed56d3fab603$var$isContainer(arg) {
    return typeof arg != 'string' && (Array.isArray(arg) || ArrayBuffer.isView(arg) || arg instanceof ArrayBuffer);
}
var $a8feed56d3fab603$var$dtypeClass = {
    'uint8': Uint8Array,
    'uint8_clamped': Uint8ClampedArray,
    'uint16': Uint16Array,
    'uint32': Uint32Array,
    'int8': Int8Array,
    'int16': Int16Array,
    'int32': Int32Array,
    'float32': Float32Array,
    'float64': Float64Array,
    'array': Array,
    'arraybuffer': Uint8Array,
    'buffer': Uint8Array
};
var $a8feed56d3fab603$var$defaultDtype = {
    'float32': 'float32',
    'audiobuffer': 'float32',
    'ndsamples': 'float32',
    'ndarray': 'float32',
    'float64': 'float64',
    'buffer': 'uint8',
    'arraybuffer': 'uint8',
    'uint8': 'uint8',
    'uint8_clamped': 'uint8',
    'uint16': 'uint16',
    'uint32': 'uint32',
    'int8': 'int8',
    'int16': 'int16',
    'int32': 'int32',
    'array': 'array'
};
//make sure all format properties are present
function $a8feed56d3fab603$var$normalize(obj) {
    if (!obj.dtype) obj.dtype = $a8feed56d3fab603$var$defaultDtype[obj.type] || 'array';
    //provide limits
    switch(obj.dtype){
        case 'float32':
        case 'float64':
        case 'audiobuffer':
        case 'ndsamples':
        case 'ndarray':
            obj.min = -1;
            obj.max = 1;
            break;
        case 'uint8':
            obj.min = 0;
            obj.max = 255;
            break;
        case 'uint16':
            obj.min = 0;
            obj.max = 65535;
            break;
        case 'uint32':
            obj.min = 0;
            obj.max = 4294967295;
            break;
        case 'int8':
            obj.min = -128;
            obj.max = 127;
            break;
        case 'int16':
            obj.min = -32768;
            obj.max = 32767;
            break;
        case 'int32':
            obj.min = -2147483648;
            obj.max = 2147483647;
            break;
        default:
            obj.min = -1;
            obj.max = 1;
            break;
    }
    return obj;
}

});
parcelRegister("foPox", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4Jj9n = parcelRequire("4Jj9n");
'use strict';
function $b360f6dc8340292f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b360f6dc8340292f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b360f6dc8340292f$var$_typeof(o);
}
function $b360f6dc8340292f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $b360f6dc8340292f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $b360f6dc8340292f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b360f6dc8340292f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b360f6dc8340292f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b360f6dc8340292f$var$_toPropertyKey(arg) {
    var key = $b360f6dc8340292f$var$_toPrimitive(arg, "string");
    return $b360f6dc8340292f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b360f6dc8340292f$var$_toPrimitive(input, hint) {
    if ($b360f6dc8340292f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b360f6dc8340292f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $b360f6dc8340292f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $l81CI = parcelRequire("l81CI");
var $b360f6dc8340292f$var$_require$codes = $l81CI.codes, $b360f6dc8340292f$var$ERR_AMBIGUOUS_ARGUMENT = $b360f6dc8340292f$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $b360f6dc8340292f$var$ERR_INVALID_ARG_TYPE = $b360f6dc8340292f$var$_require$codes.ERR_INVALID_ARG_TYPE, $b360f6dc8340292f$var$ERR_INVALID_ARG_VALUE = $b360f6dc8340292f$var$_require$codes.ERR_INVALID_ARG_VALUE, $b360f6dc8340292f$var$ERR_INVALID_RETURN_VALUE = $b360f6dc8340292f$var$_require$codes.ERR_INVALID_RETURN_VALUE, $b360f6dc8340292f$var$ERR_MISSING_ARGS = $b360f6dc8340292f$var$_require$codes.ERR_MISSING_ARGS;

var $iJFgN = parcelRequire("iJFgN");

var $pVemT = parcelRequire("pVemT");
var $b360f6dc8340292f$var$inspect = $pVemT.inspect;

var $pVemT = parcelRequire("pVemT");
var $b360f6dc8340292f$require$_require$types = $pVemT.types;
var $b360f6dc8340292f$var$isPromise = $b360f6dc8340292f$require$_require$types.isPromise, $b360f6dc8340292f$var$isRegExp = $b360f6dc8340292f$require$_require$types.isRegExp;

var $b360f6dc8340292f$var$objectAssign = (parcelRequire("a1N7Q"))();

var $b360f6dc8340292f$var$objectIs = (parcelRequire("4WxrU"))();

var $b360f6dc8340292f$var$RegExpPrototypeTest = (parcelRequire("cHfzZ"))('RegExp.prototype.test');
var $b360f6dc8340292f$var$errorCache = new Map();
var $b360f6dc8340292f$var$isDeepEqual;
var $b360f6dc8340292f$var$isDeepStrictEqual;
var $b360f6dc8340292f$var$parseExpressionAt;
var $b360f6dc8340292f$var$findNodeAround;
var $b360f6dc8340292f$var$decoder;

function $b360f6dc8340292f$var$lazyLoadComparison() {
    var comparison = (parcelRequire("aO7Zc"));
    $b360f6dc8340292f$var$isDeepEqual = comparison.isDeepEqual;
    $b360f6dc8340292f$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $b360f6dc8340292f$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $b360f6dc8340292f$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $b360f6dc8340292f$var$escapeFn = function escapeFn(str) {
    return $b360f6dc8340292f$var$meta[str.charCodeAt(0)];
};
var $b360f6dc8340292f$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $b360f6dc8340292f$var$assert = module.exports = $b360f6dc8340292f$var$ok;
var $b360f6dc8340292f$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $b360f6dc8340292f$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $iJFgN(obj);
}
function $b360f6dc8340292f$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($b360f6dc8340292f$var$warned === false) {
            $b360f6dc8340292f$var$warned = true;
            var warn = $4Jj9n.emitWarning ? $4Jj9n.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $b360f6dc8340292f$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $iJFgN(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$b360f6dc8340292f$var$assert.fail = $b360f6dc8340292f$var$fail;
// The AssertionError is defined in internal/error.
$b360f6dc8340292f$var$assert.AssertionError = $iJFgN;
function $b360f6dc8340292f$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $iJFgN({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $b360f6dc8340292f$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $b360f6dc8340292f$var$innerOk.apply(void 0, [
        $b360f6dc8340292f$var$ok,
        args.length
    ].concat(args));
}
$b360f6dc8340292f$var$assert.ok = $b360f6dc8340292f$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $b360f6dc8340292f$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $b360f6dc8340292f$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $b360f6dc8340292f$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$b360f6dc8340292f$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b360f6dc8340292f$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $b360f6dc8340292f$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$b360f6dc8340292f$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b360f6dc8340292f$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b360f6dc8340292f$var$isDeepEqual === undefined) $b360f6dc8340292f$var$lazyLoadComparison();
    if (!$b360f6dc8340292f$var$isDeepEqual(actual, expected)) $b360f6dc8340292f$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$b360f6dc8340292f$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b360f6dc8340292f$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b360f6dc8340292f$var$isDeepEqual === undefined) $b360f6dc8340292f$var$lazyLoadComparison();
    if ($b360f6dc8340292f$var$isDeepEqual(actual, expected)) $b360f6dc8340292f$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $b360f6dc8340292f$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b360f6dc8340292f$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b360f6dc8340292f$var$isDeepEqual === undefined) $b360f6dc8340292f$var$lazyLoadComparison();
    if (!$b360f6dc8340292f$var$isDeepStrictEqual(actual, expected)) $b360f6dc8340292f$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$b360f6dc8340292f$var$assert.notDeepStrictEqual = $b360f6dc8340292f$var$notDeepStrictEqual;
function $b360f6dc8340292f$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b360f6dc8340292f$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b360f6dc8340292f$var$isDeepEqual === undefined) $b360f6dc8340292f$var$lazyLoadComparison();
    if ($b360f6dc8340292f$var$isDeepStrictEqual(actual, expected)) $b360f6dc8340292f$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $b360f6dc8340292f$var$notDeepStrictEqual
    });
}
$b360f6dc8340292f$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b360f6dc8340292f$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$b360f6dc8340292f$var$objectIs(actual, expected)) $b360f6dc8340292f$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$b360f6dc8340292f$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b360f6dc8340292f$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b360f6dc8340292f$var$objectIs(actual, expected)) $b360f6dc8340292f$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $b360f6dc8340292f$var$Comparison = /*#__PURE__*/ $b360f6dc8340292f$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $b360f6dc8340292f$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $b360f6dc8340292f$var$isRegExp(obj[key]) && $b360f6dc8340292f$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $b360f6dc8340292f$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$b360f6dc8340292f$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $b360f6dc8340292f$var$Comparison(actual, keys);
            var b = new $b360f6dc8340292f$var$Comparison(expected, keys, actual);
            var err = new $iJFgN({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $b360f6dc8340292f$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $b360f6dc8340292f$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($b360f6dc8340292f$var$isRegExp(expected)) return $b360f6dc8340292f$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $b360f6dc8340292f$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($b360f6dc8340292f$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $iJFgN({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $b360f6dc8340292f$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($b360f6dc8340292f$var$isDeepEqual === undefined) $b360f6dc8340292f$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $b360f6dc8340292f$var$isRegExp(expected[key]) && $b360f6dc8340292f$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $b360f6dc8340292f$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $b360f6dc8340292f$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $b360f6dc8340292f$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $b360f6dc8340292f$var$NO_EXCEPTION_SENTINEL;
}
function $b360f6dc8340292f$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $b360f6dc8340292f$var$isPromise(obj) || obj !== null && $b360f6dc8340292f$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $b360f6dc8340292f$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$b360f6dc8340292f$var$checkIsPromise(resultPromise)) throw new $b360f6dc8340292f$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($b360f6dc8340292f$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $b360f6dc8340292f$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $b360f6dc8340292f$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $b360f6dc8340292f$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $b360f6dc8340292f$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($b360f6dc8340292f$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $b360f6dc8340292f$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $b360f6dc8340292f$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $b360f6dc8340292f$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $b360f6dc8340292f$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $b360f6dc8340292f$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $b360f6dc8340292f$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$b360f6dc8340292f$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $b360f6dc8340292f$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $b360f6dc8340292f$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $b360f6dc8340292f$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $b360f6dc8340292f$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$b360f6dc8340292f$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $b360f6dc8340292f$var$expectsError.apply(void 0, [
        throws,
        $b360f6dc8340292f$var$getActual(promiseFn)
    ].concat(args));
};
$b360f6dc8340292f$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $b360f6dc8340292f$var$waitForActual(promiseFn).then(function(result) {
        return $b360f6dc8340292f$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$b360f6dc8340292f$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $b360f6dc8340292f$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $b360f6dc8340292f$var$getActual(fn)
    ].concat(args));
};
$b360f6dc8340292f$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $b360f6dc8340292f$var$waitForActual(fn).then(function(result) {
        return $b360f6dc8340292f$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$b360f6dc8340292f$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($b360f6dc8340292f$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $b360f6dc8340292f$var$inspect(err);
        var newErr = new $iJFgN({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $b360f6dc8340292f$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$b360f6dc8340292f$var$isRegExp(regexp)) throw new $b360f6dc8340292f$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $b360f6dc8340292f$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($b360f6dc8340292f$var$_typeof(string), " (").concat($b360f6dc8340292f$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($b360f6dc8340292f$var$inspect(regexp), ". Input:\n\n").concat($b360f6dc8340292f$var$inspect(string), "\n"));
        var err = new $iJFgN({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$b360f6dc8340292f$var$assert.match = function match(string, regexp, message) {
    $b360f6dc8340292f$var$internalMatch(string, regexp, message, match, 'match');
};
$b360f6dc8340292f$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $b360f6dc8340292f$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $b360f6dc8340292f$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $b360f6dc8340292f$var$innerOk.apply(void 0, [
        $b360f6dc8340292f$var$strict,
        args.length
    ].concat(args));
}
$b360f6dc8340292f$var$assert.strict = $b360f6dc8340292f$var$objectAssign($b360f6dc8340292f$var$strict, $b360f6dc8340292f$var$assert, {
    equal: $b360f6dc8340292f$var$assert.strictEqual,
    deepEqual: $b360f6dc8340292f$var$assert.deepStrictEqual,
    notEqual: $b360f6dc8340292f$var$assert.notStrictEqual,
    notDeepEqual: $b360f6dc8340292f$var$assert.notDeepStrictEqual
});
$b360f6dc8340292f$var$assert.strict.strict = $b360f6dc8340292f$var$assert.strict;

});
parcelRegister("4Jj9n", function(module, exports) {
// shim for using process in browser
var $371a3837fd81d701$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = 'browser';
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ''; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$371a3837fd81d701$var$process.cwd = function() {
    return '/';
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};

});

parcelRegister("l81CI", function(module, exports) {

$parcel$export(module.exports, "codes", () => $f61b9ab4c7fc769f$export$e45cb6485273080e, (v) => $f61b9ab4c7fc769f$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $f61b9ab4c7fc769f$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $f61b9ab4c7fc769f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f61b9ab4c7fc769f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f61b9ab4c7fc769f$var$_typeof(o);
}
function $f61b9ab4c7fc769f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f61b9ab4c7fc769f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f61b9ab4c7fc769f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f61b9ab4c7fc769f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f61b9ab4c7fc769f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f61b9ab4c7fc769f$var$_toPropertyKey(arg) {
    var key = $f61b9ab4c7fc769f$var$_toPrimitive(arg, "string");
    return $f61b9ab4c7fc769f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f61b9ab4c7fc769f$var$_toPrimitive(input, hint) {
    if ($f61b9ab4c7fc769f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f61b9ab4c7fc769f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f61b9ab4c7fc769f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f61b9ab4c7fc769f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $f61b9ab4c7fc769f$var$_setPrototypeOf(subClass, superClass);
}
function $f61b9ab4c7fc769f$var$_setPrototypeOf(o, p) {
    $f61b9ab4c7fc769f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f61b9ab4c7fc769f$var$_setPrototypeOf(o, p);
}
function $f61b9ab4c7fc769f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f61b9ab4c7fc769f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $f61b9ab4c7fc769f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f61b9ab4c7fc769f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f61b9ab4c7fc769f$var$_possibleConstructorReturn(this, result);
    };
}
function $f61b9ab4c7fc769f$var$_possibleConstructorReturn(self, call) {
    if (call && ($f61b9ab4c7fc769f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f61b9ab4c7fc769f$var$_assertThisInitialized(self);
}
function $f61b9ab4c7fc769f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f61b9ab4c7fc769f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f61b9ab4c7fc769f$var$_getPrototypeOf(o) {
    $f61b9ab4c7fc769f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f61b9ab4c7fc769f$var$_getPrototypeOf(o);
}
var $f61b9ab4c7fc769f$var$codes = {};
// Lazy loaded
var $f61b9ab4c7fc769f$var$assert;
var $f61b9ab4c7fc769f$var$util;
function $f61b9ab4c7fc769f$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $f61b9ab4c7fc769f$var$_inherits(NodeError, _Base);
        var _super = $f61b9ab4c7fc769f$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $f61b9ab4c7fc769f$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $f61b9ab4c7fc769f$var$_createClass(NodeError);
    }(Base);
    $f61b9ab4c7fc769f$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $f61b9ab4c7fc769f$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $f61b9ab4c7fc769f$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $f61b9ab4c7fc769f$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $f61b9ab4c7fc769f$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$f61b9ab4c7fc769f$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$f61b9ab4c7fc769f$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($f61b9ab4c7fc769f$var$assert === undefined) $f61b9ab4c7fc769f$var$assert = (parcelRequire("foPox"));
    $f61b9ab4c7fc769f$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $f61b9ab4c7fc769f$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($f61b9ab4c7fc769f$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($f61b9ab4c7fc769f$var$oneOf(expected, 'type'));
    else {
        var type = $f61b9ab4c7fc769f$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($f61b9ab4c7fc769f$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($f61b9ab4c7fc769f$var$_typeof(actual));
    return msg;
}, TypeError);

$f61b9ab4c7fc769f$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($f61b9ab4c7fc769f$var$util === undefined) $f61b9ab4c7fc769f$var$util = (parcelRequire("pVemT"));
    var inspected = $f61b9ab4c7fc769f$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$f61b9ab4c7fc769f$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($f61b9ab4c7fc769f$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$f61b9ab4c7fc769f$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($f61b9ab4c7fc769f$var$assert === undefined) $f61b9ab4c7fc769f$var$assert = (parcelRequire("foPox"));
    $f61b9ab4c7fc769f$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$f61b9ab4c7fc769f$export$e45cb6485273080e = $f61b9ab4c7fc769f$var$codes;

});
parcelRegister("pVemT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4Jj9n = parcelRequire("4Jj9n");
var $04debabf9f18a7a1$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $04debabf9f18a7a1$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$04debabf9f18a7a1$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($04debabf9f18a7a1$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($04debabf9f18a7a1$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($04debabf9f18a7a1$var$isNull(x) || !$04debabf9f18a7a1$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $04debabf9f18a7a1$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($4Jj9n.throwDeprecation) throw new Error(msg);
            else if ($4Jj9n.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $04debabf9f18a7a1$var$debugs = {};
var $04debabf9f18a7a1$var$debugEnvRegex = /^$/;
var $04debabf9f18a7a1$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$04debabf9f18a7a1$var$debugs[set]) {
        if ($04debabf9f18a7a1$var$debugEnvRegex.test(set)) {
            var pid = $4Jj9n.pid;
            $04debabf9f18a7a1$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $04debabf9f18a7a1$var$debugs[set] = function() {};
    }
    return $04debabf9f18a7a1$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $04debabf9f18a7a1$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $04debabf9f18a7a1$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($04debabf9f18a7a1$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($04debabf9f18a7a1$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($04debabf9f18a7a1$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($04debabf9f18a7a1$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($04debabf9f18a7a1$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $04debabf9f18a7a1$var$stylizeWithColor;
    return $04debabf9f18a7a1$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $04debabf9f18a7a1$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$04debabf9f18a7a1$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$04debabf9f18a7a1$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $04debabf9f18a7a1$var$stylizeWithColor(str, styleType) {
    var style = $04debabf9f18a7a1$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $04debabf9f18a7a1$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $04debabf9f18a7a1$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $04debabf9f18a7a1$var$stylizeNoColor(str, styleType) {
    return str;
}
function $04debabf9f18a7a1$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $04debabf9f18a7a1$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $04debabf9f18a7a1$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$04debabf9f18a7a1$var$isString(ret)) ret = $04debabf9f18a7a1$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $04debabf9f18a7a1$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $04debabf9f18a7a1$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($04debabf9f18a7a1$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $04debabf9f18a7a1$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($04debabf9f18a7a1$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($04debabf9f18a7a1$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($04debabf9f18a7a1$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($04debabf9f18a7a1$var$isError(value)) return $04debabf9f18a7a1$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($04debabf9f18a7a1$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($04debabf9f18a7a1$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($04debabf9f18a7a1$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($04debabf9f18a7a1$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($04debabf9f18a7a1$var$isError(value)) base = ' ' + $04debabf9f18a7a1$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($04debabf9f18a7a1$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $04debabf9f18a7a1$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $04debabf9f18a7a1$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $04debabf9f18a7a1$var$reduceToSingleString(output, base, braces);
}
function $04debabf9f18a7a1$var$formatPrimitive(ctx, value) {
    if ($04debabf9f18a7a1$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($04debabf9f18a7a1$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($04debabf9f18a7a1$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($04debabf9f18a7a1$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($04debabf9f18a7a1$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $04debabf9f18a7a1$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $04debabf9f18a7a1$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($04debabf9f18a7a1$var$hasOwnProperty(value, String(i))) output.push($04debabf9f18a7a1$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($04debabf9f18a7a1$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $04debabf9f18a7a1$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$04debabf9f18a7a1$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($04debabf9f18a7a1$var$isNull(recurseTimes)) str = $04debabf9f18a7a1$var$formatValue(ctx, desc.value, null);
            else str = $04debabf9f18a7a1$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($04debabf9f18a7a1$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $04debabf9f18a7a1$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("e9HhI"));
function $04debabf9f18a7a1$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $04debabf9f18a7a1$var$isArray;
function $04debabf9f18a7a1$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $04debabf9f18a7a1$var$isBoolean;
function $04debabf9f18a7a1$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $04debabf9f18a7a1$var$isNull;
function $04debabf9f18a7a1$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $04debabf9f18a7a1$var$isNullOrUndefined;
function $04debabf9f18a7a1$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $04debabf9f18a7a1$var$isNumber;
function $04debabf9f18a7a1$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $04debabf9f18a7a1$var$isString;
function $04debabf9f18a7a1$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $04debabf9f18a7a1$var$isSymbol;
function $04debabf9f18a7a1$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $04debabf9f18a7a1$var$isUndefined;
function $04debabf9f18a7a1$var$isRegExp(re) {
    return $04debabf9f18a7a1$var$isObject(re) && $04debabf9f18a7a1$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $04debabf9f18a7a1$var$isRegExp;
module.exports.types.isRegExp = $04debabf9f18a7a1$var$isRegExp;
function $04debabf9f18a7a1$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $04debabf9f18a7a1$var$isObject;
function $04debabf9f18a7a1$var$isDate(d) {
    return $04debabf9f18a7a1$var$isObject(d) && $04debabf9f18a7a1$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $04debabf9f18a7a1$var$isDate;
module.exports.types.isDate = $04debabf9f18a7a1$var$isDate;
function $04debabf9f18a7a1$var$isError(e) {
    return $04debabf9f18a7a1$var$isObject(e) && ($04debabf9f18a7a1$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $04debabf9f18a7a1$var$isError;
module.exports.types.isNativeError = $04debabf9f18a7a1$var$isError;
function $04debabf9f18a7a1$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $04debabf9f18a7a1$var$isFunction;
function $04debabf9f18a7a1$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $04debabf9f18a7a1$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("gVfcn"));
function $04debabf9f18a7a1$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $04debabf9f18a7a1$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $04debabf9f18a7a1$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $04debabf9f18a7a1$var$timestamp() {
    var d = new Date();
    var time = [
        $04debabf9f18a7a1$var$pad(d.getHours()),
        $04debabf9f18a7a1$var$pad(d.getMinutes()),
        $04debabf9f18a7a1$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $04debabf9f18a7a1$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $04debabf9f18a7a1$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("9YOog"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$04debabf9f18a7a1$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $04debabf9f18a7a1$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $04debabf9f18a7a1$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($04debabf9f18a7a1$var$kCustomPromisifiedSymbol && original[$04debabf9f18a7a1$var$kCustomPromisifiedSymbol]) {
        var fn = original[$04debabf9f18a7a1$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $04debabf9f18a7a1$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($04debabf9f18a7a1$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $04debabf9f18a7a1$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $04debabf9f18a7a1$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $04debabf9f18a7a1$var$kCustomPromisifiedSymbol;
function $04debabf9f18a7a1$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $04debabf9f18a7a1$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $4Jj9n.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $4Jj9n.nextTick($04debabf9f18a7a1$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $04debabf9f18a7a1$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $04debabf9f18a7a1$var$callbackify;

});
parcelRegister("e9HhI", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $jEMVV = parcelRequire("jEMVV");

var $3KZPn = parcelRequire("3KZPn");

var $82kf0 = parcelRequire("82kf0");

var $2BlbL = parcelRequire("2BlbL");
function $a4e37b6276faa3cc$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $a4e37b6276faa3cc$var$BigIntSupported = typeof BigInt !== 'undefined';
var $a4e37b6276faa3cc$var$SymbolSupported = typeof Symbol !== 'undefined';
var $a4e37b6276faa3cc$var$ObjectToString = $a4e37b6276faa3cc$var$uncurryThis(Object.prototype.toString);
var $a4e37b6276faa3cc$var$numberValue = $a4e37b6276faa3cc$var$uncurryThis(Number.prototype.valueOf);
var $a4e37b6276faa3cc$var$stringValue = $a4e37b6276faa3cc$var$uncurryThis(String.prototype.valueOf);
var $a4e37b6276faa3cc$var$booleanValue = $a4e37b6276faa3cc$var$uncurryThis(Boolean.prototype.valueOf);
if ($a4e37b6276faa3cc$var$BigIntSupported) var $a4e37b6276faa3cc$var$bigIntValue = $a4e37b6276faa3cc$var$uncurryThis(BigInt.prototype.valueOf);
if ($a4e37b6276faa3cc$var$SymbolSupported) var $a4e37b6276faa3cc$var$symbolValue = $a4e37b6276faa3cc$var$uncurryThis(Symbol.prototype.valueOf);
function $a4e37b6276faa3cc$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $jEMVV;
module.exports.isGeneratorFunction = $3KZPn;
module.exports.isTypedArray = $2BlbL;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $a4e37b6276faa3cc$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $a4e37b6276faa3cc$var$isPromise;
function $a4e37b6276faa3cc$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $2BlbL(value) || $a4e37b6276faa3cc$var$isDataView(value);
}
module.exports.isArrayBufferView = $a4e37b6276faa3cc$var$isArrayBufferView;
function $a4e37b6276faa3cc$var$isUint8Array(value) {
    return $82kf0(value) === 'Uint8Array';
}
module.exports.isUint8Array = $a4e37b6276faa3cc$var$isUint8Array;
function $a4e37b6276faa3cc$var$isUint8ClampedArray(value) {
    return $82kf0(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $a4e37b6276faa3cc$var$isUint8ClampedArray;
function $a4e37b6276faa3cc$var$isUint16Array(value) {
    return $82kf0(value) === 'Uint16Array';
}
module.exports.isUint16Array = $a4e37b6276faa3cc$var$isUint16Array;
function $a4e37b6276faa3cc$var$isUint32Array(value) {
    return $82kf0(value) === 'Uint32Array';
}
module.exports.isUint32Array = $a4e37b6276faa3cc$var$isUint32Array;
function $a4e37b6276faa3cc$var$isInt8Array(value) {
    return $82kf0(value) === 'Int8Array';
}
module.exports.isInt8Array = $a4e37b6276faa3cc$var$isInt8Array;
function $a4e37b6276faa3cc$var$isInt16Array(value) {
    return $82kf0(value) === 'Int16Array';
}
module.exports.isInt16Array = $a4e37b6276faa3cc$var$isInt16Array;
function $a4e37b6276faa3cc$var$isInt32Array(value) {
    return $82kf0(value) === 'Int32Array';
}
module.exports.isInt32Array = $a4e37b6276faa3cc$var$isInt32Array;
function $a4e37b6276faa3cc$var$isFloat32Array(value) {
    return $82kf0(value) === 'Float32Array';
}
module.exports.isFloat32Array = $a4e37b6276faa3cc$var$isFloat32Array;
function $a4e37b6276faa3cc$var$isFloat64Array(value) {
    return $82kf0(value) === 'Float64Array';
}
module.exports.isFloat64Array = $a4e37b6276faa3cc$var$isFloat64Array;
function $a4e37b6276faa3cc$var$isBigInt64Array(value) {
    return $82kf0(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $a4e37b6276faa3cc$var$isBigInt64Array;
function $a4e37b6276faa3cc$var$isBigUint64Array(value) {
    return $82kf0(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $a4e37b6276faa3cc$var$isBigUint64Array;
function $a4e37b6276faa3cc$var$isMapToString(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object Map]';
}
$a4e37b6276faa3cc$var$isMapToString.working = typeof Map !== 'undefined' && $a4e37b6276faa3cc$var$isMapToString(new Map());
function $a4e37b6276faa3cc$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $a4e37b6276faa3cc$var$isMapToString.working ? $a4e37b6276faa3cc$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $a4e37b6276faa3cc$var$isMap;
function $a4e37b6276faa3cc$var$isSetToString(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object Set]';
}
$a4e37b6276faa3cc$var$isSetToString.working = typeof Set !== 'undefined' && $a4e37b6276faa3cc$var$isSetToString(new Set());
function $a4e37b6276faa3cc$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $a4e37b6276faa3cc$var$isSetToString.working ? $a4e37b6276faa3cc$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $a4e37b6276faa3cc$var$isSet;
function $a4e37b6276faa3cc$var$isWeakMapToString(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object WeakMap]';
}
$a4e37b6276faa3cc$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $a4e37b6276faa3cc$var$isWeakMapToString(new WeakMap());
function $a4e37b6276faa3cc$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $a4e37b6276faa3cc$var$isWeakMapToString.working ? $a4e37b6276faa3cc$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $a4e37b6276faa3cc$var$isWeakMap;
function $a4e37b6276faa3cc$var$isWeakSetToString(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object WeakSet]';
}
$a4e37b6276faa3cc$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $a4e37b6276faa3cc$var$isWeakSetToString(new WeakSet());
function $a4e37b6276faa3cc$var$isWeakSet(value) {
    return $a4e37b6276faa3cc$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $a4e37b6276faa3cc$var$isWeakSet;
function $a4e37b6276faa3cc$var$isArrayBufferToString(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$a4e37b6276faa3cc$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $a4e37b6276faa3cc$var$isArrayBufferToString(new ArrayBuffer());
function $a4e37b6276faa3cc$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $a4e37b6276faa3cc$var$isArrayBufferToString.working ? $a4e37b6276faa3cc$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $a4e37b6276faa3cc$var$isArrayBuffer;
function $a4e37b6276faa3cc$var$isDataViewToString(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object DataView]';
}
$a4e37b6276faa3cc$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $a4e37b6276faa3cc$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $a4e37b6276faa3cc$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $a4e37b6276faa3cc$var$isDataViewToString.working ? $a4e37b6276faa3cc$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $a4e37b6276faa3cc$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $a4e37b6276faa3cc$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $a4e37b6276faa3cc$var$isSharedArrayBufferToString(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $a4e37b6276faa3cc$var$isSharedArrayBuffer(value) {
    if (typeof $a4e37b6276faa3cc$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $a4e37b6276faa3cc$var$isSharedArrayBufferToString.working === 'undefined') $a4e37b6276faa3cc$var$isSharedArrayBufferToString.working = $a4e37b6276faa3cc$var$isSharedArrayBufferToString(new $a4e37b6276faa3cc$var$SharedArrayBufferCopy());
    return $a4e37b6276faa3cc$var$isSharedArrayBufferToString.working ? $a4e37b6276faa3cc$var$isSharedArrayBufferToString(value) : value instanceof $a4e37b6276faa3cc$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $a4e37b6276faa3cc$var$isSharedArrayBuffer;
function $a4e37b6276faa3cc$var$isAsyncFunction(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $a4e37b6276faa3cc$var$isAsyncFunction;
function $a4e37b6276faa3cc$var$isMapIterator(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $a4e37b6276faa3cc$var$isMapIterator;
function $a4e37b6276faa3cc$var$isSetIterator(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $a4e37b6276faa3cc$var$isSetIterator;
function $a4e37b6276faa3cc$var$isGeneratorObject(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $a4e37b6276faa3cc$var$isGeneratorObject;
function $a4e37b6276faa3cc$var$isWebAssemblyCompiledModule(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $a4e37b6276faa3cc$var$isWebAssemblyCompiledModule;
function $a4e37b6276faa3cc$var$isNumberObject(value) {
    return $a4e37b6276faa3cc$var$checkBoxedPrimitive(value, $a4e37b6276faa3cc$var$numberValue);
}
module.exports.isNumberObject = $a4e37b6276faa3cc$var$isNumberObject;
function $a4e37b6276faa3cc$var$isStringObject(value) {
    return $a4e37b6276faa3cc$var$checkBoxedPrimitive(value, $a4e37b6276faa3cc$var$stringValue);
}
module.exports.isStringObject = $a4e37b6276faa3cc$var$isStringObject;
function $a4e37b6276faa3cc$var$isBooleanObject(value) {
    return $a4e37b6276faa3cc$var$checkBoxedPrimitive(value, $a4e37b6276faa3cc$var$booleanValue);
}
module.exports.isBooleanObject = $a4e37b6276faa3cc$var$isBooleanObject;
function $a4e37b6276faa3cc$var$isBigIntObject(value) {
    return $a4e37b6276faa3cc$var$BigIntSupported && $a4e37b6276faa3cc$var$checkBoxedPrimitive(value, $a4e37b6276faa3cc$var$bigIntValue);
}
module.exports.isBigIntObject = $a4e37b6276faa3cc$var$isBigIntObject;
function $a4e37b6276faa3cc$var$isSymbolObject(value) {
    return $a4e37b6276faa3cc$var$SymbolSupported && $a4e37b6276faa3cc$var$checkBoxedPrimitive(value, $a4e37b6276faa3cc$var$symbolValue);
}
module.exports.isSymbolObject = $a4e37b6276faa3cc$var$isSymbolObject;
function $a4e37b6276faa3cc$var$isBoxedPrimitive(value) {
    return $a4e37b6276faa3cc$var$isNumberObject(value) || $a4e37b6276faa3cc$var$isStringObject(value) || $a4e37b6276faa3cc$var$isBooleanObject(value) || $a4e37b6276faa3cc$var$isBigIntObject(value) || $a4e37b6276faa3cc$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $a4e37b6276faa3cc$var$isBoxedPrimitive;
function $a4e37b6276faa3cc$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($a4e37b6276faa3cc$var$isArrayBuffer(value) || $a4e37b6276faa3cc$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $a4e37b6276faa3cc$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("jEMVV", function(module, exports) {
'use strict';

var $e4f7b5df835214a3$var$hasToStringTag = (parcelRequire("cJdfe"))();

var $exvo0 = parcelRequire("exvo0");
var $e4f7b5df835214a3$var$$toString = $exvo0('Object.prototype.toString');
/** @type {import('.')} */ var $e4f7b5df835214a3$var$isStandardArguments = function isArguments(value) {
    if ($e4f7b5df835214a3$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $e4f7b5df835214a3$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $e4f7b5df835214a3$var$isLegacyArguments = function isArguments(value) {
    if ($e4f7b5df835214a3$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $e4f7b5df835214a3$var$$toString(value) !== '[object Array]' && 'callee' in value && $e4f7b5df835214a3$var$$toString(value.callee) === '[object Function]';
};
var $e4f7b5df835214a3$var$supportsStandardArguments = function() {
    return $e4f7b5df835214a3$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$e4f7b5df835214a3$var$isStandardArguments.isLegacyArguments = $e4f7b5df835214a3$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $e4f7b5df835214a3$var$supportsStandardArguments ? $e4f7b5df835214a3$var$isStandardArguments : $e4f7b5df835214a3$var$isLegacyArguments;

});
parcelRegister("cJdfe", function(module, exports) {
'use strict';

var $9VQ4N = parcelRequire("9VQ4N");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $9VQ4N() && !!Symbol.toStringTag;
};

});
parcelRegister("9VQ4N", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("exvo0", function(module, exports) {
'use strict';

var $4YUXM = parcelRequire("4YUXM");

var $lH1kJ = parcelRequire("lH1kJ");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $a95c7e6883bd7de8$var$$indexOf = $lH1kJ([
    $4YUXM('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $4YUXM(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $a95c7e6883bd7de8$var$$indexOf(name, '.prototype.') > -1) return $lH1kJ(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("4YUXM", function(module, exports) {
'use strict';
var $3a08f3b93b399588$var$undefined1;

var $aiQs8 = parcelRequire("aiQs8");

var $2DlCe = parcelRequire("2DlCe");

var $TtWO0 = parcelRequire("TtWO0");

var $aG0Ti = parcelRequire("aG0Ti");

var $cwaZa = parcelRequire("cwaZa");

var $1rcCL = parcelRequire("1rcCL");

var $jQFIR = parcelRequire("jQFIR");

var $6Unty = parcelRequire("6Unty");

var $38UJ9 = parcelRequire("38UJ9");

var $iGzt4 = parcelRequire("iGzt4");

var $dWJBO = parcelRequire("dWJBO");

var $i9udS = parcelRequire("i9udS");

var $hE7Bh = parcelRequire("hE7Bh");

var $gJSpD = parcelRequire("gJSpD");

var $8xHx6 = parcelRequire("8xHx6");
var $3a08f3b93b399588$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $3a08f3b93b399588$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $3a08f3b93b399588$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $7SE9t = parcelRequire("7SE9t");

var $cILf7 = parcelRequire("cILf7");
var $3a08f3b93b399588$var$throwTypeError = function() {
    throw new $jQFIR();
};
var $3a08f3b93b399588$var$ThrowTypeError = $7SE9t ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $3a08f3b93b399588$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $7SE9t(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $3a08f3b93b399588$var$throwTypeError;
        }
    }
}() : $3a08f3b93b399588$var$throwTypeError;

var $3a08f3b93b399588$var$hasSymbols = (parcelRequire("fa2Fq"))();

var $cKjXh = parcelRequire("cKjXh");

var $5O4uz = parcelRequire("5O4uz");

var $bOsTQ = parcelRequire("bOsTQ");

var $4G4X6 = parcelRequire("4G4X6");

var $9ttrx = parcelRequire("9ttrx");
var $3a08f3b93b399588$var$needsEval = {};
var $3a08f3b93b399588$var$TypedArray = typeof Uint8Array === 'undefined' || !$cKjXh ? undefined : $cKjXh(Uint8Array);
var $3a08f3b93b399588$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $3a08f3b93b399588$var$hasSymbols && $cKjXh ? $cKjXh([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $3a08f3b93b399588$var$needsEval,
    '%AsyncGenerator%': $3a08f3b93b399588$var$needsEval,
    '%AsyncGeneratorFunction%': $3a08f3b93b399588$var$needsEval,
    '%AsyncIteratorPrototype%': $3a08f3b93b399588$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $2DlCe,
    '%eval%': eval,
    '%EvalError%': $TtWO0,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $3a08f3b93b399588$var$$Function,
    '%GeneratorFunction%': $3a08f3b93b399588$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $3a08f3b93b399588$var$hasSymbols && $cKjXh ? $cKjXh($cKjXh([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$3a08f3b93b399588$var$hasSymbols || !$cKjXh ? undefined : $cKjXh(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $aiQs8,
    '%Object.getOwnPropertyDescriptor%': $7SE9t,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $aG0Ti,
    '%ReferenceError%': $cwaZa,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$3a08f3b93b399588$var$hasSymbols || !$cKjXh ? undefined : $cKjXh(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $3a08f3b93b399588$var$hasSymbols && $cKjXh ? $cKjXh(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $3a08f3b93b399588$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $1rcCL,
    '%ThrowTypeError%': $3a08f3b93b399588$var$ThrowTypeError,
    '%TypedArray%': $3a08f3b93b399588$var$TypedArray,
    '%TypeError%': $jQFIR,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $6Unty,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9ttrx,
    '%Function.prototype.apply%': $4G4X6,
    '%Object.defineProperty%': $cILf7,
    '%Object.getPrototypeOf%': $5O4uz,
    '%Math.abs%': $38UJ9,
    '%Math.floor%': $iGzt4,
    '%Math.max%': $dWJBO,
    '%Math.min%': $i9udS,
    '%Math.pow%': $hE7Bh,
    '%Math.round%': $gJSpD,
    '%Math.sign%': $8xHx6,
    '%Reflect.getPrototypeOf%': $bOsTQ
};
if ($cKjXh) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $3a08f3b93b399588$var$errorProto = $cKjXh($cKjXh(e));
    $3a08f3b93b399588$var$INTRINSICS['%Error.prototype%'] = $3a08f3b93b399588$var$errorProto;
}
var $3a08f3b93b399588$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $3a08f3b93b399588$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $3a08f3b93b399588$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $3a08f3b93b399588$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $cKjXh) value = $cKjXh(gen.prototype);
    }
    $3a08f3b93b399588$var$INTRINSICS[name] = value;
    return value;
};
var $3a08f3b93b399588$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $1rs7J = parcelRequire("1rs7J");

var $9VOPG = parcelRequire("9VOPG");
var $3a08f3b93b399588$var$$concat = $1rs7J.call($9ttrx, Array.prototype.concat);
var $3a08f3b93b399588$var$$spliceApply = $1rs7J.call($4G4X6, Array.prototype.splice);
var $3a08f3b93b399588$var$$replace = $1rs7J.call($9ttrx, String.prototype.replace);
var $3a08f3b93b399588$var$$strSlice = $1rs7J.call($9ttrx, String.prototype.slice);
var $3a08f3b93b399588$var$$exec = $1rs7J.call($9ttrx, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $3a08f3b93b399588$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $3a08f3b93b399588$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $3a08f3b93b399588$var$stringToPath = function stringToPath(string) {
    var first = $3a08f3b93b399588$var$$strSlice(string, 0, 1);
    var last = $3a08f3b93b399588$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $1rcCL('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $1rcCL('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $3a08f3b93b399588$var$$replace(string, $3a08f3b93b399588$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $3a08f3b93b399588$var$$replace(subString, $3a08f3b93b399588$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $3a08f3b93b399588$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($9VOPG($3a08f3b93b399588$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $3a08f3b93b399588$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($9VOPG($3a08f3b93b399588$var$INTRINSICS, intrinsicName)) {
        var value = $3a08f3b93b399588$var$INTRINSICS[intrinsicName];
        if (value === $3a08f3b93b399588$var$needsEval) value = $3a08f3b93b399588$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $jQFIR('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $1rcCL('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $jQFIR('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $jQFIR('"allowMissing" argument must be a boolean');
    if ($3a08f3b93b399588$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $1rcCL('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $3a08f3b93b399588$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $3a08f3b93b399588$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $3a08f3b93b399588$var$$spliceApply(parts, $3a08f3b93b399588$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $3a08f3b93b399588$var$$strSlice(part, 0, 1);
        var last = $3a08f3b93b399588$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $1rcCL('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($9VOPG($3a08f3b93b399588$var$INTRINSICS, intrinsicRealName)) value = $3a08f3b93b399588$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $jQFIR('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($7SE9t && i + 1 >= parts.length) {
                var desc = $7SE9t(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $9VOPG(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $3a08f3b93b399588$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("aiQs8", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("2DlCe", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("TtWO0", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("aG0Ti", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("cwaZa", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("1rcCL", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("jQFIR", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("6Unty", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("38UJ9", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("iGzt4", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("dWJBO", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("i9udS", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("hE7Bh", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("gJSpD", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("8xHx6", function(module, exports) {
'use strict';

var $io64q = parcelRequire("io64q");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($io64q(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("io64q", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("7SE9t", function(module, exports) {
'use strict';

var $8rLHf = parcelRequire("8rLHf");
var $5bccb8dbb44f329c$require$$gOPD = $8rLHf;
if ($5bccb8dbb44f329c$require$$gOPD) try {
    $5bccb8dbb44f329c$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $5bccb8dbb44f329c$require$$gOPD = null;
}
module.exports = $5bccb8dbb44f329c$require$$gOPD;

});
parcelRegister("8rLHf", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("cILf7", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $942e3d902bcc477c$var$$defineProperty = Object.defineProperty || false;
if ($942e3d902bcc477c$var$$defineProperty) try {
    $942e3d902bcc477c$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $942e3d902bcc477c$var$$defineProperty = false;
}
module.exports = $942e3d902bcc477c$var$$defineProperty;

});

parcelRegister("fa2Fq", function(module, exports) {
'use strict';
var $b099dbd68238d6ce$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $9VQ4N = parcelRequire("9VQ4N");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $b099dbd68238d6ce$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $b099dbd68238d6ce$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $9VQ4N();
};

});

parcelRegister("cKjXh", function(module, exports) {
'use strict';

var $bOsTQ = parcelRequire("bOsTQ");

var $5O4uz = parcelRequire("5O4uz");

var $dv9TT = parcelRequire("dv9TT");
/** @type {import('.')} */ module.exports = $bOsTQ ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $bOsTQ(O);
} : $5O4uz ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $5O4uz(O);
} : $dv9TT ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $dv9TT(O);
} : null;

});
parcelRegister("bOsTQ", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("5O4uz", function(module, exports) {
'use strict';

var $aiQs8 = parcelRequire("aiQs8");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $aiQs8.getPrototypeOf || null;

});

parcelRegister("dv9TT", function(module, exports) {
'use strict';

var $lH1kJ = parcelRequire("lH1kJ");

var $7SE9t = parcelRequire("7SE9t");
var $9d45d9abe8425603$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $9d45d9abe8425603$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $9d45d9abe8425603$var$desc = !!$9d45d9abe8425603$var$hasProtoAccessor && $7SE9t && $7SE9t(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $9d45d9abe8425603$var$$Object = Object;
var $9d45d9abe8425603$var$$getPrototypeOf = $9d45d9abe8425603$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $9d45d9abe8425603$var$desc && typeof $9d45d9abe8425603$var$desc.get === 'function' ? $lH1kJ([
    $9d45d9abe8425603$var$desc.get
]) : typeof $9d45d9abe8425603$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $9d45d9abe8425603$var$$getPrototypeOf(value == null ? value : $9d45d9abe8425603$var$$Object(value));
} : false;

});
parcelRegister("lH1kJ", function(module, exports) {
'use strict';

var $1rs7J = parcelRequire("1rs7J");

var $jQFIR = parcelRequire("jQFIR");

var $9ttrx = parcelRequire("9ttrx");

var $9LBpG = parcelRequire("9LBpG");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $jQFIR('a function is required');
    return $9LBpG($1rs7J, $9ttrx, args);
};

});
parcelRegister("1rs7J", function(module, exports) {
'use strict';

var $eXzJr = parcelRequire("eXzJr");
module.exports = Function.prototype.bind || $eXzJr;

});
parcelRegister("eXzJr", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $ae424afb5f8fb4e2$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $ae424afb5f8fb4e2$var$toStr = Object.prototype.toString;
var $ae424afb5f8fb4e2$var$max = Math.max;
var $ae424afb5f8fb4e2$var$funcType = '[object Function]';
var $ae424afb5f8fb4e2$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $ae424afb5f8fb4e2$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $ae424afb5f8fb4e2$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $ae424afb5f8fb4e2$var$toStr.apply(target) !== $ae424afb5f8fb4e2$var$funcType) throw new TypeError($ae424afb5f8fb4e2$var$ERROR_MESSAGE + target);
    var args = $ae424afb5f8fb4e2$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $ae424afb5f8fb4e2$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $ae424afb5f8fb4e2$var$concatty(args, arguments));
    };
    var boundLength = $ae424afb5f8fb4e2$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $ae424afb5f8fb4e2$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9ttrx", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("9LBpG", function(module, exports) {
'use strict';

var $1rs7J = parcelRequire("1rs7J");

var $4G4X6 = parcelRequire("4G4X6");

var $9ttrx = parcelRequire("9ttrx");

var $4cvMh = parcelRequire("4cvMh");
/** @type {import('./actualApply')} */ module.exports = $4cvMh || $1rs7J.call($9ttrx, $4G4X6);

});
parcelRegister("4G4X6", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("4cvMh", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("9VOPG", function(module, exports) {
'use strict';
var $73b0de3d2e3453fc$var$call = Function.prototype.call;
var $73b0de3d2e3453fc$var$$hasOwn = Object.prototype.hasOwnProperty;

var $1rs7J = parcelRequire("1rs7J");
/** @type {import('.')} */ module.exports = $1rs7J.call($73b0de3d2e3453fc$var$call, $73b0de3d2e3453fc$var$$hasOwn);

});




parcelRegister("3KZPn", function(module, exports) {
'use strict';

var $exvo0 = parcelRequire("exvo0");

var $cSOI9 = parcelRequire("cSOI9");
var $2bc5a0a7412e273a$var$isFnRegex = $cSOI9(/^\s*(?:function)?\*/);

var $2bc5a0a7412e273a$var$hasToStringTag = (parcelRequire("cJdfe"))();

var $cKjXh = parcelRequire("cKjXh");
var $2bc5a0a7412e273a$var$toStr = $exvo0('Object.prototype.toString');
var $2bc5a0a7412e273a$var$fnToStr = $exvo0('Function.prototype.toString');

var $jtvN6 = parcelRequire("jtvN6");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($2bc5a0a7412e273a$var$isFnRegex($2bc5a0a7412e273a$var$fnToStr(fn))) return true;
    if (!$2bc5a0a7412e273a$var$hasToStringTag) {
        var str = $2bc5a0a7412e273a$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$cKjXh) return false;
    var GeneratorFunction = $jtvN6();
    return GeneratorFunction && $cKjXh(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("cSOI9", function(module, exports) {
'use strict';

var $exvo0 = parcelRequire("exvo0");

var $98qmk = parcelRequire("98qmk");
var $9611dd5a5ec50113$var$$exec = $exvo0('RegExp.prototype.exec');

var $jQFIR = parcelRequire("jQFIR");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$98qmk(regex)) throw new $jQFIR('`regex` must be a RegExp');
    return function test(s) {
        return $9611dd5a5ec50113$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("98qmk", function(module, exports) {
'use strict';

var $exvo0 = parcelRequire("exvo0");

var $6a694ecd43212659$var$hasToStringTag = (parcelRequire("cJdfe"))();

var $9VOPG = parcelRequire("9VOPG");

var $7SE9t = parcelRequire("7SE9t");
/** @type {import('.')} */ var $6a694ecd43212659$var$fn;
if ($6a694ecd43212659$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $6a694ecd43212659$var$$exec = $exvo0('RegExp.prototype.exec');
    /** @type {object} */ var $6a694ecd43212659$var$isRegexMarker = {};
    var $6a694ecd43212659$var$throwRegexMarker = function() {
        throw $6a694ecd43212659$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $6a694ecd43212659$var$badStringifier = {
        toString: $6a694ecd43212659$var$throwRegexMarker,
        valueOf: $6a694ecd43212659$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $6a694ecd43212659$var$badStringifier[Symbol.toPrimitive] = $6a694ecd43212659$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $6a694ecd43212659$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $7SE9t(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $9VOPG(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $6a694ecd43212659$var$$exec(value, /** @type {unknown} */ $6a694ecd43212659$var$badStringifier);
        } catch (e) {
            return e === $6a694ecd43212659$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $6a694ecd43212659$var$$toString = $exvo0('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $6a694ecd43212659$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $6a694ecd43212659$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $6a694ecd43212659$var$$toString(value) === $6a694ecd43212659$var$regexClass;
    };
}
module.exports = $6a694ecd43212659$var$fn;

});


parcelRegister("jtvN6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c15e147219e6d4c8$export$2e2bcd8739ae039);

var $l604U = parcelRequire("l604U");
var /** @type {import('./index.d.mts').default} */ $c15e147219e6d4c8$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($l604U)));

});
parcelRegister("l604U", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $f5ba380e70281abd$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$f5ba380e70281abd$var$cached;

});



parcelRegister("82kf0", function(module, exports) {
'use strict';

var $8VxG3 = parcelRequire("8VxG3");

var $gEiH1 = parcelRequire("gEiH1");

var $6Qtg6 = parcelRequire("6Qtg6");

var $exvo0 = parcelRequire("exvo0");

var $7SE9t = parcelRequire("7SE9t");

var $cKjXh = parcelRequire("cKjXh");
var $5d9e36139148c689$var$$toString = $exvo0('Object.prototype.toString');

var $5d9e36139148c689$var$hasToStringTag = (parcelRequire("cJdfe"))();
var $5d9e36139148c689$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $5d9e36139148c689$var$typedArrays = $gEiH1();
var $5d9e36139148c689$var$$slice = $exvo0('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $5d9e36139148c689$var$$indexOf = $exvo0('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $5d9e36139148c689$var$cache = {
    __proto__: null
};
if ($5d9e36139148c689$var$hasToStringTag && $7SE9t && $cKjXh) $8VxG3($5d9e36139148c689$var$typedArrays, function(typedArray) {
    var arr = new $5d9e36139148c689$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $cKjXh) {
        var proto = $cKjXh(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $7SE9t(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $cKjXh(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $7SE9t(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = $6Qtg6(descriptor.get);
            $5d9e36139148c689$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else $8VxG3($5d9e36139148c689$var$typedArrays, function(typedArray) {
    var arr = new $5d9e36139148c689$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
        $6Qtg6(fn);
        $5d9e36139148c689$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $5d9e36139148c689$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $8VxG3(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $5d9e36139148c689$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $5d9e36139148c689$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $5d9e36139148c689$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $8VxG3(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $5d9e36139148c689$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $5d9e36139148c689$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$5d9e36139148c689$var$hasToStringTag) {
        /** @type {string} */ var tag = $5d9e36139148c689$var$$slice($5d9e36139148c689$var$$toString(value), 8, -1);
        if ($5d9e36139148c689$var$$indexOf($5d9e36139148c689$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $5d9e36139148c689$var$trySlices(value);
    }
    if (!$7SE9t) return null;
     // unknown engine
    return $5d9e36139148c689$var$tryTypedArrays(value);
};

});
parcelRegister("8VxG3", function(module, exports) {
'use strict';

var $9oota = parcelRequire("9oota");
var $67fdc52fb081d132$var$toStr = Object.prototype.toString;
var $67fdc52fb081d132$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $67fdc52fb081d132$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($67fdc52fb081d132$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $67fdc52fb081d132$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $67fdc52fb081d132$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($67fdc52fb081d132$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $67fdc52fb081d132$var$isArray(x) {
    return $67fdc52fb081d132$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$9oota(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($67fdc52fb081d132$var$isArray(list)) $67fdc52fb081d132$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $67fdc52fb081d132$var$forEachString(list, iterator, receiver);
    else $67fdc52fb081d132$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("9oota", function(module, exports) {
'use strict';
var $6d69560fa6c74dba$var$fnToStr = Function.prototype.toString;
var $6d69560fa6c74dba$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $6d69560fa6c74dba$var$badArrayLike;
var $6d69560fa6c74dba$var$isCallableMarker;
if (typeof $6d69560fa6c74dba$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $6d69560fa6c74dba$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $6d69560fa6c74dba$var$isCallableMarker;
        }
    });
    $6d69560fa6c74dba$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $6d69560fa6c74dba$var$reflectApply(function() {
        throw 42;
    }, null, $6d69560fa6c74dba$var$badArrayLike);
} catch (_) {
    if (_ !== $6d69560fa6c74dba$var$isCallableMarker) $6d69560fa6c74dba$var$reflectApply = null;
}
else $6d69560fa6c74dba$var$reflectApply = null;
var $6d69560fa6c74dba$var$constructorRegex = /^\s*class\b/;
var $6d69560fa6c74dba$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $6d69560fa6c74dba$var$fnToStr.call(value);
        return $6d69560fa6c74dba$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $6d69560fa6c74dba$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($6d69560fa6c74dba$var$isES6ClassFn(value)) return false;
        $6d69560fa6c74dba$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $6d69560fa6c74dba$var$toStr = Object.prototype.toString;
var $6d69560fa6c74dba$var$objectClass = '[object Object]';
var $6d69560fa6c74dba$var$fnClass = '[object Function]';
var $6d69560fa6c74dba$var$genClass = '[object GeneratorFunction]';
var $6d69560fa6c74dba$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $6d69560fa6c74dba$var$ddaClass2 = '[object HTML document.all class]';
var $6d69560fa6c74dba$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $6d69560fa6c74dba$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $6d69560fa6c74dba$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $6d69560fa6c74dba$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $6d69560fa6c74dba$var$all = document.all;
    if ($6d69560fa6c74dba$var$toStr.call($6d69560fa6c74dba$var$all) === $6d69560fa6c74dba$var$toStr.call(document.all)) $6d69560fa6c74dba$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($6d69560fa6c74dba$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $6d69560fa6c74dba$var$toStr.call(value);
            return (str === $6d69560fa6c74dba$var$ddaClass || str === $6d69560fa6c74dba$var$ddaClass2 || str === $6d69560fa6c74dba$var$ddaClass3 // opera 12.16
             || str === $6d69560fa6c74dba$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $6d69560fa6c74dba$var$reflectApply ? function isCallable(value) {
    if ($6d69560fa6c74dba$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $6d69560fa6c74dba$var$reflectApply(value, null, $6d69560fa6c74dba$var$badArrayLike);
    } catch (e) {
        if (e !== $6d69560fa6c74dba$var$isCallableMarker) return false;
    }
    return !$6d69560fa6c74dba$var$isES6ClassFn(value) && $6d69560fa6c74dba$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($6d69560fa6c74dba$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($6d69560fa6c74dba$var$hasToStringTag) return $6d69560fa6c74dba$var$tryFunctionObject(value);
    if ($6d69560fa6c74dba$var$isES6ClassFn(value)) return false;
    var strClass = $6d69560fa6c74dba$var$toStr.call(value);
    if (strClass !== $6d69560fa6c74dba$var$fnClass && strClass !== $6d69560fa6c74dba$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $6d69560fa6c74dba$var$tryFunctionObject(value);
};

});


parcelRegister("gEiH1", function(module, exports) {
'use strict';

var $hesUA = parcelRequire("hesUA");
var $c1eee1ce878a8295$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $hesUA.length; i++)if (typeof $c1eee1ce878a8295$var$g[$hesUA[i]] === 'function') // @ts-expect-error
    out[out.length] = $hesUA[i];
    return out;
};

});
parcelRegister("hesUA", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("6Qtg6", function(module, exports) {
'use strict';

var $djZMj = parcelRequire("djZMj");

var $cILf7 = parcelRequire("cILf7");

var $lH1kJ = parcelRequire("lH1kJ");

var $hS31d = parcelRequire("hS31d");
module.exports = function callBind(originalFunction) {
    var func = $lH1kJ(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $djZMj(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($cILf7) $cILf7(module.exports, 'apply', {
    value: $hS31d
});
else module.exports.apply = $hS31d;

});
parcelRegister("djZMj", function(module, exports) {
'use strict';

var $4YUXM = parcelRequire("4YUXM");

var $6dipk = parcelRequire("6dipk");

var $9b2cf88ebf061dcb$var$hasDescriptors = (parcelRequire("dp7dD"))();

var $7SE9t = parcelRequire("7SE9t");

var $jQFIR = parcelRequire("jQFIR");
var $9b2cf88ebf061dcb$var$$floor = $4YUXM('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $jQFIR('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $9b2cf88ebf061dcb$var$$floor(length) !== length) throw new $jQFIR('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $7SE9t) {
        var desc = $7SE9t(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($9b2cf88ebf061dcb$var$hasDescriptors) $6dipk(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $6dipk(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("6dipk", function(module, exports) {
'use strict';

var $cILf7 = parcelRequire("cILf7");

var $1rcCL = parcelRequire("1rcCL");

var $jQFIR = parcelRequire("jQFIR");

var $7SE9t = parcelRequire("7SE9t");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $jQFIR('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $jQFIR('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $jQFIR('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $jQFIR('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $jQFIR('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $jQFIR('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$7SE9t && $7SE9t(obj, property);
    if ($cILf7) $cILf7(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $1rcCL('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("dp7dD", function(module, exports) {
'use strict';

var $cILf7 = parcelRequire("cILf7");
var $9c2335b3e3936cef$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$cILf7;
};
$9c2335b3e3936cef$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$cILf7) return null;
    try {
        return $cILf7([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $9c2335b3e3936cef$var$hasPropertyDescriptors;

});


parcelRegister("hS31d", function(module, exports) {
'use strict';

var $1rs7J = parcelRequire("1rs7J");

var $4G4X6 = parcelRequire("4G4X6");

var $9LBpG = parcelRequire("9LBpG");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $9LBpG($1rs7J, $4G4X6, arguments);
};

});



parcelRegister("2BlbL", function(module, exports) {
'use strict';

var $82kf0 = parcelRequire("82kf0");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$82kf0(value);
};

});


parcelRegister("gVfcn", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("9YOog", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRegister("iJFgN", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $4Jj9n = parcelRequire("4Jj9n");
'use strict';
function $da3c714bf73d5d78$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $da3c714bf73d5d78$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $da3c714bf73d5d78$var$ownKeys(Object(t), !0).forEach(function(r) {
            $da3c714bf73d5d78$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $da3c714bf73d5d78$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $da3c714bf73d5d78$var$_defineProperty(obj, key, value) {
    key = $da3c714bf73d5d78$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $da3c714bf73d5d78$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $da3c714bf73d5d78$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $da3c714bf73d5d78$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $da3c714bf73d5d78$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $da3c714bf73d5d78$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $da3c714bf73d5d78$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $da3c714bf73d5d78$var$_toPropertyKey(arg) {
    var key = $da3c714bf73d5d78$var$_toPrimitive(arg, "string");
    return $da3c714bf73d5d78$var$_typeof(key) === "symbol" ? key : String(key);
}
function $da3c714bf73d5d78$var$_toPrimitive(input, hint) {
    if ($da3c714bf73d5d78$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($da3c714bf73d5d78$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $da3c714bf73d5d78$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $da3c714bf73d5d78$var$_setPrototypeOf(subClass, superClass);
}
function $da3c714bf73d5d78$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $da3c714bf73d5d78$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $da3c714bf73d5d78$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $da3c714bf73d5d78$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $da3c714bf73d5d78$var$_possibleConstructorReturn(this, result);
    };
}
function $da3c714bf73d5d78$var$_possibleConstructorReturn(self, call) {
    if (call && ($da3c714bf73d5d78$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $da3c714bf73d5d78$var$_assertThisInitialized(self);
}
function $da3c714bf73d5d78$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $da3c714bf73d5d78$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $da3c714bf73d5d78$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$da3c714bf73d5d78$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $da3c714bf73d5d78$var$_construct(Class, arguments, $da3c714bf73d5d78$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $da3c714bf73d5d78$var$_setPrototypeOf(Wrapper, Class);
    };
    return $da3c714bf73d5d78$var$_wrapNativeSuper(Class);
}
function $da3c714bf73d5d78$var$_construct(Parent, args, Class) {
    if ($da3c714bf73d5d78$var$_isNativeReflectConstruct()) $da3c714bf73d5d78$var$_construct = Reflect.construct.bind();
    else $da3c714bf73d5d78$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $da3c714bf73d5d78$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $da3c714bf73d5d78$var$_construct.apply(null, arguments);
}
function $da3c714bf73d5d78$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $da3c714bf73d5d78$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $da3c714bf73d5d78$var$_setPrototypeOf(o, p) {
    $da3c714bf73d5d78$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $da3c714bf73d5d78$var$_setPrototypeOf(o, p);
}
function $da3c714bf73d5d78$var$_getPrototypeOf(o) {
    $da3c714bf73d5d78$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $da3c714bf73d5d78$var$_getPrototypeOf(o);
}
function $da3c714bf73d5d78$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $da3c714bf73d5d78$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $da3c714bf73d5d78$var$_typeof(o);
}

var $pVemT = parcelRequire("pVemT");
var $da3c714bf73d5d78$var$inspect = $pVemT.inspect;

var $l81CI = parcelRequire("l81CI");
var $da3c714bf73d5d78$var$ERR_INVALID_ARG_TYPE = $l81CI.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $da3c714bf73d5d78$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $da3c714bf73d5d78$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $da3c714bf73d5d78$var$blue = '';
var $da3c714bf73d5d78$var$green = '';
var $da3c714bf73d5d78$var$red = '';
var $da3c714bf73d5d78$var$white = '';
var $da3c714bf73d5d78$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $da3c714bf73d5d78$var$kMaxShortLength = 10;
function $da3c714bf73d5d78$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $da3c714bf73d5d78$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $da3c714bf73d5d78$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $da3c714bf73d5d78$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $da3c714bf73d5d78$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $da3c714bf73d5d78$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $da3c714bf73d5d78$var$_typeof(actual) === 'object' && $da3c714bf73d5d78$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $da3c714bf73d5d78$var$kMaxShortLength) {
            if (($da3c714bf73d5d78$var$_typeof(actual) !== 'object' || actual === null) && ($da3c714bf73d5d78$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($da3c714bf73d5d78$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $4Jj9n.stderr && $4Jj9n.stderr.isTTY ? $4Jj9n.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($da3c714bf73d5d78$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($da3c714bf73d5d78$var$blue, "...").concat($da3c714bf73d5d78$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($da3c714bf73d5d78$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($da3c714bf73d5d78$var$blue, "...").concat($da3c714bf73d5d78$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $da3c714bf73d5d78$var$kReadableOperator[operator] + "\n".concat($da3c714bf73d5d78$var$green, "+ actual").concat($da3c714bf73d5d78$var$white, " ").concat($da3c714bf73d5d78$var$red, "- expected").concat($da3c714bf73d5d78$var$white);
    var skippedMsg = " ".concat($da3c714bf73d5d78$var$blue, "...").concat($da3c714bf73d5d78$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($da3c714bf73d5d78$var$blue, "...").concat($da3c714bf73d5d78$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($da3c714bf73d5d78$var$red, "-").concat($da3c714bf73d5d78$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($da3c714bf73d5d78$var$blue, "...").concat($da3c714bf73d5d78$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($da3c714bf73d5d78$var$green, "+").concat($da3c714bf73d5d78$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$da3c714bf73d5d78$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $da3c714bf73d5d78$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($da3c714bf73d5d78$var$blue, "...").concat($da3c714bf73d5d78$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($da3c714bf73d5d78$var$green, "+").concat($da3c714bf73d5d78$var$white, " ").concat(actualLine);
                other += "\n".concat($da3c714bf73d5d78$var$red, "-").concat($da3c714bf73d5d78$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($da3c714bf73d5d78$var$blue, "...").concat($da3c714bf73d5d78$var$white).concat(other, "\n") + "".concat($da3c714bf73d5d78$var$blue, "...").concat($da3c714bf73d5d78$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $da3c714bf73d5d78$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $da3c714bf73d5d78$var$_inherits(AssertionError, _Error);
    var _super = $da3c714bf73d5d78$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $da3c714bf73d5d78$var$_classCallCheck(this, AssertionError);
        if ($da3c714bf73d5d78$var$_typeof(options) !== 'object' || options === null) throw new $da3c714bf73d5d78$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($4Jj9n.stderr && $4Jj9n.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($4Jj9n.stderr && $4Jj9n.stderr.getColorDepth && $4Jj9n.stderr.getColorDepth() !== 1) {
                    $da3c714bf73d5d78$var$blue = "\x1B[34m";
                    $da3c714bf73d5d78$var$green = "\x1B[32m";
                    $da3c714bf73d5d78$var$white = "\x1B[39m";
                    $da3c714bf73d5d78$var$red = "\x1B[31m";
                } else {
                    $da3c714bf73d5d78$var$blue = '';
                    $da3c714bf73d5d78$var$green = '';
                    $da3c714bf73d5d78$var$white = '';
                    $da3c714bf73d5d78$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($da3c714bf73d5d78$var$_typeof(actual) === 'object' && actual !== null && $da3c714bf73d5d78$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $da3c714bf73d5d78$var$copyError(actual);
                expected = $da3c714bf73d5d78$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $da3c714bf73d5d78$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $da3c714bf73d5d78$var$kReadableOperator[operator];
                var res = $da3c714bf73d5d78$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $da3c714bf73d5d78$var$_typeof(actual) === 'object' && actual !== null) base = $da3c714bf73d5d78$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($da3c714bf73d5d78$var$blue, "...").concat($da3c714bf73d5d78$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $da3c714bf73d5d78$var$inspectValue(actual);
                var other = '';
                var knownOperators = $da3c714bf73d5d78$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($da3c714bf73d5d78$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($da3c714bf73d5d78$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($da3c714bf73d5d78$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($da3c714bf73d5d78$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $da3c714bf73d5d78$var$_possibleConstructorReturn(_this);
    }
    $da3c714bf73d5d78$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $da3c714bf73d5d78$var$inspect(this, $da3c714bf73d5d78$var$_objectSpread($da3c714bf73d5d78$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $da3c714bf73d5d78$var$_wrapNativeSuper(Error), $da3c714bf73d5d78$var$inspect.custom);
module.exports = $da3c714bf73d5d78$var$AssertionError;

});

parcelRegister("a1N7Q", function(module, exports) {
'use strict';

var $cJWFK = parcelRequire("cJWFK");
var $74d01ab1cb4b18f3$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $74d01ab1cb4b18f3$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $cJWFK;
    if ($74d01ab1cb4b18f3$var$lacksProperEnumerationOrder()) return $cJWFK;
    if ($74d01ab1cb4b18f3$var$assignHasPendingExceptions()) return $cJWFK;
    return Object.assign;
};

});
parcelRegister("cJWFK", function(module, exports) {
'use strict';

var $9zcAj = parcelRequire("9zcAj");

var $94673319604bee6b$var$hasSymbols = (parcelRequire("9VQ4N"))();

var $exvo0 = parcelRequire("exvo0");

var $aiQs8 = parcelRequire("aiQs8");
var $94673319604bee6b$var$$push = $exvo0('Array.prototype.push');
var $94673319604bee6b$var$$propIsEnumerable = $exvo0('Object.prototype.propertyIsEnumerable');
var $94673319604bee6b$var$originalGetSymbols = $94673319604bee6b$var$hasSymbols ? $aiQs8.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $aiQs8(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $aiQs8(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $9zcAj(from);
        var getSymbols = $94673319604bee6b$var$hasSymbols && ($aiQs8.getOwnPropertySymbols || $94673319604bee6b$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($94673319604bee6b$var$$propIsEnumerable(from, key)) $94673319604bee6b$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($94673319604bee6b$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("9zcAj", function(module, exports) {
'use strict';
var $6f712504e9fa9490$var$slice = Array.prototype.slice;

var $5IH7g = parcelRequire("5IH7g");
var $6f712504e9fa9490$var$origKeys = Object.keys;

var $6f712504e9fa9490$var$keysShim = $6f712504e9fa9490$var$origKeys ? function keys(o) {
    return $6f712504e9fa9490$var$origKeys(o);
} : (parcelRequire("4XBEa"));
var $6f712504e9fa9490$var$originalKeys = Object.keys;
$6f712504e9fa9490$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($5IH7g(object)) return $6f712504e9fa9490$var$originalKeys($6f712504e9fa9490$var$slice.call(object));
            return $6f712504e9fa9490$var$originalKeys(object);
        };
    } else Object.keys = $6f712504e9fa9490$var$keysShim;
    return Object.keys || $6f712504e9fa9490$var$keysShim;
};
module.exports = $6f712504e9fa9490$var$keysShim;

});
parcelRegister("5IH7g", function(module, exports) {
'use strict';
var $42a281cde968d9bd$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $42a281cde968d9bd$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $42a281cde968d9bd$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("4XBEa", function(module, exports) {
'use strict';
var $39c9e00506b0cbf9$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $39c9e00506b0cbf9$var$has = Object.prototype.hasOwnProperty;
    var $39c9e00506b0cbf9$var$toStr = Object.prototype.toString;
    var $39c9e00506b0cbf9$var$isArgs = (parcelRequire("5IH7g")); // eslint-disable-line global-require
    var $39c9e00506b0cbf9$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $39c9e00506b0cbf9$var$hasDontEnumBug = !$39c9e00506b0cbf9$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $39c9e00506b0cbf9$var$hasProtoEnumBug = $39c9e00506b0cbf9$var$isEnumerable.call(function() {}, 'prototype');
    var $39c9e00506b0cbf9$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $39c9e00506b0cbf9$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $39c9e00506b0cbf9$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $39c9e00506b0cbf9$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$39c9e00506b0cbf9$var$excludedKeys['$' + k] && $39c9e00506b0cbf9$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $39c9e00506b0cbf9$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $39c9e00506b0cbf9$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$39c9e00506b0cbf9$var$hasAutomationEqualityBug) return $39c9e00506b0cbf9$var$equalsConstructorPrototype(o);
        try {
            return $39c9e00506b0cbf9$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $39c9e00506b0cbf9$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $39c9e00506b0cbf9$var$toStr.call(object) === '[object Function]';
        var isArguments = $39c9e00506b0cbf9$var$isArgs(object);
        var isString = isObject && $39c9e00506b0cbf9$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $39c9e00506b0cbf9$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$39c9e00506b0cbf9$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $39c9e00506b0cbf9$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($39c9e00506b0cbf9$var$hasDontEnumBug) {
            var skipConstructor = $39c9e00506b0cbf9$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $39c9e00506b0cbf9$var$dontEnums.length; ++k)if (!(skipConstructor && $39c9e00506b0cbf9$var$dontEnums[k] === 'constructor') && $39c9e00506b0cbf9$var$has.call(object, $39c9e00506b0cbf9$var$dontEnums[k])) theKeys.push($39c9e00506b0cbf9$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $39c9e00506b0cbf9$var$keysShim;

});




parcelRegister("4WxrU", function(module, exports) {
'use strict';

var $4UKK0 = parcelRequire("4UKK0");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $4UKK0;
};

});
parcelRegister("4UKK0", function(module, exports) {
'use strict';
var $3940a62c56ccaf7a$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($3940a62c56ccaf7a$var$numberIsNaN(a) && $3940a62c56ccaf7a$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("cHfzZ", function(module, exports) {
'use strict';

var $4YUXM = parcelRequire("4YUXM");

var $6Qtg6 = parcelRequire("6Qtg6");
var $93e595eea8cd9129$var$$indexOf = $6Qtg6($4YUXM('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $4YUXM(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $93e595eea8cd9129$var$$indexOf(name, '.prototype.') > -1) return $6Qtg6(intrinsic);
    return intrinsic;
};

});

parcelRegister("aO7Zc", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $7de4c4c8fccb3ba8$var$_slicedToArray(arr, i) {
    return $7de4c4c8fccb3ba8$var$_arrayWithHoles(arr) || $7de4c4c8fccb3ba8$var$_iterableToArrayLimit(arr, i) || $7de4c4c8fccb3ba8$var$_unsupportedIterableToArray(arr, i) || $7de4c4c8fccb3ba8$var$_nonIterableRest();
}
function $7de4c4c8fccb3ba8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7de4c4c8fccb3ba8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7de4c4c8fccb3ba8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7de4c4c8fccb3ba8$var$_arrayLikeToArray(o, minLen);
}
function $7de4c4c8fccb3ba8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7de4c4c8fccb3ba8$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $7de4c4c8fccb3ba8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $7de4c4c8fccb3ba8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7de4c4c8fccb3ba8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7de4c4c8fccb3ba8$var$_typeof(o);
}
var $7de4c4c8fccb3ba8$var$regexFlagsSupported = /a/g.flags !== undefined;
var $7de4c4c8fccb3ba8$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $7de4c4c8fccb3ba8$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $7de4c4c8fccb3ba8$var$objectIs = Object.is ? Object.is : (parcelRequire("NQAfn"));
var $7de4c4c8fccb3ba8$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $7de4c4c8fccb3ba8$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("iC2Ks"));
function $7de4c4c8fccb3ba8$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $7de4c4c8fccb3ba8$var$hasOwnProperty = $7de4c4c8fccb3ba8$var$uncurryThis(Object.prototype.hasOwnProperty);
var $7de4c4c8fccb3ba8$var$propertyIsEnumerable = $7de4c4c8fccb3ba8$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $7de4c4c8fccb3ba8$var$objectToString = $7de4c4c8fccb3ba8$var$uncurryThis(Object.prototype.toString);

var $pVemT = parcelRequire("pVemT");
var $7de4c4c8fccb3ba8$require$_require$types = $pVemT.types;
var $7de4c4c8fccb3ba8$var$isAnyArrayBuffer = $7de4c4c8fccb3ba8$require$_require$types.isAnyArrayBuffer, $7de4c4c8fccb3ba8$var$isArrayBufferView = $7de4c4c8fccb3ba8$require$_require$types.isArrayBufferView, $7de4c4c8fccb3ba8$var$isDate = $7de4c4c8fccb3ba8$require$_require$types.isDate, $7de4c4c8fccb3ba8$var$isMap = $7de4c4c8fccb3ba8$require$_require$types.isMap, $7de4c4c8fccb3ba8$var$isRegExp = $7de4c4c8fccb3ba8$require$_require$types.isRegExp, $7de4c4c8fccb3ba8$var$isSet = $7de4c4c8fccb3ba8$require$_require$types.isSet, $7de4c4c8fccb3ba8$var$isNativeError = $7de4c4c8fccb3ba8$require$_require$types.isNativeError, $7de4c4c8fccb3ba8$var$isBoxedPrimitive = $7de4c4c8fccb3ba8$require$_require$types.isBoxedPrimitive, $7de4c4c8fccb3ba8$var$isNumberObject = $7de4c4c8fccb3ba8$require$_require$types.isNumberObject, $7de4c4c8fccb3ba8$var$isStringObject = $7de4c4c8fccb3ba8$require$_require$types.isStringObject, $7de4c4c8fccb3ba8$var$isBooleanObject = $7de4c4c8fccb3ba8$require$_require$types.isBooleanObject, $7de4c4c8fccb3ba8$var$isBigIntObject = $7de4c4c8fccb3ba8$require$_require$types.isBigIntObject, $7de4c4c8fccb3ba8$var$isSymbolObject = $7de4c4c8fccb3ba8$require$_require$types.isSymbolObject, $7de4c4c8fccb3ba8$var$isFloat32Array = $7de4c4c8fccb3ba8$require$_require$types.isFloat32Array, $7de4c4c8fccb3ba8$var$isFloat64Array = $7de4c4c8fccb3ba8$require$_require$types.isFloat64Array;
function $7de4c4c8fccb3ba8$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $7de4c4c8fccb3ba8$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($7de4c4c8fccb3ba8$var$isNonIndex).concat($7de4c4c8fccb3ba8$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $7de4c4c8fccb3ba8$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $7de4c4c8fccb3ba8$var$ONLY_ENUMERABLE = undefined;
var $7de4c4c8fccb3ba8$var$kStrict = true;
var $7de4c4c8fccb3ba8$var$kLoose = false;
var $7de4c4c8fccb3ba8$var$kNoIterator = 0;
var $7de4c4c8fccb3ba8$var$kIsArray = 1;
var $7de4c4c8fccb3ba8$var$kIsSet = 2;
var $7de4c4c8fccb3ba8$var$kIsMap = 3;
// Check if they have the same source and flags
function $7de4c4c8fccb3ba8$var$areSimilarRegExps(a, b) {
    return $7de4c4c8fccb3ba8$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $7de4c4c8fccb3ba8$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $7de4c4c8fccb3ba8$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $7de4c4c8fccb3ba8$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $7de4c4c8fccb3ba8$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $7de4c4c8fccb3ba8$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $7de4c4c8fccb3ba8$var$isEqualBoxedPrimitive(val1, val2) {
    if ($7de4c4c8fccb3ba8$var$isNumberObject(val1)) return $7de4c4c8fccb3ba8$var$isNumberObject(val2) && $7de4c4c8fccb3ba8$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($7de4c4c8fccb3ba8$var$isStringObject(val1)) return $7de4c4c8fccb3ba8$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($7de4c4c8fccb3ba8$var$isBooleanObject(val1)) return $7de4c4c8fccb3ba8$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($7de4c4c8fccb3ba8$var$isBigIntObject(val1)) return $7de4c4c8fccb3ba8$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $7de4c4c8fccb3ba8$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $7de4c4c8fccb3ba8$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $7de4c4c8fccb3ba8$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($7de4c4c8fccb3ba8$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $7de4c4c8fccb3ba8$var$numberIsNaN(val1) && $7de4c4c8fccb3ba8$var$numberIsNaN(val2);
        if ($7de4c4c8fccb3ba8$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $7de4c4c8fccb3ba8$var$_typeof(val1) !== 'object') {
            if (val2 === null || $7de4c4c8fccb3ba8$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $7de4c4c8fccb3ba8$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $7de4c4c8fccb3ba8$var$objectToString(val1);
    var val2Tag = $7de4c4c8fccb3ba8$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $7de4c4c8fccb3ba8$var$getOwnNonIndexProperties(val1, $7de4c4c8fccb3ba8$var$ONLY_ENUMERABLE);
        var keys2 = $7de4c4c8fccb3ba8$var$getOwnNonIndexProperties(val2, $7de4c4c8fccb3ba8$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $7de4c4c8fccb3ba8$var$keyCheck(val1, val2, strict, memos, $7de4c4c8fccb3ba8$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$7de4c4c8fccb3ba8$var$isMap(val1) && $7de4c4c8fccb3ba8$var$isMap(val2) || !$7de4c4c8fccb3ba8$var$isSet(val1) && $7de4c4c8fccb3ba8$var$isSet(val2)) return false;
    }
    if ($7de4c4c8fccb3ba8$var$isDate(val1)) {
        if (!$7de4c4c8fccb3ba8$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($7de4c4c8fccb3ba8$var$isRegExp(val1)) {
        if (!$7de4c4c8fccb3ba8$var$isRegExp(val2) || !$7de4c4c8fccb3ba8$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($7de4c4c8fccb3ba8$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($7de4c4c8fccb3ba8$var$isArrayBufferView(val1)) {
        if (!strict && ($7de4c4c8fccb3ba8$var$isFloat32Array(val1) || $7de4c4c8fccb3ba8$var$isFloat64Array(val1))) {
            if (!$7de4c4c8fccb3ba8$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$7de4c4c8fccb3ba8$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $7de4c4c8fccb3ba8$var$getOwnNonIndexProperties(val1, $7de4c4c8fccb3ba8$var$ONLY_ENUMERABLE);
        var _keys2 = $7de4c4c8fccb3ba8$var$getOwnNonIndexProperties(val2, $7de4c4c8fccb3ba8$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $7de4c4c8fccb3ba8$var$keyCheck(val1, val2, strict, memos, $7de4c4c8fccb3ba8$var$kNoIterator, _keys);
    } else if ($7de4c4c8fccb3ba8$var$isSet(val1)) {
        if (!$7de4c4c8fccb3ba8$var$isSet(val2) || val1.size !== val2.size) return false;
        return $7de4c4c8fccb3ba8$var$keyCheck(val1, val2, strict, memos, $7de4c4c8fccb3ba8$var$kIsSet);
    } else if ($7de4c4c8fccb3ba8$var$isMap(val1)) {
        if (!$7de4c4c8fccb3ba8$var$isMap(val2) || val1.size !== val2.size) return false;
        return $7de4c4c8fccb3ba8$var$keyCheck(val1, val2, strict, memos, $7de4c4c8fccb3ba8$var$kIsMap);
    } else if ($7de4c4c8fccb3ba8$var$isAnyArrayBuffer(val1)) {
        if (!$7de4c4c8fccb3ba8$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($7de4c4c8fccb3ba8$var$isBoxedPrimitive(val1) && !$7de4c4c8fccb3ba8$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $7de4c4c8fccb3ba8$var$keyCheck(val1, val2, strict, memos, $7de4c4c8fccb3ba8$var$kNoIterator);
}
function $7de4c4c8fccb3ba8$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $7de4c4c8fccb3ba8$var$propertyIsEnumerable(val, k);
    });
}
function $7de4c4c8fccb3ba8$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$7de4c4c8fccb3ba8$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $7de4c4c8fccb3ba8$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($7de4c4c8fccb3ba8$var$propertyIsEnumerable(val1, key)) {
                    if (!$7de4c4c8fccb3ba8$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($7de4c4c8fccb3ba8$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $7de4c4c8fccb3ba8$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $7de4c4c8fccb3ba8$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $7de4c4c8fccb3ba8$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $7de4c4c8fccb3ba8$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $7de4c4c8fccb3ba8$var$kNoIterator || iterationType === $7de4c4c8fccb3ba8$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $7de4c4c8fccb3ba8$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $7de4c4c8fccb3ba8$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $7de4c4c8fccb3ba8$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($7de4c4c8fccb3ba8$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $7de4c4c8fccb3ba8$var$findLooseMatchingPrimitives(prim) {
    switch($7de4c4c8fccb3ba8$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($7de4c4c8fccb3ba8$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $7de4c4c8fccb3ba8$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $7de4c4c8fccb3ba8$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $7de4c4c8fccb3ba8$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $7de4c4c8fccb3ba8$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$7de4c4c8fccb3ba8$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $7de4c4c8fccb3ba8$var$innerDeepEqual(item, curB, false, memo);
}
function $7de4c4c8fccb3ba8$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $7de4c4c8fccb3ba8$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($7de4c4c8fccb3ba8$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$7de4c4c8fccb3ba8$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $7de4c4c8fccb3ba8$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($7de4c4c8fccb3ba8$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$7de4c4c8fccb3ba8$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$7de4c4c8fccb3ba8$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $7de4c4c8fccb3ba8$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $7de4c4c8fccb3ba8$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($7de4c4c8fccb3ba8$var$innerDeepEqual(key1, key2, strict, memo) && $7de4c4c8fccb3ba8$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $7de4c4c8fccb3ba8$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $7de4c4c8fccb3ba8$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $7de4c4c8fccb3ba8$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($7de4c4c8fccb3ba8$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$7de4c4c8fccb3ba8$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$7de4c4c8fccb3ba8$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $7de4c4c8fccb3ba8$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $7de4c4c8fccb3ba8$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($7de4c4c8fccb3ba8$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$7de4c4c8fccb3ba8$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$7de4c4c8fccb3ba8$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$7de4c4c8fccb3ba8$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $7de4c4c8fccb3ba8$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $7de4c4c8fccb3ba8$var$kIsSet) {
        if (!$7de4c4c8fccb3ba8$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $7de4c4c8fccb3ba8$var$kIsMap) {
        if (!$7de4c4c8fccb3ba8$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $7de4c4c8fccb3ba8$var$kIsArray) for(; i < a.length; i++){
        if ($7de4c4c8fccb3ba8$var$hasOwnProperty(a, i)) {
            if (!$7de4c4c8fccb3ba8$var$hasOwnProperty(b, i) || !$7de4c4c8fccb3ba8$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($7de4c4c8fccb3ba8$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$7de4c4c8fccb3ba8$var$hasOwnProperty(b, key) || !$7de4c4c8fccb3ba8$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$7de4c4c8fccb3ba8$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $7de4c4c8fccb3ba8$var$isDeepEqual(val1, val2) {
    return $7de4c4c8fccb3ba8$var$innerDeepEqual(val1, val2, $7de4c4c8fccb3ba8$var$kLoose);
}
function $7de4c4c8fccb3ba8$var$isDeepStrictEqual(val1, val2) {
    return $7de4c4c8fccb3ba8$var$innerDeepEqual(val1, val2, $7de4c4c8fccb3ba8$var$kStrict);
}
module.exports = {
    isDeepEqual: $7de4c4c8fccb3ba8$var$isDeepEqual,
    isDeepStrictEqual: $7de4c4c8fccb3ba8$var$isDeepStrictEqual
};

});
parcelRegister("NQAfn", function(module, exports) {
'use strict';

var $lMJ5M = parcelRequire("lMJ5M");

var $6Qtg6 = parcelRequire("6Qtg6");

var $4UKK0 = parcelRequire("4UKK0");

var $4WxrU = parcelRequire("4WxrU");

var $hMtaR = parcelRequire("hMtaR");
var $095d5dbb5050d632$var$polyfill = $6Qtg6($4WxrU(), Object);
$lMJ5M($095d5dbb5050d632$var$polyfill, {
    getPolyfill: $4WxrU,
    implementation: $4UKK0,
    shim: $hMtaR
});
module.exports = $095d5dbb5050d632$var$polyfill;

});
parcelRegister("lMJ5M", function(module, exports) {
'use strict';

var $9zcAj = parcelRequire("9zcAj");
var $fdc10f09642432c5$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $fdc10f09642432c5$var$toStr = Object.prototype.toString;
var $fdc10f09642432c5$var$concat = Array.prototype.concat;

var $6dipk = parcelRequire("6dipk");
var $fdc10f09642432c5$var$isFunction = function(fn) {
    return typeof fn === 'function' && $fdc10f09642432c5$var$toStr.call(fn) === '[object Function]';
};

var $fdc10f09642432c5$var$supportsDescriptors = (parcelRequire("dp7dD"))();
var $fdc10f09642432c5$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$fdc10f09642432c5$var$isFunction(predicate) || !predicate()) return;
    }
    if ($fdc10f09642432c5$var$supportsDescriptors) $6dipk(object, name, value, true);
    else $6dipk(object, name, value);
};
var $fdc10f09642432c5$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $9zcAj(map);
    if ($fdc10f09642432c5$var$hasSymbols) props = $fdc10f09642432c5$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$fdc10f09642432c5$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$fdc10f09642432c5$var$defineProperties.supportsDescriptors = !!$fdc10f09642432c5$var$supportsDescriptors;
module.exports = $fdc10f09642432c5$var$defineProperties;

});

parcelRegister("hMtaR", function(module, exports) {
'use strict';

var $4WxrU = parcelRequire("4WxrU");

var $lMJ5M = parcelRequire("lMJ5M");
module.exports = function shimObjectIs() {
    var polyfill = $4WxrU();
    $lMJ5M(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("iC2Ks", function(module, exports) {
'use strict';

var $6Qtg6 = parcelRequire("6Qtg6");

var $lMJ5M = parcelRequire("lMJ5M");

var $cxaLB = parcelRequire("cxaLB");

var $5aCg0 = parcelRequire("5aCg0");

var $gDpax = parcelRequire("gDpax");
var $d8cde85e87d7d589$var$polyfill = $6Qtg6($5aCg0(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $lMJ5M($d8cde85e87d7d589$var$polyfill, {
    getPolyfill: $5aCg0,
    implementation: $cxaLB,
    shim: $gDpax
});
module.exports = $d8cde85e87d7d589$var$polyfill;

});
parcelRegister("cxaLB", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("5aCg0", function(module, exports) {
'use strict';

var $cxaLB = parcelRequire("cxaLB");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $cxaLB;
};

});

parcelRegister("gDpax", function(module, exports) {
'use strict';

var $lMJ5M = parcelRequire("lMJ5M");

var $5aCg0 = parcelRequire("5aCg0");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $5aCg0();
    $lMJ5M(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("7E4wf", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ // The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function(obj) {
    return obj != null && ($590fc640dd350ee6$var$isBuffer(obj) || $590fc640dd350ee6$var$isSlowBuffer(obj) || !!obj._isBuffer);
};
function $590fc640dd350ee6$var$isBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function $590fc640dd350ee6$var$isSlowBuffer(obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && $590fc640dd350ee6$var$isBuffer(obj.slice(0, 0));
}

});

parcelRegister("4eC3c", function(module, exports) {
/**
 * @module audio-format
 */ 'use strict';

var $6rlQG = parcelRequire("6rlQG");

var $dEfD5 = parcelRequire("dEfD5");

var $3Bjqc = parcelRequire("3Bjqc");

var $7E4wf = parcelRequire("7E4wf");

var $3aHTW = parcelRequire("3aHTW");

var $dzE9k = parcelRequire("dzE9k");
module.exports = {
    parse: $3155fc4ee2a175ca$var$parse,
    stringify: $3155fc4ee2a175ca$var$stringify,
    detect: $3155fc4ee2a175ca$var$detect,
    type: $3155fc4ee2a175ca$var$getType
};
var $3155fc4ee2a175ca$var$endianness = $dEfD5.endianness instanceof Function ? $dEfD5.endianness().toLowerCase() : 'le';
var $3155fc4ee2a175ca$var$types = {
    'uint': 'uint32',
    'uint8': 'uint8',
    'uint8_clamped': 'uint8',
    'uint16': 'uint16',
    'uint32': 'uint32',
    'int': 'int32',
    'int8': 'int8',
    'int16': 'int16',
    'int32': 'int32',
    'float': 'float32',
    'float32': 'float32',
    'float64': 'float64',
    'array': 'array',
    'arraybuffer': 'arraybuffer',
    'buffer': 'buffer',
    'audiobuffer': 'audiobuffer',
    'ndarray': 'ndarray',
    'ndsamples': 'ndsamples'
};
var $3155fc4ee2a175ca$var$channelNumber = {
    'mono': 1,
    'stereo': 2,
    'quad': 4,
    '5.1': 6,
    '2.1': 3,
    '3-channel': 3,
    '5-channel': 5
};
var $3155fc4ee2a175ca$var$maxChannels = 32;
for(var $3155fc4ee2a175ca$var$i = 6; $3155fc4ee2a175ca$var$i < $3155fc4ee2a175ca$var$maxChannels; $3155fc4ee2a175ca$var$i++)$3155fc4ee2a175ca$var$channelNumber[$3155fc4ee2a175ca$var$i + '-channel'] = $3155fc4ee2a175ca$var$i;
var $3155fc4ee2a175ca$var$channelName = {};
for(var $3155fc4ee2a175ca$var$name in $3155fc4ee2a175ca$var$channelNumber)$3155fc4ee2a175ca$var$channelName[$3155fc4ee2a175ca$var$channelNumber[$3155fc4ee2a175ca$var$name]] = $3155fc4ee2a175ca$var$name;
//parse format string
function $3155fc4ee2a175ca$var$parse(str) {
    var format = {};
    var parts = str.split(/\s*[,;_]\s*|\s+/);
    for(var i = 0; i < parts.length; i++){
        var part = parts[i].toLowerCase();
        if (part === 'planar' && format.interleaved == null) {
            format.interleaved = false;
            if (format.channels == null) format.channels = 2;
        } else if ((part === 'interleave' || part === 'interleaved') && format.interleaved == null) {
            format.interleaved = true;
            if (format.channels == null) format.channels = 2;
        } else if ($3155fc4ee2a175ca$var$channelNumber[part]) format.channels = $3155fc4ee2a175ca$var$channelNumber[part];
        else if (part === 'le' || part === 'LE' || part === 'littleendian' || part === 'bigEndian') format.endianness = 'le';
        else if (part === 'be' || part === 'BE' || part === 'bigendian' || part === 'bigEndian') format.endianness = 'be';
        else if ($3155fc4ee2a175ca$var$types[part]) {
            format.type = $3155fc4ee2a175ca$var$types[part];
            if (part === 'audiobuffer') {
                format.endianness = $3155fc4ee2a175ca$var$endianness;
                format.interleaved = false;
            }
        } else if ($6rlQG[part]) format.sampleRate = $6rlQG[part];
        else if (/^\d+$/.test(part)) format.sampleRate = parseInt(part);
        else throw Error('Cannot identify part `' + part + '`');
    }
    return format;
}
//parse available format properties from an object
function $3155fc4ee2a175ca$var$detect(obj) {
    if (!obj) return {};
    var format = $dzE9k(obj, {
        channels: 'channel channels numberOfChannels channelCount',
        sampleRate: 'sampleRate rate',
        interleaved: 'interleave interleaved',
        type: 'type dtype',
        endianness: 'endianness'
    });
    // ndsamples case
    if (obj.format) format.type = 'ndsamples';
    if (format.sampleRate == null && obj.format && obj.format.sampleRate) format.sampleRate = obj.format.sampleRate;
    if (obj.planar) format.interleaved = false;
    if (format.interleaved != null) {
        if (format.channels == null) format.channels = 2;
    }
    if (format.type == null) {
        var type = $3155fc4ee2a175ca$var$getType(obj);
        if (type) format.type = type;
    }
    if (format.type === 'audiobuffer') {
        format.endianness = $3155fc4ee2a175ca$var$endianness;
        format.interleaved = false;
    }
    return format;
}
//convert format string to format object
function $3155fc4ee2a175ca$var$stringify(format, omit) {
    if (omit === undefined) omit = {
        endianness: 'le'
    };
    else if (omit == null) omit = {};
    else if (typeof omit === 'string') omit = $3155fc4ee2a175ca$var$parse(omit);
    else omit = $3155fc4ee2a175ca$var$detect(omit);
    if (!$3aHTW(format)) format = $3155fc4ee2a175ca$var$detect(format);
    var parts = [];
    if (format.type != null && format.type !== omit.type) parts.push(format.type || 'float32');
    if (format.channels != null && format.channels !== omit.channels) parts.push($3155fc4ee2a175ca$var$channelName[format.channels]);
    if (format.endianness != null && format.endianness !== omit.endianness) parts.push(format.endianness || 'le');
    if (format.interleaved != null && format.interleaved !== omit.interleaved) {
        if (format.type !== 'audiobuffer') parts.push(format.interleaved ? 'interleaved' : 'planar');
    }
    if (format.sampleRate != null && format.sampleRate !== omit.sampleRate) parts.push(format.sampleRate);
    return parts.join(' ');
}
//return type string for an object
function $3155fc4ee2a175ca$var$getType(arg) {
    if ($3Bjqc(arg)) return 'audiobuffer';
    if ($7E4wf(arg)) return 'buffer';
    if (Array.isArray(arg)) return 'array';
    if (arg instanceof ArrayBuffer) return 'arraybuffer';
    if (arg.shape && arg.dtype) return arg.format ? 'ndsamples' : 'ndarray';
    if (arg instanceof Float32Array) return 'float32';
    if (arg instanceof Float64Array) return 'float64';
    if (arg instanceof Uint8Array) return 'uint8';
    if (arg instanceof Uint8ClampedArray) return 'uint8_clamped';
    if (arg instanceof Int8Array) return 'int8';
    if (arg instanceof Int16Array) return 'int16';
    if (arg instanceof Uint16Array) return 'uint16';
    if (arg instanceof Int32Array) return 'int32';
    if (arg instanceof Uint32Array) return 'uint32';
}

});
parcelRegister("6rlQG", function(module, exports) {
module.exports = JSON.parse("{\"8000\":8000,\"11025\":11025,\"16000\":16000,\"22050\":22050,\"44100\":44100,\"48000\":48000,\"88200\":88200,\"96000\":96000,\"176400\":176400,\"192000\":192000,\"352800\":352800,\"384000\":384000}");

});

parcelRegister("dEfD5", function(module, exports) {

$parcel$export(module.exports, "endianness", () => $9efb22786f6530bf$export$edf525f30916fbb8, (v) => $9efb22786f6530bf$export$edf525f30916fbb8 = v);
var $9efb22786f6530bf$export$edf525f30916fbb8;
var $9efb22786f6530bf$export$640106f6dc7d2706;
var $9efb22786f6530bf$export$3ea386628068cf62;
var $9efb22786f6530bf$export$749d472264fad440;
var $9efb22786f6530bf$export$8b931a48d9488767;
var $9efb22786f6530bf$export$9123f37609399513;
var $9efb22786f6530bf$export$9b60beb643db4d69;
var $9efb22786f6530bf$export$bf9fb029d174d554;
var $9efb22786f6530bf$export$23d3fad09dc44362;
var $9efb22786f6530bf$export$d2f3c2f7e0c7dcf5;
var $9efb22786f6530bf$export$3bf7c33313eba0fe;
var $9efb22786f6530bf$export$7925d89f138dad5b;
var $9efb22786f6530bf$export$722a64dea1b767dc;
var $9efb22786f6530bf$export$9e6c06a7d47f9af7;
var $9efb22786f6530bf$export$6b76988456c0292f;
var $9efb22786f6530bf$export$266d3b9babd1fc45;
var $9efb22786f6530bf$export$c1d46b5ea6262c0b;
$9efb22786f6530bf$export$edf525f30916fbb8 = function() {
    return 'LE';
};
$9efb22786f6530bf$export$640106f6dc7d2706 = function() {
    if (typeof location !== 'undefined') return location.hostname;
    else return '';
};
$9efb22786f6530bf$export$3ea386628068cf62 = function() {
    return [];
};
$9efb22786f6530bf$export$749d472264fad440 = function() {
    return 0;
};
$9efb22786f6530bf$export$8b931a48d9488767 = function() {
    return Number.MAX_VALUE;
};
$9efb22786f6530bf$export$9123f37609399513 = function() {
    return Number.MAX_VALUE;
};
$9efb22786f6530bf$export$9b60beb643db4d69 = function() {
    return [];
};
$9efb22786f6530bf$export$bf9fb029d174d554 = function() {
    return 'Browser';
};
$9efb22786f6530bf$export$23d3fad09dc44362 = function() {
    if (typeof navigator !== 'undefined') return navigator.appVersion;
    return '';
};
$9efb22786f6530bf$export$d2f3c2f7e0c7dcf5 = $9efb22786f6530bf$export$3bf7c33313eba0fe = function() {
    return {};
};
$9efb22786f6530bf$export$7925d89f138dad5b = function() {
    return 'javascript';
};
$9efb22786f6530bf$export$722a64dea1b767dc = function() {
    return 'browser';
};
$9efb22786f6530bf$export$9e6c06a7d47f9af7 = $9efb22786f6530bf$export$6b76988456c0292f = function() {
    return '/tmp';
};
$9efb22786f6530bf$export$266d3b9babd1fc45 = '\n';
$9efb22786f6530bf$export$c1d46b5ea6262c0b = function() {
    return '/';
};

});

parcelRegister("dzE9k", function(module, exports) {
'use strict';
module.exports = function pick(src, props, keepRest) {
    var result = {}, prop, i;
    if (typeof props === 'string') props = $9e1db013ea67f484$var$toList(props);
    if (Array.isArray(props)) {
        var res = {};
        for(i = 0; i < props.length; i++)res[props[i]] = true;
        props = res;
    }
    // convert strings to lists
    for(prop in props)props[prop] = $9e1db013ea67f484$var$toList(props[prop]);
    // keep-rest strategy requires unmatched props to be preserved
    var occupied = {};
    for(prop in props){
        var aliases = props[prop];
        if (Array.isArray(aliases)) for(i = 0; i < aliases.length; i++){
            var alias = aliases[i];
            if (keepRest) occupied[alias] = true;
            if (alias in src) {
                result[prop] = src[alias];
                if (keepRest) for(var j = i; j < aliases.length; j++)occupied[aliases[j]] = true;
                break;
            }
        }
        else if (prop in src) {
            if (props[prop]) result[prop] = src[prop];
            if (keepRest) occupied[prop] = true;
        }
    }
    if (keepRest) for(prop in src){
        if (occupied[prop]) continue;
        result[prop] = src[prop];
    }
    return result;
};
var $9e1db013ea67f484$var$CACHE = {};
function $9e1db013ea67f484$var$toList(arg) {
    if ($9e1db013ea67f484$var$CACHE[arg]) return $9e1db013ea67f484$var$CACHE[arg];
    if (typeof arg === 'string') arg = $9e1db013ea67f484$var$CACHE[arg] = arg.split(/\s*,\s*|\s+/);
    return arg;
}

});


parcelRegister("2ocMU", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $1bd7be12f41d51a4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $1bd7be12f41d51a4$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $1bd7be12f41d51a4$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $1bd7be12f41d51a4$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $1bd7be12f41d51a4$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $1bd7be12f41d51a4$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $1bd7be12f41d51a4$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($1bd7be12f41d51a4$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($1bd7be12f41d51a4$var$getOwnPropertySymbols) {
            symbols = $1bd7be12f41d51a4$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($1bd7be12f41d51a4$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("dZQxA", function(module, exports) {
/**
 * @module  string-to-arraybuffer
 */ 'use strict';

var $g5zp5 = parcelRequire("g5zp5");

var $BNRDT = parcelRequire("BNRDT");
module.exports = function stringToArrayBuffer(arg) {
    if (typeof arg !== 'string') throw Error('Argument should be a string');
    //valid data uri
    if (/^data\:/i.test(arg)) return $a309ba55b116e976$var$decode(arg);
    //base64
    if ($BNRDT(arg)) arg = $g5zp5(arg);
    return $a309ba55b116e976$var$str2ab(arg);
};
function $a309ba55b116e976$var$str2ab(str) {
    var array = new Uint8Array(str.length);
    for(var i = 0; i < str.length; i++)array[i] = str.charCodeAt(i);
    return array.buffer;
}
function $a309ba55b116e976$var$decode(uri) {
    // strip newlines
    uri = uri.replace(/\r?\n/g, '');
    // split the URI up into the "metadata" and the "data" portions
    var firstComma = uri.indexOf(',');
    if (-1 === firstComma || firstComma <= 4) throw new TypeError('malformed data-URI');
    // remove the "data:" scheme and parse the metadata
    var meta = uri.substring(5, firstComma).split(';');
    var base64 = false;
    var charset = 'US-ASCII';
    for(var i = 0; i < meta.length; i++){
        if ('base64' == meta[i]) base64 = true;
        else if (0 == meta[i].indexOf('charset=')) charset = meta[i].substring(8);
    }
    // get the encoded data portion and decode URI-encoded chars
    var data = unescape(uri.substring(firstComma + 1));
    if (base64) data = $g5zp5(data);
    var abuf = $a309ba55b116e976$var$str2ab(data);
    abuf.type = meta[0] || 'text/plain';
    abuf.charset = charset;
    return abuf;
}

});
parcelRegister("g5zp5", function(module, exports) {
module.exports = function _atob(str) {
    return atob(str);
};

});

parcelRegister("BNRDT", function(module, exports) {
(function(root) {
    'use strict';
    function isBase64(v, opts) {
        if (v instanceof Boolean || typeof v === 'boolean') return false;
        if (!(opts instanceof Object)) opts = {};
        if (opts.hasOwnProperty('allowBlank') && !opts.allowBlank && v === '') return false;
        var regex = '(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}==|[A-Za-z0-9+\/]{3}=)?';
        if (opts.mime) regex = '(data:\\w+\\/[a-zA-Z\\+\\-\\.]+;base64,)?' + regex;
        if (opts.paddingRequired === false) regex = '(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}(==)?|[A-Za-z0-9+\\/]{3}=?)?';
        return new RegExp('^' + regex + '$', 'gi').test(v);
    }
    if (module.exports) exports = module.exports = isBase64;
    exports.isBase64 = isBase64;
})(this);

});




parcelRegister("3Bdmq", function(module, exports) {
'use strict';

var $cI1ok = parcelRequire("cI1ok");
const $29ef30f7e55f83db$var$$ = $cI1ok.Observable;
const $29ef30f7e55f83db$var$noop = ()=>{};
/*
const _MediaRecorder = function(stream, options, ctx) {
	this._state = window.RecordingState.inactive;
	this._stream = stream;

	this._encoder = new window.VorbisEncoder();
	this._chunks = [];

	this._ctx = ctx || new AudioContext();
	this._sourceNode = this._ctx.createMediaStreamSource(stream);
	this._procNode = this._ctx.createScriptProcessor(4096);

	this._onstart = noop;
	this._ondataavailable = noop;
	this._onstop = noop;

	// ---

	this._encoder.ondata = this.handleEncoderData.bind(this);

	this._encoder.onfinish = this.handleEncoderFinish.bind(this);

	this._procNode.onaudioprocess = this.handleAudioProcess.bind(this);
};

_MediaRecorder.prototype = Object.create(window.VorbisMediaRecorder.prototype);
_MediaRecorder.prototype.constructor = _MediaRecorder;
*/ const $29ef30f7e55f83db$var$record = (stream, ctx)=>{
    let mediaRecorder = new window.MediaRecorder(stream, {
        audioBitsPerSecond: 32000
    });
    // let mediaRecorder = new _MediaRecorder(stream, {audioBitsPerSecond: 32000}, ctx);
    // mediaRecorder.mimeType = 'audio/ogg';
    let chunks = [];
    mediaRecorder.start();
    let data$ = new $cI1ok.Subject();
    mediaRecorder.ondataavailable = (e)=>{
        chunks.push(e.data);
        console.log({
            chunk: e.data
        });
    };
    mediaRecorder.onstop = ()=>{
        data$.onNext(chunks.length === 1 ? chunks[0] : new Blob(chunks, {
            type: chunks[0].type
        }));
    };
    return {
        data$: data$,
        stop: ()=>mediaRecorder.stop()
    };
};
module.exports = {
    record: $29ef30f7e55f83db$var$record
};

});

parcelRegister("6TsbL", function(module, exports) {
'use strict';

var $cI1ok = parcelRequire("cI1ok");
const $504dbecdd81b0133$var$$ = $cI1ok.Observable;

var $lvEvf = parcelRequire("lvEvf");

var $6PzUf = parcelRequire("6PzUf");

var $jjnZg = parcelRequire("jjnZg");
var $504dbecdd81b0133$require$arr = $jjnZg.arr;
var $504dbecdd81b0133$require$obj = $jjnZg.obj;
var $504dbecdd81b0133$require$fn = $jjnZg.fn;
const $504dbecdd81b0133$var$load = (file, readAs = 'text')=>$504dbecdd81b0133$var$$.create((stream)=>{
        const fr = new FileReader();
        fr.onload = function(ev) {
            // console.log(readAs, ev.target.result);
            stream.onNext(readAs === 'json' ? JSON.parse(ev.target.result) : ev.target.result);
            stream.onCompleted();
        };
        console.log(file, readAs);
        (typeof file === 'string' ? $504dbecdd81b0133$var$$.fromPromise(fetch(file)).flatMap((res)=>res.blob()) : $504dbecdd81b0133$var$$.just(file)).subscribe((f)=>(console.log(f), $504dbecdd81b0133$require$obj.switch(readAs, {
                arrayBuffer: (f)=>fr.readAsArrayBuffer(f),
                default: (f)=>fr.readAsText(f)
            })(f)));
    });
const $504dbecdd81b0133$var$loadZip = (file)=>$504dbecdd81b0133$var$load(file, 'arrayBuffer').flatMap((data)=>$504dbecdd81b0133$var$$.fromPromise($6PzUf.loadAsync(data))).flatMap((zf)=>$504dbecdd81b0133$var$$.concat(Object.keys(zf.files).filter((k)=>!zf.files[k].dir).map((k)=>(console.log(k), k)).map((k)=>$504dbecdd81b0133$var$$.fromPromise(zf.files[k].async('arraybuffer')).map((v)=>({
                    k: k,
                    v: v
                })))).reduce((o, { k: k, v: v })=>$504dbecdd81b0133$require$obj.patch(o, k, v), {}));
const $504dbecdd81b0133$var$save = (fileName, content)=>$lvEvf.saveAs(new Blob([
        JSON.stringify(content)
    ], {
        type: "text/plain;charset=utf-8"
    }), fileName);
module.exports = {
    load: $504dbecdd81b0133$var$load,
    loadZip: $504dbecdd81b0133$var$loadZip,
    save: $504dbecdd81b0133$var$save
};

});
parcelRegister("lvEvf", function(module, exports) {
/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */ /*global self */ /*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */ /*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */ var $fa8be949723f0250$var$saveAs = $fa8be949723f0250$var$saveAs || function(view) {
    "use strict";
    // IE <10 is explicitly unsupported
    if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) return;
    var doc = view.document, get_URL = function() {
        return view.URL || view.webkitURL || view;
    }, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a"), can_use_save_link = "download" in save_link, click = function(node) {
        var event = new MouseEvent("click");
        node.dispatchEvent(event);
    }, is_safari = /constructor/i.test(view.HTMLElement) || view.safari, is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent), throw_outside = function(ex) {
        (view.setImmediate || view.setTimeout)(function() {
            throw ex;
        }, 0);
    }, force_saveable_type = "application/octet-stream", arbitrary_revoke_timeout = 40000 // in ms
    , revoke = function(file) {
        var revoker = function() {
            if (typeof file === "string") get_URL().revokeObjectURL(file);
            else file.remove();
        };
        setTimeout(revoker, arbitrary_revoke_timeout);
    }, dispatch = function(filesaver, event_types, event) {
        event_types = [].concat(event_types);
        var i = event_types.length;
        while(i--){
            var listener = filesaver["on" + event_types[i]];
            if (typeof listener === "function") try {
                listener.call(filesaver, event || filesaver);
            } catch (ex) {
                throw_outside(ex);
            }
        }
    }, auto_bom = function(blob) {
        // prepend BOM for UTF-8 XML and text/* types (including HTML)
        // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
        if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
            String.fromCharCode(0xFEFF),
            blob
        ], {
            type: blob.type
        });
        return blob;
    }, FileSaver = function(blob, name, no_auto_bom) {
        if (!no_auto_bom) blob = auto_bom(blob);
        // First try a.download, then web filesystem, then object URLs
        var filesaver = this, type = blob.type, force = type === force_saveable_type, object_url, dispatch_all = function() {
            dispatch(filesaver, "writestart progress write writeend".split(" "));
        }, fs_error = function() {
            if ((is_chrome_ios || force && is_safari) && view.FileReader) {
                // Safari doesn't allow downloading of blob urls
                var reader = new FileReader();
                reader.onloadend = function() {
                    var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
                    var popup = view.open(url, '_blank');
                    if (!popup) view.location.href = url;
                    url = undefined; // release reference before dispatching
                    filesaver.readyState = filesaver.DONE;
                    dispatch_all();
                };
                reader.readAsDataURL(blob);
                filesaver.readyState = filesaver.INIT;
                return;
            }
            // don't create more object URLs than needed
            if (!object_url) object_url = get_URL().createObjectURL(blob);
            if (force) view.location.href = object_url;
            else {
                var opened = view.open(object_url, "_blank");
                if (!opened) // Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
                view.location.href = object_url;
            }
            filesaver.readyState = filesaver.DONE;
            dispatch_all();
            revoke(object_url);
        };
        filesaver.readyState = filesaver.INIT;
        if (can_use_save_link) {
            object_url = get_URL().createObjectURL(blob);
            setTimeout(function() {
                save_link.href = object_url;
                save_link.download = name;
                click(save_link);
                dispatch_all();
                revoke(object_url);
                filesaver.readyState = filesaver.DONE;
            });
            return;
        }
        fs_error();
    }, FS_proto = FileSaver.prototype, saveAs = function(blob, name, no_auto_bom) {
        return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
    };
    // IE 10+ (native saveAs)
    if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) return function(blob, name, no_auto_bom) {
        name = name || blob.name || "download";
        if (!no_auto_bom) blob = auto_bom(blob);
        return navigator.msSaveOrOpenBlob(blob, name);
    };
    FS_proto.abort = function() {};
    FS_proto.readyState = FS_proto.INIT = 0;
    FS_proto.WRITING = 1;
    FS_proto.DONE = 2;
    FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;
    return saveAs;
}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || module.exports.content);
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window
if (module.exports) module.exports.saveAs = $fa8be949723f0250$var$saveAs;
else if (typeof define !== "undefined" && define !== null && define.amd !== null) define("FileSaver.js", function() {
    return $fa8be949723f0250$var$saveAs;
});

});

parcelRegister("6PzUf", function(module, exports) {
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ 
var $cbQCu = parcelRequire("cbQCu");
var $4f935bb8b4cfed5e$require$Buffer = $cbQCu.Buffer;

var $4Jj9n = parcelRequire("4Jj9n");
!function(e) {
    module.exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\0\0",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $4f935bb8b4cfed5e$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($4f935bb8b4cfed5e$require$Buffer.from && $4f935bb8b4cfed5e$require$Buffer.from !== Uint8Array.from) return $4f935bb8b4cfed5e$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $4f935bb8b4cfed5e$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($4f935bb8b4cfed5e$require$Buffer.alloc) return $4f935bb8b4cfed5e$require$Buffer.alloc(e);
                        var t = new $4f935bb8b4cfed5e$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $4f935bb8b4cfed5e$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $4f935bb8b4cfed5e$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $4f935bb8b4cfed5e$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $4Jj9n.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});

});
parcelRegister("cbQCu", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $8dff54558831dec9$export$a143d493d941bafc, (v) => $8dff54558831dec9$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $8dff54558831dec9$export$f99ded8fe4b79145, (v) => $8dff54558831dec9$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8dff54558831dec9$export$a143d493d941bafc;
var $8dff54558831dec9$export$e4cf37d7f6fb9e0a;
var $8dff54558831dec9$export$f99ded8fe4b79145;
var $8dff54558831dec9$export$599f31c3813fae4d;
'use strict';

var $6ocIT = parcelRequire("6ocIT");

var $1wLos = parcelRequire("1wLos");
const $8dff54558831dec9$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$8dff54558831dec9$export$a143d493d941bafc = $8dff54558831dec9$var$Buffer;
$8dff54558831dec9$export$e4cf37d7f6fb9e0a = $8dff54558831dec9$var$SlowBuffer;
$8dff54558831dec9$export$f99ded8fe4b79145 = 50;
const $8dff54558831dec9$var$K_MAX_LENGTH = 0x7fffffff;
$8dff54558831dec9$export$599f31c3813fae4d = $8dff54558831dec9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT = $8dff54558831dec9$var$typedArraySupport();
if (!$8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8dff54558831dec9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8dff54558831dec9$var$createBuffer(length) {
    if (length > $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8dff54558831dec9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8dff54558831dec9$var$allocUnsafe(arg);
    }
    return $8dff54558831dec9$var$from(arg, encodingOrOffset, length);
}
$8dff54558831dec9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8dff54558831dec9$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $8dff54558831dec9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8dff54558831dec9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8dff54558831dec9$var$isInstance(value, ArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, ArrayBuffer)) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($8dff54558831dec9$var$isInstance(value, SharedArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, SharedArrayBuffer))) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8dff54558831dec9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8dff54558831dec9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $8dff54558831dec9$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8dff54558831dec9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8dff54558831dec9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8dff54558831dec9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8dff54558831dec9$var$Buffer, Uint8Array);
function $8dff54558831dec9$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8dff54558831dec9$var$alloc(size, fill, encoding) {
    $8dff54558831dec9$var$assertSize(size);
    if (size <= 0) return $8dff54558831dec9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $8dff54558831dec9$var$createBuffer(size).fill(fill, encoding) : $8dff54558831dec9$var$createBuffer(size).fill(fill);
    return $8dff54558831dec9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8dff54558831dec9$var$Buffer.alloc = function(size, fill, encoding) {
    return $8dff54558831dec9$var$alloc(size, fill, encoding);
};
function $8dff54558831dec9$var$allocUnsafe(size) {
    $8dff54558831dec9$var$assertSize(size);
    return $8dff54558831dec9$var$createBuffer(size < 0 ? 0 : $8dff54558831dec9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8dff54558831dec9$var$Buffer.allocUnsafe = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8dff54558831dec9$var$Buffer.allocUnsafeSlow = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
function $8dff54558831dec9$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $8dff54558831dec9$var$byteLength(string, encoding) | 0;
    let buf = $8dff54558831dec9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8dff54558831dec9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8dff54558831dec9$var$checked(array.length) | 0;
    const buf = $8dff54558831dec9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8dff54558831dec9$var$fromArrayView(arrayView) {
    if ($8dff54558831dec9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8dff54558831dec9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8dff54558831dec9$var$fromArrayLike(arrayView);
}
function $8dff54558831dec9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
function $8dff54558831dec9$var$fromObject(obj) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(obj)) {
        const len = $8dff54558831dec9$var$checked(obj.length) | 0;
        const buf = $8dff54558831dec9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $8dff54558831dec9$var$numberIsNaN(obj.length)) return $8dff54558831dec9$var$createBuffer(0);
        return $8dff54558831dec9$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $8dff54558831dec9$var$fromArrayLike(obj.data);
}
function $8dff54558831dec9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8dff54558831dec9$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $8dff54558831dec9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8dff54558831dec9$var$Buffer.alloc(+length);
}
$8dff54558831dec9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8dff54558831dec9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8dff54558831dec9$var$Buffer.compare = function compare(a, b) {
    if ($8dff54558831dec9$var$isInstance(a, Uint8Array)) a = $8dff54558831dec9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8dff54558831dec9$var$isInstance(b, Uint8Array)) b = $8dff54558831dec9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(a) || !$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8dff54558831dec9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$8dff54558831dec9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8dff54558831dec9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8dff54558831dec9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8dff54558831dec9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) buf = $8dff54558831dec9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8dff54558831dec9$var$byteLength(string, encoding) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8dff54558831dec9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $8dff54558831dec9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8dff54558831dec9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8dff54558831dec9$var$Buffer.byteLength = $8dff54558831dec9$var$byteLength;
function $8dff54558831dec9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Slice(this, start, end);
        case 'ascii':
            return $8dff54558831dec9$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$latin1Slice(this, start, end);
        case 'base64':
            return $8dff54558831dec9$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8dff54558831dec9$var$Buffer.prototype._isBuffer = true;
function $8dff54558831dec9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8dff54558831dec9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$8dff54558831dec9$var$swap(this, i, i + 1);
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $8dff54558831dec9$var$swap(this, i, i + 3);
        $8dff54558831dec9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $8dff54558831dec9$var$swap(this, i, i + 7);
        $8dff54558831dec9$var$swap(this, i + 1, i + 6);
        $8dff54558831dec9$var$swap(this, i + 2, i + 5);
        $8dff54558831dec9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $8dff54558831dec9$var$utf8Slice(this, 0, length);
    return $8dff54558831dec9$var$slowToString.apply(this, arguments);
};
$8dff54558831dec9$var$Buffer.prototype.toLocaleString = $8dff54558831dec9$var$Buffer.prototype.toString;
$8dff54558831dec9$var$Buffer.prototype.equals = function equals(b) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $8dff54558831dec9$var$Buffer.compare(this, b) === 0;
};
$8dff54558831dec9$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $8dff54558831dec9$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($8dff54558831dec9$var$customInspectSymbol) $8dff54558831dec9$var$Buffer.prototype[$8dff54558831dec9$var$customInspectSymbol] = $8dff54558831dec9$var$Buffer.prototype.inspect;
$8dff54558831dec9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8dff54558831dec9$var$isInstance(target, Uint8Array)) target = $8dff54558831dec9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8dff54558831dec9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8dff54558831dec9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $8dff54558831dec9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8dff54558831dec9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8dff54558831dec9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8dff54558831dec9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $8dff54558831dec9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8dff54558831dec9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8dff54558831dec9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8dff54558831dec9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8dff54558831dec9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8dff54558831dec9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8dff54558831dec9$var$utf8Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8dff54558831dec9$var$asciiWrite(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$asciiToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$base64Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$base64ToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$ucs2Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8dff54558831dec9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $8dff54558831dec9$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8dff54558831dec9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8dff54558831dec9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6ocIT.fromByteArray(buf);
    else return $6ocIT.fromByteArray(buf.slice(start, end));
}
function $8dff54558831dec9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8dff54558831dec9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8dff54558831dec9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8dff54558831dec9$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8dff54558831dec9$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8dff54558831dec9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $8dff54558831dec9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8dff54558831dec9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8dff54558831dec9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8dff54558831dec9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8dff54558831dec9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$8dff54558831dec9$var$Buffer.prototype.readUintLE = $8dff54558831dec9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUintBE = $8dff54558831dec9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUint8 = $8dff54558831dec9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8dff54558831dec9$var$Buffer.prototype.readUint16LE = $8dff54558831dec9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8dff54558831dec9$var$Buffer.prototype.readUint16BE = $8dff54558831dec9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8dff54558831dec9$var$Buffer.prototype.readUint32LE = $8dff54558831dec9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8dff54558831dec9$var$Buffer.prototype.readUint32BE = $8dff54558831dec9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8dff54558831dec9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8dff54558831dec9$var$Buffer.prototype.readBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8dff54558831dec9$var$Buffer.prototype.readBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8dff54558831dec9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, true, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, false, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, true, 52, 8);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, false, 52, 8);
};
function $8dff54558831dec9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$8dff54558831dec9$var$Buffer.prototype.writeUintLE = $8dff54558831dec9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUintBE = $8dff54558831dec9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint8 = $8dff54558831dec9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8dff54558831dec9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8dff54558831dec9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $8dff54558831dec9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $8dff54558831dec9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8dff54558831dec9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, false, noAssert);
};
function $8dff54558831dec9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8dff54558831dec9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8dff54558831dec9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8dff54558831dec9$var$Buffer.isBuffer(val) ? val : $8dff54558831dec9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8dff54558831dec9$var$errors = {};
function $8dff54558831dec9$var$E(sym, getMessage, Base) {
    $8dff54558831dec9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8dff54558831dec9$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$8dff54558831dec9$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8dff54558831dec9$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8dff54558831dec9$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8dff54558831dec9$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8dff54558831dec9$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8dff54558831dec9$var$checkBounds(buf, offset, byteLength) {
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8dff54558831dec9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $8dff54558831dec9$var$checkBounds(buf, offset, byteLength);
}
function $8dff54558831dec9$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $8dff54558831dec9$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $8dff54558831dec9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8dff54558831dec9$var$validateNumber(value, type);
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $8dff54558831dec9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8dff54558831dec9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8dff54558831dec9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8dff54558831dec9$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $8dff54558831dec9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $8dff54558831dec9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8dff54558831dec9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8dff54558831dec9$var$base64ToBytes(str) {
    return $6ocIT.toByteArray($8dff54558831dec9$var$base64clean(str));
}
function $8dff54558831dec9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8dff54558831dec9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8dff54558831dec9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8dff54558831dec9$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8dff54558831dec9$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $8dff54558831dec9$var$BufferBigIntNotDefined : fn;
}
function $8dff54558831dec9$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("6ocIT", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $4a6eda7d0e4e0857$export$d622b2ad8d90c771, (v) => $4a6eda7d0e4e0857$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $4a6eda7d0e4e0857$export$6100ba28696e12de, (v) => $4a6eda7d0e4e0857$export$6100ba28696e12de = v);
var $4a6eda7d0e4e0857$export$a48f0734ac7c2329;
var $4a6eda7d0e4e0857$export$d622b2ad8d90c771;
var $4a6eda7d0e4e0857$export$6100ba28696e12de;
'use strict';
$4a6eda7d0e4e0857$export$a48f0734ac7c2329 = $4a6eda7d0e4e0857$var$byteLength;
$4a6eda7d0e4e0857$export$d622b2ad8d90c771 = $4a6eda7d0e4e0857$var$toByteArray;
$4a6eda7d0e4e0857$export$6100ba28696e12de = $4a6eda7d0e4e0857$var$fromByteArray;
var $4a6eda7d0e4e0857$var$lookup = [];
var $4a6eda7d0e4e0857$var$revLookup = [];
var $4a6eda7d0e4e0857$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $4a6eda7d0e4e0857$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $4a6eda7d0e4e0857$var$i = 0, $4a6eda7d0e4e0857$var$len = $4a6eda7d0e4e0857$var$code.length; $4a6eda7d0e4e0857$var$i < $4a6eda7d0e4e0857$var$len; ++$4a6eda7d0e4e0857$var$i){
    $4a6eda7d0e4e0857$var$lookup[$4a6eda7d0e4e0857$var$i] = $4a6eda7d0e4e0857$var$code[$4a6eda7d0e4e0857$var$i];
    $4a6eda7d0e4e0857$var$revLookup[$4a6eda7d0e4e0857$var$code.charCodeAt($4a6eda7d0e4e0857$var$i)] = $4a6eda7d0e4e0857$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a6eda7d0e4e0857$var$revLookup['-'.charCodeAt(0)] = 62;
$4a6eda7d0e4e0857$var$revLookup['_'.charCodeAt(0)] = 63;
function $4a6eda7d0e4e0857$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a6eda7d0e4e0857$var$byteLength(b64) {
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$toByteArray(b64) {
    var tmp;
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a6eda7d0e4e0857$var$Arr($4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 18 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 2 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 10 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a6eda7d0e4e0857$var$tripletToBase64(num) {
    return $4a6eda7d0e4e0857$var$lookup[num >> 18 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 12 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 6 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num & 0x3F];
}
function $4a6eda7d0e4e0857$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a6eda7d0e4e0857$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $4a6eda7d0e4e0857$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a6eda7d0e4e0857$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 2] + $4a6eda7d0e4e0857$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 10] + $4a6eda7d0e4e0857$var$lookup[tmp >> 4 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("1wLos", function(module, exports) {

$parcel$export(module.exports, "read", () => $11cd8afb6c84e33a$export$aafa59e2e03f2942, (v) => $11cd8afb6c84e33a$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $11cd8afb6c84e33a$export$68d8715fc104d294, (v) => $11cd8afb6c84e33a$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11cd8afb6c84e33a$export$aafa59e2e03f2942;
var $11cd8afb6c84e33a$export$68d8715fc104d294;
$11cd8afb6c84e33a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11cd8afb6c84e33a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("5kgSa", function(module, exports) {
'use strict';

var $jjnZg = parcelRequire("jjnZg");
var $3e0be88d82a1101f$require$obj = $jjnZg.obj;
var $3e0be88d82a1101f$require$fn = $jjnZg.fn;

var $kTQ8i = parcelRequire("kTQ8i");
parcelRequire("kKA2u");
const $3e0be88d82a1101f$var$initial = {
    device: '-1',
    devices: [],
    channel: 1,
    setup: false,
    clicks: {
        36: [
            'playRec',
            '0'
        ],
        37: [
            'playRec',
            '1'
        ],
        38: [
            'playRec',
            '2'
        ],
        39: [
            'playRec',
            '3'
        ],
        40: [
            'stop',
            '0'
        ],
        41: [
            'stop',
            '1'
        ],
        42: [
            'stop',
            '2'
        ],
        43: [
            'stop',
            '3'
        ]
    },
    dblClicks: {
        40: [
            'clear',
            '0'
        ],
        41: [
            'clear',
            '1'
        ],
        42: [
            'clear',
            '2'
        ],
        43: [
            'clear',
            '3'
        ]
    },
    controller: {
        24: [
            'change',
            '0',
            'gain'
        ],
        25: [
            'change',
            '1',
            'gain'
        ],
        26: [
            'change',
            '2',
            'gain'
        ],
        27: [
            'change',
            '3',
            'gain'
        ],
        64: [
            'playRec'
        ]
    }
};
const $3e0be88d82a1101f$var$connect = (devices)=>(state)=>$3e0be88d82a1101f$require$obj.patch(state, 'midi', {
            devices: devices
        });
const $3e0be88d82a1101f$var$actions = {
    initial: $3e0be88d82a1101f$var$initial,
    connect: $3e0be88d82a1101f$var$connect
};
let $3e0be88d82a1101f$var$unhook = ()=>{};
const $3e0be88d82a1101f$var$hook = ({ state$: state$, actions: actions, tapTempo: tapTempo })=>{
    let subs = [];
    const { devices$: devices$, msg$: msg$ } = $kTQ8i.init();
    const parsedMidiMsg$ = msg$.map((raw)=>({
            msg: $kTQ8i.parseMidiMsg(raw.msg),
            raw: raw
        }))// .map(data => (console.log(data), data))
    .share();
    // midi device access
    subs.push(devices$.subscribe((data)=>actions.midi.connect(data)));
    // hook midi signals
    // midi.access$.subscribe(); // data => actions.state.midi.connect(data));
    const midiClicks$ = parsedMidiMsg$.filter((data)=>data.msg.state === 'noteOn').share();
    const midiDblClicks$ = midiClicks$.buffer(midiClicks$.debounce(250)).map((list)=>(console.log(list), list)).filter((list)=>list.length === 2 && list[0].msg.note.number === list[1].msg.note.number).map((list)=>list[0]);
    midiClicks$.withLatestFrom(state$, (data, state)=>({
            data: data,
            state: state
        })).filter(({ data: data, state: state })=>(data.raw.input.id === state.midi.device || state.midi.device === '-1') && state.midi.clicks[data.msg.note.number] && data.msg.channel === state.midi.channel).subscribe(({ data: data, state: state })=>{
        const mmap = state.midi.clicks[data.msg.note.number];
        if (actions[mmap[0]] && actions[mmap[0]] instanceof Function) actions[mmap[0]](mmap[1], mmap[2]);
    });
    midiDblClicks$.withLatestFrom(state$, (data, state)=>({
            data: data,
            state: state
        })).filter(({ data: data, state: state })=>(data.raw.input.id === state.midi.device || state.midi.device === '-1') && state.midi.dblClicks[data.msg.note.number] && data.msg.channel === state.midi.channel).subscribe(({ data: data, state: state })=>{
        console.log('double click');
        const mmap = state.midi.dblClicks[data.msg.note.number];
        if (actions[mmap[0]] && actions[mmap[0]] instanceof Function) actions[mmap[0]](mmap[1], mmap[2]);
    });
    // clickStream
    // .buffer(clickStream.debounce(250))
    // .map(list => list.length)
    // .filter(x => x === 2)
    $3e0be88d82a1101f$var$unhook = ()=>subs.forEach((sub)=>sub.dispose());
};
module.exports = {
    actions: $3e0be88d82a1101f$var$actions,
    hook: $3e0be88d82a1101f$var$hook,
    unhook: ()=>$3e0be88d82a1101f$var$unhook()
};

});
parcelRegister("kTQ8i", function(module, exports) {
'use strict';

var $cI1ok = parcelRequire("cI1ok");
const $f371622efe57d651$var$$ = $cI1ok.Observable;
const $f371622efe57d651$var$keys = [
    'C',
    'C#',
    'D',
    'D#',
    'E',
    'F',
    'F#',
    'G',
    'G#',
    'A',
    'A#',
    'B'
];
const $f371622efe57d651$var$numberToNote = (number)=>({
        key: $f371622efe57d651$var$keys[number % 12],
        octave: parseInt((number - number % 12) / 12, 10) - 1,
        number: number
    });
const $f371622efe57d651$var$noteToNumber = (note)=>$f371622efe57d651$var$keys.indexOf(note.replace(/[0-9]+/, '')) + (parseInt(note.replace(/[A-Z#b]+/, ''), 10) + 1) * 12;
const $f371622efe57d651$var$parseMidiMsg = (event)=>{
    // Mask off the lower nibble (MIDI channel, which we don't care about)
    const status = event.data[0] & 0xf0;
    const binary = event.data[0].toString(2);
    const channel = event.data[0] - status + 1;
    let msg = {};
    switch(binary.slice(0, 4)){
        // noteoff
        case "1000":
            msg = {
                state: 'noteOff',
                note: $f371622efe57d651$var$numberToNote(event.data[1])
            };
            break;
        // noteon
        case "1001":
            msg = event.data[2] !== 0 // if velocity != 0, this is a note-on message
             ? {
                state: 'noteOn',
                note: $f371622efe57d651$var$numberToNote(event.data[1]),
                velocity: parseFloat((event.data[2] / 127).toFixed(2))
            } : {
                state: 'noteOff',
                note: $f371622efe57d651$var$numberToNote(event.data[1])
            };
            break;
        // pitch wheel
        case "1110":
            msg = {
                state: 'pitchBend',
                pitchValue: event.data[2] === 64 ? 0 : parseFloat((event.data[2] / 63.5 - 1).toFixed(2))
            };
            break;
        // controller
        case "1011":
            msg = {
                state: "controller",
                controller: event.data[1],
                value: parseFloat((event.data[2] / 127).toFixed(2))
            };
            break;
        case "1100":
            msg = {
                state: "bankSelect",
                bank: event.data[1]
            };
            break;
        default:
            msg = {
                state: false
            };
            break;
    }
    return Object.assign({}, msg, {
        binary: binary,
        status: status,
        channel: channel,
        data: event.data
    });
};
//
// const hookUpMIDIInput = midiAccess => {
// 	var haveAtLeastOneDevice = false;
// 	var inputs = midiAccess.inputs.values();
// 	for (var input = inputs.next(); input && !input.done; input = inputs.next()) {
// 		input.value.onmidimessage = MIDIMessageEventHandler;
// 		haveAtLeastOneDevice = true;
// 	}
// };
//
// const onMIDIInit = midi => {
// 	hookUpMIDIInput(midi);
// 	midi.onstatechange = hookUpMIDIInput;
// };
//
// const onMIDIReject = err =>
// 	console.log(err, 'The MIDI system failed to start.');
//
// (navigator.requestMIDIAccess)
// 		&& navigator.requestMIDIAccess().then(onMIDIInit, onMIDIReject);
const $f371622efe57d651$var$parseAccess = (access)=>{
    let inputs = [];
    let outputs = [];
    // console.log(access);
    access.inputs.forEach((input)=>inputs.push(input));
    access.outputs.forEach((output)=>outputs.push(output));
    return {
        access: access,
        inputs: inputs,
        outputs: outputs
    };
};
const $f371622efe57d651$var$init = ()=>{
    const devices$ = new $cI1ok.Subject();
    $f371622efe57d651$var$$.fromPromise(navigator.requestMIDIAccess()).flatMap((access)=>$f371622efe57d651$var$$.create((stream)=>{
            access.onstatechange = (connection)=>stream.onNext(connection.currentTarget);
        }).startWith(access)).map($f371622efe57d651$var$parseAccess)// .map(data => (console.log('midi access', data), data))
    .subscribe((device)=>devices$.onNext(device));
    // .share();
    const msg$ = new $cI1ok.Subject();
    devices$.flatMap(({ access: access, inputs: inputs })=>inputs.reduce((msgStream, input)=>msgStream.merge($f371622efe57d651$var$$.fromEventPattern((h)=>{
                input.onmidimessage = h;
            }).map((msg)=>({
                    access: access,
                    input: input,
                    msg: msg
                }))), $f371622efe57d651$var$$.empty())).subscribe((msg)=>msg$.onNext(msg));
    return {
        devices$: devices$,
        msg$: msg$
    };
};
module.exports = {
    init: $f371622efe57d651$var$init,
    numberToNote: $f371622efe57d651$var$numberToNote,
    noteToNumber: $f371622efe57d651$var$noteToNumber,
    parseMidiMsg: $f371622efe57d651$var$parseMidiMsg
};

});


'use strict';

var $cI1ok = parcelRequire("cI1ok");
const $8f6a480bb40b134f$var$$ = $cI1ok.Observable;

var $1VO3A = parcelRequire("1VO3A");

var $jjnZg = parcelRequire("jjnZg");
var $8f6a480bb40b134f$require$obj = $jjnZg.obj;
var $8f6a480bb40b134f$require$arr = $jjnZg.arr;

var $7TCVA = parcelRequire("7TCVA");
window.a = $7TCVA;
var $f134bb0dffae52a3$exports = {};
'use strict';

var $cI1ok = parcelRequire("cI1ok");
const $f134bb0dffae52a3$var$$ = $cI1ok.Observable;
var $fb12c2f1c6b96ca2$exports = {};
var $eb2bb98225a8c269$exports = {};
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) $eb2bb98225a8c269$exports = function() {
        return performance.now();
    };
    else if (Date.now) {
        $eb2bb98225a8c269$exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        $eb2bb98225a8c269$exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call($eb2bb98225a8c269$exports);


var $fb12c2f1c6b96ca2$var$root = typeof window === 'undefined' ? $parcel$global : window, $fb12c2f1c6b96ca2$var$vendors = [
    'moz',
    'webkit'
], $fb12c2f1c6b96ca2$var$suffix = 'AnimationFrame', $fb12c2f1c6b96ca2$var$raf = $fb12c2f1c6b96ca2$var$root['request' + $fb12c2f1c6b96ca2$var$suffix], $fb12c2f1c6b96ca2$var$caf = $fb12c2f1c6b96ca2$var$root['cancel' + $fb12c2f1c6b96ca2$var$suffix] || $fb12c2f1c6b96ca2$var$root['cancelRequest' + $fb12c2f1c6b96ca2$var$suffix];
for(var $fb12c2f1c6b96ca2$var$i = 0; !$fb12c2f1c6b96ca2$var$raf && $fb12c2f1c6b96ca2$var$i < $fb12c2f1c6b96ca2$var$vendors.length; $fb12c2f1c6b96ca2$var$i++){
    $fb12c2f1c6b96ca2$var$raf = $fb12c2f1c6b96ca2$var$root[$fb12c2f1c6b96ca2$var$vendors[$fb12c2f1c6b96ca2$var$i] + 'Request' + $fb12c2f1c6b96ca2$var$suffix];
    $fb12c2f1c6b96ca2$var$caf = $fb12c2f1c6b96ca2$var$root[$fb12c2f1c6b96ca2$var$vendors[$fb12c2f1c6b96ca2$var$i] + 'Cancel' + $fb12c2f1c6b96ca2$var$suffix] || $fb12c2f1c6b96ca2$var$root[$fb12c2f1c6b96ca2$var$vendors[$fb12c2f1c6b96ca2$var$i] + 'CancelRequest' + $fb12c2f1c6b96ca2$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$fb12c2f1c6b96ca2$var$raf || !$fb12c2f1c6b96ca2$var$caf) {
    var $fb12c2f1c6b96ca2$var$last = 0, $fb12c2f1c6b96ca2$var$id = 0, $fb12c2f1c6b96ca2$var$queue = [], $fb12c2f1c6b96ca2$var$frameDuration = 1000 / 60;
    $fb12c2f1c6b96ca2$var$raf = function(callback) {
        if ($fb12c2f1c6b96ca2$var$queue.length === 0) {
            var _now = $eb2bb98225a8c269$exports(), next = Math.max(0, $fb12c2f1c6b96ca2$var$frameDuration - (_now - $fb12c2f1c6b96ca2$var$last));
            $fb12c2f1c6b96ca2$var$last = next + _now;
            setTimeout(function() {
                var cp = $fb12c2f1c6b96ca2$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $fb12c2f1c6b96ca2$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($fb12c2f1c6b96ca2$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $fb12c2f1c6b96ca2$var$queue.push({
            handle: ++$fb12c2f1c6b96ca2$var$id,
            callback: callback,
            cancelled: false
        });
        return $fb12c2f1c6b96ca2$var$id;
    };
    $fb12c2f1c6b96ca2$var$caf = function(handle) {
        for(var i = 0; i < $fb12c2f1c6b96ca2$var$queue.length; i++)if ($fb12c2f1c6b96ca2$var$queue[i].handle === handle) $fb12c2f1c6b96ca2$var$queue[i].cancelled = true;
    };
}
$fb12c2f1c6b96ca2$exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $fb12c2f1c6b96ca2$var$raf.call($fb12c2f1c6b96ca2$var$root, fn);
};
$fb12c2f1c6b96ca2$exports.cancel = function() {
    $fb12c2f1c6b96ca2$var$caf.apply($fb12c2f1c6b96ca2$var$root, arguments);
};
$fb12c2f1c6b96ca2$exports.polyfill = function(object) {
    if (!object) object = $fb12c2f1c6b96ca2$var$root;
    object.requestAnimationFrame = $fb12c2f1c6b96ca2$var$raf;
    object.cancelAnimationFrame = $fb12c2f1c6b96ca2$var$caf;
};


const $f134bb0dffae52a3$var$tick = (cb)=>$fb12c2f1c6b96ca2$exports(function(dt) {
        cb(dt);
        $f134bb0dffae52a3$var$tick(cb);
    });
const $f134bb0dffae52a3$var$frame = ()=>$f134bb0dffae52a3$var$$.create((obs)=>$f134bb0dffae52a3$var$tick((dt)=>obs.onNext(dt))).filter((dt)=>dt !== 0).share();
const $f134bb0dffae52a3$var$loop = (state$, node)=>$f134bb0dffae52a3$var$frame(node).withLatestFrom(state$, (dt, state)=>({
            dt: dt,
            state: state
        }));
$f134bb0dffae52a3$exports = {
    frame: $f134bb0dffae52a3$var$frame,
    loop: $f134bb0dffae52a3$var$loop
};


var $1ea79d5b96757799$exports = {};
'use strict';

var $cI1ok = parcelRequire("cI1ok");
const $1ea79d5b96757799$var$$ = $cI1ok.Observable;

var $jjnZg = parcelRequire("jjnZg");
var $1ea79d5b96757799$require$arr = $jjnZg.arr;
var $1ea79d5b96757799$require$obj = $jjnZg.obj;
const $1ea79d5b96757799$var$observe = (source)=>source instanceof $cI1ok.Observable ? source : source.then instanceof Function ? $cI1ok.Observable.fromPromise(source) : $cI1ok.Observable.just(source);
const $1ea79d5b96757799$var$adapt = (o, p = [])=>Object.keys(o).filter((key)=>key !== 'initial').reduce((o2, key)=>Object.assign({}, o2, o[key] instanceof Function && $1ea79d5b96757799$require$obj.keyValue(key, function() {
            $1ea79d5b96757799$var$observe(o[key].apply(null, Array.from(arguments))).subscribe((resp)=>o2.stream.onNext(Object.assign(resp, {
                    path: [].concat(p, key),
                    payload: Array.from(arguments)
                })));
        }) || o[key] instanceof Object && (()=>{
            let o3 = $1ea79d5b96757799$var$adapt(o[key], [].concat(p, key));
            o3.stream.subscribe((resp)=>o2.stream.onNext(resp));
            return Object.assign({
                initial: Object.assign({}, o2.initial, $1ea79d5b96757799$require$obj.keyValue(key, o3.initial))
            }, $1ea79d5b96757799$require$obj.keyValue(key, o3));
        })() || $1ea79d5b96757799$require$obj.keyValue(key, o[key])), {
        stream: new $cI1ok.Subject(),
        initial: o.initial || {}
    });
const $1ea79d5b96757799$var$attach = (tree, path, node)=>[
        $1ea79d5b96757799$var$adapt(node, path)
    ].map((adaptedNode)=>(adaptedNode.stream.subscribe((resp)=>tree.stream.onNext(resp)), Object.assign({}, $1ea79d5b96757799$require$obj.patch(tree, path, adaptedNode), {
            initial: $1ea79d5b96757799$require$obj.patch(tree.initial, path, adaptedNode.initial)
        }))).pop();
$1ea79d5b96757799$exports = {
    adapt: $1ea79d5b96757799$var$adapt,
    attach: $1ea79d5b96757799$var$attach
};



let $8f6a480bb40b134f$var$actions = $1ea79d5b96757799$exports.adapt((parcelRequire("6dWku")));

var $8f6a480bb40b134f$require$ui = (parcelRequire("cVcju"));
let $8f6a480bb40b134f$var$actions$;
const $8f6a480bb40b134f$var$state$ = new $cI1ok.BehaviorSubject();

var $8f6a480bb40b134f$require$visuals = (parcelRequire("aBnNP"));

var $8f6a480bb40b134f$require$audio = (parcelRequire("gYqGB"));
$8f6a480bb40b134f$var$actions = $1ea79d5b96757799$exports.attach($8f6a480bb40b134f$var$actions, 'audio', $8f6a480bb40b134f$require$audio.actions);

var $8f6a480bb40b134f$require$midi = (parcelRequire("5kgSa"));
$8f6a480bb40b134f$var$actions = $1ea79d5b96757799$exports.attach($8f6a480bb40b134f$var$actions, 'midi', $8f6a480bb40b134f$require$midi.actions);







// shared objects
// hot reloading
if (null) {
    // actions
    $8f6a480bb40b134f$var$actions$ = $8f6a480bb40b134f$var$$.fromEventPattern((h)=>null.accept("./actions", h)).flatMap(()=>{
        $8f6a480bb40b134f$var$actions = $1ea79d5b96757799$exports.adapt((parcelRequire("6dWku")));
        $8f6a480bb40b134f$var$actions = $1ea79d5b96757799$exports.attach($8f6a480bb40b134f$var$actions, 'audio', $8f6a480bb40b134f$require$audio.actions);
        $8f6a480bb40b134f$var$actions = $1ea79d5b96757799$exports.attach($8f6a480bb40b134f$var$actions, 'midi', $8f6a480bb40b134f$require$midi.actions);
        return $8f6a480bb40b134f$var$actions.stream.startWith((state)=>state);
    }).merge($8f6a480bb40b134f$var$actions.stream);
    // ui
    null.accept("./ui", function() {
        $8f6a480bb40b134f$require$ui = (parcelRequire("cVcju"));
        $8f6a480bb40b134f$var$actions.stream.onNext((state)=>state);
    });
    // services
    // visuals
    null.accept("./services/visuals.js", function() {
        $8f6a480bb40b134f$require$visuals.unhook();
        $8f6a480bb40b134f$require$visuals = (parcelRequire("aBnNP"));
        $8f6a480bb40b134f$require$visuals.hook({
            state$: $8f6a480bb40b134f$var$state$,
            actions: $8f6a480bb40b134f$var$actions
        });
        $8f6a480bb40b134f$var$actions.ping();
    });
    // audio
    null.accept("./services/audio.js", function() {
        $8f6a480bb40b134f$require$audio.unhook();
        $8f6a480bb40b134f$require$audio = (parcelRequire("gYqGB"));
        $8f6a480bb40b134f$var$actions = $1ea79d5b96757799$exports.adapt((parcelRequire("6dWku")));
        $8f6a480bb40b134f$var$actions = $1ea79d5b96757799$exports.attach($8f6a480bb40b134f$var$actions, 'audio', $8f6a480bb40b134f$require$audio.actions);
        $8f6a480bb40b134f$var$actions = $1ea79d5b96757799$exports.attach($8f6a480bb40b134f$var$actions, 'midi', $8f6a480bb40b134f$require$midi.actions);
        $8f6a480bb40b134f$require$audio.hook({
            state$: $8f6a480bb40b134f$var$state$,
            actions: $8f6a480bb40b134f$var$actions
        });
        $8f6a480bb40b134f$var$actions.ping();
    });
    // midi
    null.accept("./services/midi.js", function() {
        $8f6a480bb40b134f$require$midi.unhook();
        $8f6a480bb40b134f$require$midi = (parcelRequire("5kgSa"));
        $8f6a480bb40b134f$var$actions = $1ea79d5b96757799$exports.adapt((parcelRequire("6dWku")));
        $8f6a480bb40b134f$var$actions = $1ea79d5b96757799$exports.attach($8f6a480bb40b134f$var$actions, 'audio', $8f6a480bb40b134f$require$audio.actions);
        $8f6a480bb40b134f$var$actions = $1ea79d5b96757799$exports.attach($8f6a480bb40b134f$var$actions, 'midi', $8f6a480bb40b134f$require$midi.actions);
        $8f6a480bb40b134f$require$midi.hook({
            state$: $8f6a480bb40b134f$var$state$,
            actions: $8f6a480bb40b134f$var$actions
        });
        $8f6a480bb40b134f$var$actions.ping();
    });
} else $8f6a480bb40b134f$var$actions$ = $8f6a480bb40b134f$var$actions.stream;
// actions -> state
$8f6a480bb40b134f$var$actions$.map((action)=>(action.path && console.log(action.path.join('.'), action.payload), console.log(action), action)).startWith(()=>$8f6a480bb40b134f$var$actions.initial).scan((state, change)=>change(state), {}).map((state)=>(console.log(state), state)).subscribe((state)=>$8f6a480bb40b134f$var$state$.onNext(state));
// Request permissions on page load - browser will show native prompts
// Audio context resume
if ($7TCVA.context.state === 'suspended') $7TCVA.context.resume().catch((err)=>{
    console.error('Failed to resume audio context:', err);
});
// MIDI access
if (navigator.requestMIDIAccess) navigator.requestMIDIAccess().catch((err)=>{
    console.error('Failed to request MIDI access:', err);
});
// Resume audio context on first user interaction (required by modern browsers)
const $8f6a480bb40b134f$var$resumeAudioOnInteraction = ()=>{
    if ($7TCVA.context.state === 'suspended') $7TCVA.context.resume().then(()=>{
        console.log('Audio context resumed');
    }).catch((err)=>{
        console.error('Failed to resume audio context:', err);
    });
    document.removeEventListener('click', $8f6a480bb40b134f$var$resumeAudioOnInteraction);
    document.removeEventListener('touchstart', $8f6a480bb40b134f$var$resumeAudioOnInteraction);
};
document.addEventListener('click', $8f6a480bb40b134f$var$resumeAudioOnInteraction, {
    once: true
});
document.addEventListener('touchstart', $8f6a480bb40b134f$var$resumeAudioOnInteraction, {
    once: true
});
// state -> ui
// const ui$ = state$.map(state => ui({state, actions}));
const $8f6a480bb40b134f$var$ui$ = $f134bb0dffae52a3$exports.frame().withLatestFrom($8f6a480bb40b134f$var$state$, (t, state)=>state).map((state)=>$8f6a480bb40b134f$require$ui({
        state: state,
        actions: $8f6a480bb40b134f$var$actions
    }));
// hooks
$8f6a480bb40b134f$require$visuals.hook({
    state$: $8f6a480bb40b134f$var$state$,
    actions: $8f6a480bb40b134f$var$actions
});
$8f6a480bb40b134f$require$audio.hook({
    state$: $8f6a480bb40b134f$var$state$,
    actions: $8f6a480bb40b134f$var$actions
});
$8f6a480bb40b134f$require$midi.hook({
    state$: $8f6a480bb40b134f$var$state$,
    actions: $8f6a480bb40b134f$var$actions
});
// patch stream to dom
$1VO3A.patchStream($8f6a480bb40b134f$var$ui$, '#ui');
// livereload impl.
if (null) document.write(`<script src="http://${(location.host || 'localhost').split(':')[0]}` + `:35729/livereload.js?snipver=1"></script>`);


//# sourceMappingURL=js-loop-station.8cd63c34.js.map
